import { useState, useRef, useEffect, Fragment } from 'react';
import * as XLSX from 'xlsx';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import ImageModule from 'docxtemplater-image-module-free';
import { auth, db, firebaseConfig } from './firebaseConfig';
import { initializeApp, deleteApp } from 'firebase/app';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, getDocs, setDoc, onSnapshot, collection, query, where, addDoc, updateDoc, deleteDoc, arrayUnion, serverTimestamp, runTransaction } from 'firebase/firestore';

const s = {
  app: { fontFamily: 'Segoe UI, sans-serif', maxWidth: '480px', margin: '0 auto', minHeight: '100vh', background: '#f5f6fa' },
  topbar: { background: 'var(--brand)', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  topbarAdmin: { background: 'var(--brand-darker)', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  topbarTitle: { color: 'white', fontSize: '18px', fontWeight: '600' },
  topbarSub: { color: 'rgba(255,255,255,0.7)', fontSize: '12px' },
  avatar: { width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: '600' },
  content: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '14px', paddingBottom: '80px' },
  card: { background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  cardLabel: { fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px', fontWeight: '600' },
  statRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' },
  stat: { background: '#f5f6fa', borderRadius: '8px', padding: '12px' },
  statNum: { fontSize: '24px', fontWeight: '600', color: '#2d2d2d' },
  statLbl: { fontSize: '11px', color: '#888', marginTop: '2px' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0f0f0' },
  rowLast: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' },
  name: { fontSize: '13px', fontWeight: '600', color: '#2d2d2d' },
  sub: { fontSize: '12px', color: '#888', marginTop: '2px' },
  badge: (color, bg) => ({ fontSize: '11px', padding: '3px 10px', borderRadius: '20px', fontWeight: '500', color, background: bg }),
  nav: { position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: '480px', background: 'white', borderTop: '1px solid #eee', display: 'flex' },
  navBtn: (active) => ({ flex: 1, padding: '10px 4px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', cursor: 'pointer', border: 'none', background: 'none' }),
  navLbl: (active) => ({ fontSize: '10px', color: active ? 'var(--brand)' : '#888' }),
  loginBox: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa', padding: '20px' },
  loginCard: { background: 'white', borderRadius: '16px', padding: '32px 24px', width: '100%', maxWidth: '380px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  input: { width: '100%', padding: '12px 14px', borderRadius: '8px', border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '14px', boxSizing: 'border-box', outline: 'none' },
  loginBtn: { width: '100%', padding: '14px', background: 'var(--brand)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' },
  roleRow: { display: 'flex', gap: '10px', marginBottom: '20px' },
  roleBtn: (active) => ({ flex: 1, padding: '10px', borderRadius: '8px', border: `2px solid ${active ? 'var(--brand)' : '#e0e0e0'}`, background: active ? 'var(--brand-light)' : 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: active ? 'var(--brand)' : '#555' }),
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', cursor: 'pointer' },
  primaryBtn: { width: '100%', padding: '12px', background: 'var(--brand)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '6px' },
  outlineBtn: { padding: '7px 14px', background: 'white', color: 'var(--brand)', border: '1px solid #4A3CDB', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' },
  dangerBtn: { padding: '7px 14px', background: 'white', color: '#b71c1c', border: '1px solid #b71c1c', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' },
  assignBtn: { padding: '7px 14px', background: 'var(--brand)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' },
  dlBtn: { background: 'var(--brand-light)', border: 'none', color: 'var(--brand)', fontSize: '11px', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' },
  timeGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginTop: '10px' },
  timeSlot: (selected) => ({ padding: '10px', borderRadius: '8px', border: `2px solid ${selected ? 'var(--brand)' : '#e0e0e0'}`, background: selected ? 'var(--brand-light)' : 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: selected ? 'var(--brand)' : '#555', textAlign: 'center' }),
  successBox: { background: '#e8f5e9', borderRadius: '10px', padding: '14px', textAlign: 'center', color: '#2e7d32', fontSize: '13px', fontWeight: '500' },
  emptyBox: { textAlign: 'center', padding: '24px', color: '#aaa', fontSize: '13px' },
  selectInput: { width: '100%', padding: '11px 12px', borderRadius: '8px', border: '1px solid #e0e0e0', fontSize: '13px', marginBottom: '12px', background: 'white', outline: 'none' },
  tabRow: { display: 'flex', gap: '8px', marginBottom: '14px' },
  tabBtn: (active) => ({ padding: '6px 14px', borderRadius: '20px', border: 'none', background: active ? 'var(--brand)' : '#f0f0f0', color: active ? 'white' : '#666', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }),
  issueTypeBtn: (active) => ({ flex: 1, padding: '10px 6px', borderRadius: '8px', border: `2px solid ${active ? 'var(--brand)' : '#e0e0e0'}`, background: active ? 'var(--brand-light)' : 'white', cursor: 'pointer', fontSize: '12px', fontWeight: '500', color: active ? 'var(--brand)' : '#555', textAlign: 'center' }),
  navControlBtn: (enabled) => ({ width: '36px', height: '36px', borderRadius: '50%', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: '700', cursor: enabled ? 'pointer' : 'default', background: enabled ? 'var(--brand)' : '#f0f0f0', color: enabled ? 'white' : '#ccc', boxShadow: enabled ? '0 2px 6px rgba(255,107,26,0.35)' : 'none' }),
  sectionHeader: { fontSize: '13px', fontWeight: '700', color: '#2d2d2d', margin: '4px 2px 2px' },
  menuRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', cursor: 'pointer' },
  menuRowLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  menuRowIcon: { fontSize: '18px', width: '22px', textAlign: 'center' },
  menuRowLabel: { fontSize: '14px', color: '#2d2d2d', fontWeight: '500' },
  menuChevron: (open) => ({ fontSize: '14px', color: '#bbb', transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s' }),
};

// Derives the light-tint and dark-text shades used throughout the app from a
// single brand color, so a company only ever needs to pick one color, not three.
function hexToRgb(hex) {
  const clean = hex.replace('#', '');
  return [parseInt(clean.slice(0,2), 16), parseInt(clean.slice(2,4), 16), parseInt(clean.slice(4,6), 16)];
}
function lightenColor(hex, amount) {
  const [r,g,b] = hexToRgb(hex);
  const nr = Math.min(255, r + (255-r)*amount), ng = Math.min(255, g + (255-g)*amount), nb = Math.min(255, b + (255-b)*amount);
  return `rgb(${Math.round(nr)}, ${Math.round(ng)}, ${Math.round(nb)})`;
}
function darkenColor(hex, amount) {
  const [r,g,b] = hexToRgb(hex);
  return `rgb(${Math.round(r*(1-amount))}, ${Math.round(g*(1-amount))}, ${Math.round(b*(1-amount))})`;
}

const ADMIN_SEARCHABLE_FEATURES = [
  { icon: '🏠', labelKey: 'nav_overview', tab: 'overview' },
  { icon: '👥', labelKey: 'nav_team', tab: 'employees' },
  { icon: '📅', labelKey: 'nav_shifts', tab: 'shifts' },
  { icon: '🕐', labelKey: 'nav_avail', tab: 'avail' },
  { icon: '⚠️', labelKey: 'title_issues', tab: 'issues' },
  { icon: '💶', labelKey: 'title_salary', tab: 'salary' },
  { icon: '🤒', labelKey: 'nav_sick', tab: 'sick' },
  { icon: '🎨', labelKey: 'brand_color_title', tab: 'overview', special: 'brandColor' },
  { icon: '🕘', labelKey: 'fixed_schedule_title', tab: 'overview', special: 'fixedSchedule' },
  { icon: '🔄', labelKey: 'rotation_title', tab: 'overview', special: 'rotationSchedule' },
  { icon: '📋', labelKey: 'shift_templates_title', tab: 'overview', special: 'shiftTemplates' },
  { icon: '💼', labelKey: 'nav_hiring', tab: 'hiring' },
];
const EMPLOYEE_SEARCHABLE_FEATURES = [
  { icon: '🏠', labelKey: 'nav_home', tab: 'home' },
  { icon: '📅', labelKey: 'nav_shifts', tab: 'shifts' },
  { icon: '🕐', labelKey: 'nav_avail', tab: 'avail' },
  { icon: '⚠️', labelKey: 'title_issues', tab: 'issues' },
  { icon: '💶', labelKey: 'title_salary', tab: 'salary' },
  { icon: '🤒', labelKey: 'nav_sick', tab: 'sick' },
  { icon: '🏖️', labelKey: 'nav_leave', tab: 'leave' },
  { icon: '👤', labelKey: 'nav_profile', tab: 'profile' },
];

// Converts a raw Firebase Auth error into a clear, actionable message — used
// everywhere a new account gets created (employees, HR access, branch managers),
// so a duplicate email shows a helpful message instead of crashing the app.
function friendlyAccountError(err) {
  const code = err?.code || '';
  if (code === 'auth/email-already-in-use') return 'This email is already registered to another account. Please use a different email address.';
  if (code === 'auth/invalid-email') return 'That email address looks invalid — please check it and try again.';
  if (code === 'auth/weak-password') return 'Something went wrong setting up the account. Please try again.';
  return `Something went wrong: ${err?.message || err}. Please try again.`;
}

const TIME_OPTIONS = Array.from({ length: 48 }, (_, i) => {
  const h = String(Math.floor(i / 2)).padStart(2, '0');
  const m = i % 2 === 0 ? '00' : '30';
  return `${h}:${m}`;
});

const EMPLOYEES = [
  { id: 1, name: 'Employee One', initials: 'E1', color: 'var(--brand-light)', textColor: 'var(--brand-dark)', email: 'employee1@demo.com' },
  { id: 2, name: 'Employee Two', initials: 'E2', color: '#e8f5e9', textColor: '#2e7d32', email: 'employee2@demo.com' },
  { id: 3, name: 'Employee Three', initials: 'E3', color: '#fff8e1', textColor: '#f57f17', email: 'employee3@demo.com' },
  { id: 4, name: 'Employee Four', initials: 'E4', color: '#fce4ec', textColor: '#880e4f', email: 'employee4@demo.com' },
  { id: 5, name: 'Employee Five', initials: 'E5', color: '#e3f2fd', textColor: '#0d47a1', email: 'employee5@demo.com' },
];

const today = new Date().toISOString().split('T')[0];

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
];

// Translation dictionary. Full coverage for English and German — French and Spanish keys
// remain in the T{} object below (from earlier, partial work) but are hidden from selection
// until there's an actual confirmed need for them.
const T = {
  en: {
    nav_home: 'Home', nav_shifts: 'Shifts', nav_avail: 'Availability', nav_profile: 'Profile',
    nav_overview: 'Overview', nav_team: 'Team', nav_sick: 'Sick Certificates', nav_leave: 'Leave', nav_hiring: 'Hiring',
    hiring_postings_title: 'Job Postings', hiring_new_posting_btn: 'New Job Posting', hiring_job_title: 'Job Title', hiring_job_title_placeholder: 'e.g. Delivery Driver',
    hiring_role_placeholder: 'e.g. Driver, Cook, Cashier', hiring_location: 'Location', hiring_location_placeholder: 'e.g. Berlin Branch', hiring_description: 'Description',
    hiring_publish_btn: 'Publish Posting', hiring_company_code_hint: 'Candidates use this company code to find your postings',
    hiring_close_btn: 'Close', hiring_reopen_btn: 'Reopen',
    hiring_stage_applied: 'Applied', hiring_stage_interview: 'Interview', hiring_stage_hired: 'Hired', hiring_stage_rejected: 'Rejected',
    hiring_move_interview: 'Move to Interview', hiring_hire_btn: 'Hire', hiring_hired_label: 'Hired — now an employee',
    hiring_interview_rounds: 'Number of Interview Rounds', hiring_rounds_label: 'round(s)', hiring_round_label: 'Round',
    hiring_tab_postings: 'Job Postings', hiring_tab_applied: 'Applied', hiring_tab_interview: 'Interview', hiring_tab_hired: 'Hired', hiring_tab_rejected: 'Rejected',
    hiring_no_postings: 'No job postings yet.', hiring_no_applicants: 'No one here yet.', hiring_next_round_btn: 'Next Round', hiring_of: 'of',
    iss_escalate_btn: 'Not satisfied? Escalate to HR', iss_escalate_confirm: "This will send your issue to HR for a second look. Continue?", iss_escalated_label: "Escalated to HR — they'll follow up here.",
    hiring_tab_complaints: 'Complaints', hiring_complaints_hint: "Issues employees escalated because their branch manager's answer wasn't enough.",
    hiring_no_complaints: 'No escalated complaints right now.', hiring_mark_resolved: 'Mark Resolved',
    hiring_round_names_label: 'Interview Rounds', hiring_round_names_hint: 'Name each round for this job — e.g. "HR Round", "Manager Round".',
    hiring_add_round_btn: 'Add Round', hiring_open_postings: 'Open', hiring_closed_postings: 'Closed',
    hiring_selected_label: 'selected', hiring_send_message_btn: 'Send Message', hiring_message_placeholder: "e.g. You've been selected for the next round of interviews.",
    hiring_message_hint: "Each person's name will be added automatically — you don't need to write it yourself.",
    hiring_send_now_btn: 'Send', hiring_mail_subject: 'Update on your application — {job}',
    hiring_hr_access_title: 'Hiring Portal Access', hiring_hr_access_hint: 'Give someone their own dedicated login to manage hiring — separate from the branch manager account.',
    hiring_add_hr_btn: 'Give HR Access', hiring_create_hr_btn: 'Create Access',
    hq_title: 'HQ Portal', hq_company_overview: 'Company Overview', hq_branches: 'Branches',
    hq_branches_title: 'Branches & Managers', hq_add_bm_btn: 'Add Branch Manager', hq_branch_id: 'Branch ID',
    hq_branch_id_placeholder: 'e.g. berlin-mitte', hq_create_bm_btn: 'Create Branch Manager', hq_employees_in_branch: 'employees',
    hq_no_employees_yet: 'No employees assigned to this branch yet.', hq_upcoming_in_branch: 'upcoming shifts in this branch',
    hq_payroll_title: 'Monthly Payroll — All Branches', hq_payroll_hint: 'Branches send their monthly payroll here for you to review and process.',
    hq_total_gross: 'Total Gross', hq_submitted_by: 'sent by',
    hq_search_branches: '🔍 Search branches...', hq_search_employees: '🔍 Search employees in this branch...',
    hq_team_title: 'HR & Branch Manager Access', hq_team_hint: 'Everyone with HR or Branch Manager access at your company.',
    hq_team_none: 'No HR or Branch Manager accounts created yet.', hq_search_team: 'Search by name or email...',
    hq_role_hr: 'HR', hq_role_bm: 'Branch Manager',
    app_tagline: 'Smart Workforce Management',
    hq_deactivated_label: 'Access deactivated', hq_deactivate_btn: 'Deactivate', hq_reactivate_btn: 'Reactivate',
    hq_deactivate_confirm: "Deactivate {name}'s access? They won't be able to log in until reactivated.",
    hq_reactivate_confirm: "Reactivate {name}'s access? They'll be able to log in again immediately.",
    login_deactivated_title: 'Access deactivated', login_deactivated_hint: 'Your access has been deactivated. Please contact your company for details.', login_dismiss: 'Dismiss',
    leave_apply_title: 'Apply for Leave', leave_apply_short: 'Apply', leave_edit_title: 'Edit Leave Request',
    leave_note_placeholder: 'Optional note', leave_submit_btn: 'Submit Request',
    leave_tab_pending: 'Pending', leave_tab_approved: 'Approved', leave_tab_rejected: 'Rejected',
    leave_none_in_tab: 'Nothing here yet.', leave_cancel_confirm: 'Cancel this leave request?',
    leave_used_title: 'Leave Used', leave_days_unit: 'days',
    leave_requests_title: 'Leave Requests', leave_used_so_far: '{count} days used this year',
    title_issues: 'Issues', title_salary: 'Salary',
    login_employee: 'Employee', login_manager: 'Manager', login_email: 'Email address', login_password: 'Password',
    login_signin: 'Sign In', login_forgot: 'Forgot password?', login_language: 'Language',
    login_browse_jobs: 'Browse Open Positions',
    login_signup_link: 'New here? Create an account',
    signup_back_to_login: 'Back to login', signup_title: 'Create Your Account', signup_hint: 'Sign up once to browse and apply to jobs across companies using KarmaDal.',
    signup_error_missing: 'Please fill in all fields.', signup_error_password: 'Password must be at least 6 characters.',
    signup_password_hint: 'At least 6 characters.', signup_create_btn: 'Create Account',
    jobseeker_title: 'My Jobs', jobseeker_complete_profile: 'Complete Your Profile', jobseeker_profile_hint: 'Add your phone number and resume before applying to any job.',
    jobseeker_phone: 'Phone Number', jobseeker_phone_placeholder: '+49 ...', jobseeker_resume: 'Resume / CV',
    jobseeker_save_profile_btn: 'Save Profile', jobseeker_profile_incomplete: 'Please add both a phone number and a resume.',
    jobseeker_phone_taken: 'This phone number is already linked to another account.', jobseeker_complete_first: 'Complete your profile to apply',
    jobseeker_signup_prompt_title: 'Create a free account to apply', jobseeker_signup_prompt_hint: 'Sign up once to apply to {job} — and every other job on KarmaDal, in the future.',
    jobseeker_browse_hint: 'Every open position from every company using KarmaDal, all in one place.', jobseeker_search_placeholder: 'Search by title, role, location, or company...',
    jobseeker_none_open_anywhere: 'No open positions anywhere right now — check back soon.',
    choice_title: 'Which one today?', choice_hint: 'You have two kinds of access on this account — pick where you want to go.',
    choice_employee_hint: 'Your work account', choice_jobs_hint: 'Browse and apply to open positions',
    jobs_back_to_login: 'Back to login', jobs_portal_title: 'Open Positions', jobs_portal_hint: 'Enter the company code your recruiter or job posting gave you to see open roles.',
    jobs_company_code: 'Company Code', jobs_company_code_placeholder: 'e.g. oprisa2024', jobs_find_btn: 'Find Jobs', jobs_not_found: 'No open positions found for that company code.',
    jobs_apply_btn: 'Apply', jobs_none_open: 'No open positions right now.', jobs_applying_for: 'Applying for',
    jobs_your_name: 'Your Name', jobs_your_email: 'Your Email', jobs_your_phone: 'Phone (optional)', jobs_your_note: 'Cover Note (optional)',
    jobs_submit_btn: 'Submit Application', jobs_submit_error: 'Something went wrong — please try again.',
    jobs_success_title: 'Application Submitted', jobs_success_hint: "The employer will review your application and reach out if it's a match.",
    login_reset_title: 'Password Reset', login_reset_text: 'Please contact your manager to reset your password.', login_close: 'Close',
    login_error: 'Please enter email and password', login_error_invalid: 'Invalid email or password',
    home_overview: 'Overview', home_upcoming: 'Upcoming shifts', home_completed: 'Completed shifts',
    home_pending_avail: 'Pending availability', home_open_issues: 'Open issues',
    home_worked_hours: 'My Worked Hours', home_this_week: 'This week', home_this_month: 'This month',
    home_upcoming_shifts: 'Upcoming Shifts', home_no_upcoming: 'No upcoming shifts. Submit your availability!',
    home_current_shift: 'Current Shift', home_next_shift: 'Next Shift',
    swap_request_btn: 'Request Shift Swap', swap_pending: 'Swap request pending', swap_request_title: 'Request a swap for {date}',
    swap_note_placeholder: 'Optional — who you\'d prefer, or why (admin will confirm with everyone involved)', swap_submit_btn: 'Submit Request',
    swap_requests_title: 'Shift Swap Requests', swap_no_requests: 'No swap requests right now.',
    swap_approve_btn: 'Mark Resolved', swap_decline_btn: 'Decline', swap_resolved: 'Resolved', swap_declined: 'Declined',
    swap_status_pending: 'You requested a swap for this shift — waiting on your manager.', swap_status_resolved: 'Your swap request was completed.', swap_status_declined: 'Your swap request was declined.',
    swap_pick_colleague: 'Who would you like to swap with?', swap_pick_colleague_placeholder: '-- Select a colleague --',
    swap_incoming_title: '{name} wants to swap a shift with you', swap_accept_btn: 'Accept', swap_reject_btn: 'Decline',
    swap_both_agreed: 'Both employees have agreed', swap_status_declined_colleague: '{name} declined this swap.',
    notif_title: 'Notifications', notif_none: "You're all caught up.",
    notif_new_shift: 'New shift assigned', notif_sick_reviewed: 'Sick certificate reviewed', notif_doc_reviewed: 'Document reviewed',
    notif_swap_incoming: 'wants to swap a shift with you', notif_swap_result: 'Swap request update', notif_leave_result: 'Leave request update',
    notif_pending_avail: 'submitted availability', notif_pending_sick: 'submitted a sick certificate',
    notif_pending_swap: 'both agreed, awaiting your approval', notif_pending_leave: 'requested leave',
    notif_issue_reply: 'New reply on your issue', notif_contract_signed: 'Your contract has been countersigned', notif_new_slip: 'New payslip available',
    err_signature_generic: 'Something went wrong embedding the signature: {err}. Please try again.',
    err_contract_not_uploaded: 'PDF not uploaded yet by manager. Please check back later.',
    err_signature_employer: 'Something went wrong embedding the signature: {err}. The signature was NOT saved — please try again.',
    err_old_template: 'This template was created before .docx upload was added — please delete it and add it again by uploading a real Word file.',
    err_contract_generate: 'Something went wrong generating this contract: {err}. Check the template\'s placeholders match exactly (e.g. {{name}}) and try again.',
    confirm_reset_shift: 'Reset {employee}\'s {date} shift back to "not yet reported"? This clears the current attendance record.',
    confirm_remove_shift: 'Remove this shift?',
    brand_color_title: 'Brand Color', brand_color_hint: 'Sets the accent color used throughout the app for your company.',
    brand_color_tap_hint: 'Tap the square to choose a color', brand_color_apply: 'Apply Color',
    swap_status_awaiting_colleague: 'Waiting for {name} to respond.', swap_status_awaiting_admin: 'Both agreed — waiting on your manager to finalize.',
    swap_type_transfer: 'Transfer Shift', swap_type_transfer_desc: 'Give this shift to a colleague — nothing comes back from them.',
    swap_type_swap: 'Swap with Colleague', swap_type_swap_desc: 'Trade this shift for one of theirs — you both end up working a different shift.',
    swap_back_btn: 'Back', swap_incoming_swap_title: '{name} wants to swap shifts with you',
    swap_pick_own_shift: 'Which of your shifts would you offer in return?', swap_no_own_shifts: "You don't have any upcoming shifts to offer.",
    swap_pick_own_shift_placeholder: '-- Select your shift --', swap_confirm_btn: 'Confirm Swap',
    profile_photo: 'Profile Photo', profile_contract: 'My Contract', profile_hours: 'Contracted Hours',
    profile_upload_doc: 'Upload Document', profile_my_docs: 'My Documents', profile_language: 'Language',
    logout: 'Logout',
    // Statuses — used across shifts, availability, sick certs, documents, issues everywhere
    status_pending: 'Pending', status_assigned: 'Assigned', status_confirmed: 'Confirmed',
    status_missed: 'Missed', status_worked: 'Worked', status_completed: 'Completed',
    status_approved: 'Approved', status_rejected: 'Rejected', status_open: 'Open', status_resolved: 'Resolved',
    status_upcoming: 'Upcoming', status_active: 'Active', status_expired: 'Expired', status_sick_leave: 'Sick leave', status_not_reported: 'Not reported',
    // Common actions, used across many screens
    btn_submit: 'Submit', btn_cancel: 'Cancel', btn_save: 'Save', btn_edit: 'Edit',
    btn_approve: 'Approve', btn_reject: 'Reject', btn_reply: 'Reply', btn_send: 'Send',
    btn_close: 'Close', btn_clear: 'Clear', btn_attach: 'Attach file',
    // Shifts tab
    shifts_upcoming: 'Upcoming', shifts_completed: 'Completed', shifts_calendar: 'Calendar',
    shifts_ongoing: 'Ongoing', shifts_missed: 'Missed', shifts_ongoing_title: 'Ongoing Shifts', shifts_missed_title: 'Missed Shifts',
    shifts_none_ongoing: 'Nothing ongoing right now.', shifts_none_missed: 'Nothing missed — good!',
    missed_why: 'What happened with this shift?', missed_health_btn: 'Health problem', missed_other_btn: 'Other reason',
    shifts_calendar_view: 'Calendar View', shifts_upcoming_title: 'Upcoming Shifts', shifts_completed_title: 'Completed Shifts',
    shifts_none_this_week: 'No shifts assigned for this week.', shifts_marked_sick: 'Marked as sick leave',
    shifts_worked_history: 'Worked Hours History', shifts_all: 'All', shifts_approved: 'Approved', shifts_needs_approval: 'Needs Approval',
    shifts_nothing_this_month: 'Nothing here for this month.', shifts_logged: 'Logged', shifts_ended_early: 'Ended early',
    shifts_overtime: 'Overtime', shifts_sick_range: 'Sick {from} to {to}',
    shifts_approved_by_manager: 'Approved by manager', shifts_awaiting_review: 'Awaiting manager review',
    shifts_log_hours: 'Log hours', shifts_not_attended: 'Not attended', shifts_edit: 'Edit',
    // Calendar view
    cal_so_far: 'so far', cal_completed: 'completed', cal_approved: 'approved', cal_assigned: 'assigned', cal_cap: 'Cap',
    cal_scheduled: 'Scheduled', cal_worked: 'Worked', cal_absent: 'Absent', cal_sick: 'Sick',
    cal_no_shift: 'No shift on this day.', cal_not_completed: 'not yet completed', cal_mark_absent: 'Mark Absent & Notify', cal_sick_leave: 'Sick leave',
    // Availability tab
    avail_week: 'Week', avail_current: 'current', avail_quick_fill: 'Quick Fill',
    avail_quick_fill_desc: 'Set one time range and apply it to every working day this week at once.', avail_apply_week: 'Apply to week',
    avail_editing: 'Editing', avail_save: 'Save', avail_cancel: 'Cancel',
    avail_remove_confirm: 'Remove this submission and mark the day off instead?', avail_mark_day_off: 'Mark as day off instead',
    avail_day_off: 'Day off', avail_already_submitted: "You've already submitted availability for this week.",
    avail_edit_hint: "Use the ✏️ next to any day above to change it, while it's still Pending.",
    avail_note: 'Note', avail_note_hint: "(optional, applies to this week's submission)", avail_note_placeholder: 'e.g. Prefer morning shifts',
    avail_copy_next: 'Also apply this same pattern to next week', avail_submitted_msg: 'Availability submitted! Manager will assign your shifts.',
    avail_submit_btn: "Submit This Week's Availability",
    // Sick Certificates tab
    sick_notif: 'Your sick certificate ({from} to {to}) was', sick_edit_title: 'Edit Sick Certificate', sick_submit_title: 'Submit Sick Certificate',
    sick_submit_short: 'Submit', sick_covers_desc: "Covers both upcoming and already-completed shifts in this date range — they'll be marked automatically.",
    sick_from: 'Sick from', sick_to: 'Sick to', sick_note_optional: 'Note', sick_note_optional_hint: '(optional)', sick_note_placeholder: 'e.g. Flu, doctor visit',
    sick_replace_cert: 'Replace certificate', sick_upload_cert: 'Upload sick certificate',
    sick_save_changes: 'Save Changes', sick_submit_cert: 'Submit Certificate', sick_my_certs: 'My Certificates', sick_manager_note: 'Manager note',
    // Issues tab
    iss_report_title: 'Report an Issue', iss_select_shift: 'Select Shift', iss_choose_shift: '-- Choose a shift --',
    iss_general: 'General / Not shift-specific', iss_type: 'Issue Type',
    iss_before: 'Before shift', iss_during: 'During shift', iss_after: 'After shift',
    iss_description: 'Description', iss_desc_placeholder: 'Describe the issue...',
    iss_attach_doc: 'Attach document', iss_attach_doc_hint: '(optional — e.g. medical certificate)', iss_choose_file: 'Choose file',
    iss_reported_msg: 'Issue reported. Manager will be notified.', iss_report_btn: 'Report Issue',
    iss_my_issues: 'My Reported Issues', iss_submit_sick_for_date: 'Submit Sick Certificate for This Date',
    iss_reply_placeholder: 'Write a reply...', iss_send_reply: 'Send Reply', iss_manager: 'Manager',
    // Salary tab
    salary_info: 'Salary slips are uploaded by your manager each month. Download your PDF anytime.',
    salary_slips_title: 'Salary Slips', salary_none: 'No salary slips uploaded yet.',
    // Profile tab (remaining)
    prof_employee_label: 'KarmaDal Employee', prof_account_section: 'Account & Profile', prof_app_section: 'App',
    prof_upload_photo: 'Upload Photo (one-time)', prof_photo_once_hint: 'You can only upload this once. Choose a clear photo.',
    prof_photo_change_sent: 'Change request sent to your manager', prof_request_photo_change: 'Request Photo Change',
    prof_shared_by_manager: 'Shared by your manager', prof_no_contract: 'No contract shared yet. Ask your manager to share it from the Team section.',
    prof_min_hrs_week: 'Min hrs / week', prof_max_hrs_week: 'Max hrs / week', prof_hours_not_set: 'Not set by your manager yet.',
    prof_docs_examples: 'e.g. Visa, Certificate of Study, Residence Permit', prof_doc_name: 'Document Name', prof_doc_name_placeholder: 'e.g. Visa / Residence Permit',
    prof_expiry_date: 'Expiry Date', prof_file_optional: 'File', prof_file_optional_hint: '(optional)', prof_submit_doc: 'Submit Document',
    prof_expires: 'Expires', prof_resubmit_hint: '— please submit a corrected copy above.', prof_open_count: 'open',
    // Admin: Overview tab
    adm_company_overview: 'Company Overview', adm_employees: 'Employees', adm_upcoming_shifts: 'Upcoming shifts',
    adm_pending_avail: 'Pending availability', adm_open_issues_stat: 'Open issues',
    adm_working_now: 'Working now', adm_swap_stat: 'Swap requests', adm_leave_stat: 'Leave requests',
    adm_open_issues_title: 'Open Issues', adm_view: 'View', adm_pending_avail_title: 'Pending Availability', adm_assign: 'Assign',
    adm_unreported: 'Unreported Shifts — Likely Missed', adm_days_ago: 'd ago', adm_review: 'Review', adm_recent_shifts: 'Recent Shifts',
    // Admin: Availability + Auto-Assign
    aa_no_employees: 'No employees have', aa_employee_singular: 'employee has', aa_employee_plural: 'employees have',
    aa_submitted_for_week: 'submitted availability for this week —', aa_day_singular: 'day', aa_day_plural: 'days', aa_waiting: 'total, waiting for shift assignment.',
    aa_build_draft: 'Auto-Assign This Week — Build Draft',
    aa_only_builds: 'Only builds shifts for Week {n} ({start} – {end}). Respects each person\'s weekly hour cap and never double-books a day. Nothing is saved until you review and confirm below.',
    aa_draft_title: 'Auto-Assign Draft — Review Before Confirming', aa_discard: 'Discard',
    aa_weekly_totals: 'Weekly Totals After This Draft', aa_cap: 'cap', aa_nothing_to_assign: 'Nothing to assign.',
    aa_skipped: 'Skipped', aa_trimmed_from: 'Trimmed from', aa_remove: 'Remove',
    aa_confirm_assign: 'Confirm & Assign', aa_shift_singular: 'Shift', aa_shift_plural: 'Shifts',
    aa_shifts_by_employee: 'Shifts by Employee', aa_no_shifts_week: 'No shifts assigned for this week yet.',
    aa_search_placeholder: '🔍 Search or browse employees...', aa_no_matches: 'No matches', aa_search_hint: "Search or click above to see an employee's shifts this week.",
    aa_no_avail_week: 'No availability submissions for this week.', aa_submitted_avail: 'Submitted availability',
    aa_date_label: 'Date', aa_available_slots: 'Available slots', aa_already_assigned_date: 'Already assigned for this date:',
    aa_tap_slot: 'Tap a submitted slot to start from it (optional)', aa_assign_time: 'Assign shift time (you can shorten the range)',
    aa_this_shift: 'This shift', aa_today: 'Today', aa_of_ref: 'of 8h reference', aa_over: 'over', aa_left: 'left',
    aa_this_week: 'This week', aa_of_cap: 'of', aa_no_weekly_cap: 'no weekly cap set', aa_this_month_far: 'This month so far', aa_weeks4: '4 weeks',
    aa_outside_avail: "Outside {name}'s given availability", aa_overlaps: 'Overlaps with an already-assigned shift', aa_overlaps_adjust: '— adjust the time to avoid double-booking',
    aa_over_daily: '{name} would work {mins} today (across split shifts) — over the standard 8h workday',
    aa_over_weekly: 'This would put {name} at {mins} this week — over their {cap}h cap',
    aa_over_long: 'This single shift is over 10 hours — double-check the times are correct',
    aa_confirm_assignment: 'Confirm Assignment', aa_assign_another: 'Assign Another Shift to', aa_assign_shift_to: 'Assign Shift to',
    // Admin: Shifts tab (overview/calendar sub-tabs + all shifts)
    sh_all_shifts: 'All Shifts', sh_overview: 'Overview', sh_calendar: 'Calendar', sh_hours_overview: 'Hours Overview',
    sh_dayview: 'Day View', sh_day_mode: 'Day', sh_week_mode: 'Week', sh_no_shifts_day: 'No shifts scheduled for this day.',
    sh_upcoming_color: 'Upcoming', sh_ongoing_color: 'Ongoing now', sh_worked_color: 'Worked', sh_missed_color: 'Missed', sh_unreported_color: 'Unreported',
    sh_needs_review: 'needs review', sh_week: 'Week', sh_month: 'Month',
    sh_employee_calendar: 'Employee Calendar', sh_select_employee: '-- Select employee --',
    sh_mark_absent_title: "Mark {name}'s {date} shift as absent", sh_mark_absent_desc: 'This will also start a conversation with {name} (via Issues) asking what happened.',
    sh_optional_note: 'Optional note...', sh_confirm_mark_absent: 'Confirm — Mark Absent & Notify',
    sh_shifts_label: 'Shifts', sh_cat_all: 'All', sh_cat_upcoming: 'Upcoming', sh_cat_ongoing: 'Ongoing', sh_cat_review: 'Needs Review',
    sh_cat_cert: 'Awaiting Certificate', sh_cat_unexplained: 'Unexplained/Other', sh_cat_approved: 'Approved',
    sh_nothing_category: 'Nothing in this category right now.',
    sh_worked_label: 'Worked', sh_approved_paren: '(Approved)', sh_pending_review_paren: '(Pending review)',
    sh_overtime_label: 'Overtime', sh_ended_early_label: 'Ended early', sh_scheduled_until: 'scheduled until',
    sh_approved_dot: '· Approved', sh_needs_review_dot: '· Needs review', sh_reason: 'Reason',
    sh_missed_dash: 'Missed', sh_acknowledged_paid: 'Acknowledged & paid', sh_acknowledged_not_paid: 'Acknowledged (not paid)',
    sh_unreported_likely: 'Unreported — likely missed', sh_attendance_not_reported: 'Attendance not yet reported',
    sh_accept: 'Accept', sh_acknowledge_btn: 'Acknowledge', sh_approve_pay_btn: 'Approve Pay', sh_reopen_btn: 'Reopen', sh_discuss_btn: 'Discuss', sh_mark_absent_btn: 'Mark Absent',
    sh_reply_to: 'Reply to {name} about this {date} shift', sh_reply_hint_health: 'e.g. "Please submit your sick certificate once you have your appointment, and we\'ll review it then."',
    sh_reply_hint_other: 'e.g. "Please submit proof or explain further — this hasn\'t been approved yet."',
    sh_type_reply: 'Type your reply...', sh_send_reply_btn: 'Send Reply', sh_becomes_conversation: 'This becomes a real conversation in Issues — the employee can reply back, and you can continue it there anytime.',
    sh_mark_absent_row_title: "Mark {name}'s {date} shift as absent", sh_mark_absent_row_desc: 'This will also start a conversation with {name} (via Issues) asking what happened — if it turns out to be illness, you can switch it to sick leave afterward.',
    sh_correct_hours: 'Correct worked hours for {name}', sh_save_approve: 'Save & Approve',
    // Admin: Team tab
    tm_issues: 'Issues', tm_open: 'open', tm_sick_certs: 'Sick Certs', tm_pending: 'pending', tm_salary: 'Salary', tm_slip: 'slip', tm_slips: 'slips',
    tm_add_employee: 'Add Employee', tm_full_name: 'Full Name', tm_name_placeholder: 'e.g. Maria Schmidt',
    tm_email: 'Email', tm_email_placeholder: 'their real email — used to log in',
    tm_job_title: 'Job Title', tm_job_title_hint: '(e.g. Sales Executive, Team Leader)', tm_job_title_placeholder: 'e.g. Sales Executive',
    tm_join_date: 'Join Date', tm_salary_field: 'Salary', tm_salary_hint: '(optional — can also add later)', tm_salary_placeholder: 'e.g. €13.50/hour or €2,400/month',
    tm_password_note: "They'll get an email to set their own password — you won't see or choose it. Photo, contract, hour caps, and documents can be added afterward from their profile.",
    tm_creating_account: 'Creating account...', tm_add_employee_btn: 'Add Employee',
    tm_bulk_import: 'Bulk Import (CSV)', tm_import_btn: '+ Import',
    tm_bulk_desc: 'Add several employees at once from a spreadsheet export — all automatically tied to your branch, same as Add Employee.',
    tm_download_template: 'Download CSV Template', tm_choose_csv: 'Choose CSV File',
    tm_preview: 'Preview', tm_ready: 'ready', tm_with_issues: 'with issues', tm_row: 'Row', tm_joins: 'joins',
    tm_ready_badge: 'Ready', tm_create_accounts: 'Create', tm_account_singular: 'Account', tm_account_plural: 'Accounts',
    tm_creating_accounts: 'Creating accounts...', tm_of: 'of',
    tm_employees_created: 'employee', tm_employees_created_pl: 'employees', tm_created_desc: 'created — each will receive an email to set their password.',
    tm_rows_skipped: 'row', tm_rows_skipped_pl: 'rows', tm_skipped: 'skipped',
    tm_employees_title: 'Employees', tm_search_placeholder: '🔍 Search or browse employees...', tm_no_matches: 'No matches',
    tm_active: 'Active', tm_deactivated: 'Deactivated', tm_no_employees_status: 'No {status} employees.', tm_search_to_select: '🔍 Search or click above to select an employee.',
    tm_wk: 'Wk', tm_mo: 'Mo', tm_needs_review_short: 'Needs review',
    tm_employment_details: 'Employment Details', tm_not_set: 'Not set', tm_edit_employment: 'Edit Employment Details', tm_dob: 'Date of Birth',
    tm_reactivate: 'Reactivate', tm_deactivate: 'Deactivate', tm_deactivate_confirm: "Deactivate {name}? Their history stays intact, but they'll move to the Deactivated list.",
    tm_account_profile: 'Account & Profile', tm_photo: 'Photo', tm_upload_photo_btn: 'Upload Photo',
    tm_photo_requested: 'Employee requested a photo change', tm_update_photo: 'Update Photo', tm_photo_set: 'Photo set. Employee must request a change to update it.',
    tm_contract: 'Contract', tm_shared: 'Shared', tm_not_shared: 'Not shared', tm_download: 'Download', tm_share_employee: 'Share with Employee', tm_replace: 'Replace', tm_upload_contract: 'Upload Contract PDF',
    tm_contract_hour_caps: 'Contract & Hour Caps', tm_contract_type: 'Contract Type',
    tm_ct_minijob: 'Mini-job', tm_ct_werkstudent: 'Werkstudent', tm_ct_parttime: 'Part-time', tm_ct_fulltime: 'Full-time', tm_ct_fulltime_ext: 'Full-time Extended', tm_ct_custom: 'Custom',
    tm_minijob_desc: 'Mini-jobs are capped by earnings, not hours — €603/month (2026 limit).',
    tm_minijob_hint: "This limit rises with Germany's minimum wage — worth double-checking it's still current each year. Set their weekly hours directly below, based on what keeps them under this limit at their pay rate.",
    tm_optional_wage: 'Optional — their hourly wage, just to help you work out the right hours below', tm_wage_placeholder: 'e.g. 13.50',
    tm_pay_type: 'Pay Type', tm_pay_hourly: 'Per Hour', tm_pay_gross: 'Gross Salary',
    tm_gross_salary_label: 'Monthly gross salary (€)', tm_gross_salary_placeholder: 'e.g. 2500',
    tm_gross_salary_hint: 'Payable amount is calculated against their Max hrs/week × 4 as full-time equivalent hours.',
    tm_keeps_under_cap: 'h/week keeps them under the earnings cap at this wage — just a reference, doesn\'t set anything automatically.',
    tm_min_hrs_week: 'Min hrs/week', tm_max_hrs_week: 'Max hrs/week', tm_min_placeholder: 'e.g. 10', tm_max_placeholder: 'e.g. 20',
    tm_per_month: 'h/month (4 weeks)', tm_over20_werkstudent: 'Over 20h/week — may affect Werkstudent student-status benefits',
    tm_over48: "Over 48h/week — above Germany's standard legal working-time ceiling",
    tm_hrs_week: 'hrs/week', tm_edit_btn: 'Edit', tm_set_btn: 'Set',
    tm_payroll: 'Payroll: Worked & Sick Hours', tm_approved_hours_month: 'Approved hours this month', tm_approved_hours_hint: "Only hours you've accepted — the figure to actually use for payroll.",
    tm_sick_covered_month: 'Sick-covered scheduled hours this month', tm_sick_covered_hint: 'From approved sick certificates. Whether these count as paid hours depends on your own policy — this is the raw figure for you to apply it to.',
    tm_submitted_docs: 'Submitted Documents', tm_no_docs: 'No documents submitted yet.',
    tm_approve_btn: 'Approve', tm_undo_btn: 'Undo', tm_reject_btn: 'Reject',
    tm_note_approve_placeholder: 'Optional note...', tm_note_reject_placeholder: 'e.g. Photo is blurry — please resubmit a clearer copy',
    tm_confirm_approval: 'Confirm Approval', tm_confirm_rejection: 'Confirm Rejection',
    tm_other: 'Other', tm_no_issues: 'No issues reported.', tm_sick_certificates: 'Sick Certificates',
    // Admin: Issues tab
    aiss_no_issues_yet: 'No issues reported yet.', aiss_open: 'Open', aiss_resolved: 'Resolved', aiss_calendar: 'Calendar', aiss_issues_calendar: 'Issues Calendar',
    aiss_search_placeholder: '🔍 Search by ticket number or employee name...',
    feature_search_placeholder: '🔍 Search features...',
    fixed_schedule_title: 'Fixed Schedule Settings', fixed_schedule_hint: 'Sets one shared shift pattern used by employees on Fixed scheduling.',
    fixed_start_time: 'Start Time', fixed_end_time: 'End Time', fixed_break_start: 'Break Start', fixed_break_end: 'Break End',
    fixed_work_days: 'Working Days (for Fixed — Standard)', fixed_save_btn: 'Save Fixed Schedule',
    day_monday: 'Mon', day_tuesday: 'Tue', day_wednesday: 'Wed', day_thursday: 'Thu', day_friday: 'Fri', day_saturday: 'Sat', day_sunday: 'Sun',
    sched_mode_title: 'Scheduling Mode', sched_mode_hint: 'How this employee gets scheduled.',
    sched_mode_availability: 'Availability-Based (submits weekly availability)', sched_mode_fixed_standard: 'Fixed — Standard (same days every week)', sched_mode_fixed_dayoff: 'Fixed — Choose Day Off (Sunday off, picks 1 more day weekly)',
    sched_mode_rotation: 'Multi-Shift Rotation (rotates through shift types)',
    rotation_title: 'Multi-Shift Rotation', rotation_hint: 'Define named shift types (e.g. Frühschicht, Spätschicht, Nachtschicht) with their own hours and pay premium — employees rotate forward through them automatically.',
    rotation_shift_label: 'Shift', rotation_shift_name_placeholder: 'e.g. Frühschicht', rotation_premium_label: 'Pay Premium (%)',
    rotation_add_shift_btn: 'Add Shift Type', rotation_days_label: 'Days Per Shift Before Rotating', rotation_days_hint: 'How many days an employee stays on each shift type before moving to the next.',
    rotation_rest_warning: 'Warning: cycling from {last} back to {first} leaves only {hours}h of rest — German law requires at least 11h between shifts.',
    rotation_save_btn: 'Save Rotation', rotation_start_date_label: 'Rotation Start Date',
    rotation_generate_title: 'Generate Rotation Shifts', rotation_generate_hint: "Creates this week's shifts for every employee on Multi-Shift Rotation, based on their current position in the cycle.",
    rotation_generate_btn: 'Generate for This Week',
    fixed_generate_title: 'Generate Fixed Shifts', fixed_generate_hint: 'Creates real shifts for this week for every employee on Fixed scheduling. Safe to run again — never creates duplicates.',
    fixed_generate_btn: 'Generate for This Week', fixed_generate_result: '{n} shift(s) created.',
    dayoff_picker_title: 'Choose Your Day Off', dayoff_picker_hint: "Sunday's always off. Pick one more day off for next week.",
    dayoff_picker_placeholder: '-- Select a day --', dayoff_picker_saved: 'Saved for next week',
    dayoff_picker_full: 'full', fixed_max_dayoff: 'Max People Off Per Day', fixed_max_dayoff_hint: '0 = no limit. Applies only to employees on "Fixed — Choose Day Off".',
    fixed_save_success: 'Saved successfully.',
    weekoff_swap_open_btn: 'Swap Week Off with Someone', weekoff_swap_pick_hint: "Pick a colleague to trade days off with — you'll get their day, they'll get yours.",
    weekoff_swap_none_available: 'No colleagues with a different day off to swap with right now.',
    weekoff_swap_has_off: 'off on {day}', weekoff_swap_status_awaiting_colleague: 'Waiting for {name} to respond.', weekoff_swap_status_awaiting_admin: 'Both agreed — waiting on your manager to finalize.',
    weekoff_swap_incoming_title: '{name} wants to swap week off with you', weekoff_swap_incoming_detail: "You'd get {yourNew} off instead of {yourOld}.",
    aiss_raised: 'Raised', aiss_resolved_date: 'Resolved', aiss_reply: 'reply', aiss_replies: 'replies',
    aiss_cert_submitted: 'Sick certificate submitted', aiss_review_sick: 'Review in Sick Certificates',
    aiss_no_cert_yet: 'No sick certificate submitted for this date yet.',
    aiss_you_manager: 'You (Manager)', aiss_no_replies: 'No replies yet — ask the employee for more details if needed.',
    aiss_reply_placeholder: 'Reply to employee, or ask for more info...', aiss_send_reply: 'Send Reply',
    aiss_mark_resolved: 'Mark as Resolved', aiss_issue_resolved: 'Issue resolved', aiss_reopen: 'Reopen',
    // Admin: Salary tab
    asal_upload_slip: 'Upload Salary Slip', asal_employee: 'Employee', asal_select_employee: '-- Select employee --',
    asal_month: 'Month', asal_month_placeholder: 'e.g. July 2026', asal_hours_worked: 'Hours worked', asal_hours_placeholder: 'e.g. 86',
    asal_net_pay: 'Net pay', asal_net_pay_placeholder: 'e.g. €1,240', asal_upload_pdf: 'Upload PDF', asal_optional: '(optional)',
    asal_choose_pdf: 'Choose PDF file', asal_slip_uploaded: 'Salary slip uploaded!', asal_upload_btn: 'Upload Salary Slip',
    asal_all_slips: 'All Salary Slips', asal_none_uploaded: 'No salary slips uploaded yet.', asal_no_pdf: 'No PDF',
    asal_bulk_upload: 'Bulk Upload', asal_bulk_hint: 'Select multiple payslip PDFs at once. We\'ll try to match each to the right employee by filename — check and correct any that need it before submitting.',
    asal_choose_files: 'Choose PDF Files', asal_no_match: '-- Select employee --', asal_submit_bulk: 'Upload All Matched', asal_files_selected: '{count} files selected',
    pe_title: 'Payroll Export', pe_disclaimer: 'Gross pay only — hourly rate × approved hours. This does not calculate tax, social security, or net pay. Export and hand to your accountant or payroll system for that.',
    pe_regular_hours: 'Regular hours', pe_sick_hours: 'Paid sick hours', pe_rate: 'Rate/hr', pe_gross: 'Gross pay',
    pe_no_rate: 'Set hourly rate to calculate', pe_export_csv: 'Export CSV', pe_export_xlsx: 'Export Excel', pe_no_employees: 'No employees to show for this month.',
    pe_send_to_hq: 'Send to HQ', pe_sent_to_hq_success: 'Sent to HQ successfully.',
    ct_title: 'Contract Templates', ct_add: 'Add Template', ct_none: 'No templates added yet.', ct_no_templates_yet: 'No templates yet — add one in Team → Contract Templates first.',
    ct_hint: 'Upload your own Word (.docx) contract, exactly as you use it today. Anywhere you\'d normally type a name or date, type one of these instead: {{name}}, {{jobTitle}}, {{joinDate}}, {{dob}}, {{contractType}}, {{minHours}}, {{maxHours}}, {{hourlyRate}}, {{grossSalary}}, {{salary}}, {{companyName}}, {{date}} — they\'ll be replaced automatically with each employee\'s real details, keeping your original formatting intact.',
    ct_name: 'Template Name', ct_name_placeholder: 'e.g. Minijob Contract', ct_content: 'Contract Text',
    ct_content_placeholder: 'e.g. This employment contract is between {{companyName}} and {{name}}, starting {{joinDate}}...', ct_choose_docx: 'Choose .docx file',
    ct_save: 'Save Template', ct_delete_confirm: 'Delete this template? This cannot be undone.',
    ct_generate: 'Generate Contract', ct_select_template: '-- Select a template --', ct_generate_btn: 'Generate (Preview First)',
    ct_signed: 'Signed', ct_not_signed: 'Not signed yet', ct_sign_contract: 'Sign Contract', ct_type_full_name: 'Type your full name to sign',
    ct_sign_confirm: 'By typing my name below, I confirm I have read and agree to this contract.', ct_sign_btn: 'Confirm & Sign', ct_signed_on: 'Signed by {name} on {date}',
    ct_you_signed_on: 'You signed as {name} on {date}', ct_employer_signed_on: 'Employer signed by {name} on {date}',
    ct_fully_executed: 'Fully executed — both parties have signed', ct_awaiting_employer: "Waiting for the employer's signature",
    ct_type_signature: 'Type Name', ct_upload_signature: 'Upload Signature', ct_choose_image: 'Choose Signature Image',
    ct_sign_as_employer: 'Sign as Employer', ct_sign_employer_confirm: 'By signing below, you confirm this contract on behalf of the company.',
    ct_review_btn: 'Review', ct_review_hint: 'This is exactly how your signature will appear. Confirm to finalize, or go back to change it.',
    ct_confirm_sign_btn: 'Confirm & Sign', ct_back_btn: 'Back',
    // Admin: Sick Certificates review tab — the final remaining piece
    asick_none_submitted: 'No sick certificates submitted yet.', asick_pending: 'Pending', asick_approved: 'Approved', asick_rejected: 'Rejected',
    asick_no_cert_attached: 'No certificate attached — approving without proof', asick_your_note: 'Your note',
    asick_approve: 'Approve', asick_reject: 'Reject', asick_undo_rereview: 'Undo — Re-review this decision',
    asick_note_approve: 'Note (optional — e.g. "Get well soon!")', asick_reason_reject: 'Reason for rejecting — e.g. "Please upload a valid medical certificate"',
    asick_get_well: 'Get well soon!', asick_reject_placeholder: 'e.g. No certificate was attached — please upload proof and resubmit',
    asick_reject_hint: 'The employee will see this note and can edit their submission to resubmit — no time limit for a rejected certificate.',
    asick_confirm_approval: 'Confirm Approval', asick_confirm_rejection: 'Confirm Rejection',
    aes_edit_shift: 'Edit Shift', aes_date: 'Date', aes_time_range: 'Time Range', aes_save_changes: 'Save Changes',
    // Home tab notification banners + WorkedHistory — missed on first pass
    wh_alltime_total: 'All-time total',
    hn_new_shift: 'new shift', hn_new_shifts: 'new shifts', hn_assigned_bang: 'assigned!',
    hn_week_assigned_of: 'This week: {mins} assigned of your {cap}h contracted hours',
    hn_shift_not_submitted: 'shift', hn_shifts_not_submitted: 'shifts', hn_still_not_submitted: 'still not submitted',
    hn_oldest: 'Oldest', hn_log_hours_prompt: 'please log your hours (or mark it missed) so your manager can review it. Tap to go to Shifts',
    hn_document: 'document', hn_documents: 'documents', hn_reviewed: 'reviewed',
    // Log Hours / Mark Missed forms — final remaining gap
    lh_edit_hours: 'Edit the hours you worked', lh_log_hours: 'Log the hours you actually worked', lh_scheduled: 'scheduled',
    lh_total: 'Total', lh_exceeds: "This goes past your shift's scheduled end ({end}). Set the end time to {end} or earlier, and log any extra time as Overtime below.",
    lh_ended_early_warn: "You're ending this shift early (scheduled until {end}) — only {mins} will count. Please explain why below before you can submit.",
    lh_reason_early: 'Reason for leaving early', lh_what_happened: 'What happened?',
    lh_illness_hint: 'If this was due to illness, consider submitting a Sick Certificate instead so the full shift can be credited.',
    lh_add_overtime: '+ Add Overtime', lh_overtime_after: 'Overtime (after your shift ends)', lh_remove: 'Remove',
    lh_ot_overlaps: 'Overtime overlaps your regular shift — it must start at or after {end}.', lh_overtime_label2: 'Overtime',
    lh_swipe_ot: 'Swipe right to submit (+ overtime)', lh_swipe_complete: 'Swipe right to complete',
    lh_why_missed: 'Why did you miss this shift?', lh_health_problem: 'Health problem', lh_other: 'Other',
    lh_add_details: 'Add details (optional)', lh_current: 'Current', lh_submit_btn: 'Submit',
  },
  de: {
    nav_home: 'Startseite', nav_shifts: 'Schichten', nav_avail: 'Verfügbarkeit', nav_profile: 'Profil',
    nav_overview: 'Übersicht', nav_team: 'Team', nav_sick: 'Krankmeldungen', nav_leave: 'Urlaub', nav_hiring: 'Einstellung',
    hiring_postings_title: 'Stellenausschreibungen', hiring_new_posting_btn: 'Neue Stellenausschreibung', hiring_job_title: 'Stellentitel', hiring_job_title_placeholder: 'z. B. Lieferfahrer',
    hiring_role_placeholder: 'z. B. Fahrer, Koch, Kassierer', hiring_location: 'Standort', hiring_location_placeholder: 'z. B. Filiale Berlin', hiring_description: 'Beschreibung',
    hiring_publish_btn: 'Ausschreibung veröffentlichen', hiring_company_code_hint: 'Bewerber nutzen diesen Firmencode, um Ihre Stellen zu finden',
    hiring_close_btn: 'Schließen', hiring_reopen_btn: 'Wieder öffnen',
    hiring_stage_applied: 'Beworben', hiring_stage_interview: 'Interview', hiring_stage_hired: 'Eingestellt', hiring_stage_rejected: 'Abgelehnt',
    hiring_move_interview: 'Zu Interview verschieben', hiring_hire_btn: 'Einstellen', hiring_hired_label: 'Eingestellt — jetzt Mitarbeiter',
    hiring_interview_rounds: 'Anzahl der Interview-Runden', hiring_rounds_label: 'Runde(n)', hiring_round_label: 'Runde',
    hiring_tab_postings: 'Stellenausschreibungen', hiring_tab_applied: 'Beworben', hiring_tab_interview: 'Interview', hiring_tab_hired: 'Eingestellt', hiring_tab_rejected: 'Abgelehnt',
    hiring_no_postings: 'Noch keine Stellenausschreibungen.', hiring_no_applicants: 'Noch niemand hier.', hiring_next_round_btn: 'Nächste Runde', hiring_of: 'von',
    iss_escalate_btn: 'Nicht zufrieden? An HR eskalieren', iss_escalate_confirm: 'Dies sendet Ihr Anliegen zur erneuten Prüfung an HR. Fortfahren?', iss_escalated_label: 'An HR eskaliert — sie melden sich hier zurück.',
    hiring_tab_complaints: 'Beschwerden', hiring_complaints_hint: 'Anliegen, die Mitarbeiter eskaliert haben, weil die Antwort des Filialleiters nicht ausreichte.',
    hiring_no_complaints: 'Aktuell keine eskalierten Beschwerden.', hiring_mark_resolved: 'Als gelöst markieren',
    hiring_round_names_label: 'Interview-Runden', hiring_round_names_hint: 'Benennen Sie jede Runde für diese Stelle — z. B. "HR-Runde", "Manager-Runde".',
    hiring_add_round_btn: 'Runde hinzufügen', hiring_open_postings: 'Offen', hiring_closed_postings: 'Geschlossen',
    hiring_selected_label: 'ausgewählt', hiring_send_message_btn: 'Nachricht senden', hiring_message_placeholder: 'z. B. Sie wurden für die nächste Interviewrunde ausgewählt.',
    hiring_message_hint: 'Der Name jeder Person wird automatisch hinzugefügt — Sie müssen ihn nicht selbst schreiben.',
    hiring_send_now_btn: 'Senden', hiring_mail_subject: 'Update zu Ihrer Bewerbung — {job}',
    hiring_hr_access_title: 'Zugang zum Hiring-Portal', hiring_hr_access_hint: 'Geben Sie jemandem einen eigenen Zugang für die Personalgewinnung — getrennt vom Filialleiter-Konto.',
    hiring_add_hr_btn: 'HR-Zugang geben', hiring_create_hr_btn: 'Zugang erstellen',
    hq_title: 'HQ-Portal', hq_company_overview: 'Unternehmensübersicht', hq_branches: 'Filialen',
    hq_branches_title: 'Filialen & Filialleiter', hq_add_bm_btn: 'Filialleiter hinzufügen', hq_branch_id: 'Filial-ID',
    hq_branch_id_placeholder: 'z. B. berlin-mitte', hq_create_bm_btn: 'Filialleiter erstellen', hq_employees_in_branch: 'Mitarbeiter',
    hq_no_employees_yet: 'Noch keine Mitarbeiter dieser Filiale zugeordnet.', hq_upcoming_in_branch: 'bevorstehende Schichten in dieser Filiale',
    hq_payroll_title: 'Monatliche Gehaltsabrechnung — Alle Filialen', hq_payroll_hint: 'Filialen senden ihre monatliche Gehaltsabrechnung hierher zur Prüfung und Bearbeitung.',
    hq_total_gross: 'Gesamt Brutto', hq_submitted_by: 'gesendet von',
    hq_search_branches: '🔍 Filialen suchen...', hq_search_employees: '🔍 Mitarbeiter in dieser Filiale suchen...',
    hq_team_title: 'HR- & Filialleiter-Zugang', hq_team_hint: 'Alle mit HR- oder Filialleiter-Zugang in Ihrem Unternehmen.',
    hq_team_none: 'Noch keine HR- oder Filialleiter-Konten erstellt.', hq_search_team: 'Nach Name oder E-Mail suchen...',
    hq_role_hr: 'HR', hq_role_bm: 'Filialleiter',
    app_tagline: 'Intelligentes Workforce Management',
    hq_deactivated_label: 'Zugang deaktiviert', hq_deactivate_btn: 'Deaktivieren', hq_reactivate_btn: 'Reaktivieren',
    hq_deactivate_confirm: 'Zugang von {name} deaktivieren? Kein Login mehr möglich, bis reaktiviert.',
    hq_reactivate_confirm: 'Zugang von {name} reaktivieren? Login ist sofort wieder möglich.',
    login_deactivated_title: 'Zugang deaktiviert', login_deactivated_hint: 'Ihr Zugang wurde deaktiviert. Bitte kontaktieren Sie Ihr Unternehmen für Details.', login_dismiss: 'Schließen',
    leave_apply_title: 'Urlaub beantragen', leave_apply_short: 'Beantragen', leave_edit_title: 'Urlaubsantrag bearbeiten',
    leave_note_placeholder: 'Optionale Notiz', leave_submit_btn: 'Antrag senden',
    leave_tab_pending: 'Ausstehend', leave_tab_approved: 'Genehmigt', leave_tab_rejected: 'Abgelehnt',
    leave_none_in_tab: 'Hier noch nichts.', leave_cancel_confirm: 'Diesen Urlaubsantrag stornieren?',
    leave_used_title: 'Genommener Urlaub', leave_days_unit: 'Tage',
    leave_requests_title: 'Urlaubsanträge', leave_used_so_far: '{count} Tage dieses Jahr genommen',
    title_issues: 'Probleme', title_salary: 'Gehalt',
    login_employee: 'Mitarbeiter', login_manager: 'Manager', login_email: 'E-Mail-Adresse', login_password: 'Passwort',
    login_signin: 'Anmelden', login_forgot: 'Passwort vergessen?', login_language: 'Sprache',
    login_browse_jobs: 'Offene Stellen ansehen',
    login_signup_link: 'Neu hier? Konto erstellen',
    signup_back_to_login: 'Zurück zur Anmeldung', signup_title: 'Konto erstellen', signup_hint: 'Einmal registrieren, um Stellen bei Unternehmen mit KarmaDal zu durchsuchen und sich zu bewerben.',
    signup_error_missing: 'Bitte alle Felder ausfüllen.', signup_error_password: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
    signup_password_hint: 'Mindestens 6 Zeichen.', signup_create_btn: 'Konto erstellen',
    jobseeker_title: 'Meine Bewerbungen', jobseeker_complete_profile: 'Profil vervollständigen', jobseeker_profile_hint: 'Fügen Sie Ihre Telefonnummer und Ihren Lebenslauf hinzu, bevor Sie sich bewerben.',
    jobseeker_phone: 'Telefonnummer', jobseeker_phone_placeholder: '+49 ...', jobseeker_resume: 'Lebenslauf',
    jobseeker_save_profile_btn: 'Profil speichern', jobseeker_profile_incomplete: 'Bitte Telefonnummer und Lebenslauf hinzufügen.',
    jobseeker_phone_taken: 'Diese Telefonnummer ist bereits mit einem anderen Konto verknüpft.', jobseeker_complete_first: 'Profil vervollständigen, um sich zu bewerben',
    jobseeker_signup_prompt_title: 'Kostenloses Konto erstellen, um sich zu bewerben', jobseeker_signup_prompt_hint: 'Einmal registrieren, um sich für {job} zu bewerben — und für jede weitere Stelle auf KarmaDal in Zukunft.',
    jobseeker_browse_hint: 'Jede offene Stelle von jedem Unternehmen, das KarmaDal nutzt, an einem Ort.', jobseeker_search_placeholder: 'Nach Titel, Rolle, Standort oder Unternehmen suchen...',
    jobseeker_none_open_anywhere: 'Aktuell keine offenen Stellen — schauen Sie bald wieder vorbei.',
    choice_title: 'Welchen Bereich heute?', choice_hint: 'Sie haben zwei Arten von Zugang auf diesem Konto — wählen Sie, wohin Sie möchten.',
    choice_employee_hint: 'Ihr Arbeitskonto', choice_jobs_hint: 'Offene Stellen durchsuchen und sich bewerben',
    jobs_back_to_login: 'Zurück zur Anmeldung', jobs_portal_title: 'Offene Stellen', jobs_portal_hint: 'Geben Sie den Firmencode ein, den Sie von der Stellenausschreibung erhalten haben.',
    jobs_company_code: 'Firmencode', jobs_company_code_placeholder: 'z. B. oprisa2024', jobs_find_btn: 'Stellen finden', jobs_not_found: 'Keine offenen Stellen für diesen Firmencode gefunden.',
    jobs_apply_btn: 'Bewerben', jobs_none_open: 'Aktuell keine offenen Stellen.', jobs_applying_for: 'Bewerbung für',
    jobs_your_name: 'Ihr Name', jobs_your_email: 'Ihre E-Mail', jobs_your_phone: 'Telefon (optional)', jobs_your_note: 'Anschreiben (optional)',
    jobs_submit_btn: 'Bewerbung senden', jobs_submit_error: 'Etwas ist schiefgelaufen — bitte erneut versuchen.',
    jobs_success_title: 'Bewerbung gesendet', jobs_success_hint: 'Der Arbeitgeber prüft Ihre Bewerbung und meldet sich bei einer Übereinstimmung.',
    login_reset_title: 'Passwort zurücksetzen', login_reset_text: 'Bitte kontaktieren Sie Ihren Manager, um Ihr Passwort zurückzusetzen.', login_close: 'Schließen',
    login_error: 'Bitte E-Mail und Passwort eingeben', login_error_invalid: 'Ungültige E-Mail oder Passwort',
    home_overview: 'Übersicht', home_upcoming: 'Bevorstehende Schichten', home_completed: 'Abgeschlossene Schichten',
    home_pending_avail: 'Ausstehende Verfügbarkeit', home_open_issues: 'Offene Probleme',
    home_worked_hours: 'Meine gearbeiteten Stunden', home_this_week: 'Diese Woche', home_this_month: 'Diesen Monat',
    home_upcoming_shifts: 'Bevorstehende Schichten', home_no_upcoming: 'Keine bevorstehenden Schichten. Reichen Sie Ihre Verfügbarkeit ein!',
    home_current_shift: 'Aktuelle Schicht', home_next_shift: 'Nächste Schicht',
    swap_request_btn: 'Schichttausch anfragen', swap_pending: 'Tauschanfrage ausstehend', swap_request_title: 'Tausch für {date} anfragen',
    swap_note_placeholder: 'Optional — wen Sie bevorzugen würden oder warum (Manager bestätigt mit allen Beteiligten)', swap_submit_btn: 'Anfrage senden',
    swap_requests_title: 'Schichttausch-Anfragen', swap_no_requests: 'Aktuell keine Tauschanfragen.',
    swap_approve_btn: 'Als erledigt markieren', swap_decline_btn: 'Ablehnen', swap_resolved: 'Erledigt', swap_declined: 'Abgelehnt',
    swap_status_pending: 'Sie haben einen Tausch für diese Schicht angefragt — wartet auf Ihren Manager.', swap_status_resolved: 'Ihre Tauschanfrage wurde erledigt.', swap_status_declined: 'Ihre Tauschanfrage wurde abgelehnt.',
    swap_pick_colleague: 'Mit wem möchten Sie tauschen?', swap_pick_colleague_placeholder: '-- Kollegen auswählen --',
    swap_incoming_title: '{name} möchte eine Schicht mit Ihnen tauschen', swap_accept_btn: 'Annehmen', swap_reject_btn: 'Ablehnen',
    swap_both_agreed: 'Beide Mitarbeiter haben zugestimmt', swap_status_declined_colleague: '{name} hat diesen Tausch abgelehnt.',
    notif_title: 'Benachrichtigungen', notif_none: 'Sie sind auf dem neuesten Stand.',
    notif_new_shift: 'Neue Schicht zugewiesen', notif_sick_reviewed: 'Krankmeldung geprüft', notif_doc_reviewed: 'Dokument geprüft',
    notif_swap_incoming: 'möchte eine Schicht mit Ihnen tauschen', notif_swap_result: 'Tauschanfrage aktualisiert', notif_leave_result: 'Urlaubsantrag aktualisiert',
    notif_pending_avail: 'hat Verfügbarkeit eingereicht', notif_pending_sick: 'hat eine Krankmeldung eingereicht',
    notif_pending_swap: 'beide haben zugestimmt, wartet auf Ihre Genehmigung', notif_pending_leave: 'hat Urlaub beantragt',
    notif_issue_reply: 'Neue Antwort auf Ihr Problem', notif_contract_signed: 'Ihr Vertrag wurde gegengezeichnet', notif_new_slip: 'Neue Gehaltsabrechnung verfügbar',
    err_signature_generic: 'Etwas ist beim Einbetten der Unterschrift schiefgelaufen: {err}. Bitte erneut versuchen.',
    err_contract_not_uploaded: 'PDF wurde vom Manager noch nicht hochgeladen. Bitte später erneut prüfen.',
    err_signature_employer: 'Etwas ist beim Einbetten der Unterschrift schiefgelaufen: {err}. Die Unterschrift wurde NICHT gespeichert — bitte erneut versuchen.',
    err_old_template: 'Diese Vorlage wurde erstellt, bevor der .docx-Upload hinzugefügt wurde — bitte löschen und erneut als echte Word-Datei hinzufügen.',
    err_contract_generate: 'Etwas ist bei der Vertragserstellung schiefgelaufen: {err}. Prüfen Sie, ob die Platzhalter der Vorlage genau übereinstimmen (z. B. {{name}}), und versuchen Sie es erneut.',
    confirm_reset_shift: 'Schicht von {employee} am {date} zurück auf "noch nicht gemeldet" setzen? Dies löscht den aktuellen Anwesenheitsdatensatz.',
    confirm_remove_shift: 'Diese Schicht entfernen?',
    brand_color_title: 'Markenfarbe', brand_color_hint: 'Legt die Akzentfarbe fest, die in der gesamten App für Ihr Unternehmen verwendet wird.',
    brand_color_tap_hint: 'Auf das Quadrat tippen, um eine Farbe zu wählen', brand_color_apply: 'Farbe übernehmen',
    swap_status_awaiting_colleague: 'Warten auf Antwort von {name}.', swap_status_awaiting_admin: 'Beide haben zugestimmt — wartet auf Ihren Manager zur endgültigen Bestätigung.',
    swap_type_transfer: 'Schicht abgeben', swap_type_transfer_desc: 'Diese Schicht an einen Kollegen abgeben — nichts kommt zurück.',
    swap_type_swap: 'Mit Kollegen tauschen', swap_type_swap_desc: 'Diese Schicht gegen eine ihrer Schichten tauschen — beide arbeiten am Ende eine andere Schicht.',
    swap_back_btn: 'Zurück', swap_incoming_swap_title: '{name} möchte Schichten mit Ihnen tauschen',
    swap_pick_own_shift: 'Welche Ihrer Schichten würden Sie im Gegenzug anbieten?', swap_no_own_shifts: 'Sie haben keine bevorstehenden Schichten anzubieten.',
    swap_pick_own_shift_placeholder: '-- Ihre Schicht auswählen --', swap_confirm_btn: 'Tausch bestätigen',
    profile_photo: 'Profilbild', profile_contract: 'Mein Vertrag', profile_hours: 'Vertragsstunden',
    profile_upload_doc: 'Dokument hochladen', profile_my_docs: 'Meine Dokumente', profile_language: 'Sprache',
    logout: 'Abmelden',
    status_pending: 'Ausstehend', status_assigned: 'Zugewiesen', status_confirmed: 'Bestätigt',
    status_missed: 'Verpasst', status_worked: 'Gearbeitet', status_completed: 'Abgeschlossen',
    status_approved: 'Genehmigt', status_rejected: 'Abgelehnt', status_open: 'Offen', status_resolved: 'Gelöst',
    status_upcoming: 'Bevorstehend', status_active: 'Aktiv', status_expired: 'Abgelaufen', status_sick_leave: 'Krankmeldung', status_not_reported: 'Nicht gemeldet',
    btn_submit: 'Absenden', btn_cancel: 'Abbrechen', btn_save: 'Speichern', btn_edit: 'Bearbeiten',
    btn_approve: 'Genehmigen', btn_reject: 'Ablehnen', btn_reply: 'Antworten', btn_send: 'Senden',
    btn_close: 'Schließen', btn_clear: 'Löschen', btn_attach: 'Datei anhängen',
    shifts_upcoming: 'Bevorstehend', shifts_completed: 'Abgeschlossen', shifts_calendar: 'Kalender',
    shifts_ongoing: 'Laufend', shifts_missed: 'Verpasst', shifts_ongoing_title: 'Laufende Schichten', shifts_missed_title: 'Verpasste Schichten',
    shifts_none_ongoing: 'Aktuell nichts Laufendes.', shifts_none_missed: 'Nichts verpasst — gut so!',
    missed_why: 'Was ist mit dieser Schicht passiert?', missed_health_btn: 'Gesundheitliches Problem', missed_other_btn: 'Anderer Grund',
    shifts_calendar_view: 'Kalenderansicht', shifts_upcoming_title: 'Bevorstehende Schichten', shifts_completed_title: 'Abgeschlossene Schichten',
    shifts_none_this_week: 'Keine Schichten für diese Woche zugewiesen.', shifts_marked_sick: 'Als Krankmeldung markiert',
    shifts_worked_history: 'Verlauf der gearbeiteten Stunden', shifts_all: 'Alle', shifts_approved: 'Genehmigt', shifts_needs_approval: 'Benötigt Genehmigung',
    shifts_nothing_this_month: 'Für diesen Monat nichts vorhanden.', shifts_logged: 'Erfasst', shifts_ended_early: 'Vorzeitig beendet',
    shifts_overtime: 'Überstunden', shifts_sick_range: 'Krank von {from} bis {to}',
    shifts_approved_by_manager: 'Vom Manager genehmigt', shifts_awaiting_review: 'Warten auf Managerprüfung',
    shifts_log_hours: 'Stunden erfassen', shifts_not_attended: 'Nicht erschienen', shifts_edit: 'Bearbeiten',
    cal_so_far: 'bisher', cal_completed: 'erfasst', cal_approved: 'genehmigt', cal_assigned: 'zugewiesen', cal_cap: 'Obergrenze',
    cal_scheduled: 'Geplant', cal_worked: 'Gearbeitet', cal_absent: 'Abwesend', cal_sick: 'Krank',
    cal_no_shift: 'Keine Schicht an diesem Tag.', cal_not_completed: 'noch nicht abgeschlossen', cal_mark_absent: 'Als abwesend markieren & benachrichtigen', cal_sick_leave: 'Krankmeldung',
    avail_week: 'Woche', avail_current: 'aktuell', avail_quick_fill: 'Schnellausfüllung',
    avail_quick_fill_desc: 'Legen Sie einen Zeitraum fest und wenden Sie ihn auf jeden Arbeitstag dieser Woche an.', avail_apply_week: 'Auf Woche anwenden',
    avail_editing: 'Bearbeiten', avail_save: 'Speichern', avail_cancel: 'Abbrechen',
    avail_remove_confirm: 'Diese Angabe entfernen und den Tag stattdessen als frei markieren?', avail_mark_day_off: 'Stattdessen als frei markieren',
    avail_day_off: 'Frei', avail_already_submitted: 'Sie haben Ihre Verfügbarkeit für diese Woche bereits eingereicht.',
    avail_edit_hint: 'Verwenden Sie das ✏️ neben einem Tag oben, um ihn zu ändern, solange er noch ausstehend ist.',
    avail_note: 'Notiz', avail_note_hint: '(optional, gilt für diese Wocheneinreichung)', avail_note_placeholder: 'z. B. Bevorzuge Frühschichten',
    avail_copy_next: 'Dieses Muster auch für die nächste Woche übernehmen', avail_submitted_msg: 'Verfügbarkeit eingereicht! Der Manager wird Ihre Schichten zuweisen.',
    avail_submit_btn: 'Verfügbarkeit für diese Woche einreichen',
    sick_notif: 'Ihre Krankmeldung ({from} bis {to}) wurde', sick_edit_title: 'Krankmeldung bearbeiten', sick_submit_title: 'Krankmeldung einreichen',
    sick_submit_short: 'Einreichen', sick_covers_desc: 'Umfasst sowohl bevorstehende als auch bereits abgeschlossene Schichten in diesem Zeitraum — sie werden automatisch markiert.',
    sick_from: 'Krank von', sick_to: 'Krank bis', sick_note_optional: 'Notiz', sick_note_optional_hint: '(optional)', sick_note_placeholder: 'z. B. Grippe, Arztbesuch',
    sick_replace_cert: 'Bescheinigung ersetzen', sick_upload_cert: 'Krankmeldung hochladen',
    sick_save_changes: 'Änderungen speichern', sick_submit_cert: 'Bescheinigung einreichen', sick_my_certs: 'Meine Bescheinigungen', sick_manager_note: 'Manager-Notiz',
    iss_report_title: 'Problem melden', iss_select_shift: 'Schicht auswählen', iss_choose_shift: '-- Schicht wählen --',
    iss_general: 'Allgemein / Nicht schichtbezogen', iss_type: 'Problemart',
    iss_before: 'Vor der Schicht', iss_during: 'Während der Schicht', iss_after: 'Nach der Schicht',
    iss_description: 'Beschreibung', iss_desc_placeholder: 'Beschreiben Sie das Problem...',
    iss_attach_doc: 'Dokument anhängen', iss_attach_doc_hint: '(optional — z. B. ärztliches Attest)', iss_choose_file: 'Datei auswählen',
    iss_reported_msg: 'Problem gemeldet. Der Manager wird benachrichtigt.', iss_report_btn: 'Problem melden',
    iss_my_issues: 'Meine gemeldeten Probleme', iss_submit_sick_for_date: 'Krankmeldung für dieses Datum einreichen',
    iss_reply_placeholder: 'Antwort schreiben...', iss_send_reply: 'Antwort senden', iss_manager: 'Manager',
    salary_info: 'Gehaltsabrechnungen werden jeden Monat von Ihrem Manager hochgeladen. Laden Sie Ihr PDF jederzeit herunter.',
    salary_slips_title: 'Gehaltsabrechnungen', salary_none: 'Noch keine Gehaltsabrechnungen hochgeladen.',
    prof_employee_label: 'KarmaDal Mitarbeiter', prof_account_section: 'Konto & Profil', prof_app_section: 'App',
    prof_upload_photo: 'Foto hochladen (einmalig)', prof_photo_once_hint: 'Sie können dies nur einmal hochladen. Wählen Sie ein klares Foto.',
    prof_photo_change_sent: 'Änderungsanfrage an Ihren Manager gesendet', prof_request_photo_change: 'Fotoänderung anfragen',
    prof_shared_by_manager: 'Von Ihrem Manager geteilt', prof_no_contract: 'Noch kein Vertrag geteilt. Bitten Sie Ihren Manager, ihn über den Team-Bereich zu teilen.',
    prof_min_hrs_week: 'Min. Std. / Woche', prof_max_hrs_week: 'Max. Std. / Woche', prof_hours_not_set: 'Von Ihrem Manager noch nicht festgelegt.',
    prof_docs_examples: 'z. B. Visum, Studienbescheinigung, Aufenthaltstitel', prof_doc_name: 'Dokumentname', prof_doc_name_placeholder: 'z. B. Visum / Aufenthaltstitel',
    prof_expiry_date: 'Ablaufdatum', prof_file_optional: 'Datei', prof_file_optional_hint: '(optional)', prof_submit_doc: 'Dokument einreichen',
    prof_expires: 'Läuft ab', prof_resubmit_hint: '— bitte reichen Sie oben eine korrigierte Kopie ein.', prof_open_count: 'offen',
    adm_company_overview: 'Unternehmensübersicht', adm_employees: 'Mitarbeiter', adm_upcoming_shifts: 'Bevorstehende Schichten',
    adm_pending_avail: 'Ausstehende Verfügbarkeit', adm_open_issues_stat: 'Offene Probleme',
    adm_working_now: 'Arbeiten jetzt', adm_swap_stat: 'Tauschanfragen', adm_leave_stat: 'Urlaubsanträge',
    adm_open_issues_title: 'Offene Probleme', adm_view: 'Ansehen', adm_pending_avail_title: 'Ausstehende Verfügbarkeit', adm_assign: 'Zuweisen',
    adm_unreported: 'Nicht gemeldete Schichten — wahrscheinlich verpasst', adm_days_ago: 'T. her', adm_review: 'Prüfen', adm_recent_shifts: 'Letzte Schichten',
    aa_no_employees: 'Kein Mitarbeiter hat', aa_employee_singular: 'Mitarbeiter hat', aa_employee_plural: 'Mitarbeiter haben',
    aa_submitted_for_week: 'die Verfügbarkeit für diese Woche eingereicht —', aa_day_singular: 'Tag', aa_day_plural: 'Tage', aa_waiting: 'insgesamt, wartet auf Schichtzuweisung.',
    aa_build_draft: 'Diese Woche automatisch zuweisen — Entwurf erstellen',
    aa_only_builds: 'Erstellt nur Schichten für Woche {n} ({start} – {end}). Respektiert die wöchentliche Stundenobergrenze jeder Person und bucht nie einen Tag doppelt. Nichts wird gespeichert, bis Sie unten prüfen und bestätigen.',
    aa_draft_title: 'Entwurf für automatische Zuweisung — vor Bestätigung prüfen', aa_discard: 'Verwerfen',
    aa_weekly_totals: 'Wochensummen nach diesem Entwurf', aa_cap: 'Obergrenze', aa_nothing_to_assign: 'Nichts zuzuweisen.',
    aa_skipped: 'Übersprungen', aa_trimmed_from: 'Gekürzt von', aa_remove: 'Entfernen',
    aa_confirm_assign: 'Bestätigen & zuweisen', aa_shift_singular: 'Schicht', aa_shift_plural: 'Schichten',
    aa_shifts_by_employee: 'Schichten nach Mitarbeiter', aa_no_shifts_week: 'Für diese Woche sind noch keine Schichten zugewiesen.',
    aa_search_placeholder: '🔍 Mitarbeiter suchen oder durchsuchen...', aa_no_matches: 'Keine Treffer', aa_search_hint: 'Suchen oder oben klicken, um die Schichten eines Mitarbeiters für diese Woche zu sehen.',
    aa_no_avail_week: 'Für diese Woche liegen keine Verfügbarkeitsangaben vor.', aa_submitted_avail: 'Verfügbarkeit eingereicht',
    aa_date_label: 'Datum', aa_available_slots: 'Verfügbare Zeiten', aa_already_assigned_date: 'Für dieses Datum bereits zugewiesen:',
    aa_tap_slot: 'Tippen Sie auf eine eingereichte Zeit, um davon auszugehen (optional)', aa_assign_time: 'Schichtzeit zuweisen (Sie können den Zeitraum verkürzen)',
    aa_this_shift: 'Diese Schicht', aa_today: 'Heute', aa_of_ref: 'von 8-Std.-Referenz', aa_over: 'darüber', aa_left: 'übrig',
    aa_this_week: 'Diese Woche', aa_of_cap: 'von', aa_no_weekly_cap: 'keine Wochenobergrenze festgelegt', aa_this_month_far: 'Diesen Monat bisher', aa_weeks4: '4 Wochen',
    aa_outside_avail: 'Außerhalb der angegebenen Verfügbarkeit von {name}', aa_overlaps: 'Überschneidet sich mit einer bereits zugewiesenen Schicht', aa_overlaps_adjust: '— passen Sie die Zeit an, um Doppelbuchung zu vermeiden',
    aa_over_daily: '{name} würde heute {mins} arbeiten (über geteilte Schichten) — über dem üblichen 8-Std.-Arbeitstag',
    aa_over_weekly: 'Dies würde {name} diese Woche auf {mins} bringen — über der Obergrenze von {cap} Std.',
    aa_over_long: 'Diese einzelne Schicht ist über 10 Stunden lang — bitte die Zeiten überprüfen',
    aa_confirm_assignment: 'Zuweisung bestätigen', aa_assign_another: 'Weitere Schicht zuweisen an', aa_assign_shift_to: 'Schicht zuweisen an',
    sh_all_shifts: 'Alle Schichten', sh_overview: 'Übersicht', sh_calendar: 'Kalender', sh_hours_overview: 'Stundenübersicht',
    sh_dayview: 'Tagesansicht', sh_day_mode: 'Tag', sh_week_mode: 'Woche', sh_no_shifts_day: 'Keine Schichten für diesen Tag geplant.',
    sh_upcoming_color: 'Bevorstehend', sh_ongoing_color: 'Läuft gerade', sh_worked_color: 'Gearbeitet', sh_missed_color: 'Verpasst', sh_unreported_color: 'Nicht gemeldet',
    sh_needs_review: 'benötigt Prüfung', sh_week: 'Woche', sh_month: 'Monat',
    sh_employee_calendar: 'Mitarbeiterkalender', sh_select_employee: '-- Mitarbeiter auswählen --',
    sh_mark_absent_title: 'Die {date}-Schicht von {name} als abwesend markieren', sh_mark_absent_desc: 'Dies startet auch ein Gespräch mit {name} (über Probleme), um zu fragen, was passiert ist.',
    sh_optional_note: 'Optionale Notiz...', sh_confirm_mark_absent: 'Bestätigen — Als abwesend markieren & benachrichtigen',
    sh_shifts_label: 'Schichten', sh_cat_all: 'Alle', sh_cat_upcoming: 'Bevorstehend', sh_cat_ongoing: 'Laufend', sh_cat_review: 'Benötigt Prüfung',
    sh_cat_cert: 'Wartet auf Bescheinigung', sh_cat_unexplained: 'Ungeklärt/Sonstiges', sh_cat_approved: 'Genehmigt',
    sh_nothing_category: 'Aktuell nichts in dieser Kategorie.',
    sh_worked_label: 'Gearbeitet', sh_approved_paren: '(Genehmigt)', sh_pending_review_paren: '(Prüfung ausstehend)',
    sh_overtime_label: 'Überstunden', sh_ended_early_label: 'Vorzeitig beendet', sh_scheduled_until: 'geplant bis',
    sh_approved_dot: '· Genehmigt', sh_needs_review_dot: '· Benötigt Prüfung', sh_reason: 'Grund',
    sh_missed_dash: 'Verpasst', sh_acknowledged_paid: 'Bestätigt & bezahlt', sh_acknowledged_not_paid: 'Bestätigt (nicht bezahlt)',
    sh_unreported_likely: 'Nicht gemeldet — wahrscheinlich verpasst', sh_attendance_not_reported: 'Anwesenheit noch nicht gemeldet',
    sh_accept: 'Akzeptieren', sh_acknowledge_btn: 'Bestätigen', sh_approve_pay_btn: 'Zahlung genehmigen', sh_reopen_btn: 'Wieder öffnen', sh_discuss_btn: 'Besprechen', sh_mark_absent_btn: 'Als abwesend markieren',
    sh_reply_to: 'Antwort an {name} zu dieser {date}-Schicht', sh_reply_hint_health: 'z. B. "Bitte reichen Sie Ihre Krankmeldung ein, sobald Sie Ihren Termin hatten, wir prüfen sie dann."',
    sh_reply_hint_other: 'z. B. "Bitte reichen Sie einen Nachweis ein oder erklären Sie es näher — dies wurde noch nicht genehmigt."',
    sh_type_reply: 'Antwort schreiben...', sh_send_reply_btn: 'Antwort senden', sh_becomes_conversation: 'Dies wird zu einem echten Gespräch unter Probleme — der Mitarbeiter kann antworten, und Sie können es dort jederzeit fortsetzen.',
    sh_mark_absent_row_title: 'Die {date}-Schicht von {name} als abwesend markieren', sh_mark_absent_row_desc: 'Dies startet auch ein Gespräch mit {name} (über Probleme), um zu fragen, was passiert ist — falls es sich um Krankheit handelt, können Sie es danach auf Krankmeldung umstellen.',
    sh_correct_hours: 'Gearbeitete Stunden für {name} korrigieren', sh_save_approve: 'Speichern & genehmigen',
    tm_issues: 'Probleme', tm_open: 'offen', tm_sick_certs: 'Krankmeldungen', tm_pending: 'ausstehend', tm_salary: 'Gehalt', tm_slip: 'Abrechnung', tm_slips: 'Abrechnungen',
    tm_add_employee: 'Mitarbeiter hinzufügen', tm_full_name: 'Vollständiger Name', tm_name_placeholder: 'z. B. Maria Schmidt',
    tm_email: 'E-Mail', tm_email_placeholder: 'ihre echte E-Mail — wird zum Anmelden verwendet',
    tm_job_title: 'Berufsbezeichnung', tm_job_title_hint: '(z. B. Vertriebsmitarbeiter, Teamleiter)', tm_job_title_placeholder: 'z. B. Vertriebsmitarbeiter',
    tm_join_date: 'Eintrittsdatum', tm_salary_field: 'Gehalt', tm_salary_hint: '(optional — kann auch später hinzugefügt werden)', tm_salary_placeholder: 'z. B. 13,50 €/Std. oder 2.400 €/Monat',
    tm_password_note: 'Sie erhalten eine E-Mail, um ihr eigenes Passwort festzulegen — Sie sehen oder wählen es nicht. Foto, Vertrag, Stundenobergrenzen und Dokumente können später über ihr Profil hinzugefügt werden.',
    tm_creating_account: 'Konto wird erstellt...', tm_add_employee_btn: 'Mitarbeiter hinzufügen',
    tm_bulk_import: 'Massenimport (CSV)', tm_import_btn: '+ Importieren',
    tm_bulk_desc: 'Mehrere Mitarbeiter gleichzeitig aus einer Tabellenkalkulation hinzufügen — alle automatisch Ihrer Filiale zugeordnet, genau wie bei „Mitarbeiter hinzufügen".',
    tm_download_template: 'CSV-Vorlage herunterladen', tm_choose_csv: 'CSV-Datei auswählen',
    tm_preview: 'Vorschau', tm_ready: 'bereit', tm_with_issues: 'mit Problemen', tm_row: 'Zeile', tm_joins: 'beginnt',
    tm_ready_badge: 'Bereit', tm_create_accounts: 'Erstellen', tm_account_singular: 'Konto', tm_account_plural: 'Konten',
    tm_creating_accounts: 'Konten werden erstellt...', tm_of: 'von',
    tm_employees_created: 'Mitarbeiter', tm_employees_created_pl: 'Mitarbeiter', tm_created_desc: 'erstellt — jeder erhält eine E-Mail, um sein Passwort festzulegen.',
    tm_rows_skipped: 'Zeile', tm_rows_skipped_pl: 'Zeilen', tm_skipped: 'übersprungen',
    tm_employees_title: 'Mitarbeiter', tm_search_placeholder: '🔍 Mitarbeiter suchen oder durchsuchen...', tm_no_matches: 'Keine Treffer',
    tm_active: 'Aktiv', tm_deactivated: 'Deaktiviert', tm_no_employees_status: 'Keine {status} Mitarbeiter.', tm_search_to_select: '🔍 Suchen oder oben klicken, um einen Mitarbeiter auszuwählen.',
    tm_wk: 'Wo', tm_mo: 'Mo', tm_needs_review_short: 'Benötigt Prüfung',
    tm_employment_details: 'Beschäftigungsdetails', tm_not_set: 'Nicht festgelegt', tm_edit_employment: 'Beschäftigungsdetails bearbeiten', tm_dob: 'Geburtsdatum',
    tm_reactivate: 'Reaktivieren', tm_deactivate: 'Deaktivieren', tm_deactivate_confirm: '{name} deaktivieren? Der Verlauf bleibt erhalten, aber die Person wechselt in die Liste „Deaktiviert".',
    tm_account_profile: 'Konto & Profil', tm_photo: 'Foto', tm_upload_photo_btn: 'Foto hochladen',
    tm_photo_requested: 'Mitarbeiter hat eine Fotoänderung angefragt', tm_update_photo: 'Foto aktualisieren', tm_photo_set: 'Foto festgelegt. Mitarbeiter muss eine Änderung anfragen, um es zu aktualisieren.',
    tm_contract: 'Vertrag', tm_shared: 'Geteilt', tm_not_shared: 'Nicht geteilt', tm_download: 'Herunterladen', tm_share_employee: 'Mit Mitarbeiter teilen', tm_replace: 'Ersetzen', tm_upload_contract: 'Vertrags-PDF hochladen',
    tm_contract_hour_caps: 'Vertrag & Stundenobergrenzen', tm_contract_type: 'Vertragsart',
    tm_ct_minijob: 'Minijob', tm_ct_werkstudent: 'Werkstudent', tm_ct_parttime: 'Teilzeit', tm_ct_fulltime: 'Vollzeit', tm_ct_fulltime_ext: 'Vollzeit erweitert', tm_ct_custom: 'Individuell',
    tm_minijob_desc: 'Minijobs sind durch Verdienst begrenzt, nicht durch Stunden — 603 €/Monat (Grenze 2026).',
    tm_minijob_hint: 'Diese Grenze steigt mit dem deutschen Mindestlohn — es lohnt sich, jährlich zu prüfen, ob sie noch aktuell ist. Legen Sie die Wochenstunden unten direkt fest, basierend darauf, was sie bei ihrem Lohn unter dieser Grenze hält.',
    tm_optional_wage: 'Optional — ihr Stundenlohn, nur um Ihnen zu helfen, die richtigen Stunden unten zu berechnen', tm_wage_placeholder: 'z. B. 13,50',
    tm_pay_type: 'Bezahlungsart', tm_pay_hourly: 'Pro Stunde', tm_pay_gross: 'Bruttogehalt',
    tm_gross_salary_label: 'Monatliches Bruttogehalt (€)', tm_gross_salary_placeholder: 'z. B. 2500',
    tm_gross_salary_hint: 'Der zahlbare Betrag wird anhand ihrer Max. Std./Woche × 4 als Vollzeit-Referenzstunden berechnet.',
    tm_keeps_under_cap: ' Std./Woche hält sie bei diesem Lohn unter der Verdienstgrenze — nur ein Richtwert, legt nichts automatisch fest.',
    tm_min_hrs_week: 'Min. Std./Woche', tm_max_hrs_week: 'Max. Std./Woche', tm_min_placeholder: 'z. B. 10', tm_max_placeholder: 'z. B. 20',
    tm_per_month: ' Std./Monat (4 Wochen)', tm_over20_werkstudent: 'Über 20 Std./Woche — kann den Werkstudentenstatus beeinträchtigen',
    tm_over48: 'Über 48 Std./Woche — über der gesetzlichen deutschen Höchstarbeitszeit',
    tm_hrs_week: 'Std./Woche', tm_edit_btn: 'Bearbeiten', tm_set_btn: 'Festlegen',
    tm_payroll: 'Gehaltsabrechnung: Gearbeitete & Kranke Stunden', tm_approved_hours_month: 'Genehmigte Stunden diesen Monat', tm_approved_hours_hint: 'Nur akzeptierte Stunden — die Zahl, die tatsächlich für die Gehaltsabrechnung verwendet wird.',
    tm_sick_covered_month: 'Krank abgedeckte geplante Stunden diesen Monat', tm_sick_covered_hint: 'Aus genehmigten Krankmeldungen. Ob diese als bezahlte Stunden zählen, hängt von Ihrer eigenen Richtlinie ab — dies ist der Rohwert zur eigenen Anwendung.',
    tm_submitted_docs: 'Eingereichte Dokumente', tm_no_docs: 'Noch keine Dokumente eingereicht.',
    tm_approve_btn: 'Genehmigen', tm_undo_btn: 'Rückgängig', tm_reject_btn: 'Ablehnen',
    tm_note_approve_placeholder: 'Optionale Notiz...', tm_note_reject_placeholder: 'z. B. Foto ist unscharf — bitte eine klarere Kopie einreichen',
    tm_confirm_approval: 'Genehmigung bestätigen', tm_confirm_rejection: 'Ablehnung bestätigen',
    tm_other: 'Weiteres', tm_no_issues: 'Keine Probleme gemeldet.', tm_sick_certificates: 'Krankmeldungen',
    aiss_no_issues_yet: 'Noch keine Probleme gemeldet.', aiss_open: 'Offen', aiss_resolved: 'Gelöst', aiss_calendar: 'Kalender', aiss_issues_calendar: 'Problem-Kalender',
    aiss_search_placeholder: '🔍 Nach Ticketnummer oder Mitarbeitername suchen...',
    feature_search_placeholder: '🔍 Funktionen suchen...',
    fixed_schedule_title: 'Feste Schicht-Einstellungen', fixed_schedule_hint: 'Legt ein gemeinsames Schichtmuster für Mitarbeiter mit fester Planung fest.',
    fixed_start_time: 'Startzeit', fixed_end_time: 'Endzeit', fixed_break_start: 'Pausenbeginn', fixed_break_end: 'Pausenende',
    fixed_work_days: 'Arbeitstage (für Fest — Standard)', fixed_save_btn: 'Feste Schicht speichern',
    day_monday: 'Mo', day_tuesday: 'Di', day_wednesday: 'Mi', day_thursday: 'Do', day_friday: 'Fr', day_saturday: 'Sa', day_sunday: 'So',
    sched_mode_title: 'Planungsmodus', sched_mode_hint: 'Wie dieser Mitarbeiter eingeplant wird.',
    sched_mode_availability: 'Verfügbarkeitsbasiert (reicht wöchentliche Verfügbarkeit ein)', sched_mode_fixed_standard: 'Fest — Standard (gleiche Tage jede Woche)', sched_mode_fixed_dayoff: 'Fest — Freien Tag wählen (Sonntag frei, wählt 1 weiteren Tag wöchentlich)',
    sched_mode_rotation: 'Wechselschicht (rotiert durch Schichtarten)',
    rotation_title: 'Wechselschicht', rotation_hint: 'Benannte Schichtarten (z. B. Frühschicht, Spätschicht, Nachtschicht) mit eigenen Zeiten und Zuschlag festlegen — Mitarbeiter rotieren automatisch vorwärts durch diese.',
    rotation_shift_label: 'Schicht', rotation_shift_name_placeholder: 'z. B. Frühschicht', rotation_premium_label: 'Zuschlag (%)',
    rotation_add_shift_btn: 'Schichtart hinzufügen', rotation_days_label: 'Tage pro Schicht vor Rotation', rotation_days_hint: 'Wie viele Tage ein Mitarbeiter auf jeder Schichtart bleibt, bevor er zur nächsten wechselt.',
    rotation_rest_warning: 'Warnung: Der Übergang von {last} zurück zu {first} lässt nur {hours}h Ruhezeit — deutsches Recht verlangt mindestens 11h zwischen Schichten.',
    rotation_save_btn: 'Wechselschicht speichern', rotation_start_date_label: 'Rotationsstartdatum',
    rotation_generate_title: 'Wechselschichten erstellen', rotation_generate_hint: 'Erstellt die Schichten dieser Woche für alle Mitarbeiter mit Wechselschicht, basierend auf ihrer aktuellen Position im Zyklus.',
    rotation_generate_btn: 'Für diese Woche erstellen',
    fixed_generate_title: 'Feste Schichten erstellen', fixed_generate_hint: 'Erstellt echte Schichten für diese Woche für alle Mitarbeiter mit fester Planung. Kann gefahrlos erneut ausgeführt werden — erstellt nie Duplikate.',
    fixed_generate_btn: 'Für diese Woche erstellen', fixed_generate_result: '{n} Schicht(en) erstellt.',
    dayoff_picker_title: 'Ihren freien Tag wählen', dayoff_picker_hint: 'Sonntag ist immer frei. Wählen Sie einen weiteren freien Tag für nächste Woche.',
    dayoff_picker_placeholder: '-- Tag auswählen --', dayoff_picker_saved: 'Für nächste Woche gespeichert',
    dayoff_picker_full: 'voll', fixed_max_dayoff: 'Max. Personen frei pro Tag', fixed_max_dayoff_hint: '0 = kein Limit. Gilt nur für Mitarbeiter mit "Fest — Freien Tag wählen".',
    fixed_save_success: 'Erfolgreich gespeichert.',
    weekoff_swap_open_btn: 'Freien Tag mit jemandem tauschen', weekoff_swap_pick_hint: 'Wählen Sie einen Kollegen zum Tauschen — Sie erhalten dessen Tag, er Ihren.',
    weekoff_swap_none_available: 'Aktuell keine Kollegen mit einem anderen freien Tag zum Tauschen.',
    weekoff_swap_has_off: 'frei am {day}', weekoff_swap_status_awaiting_colleague: 'Warten auf Antwort von {name}.', weekoff_swap_status_awaiting_admin: 'Beide haben zugestimmt — wartet auf Ihren Manager zur endgültigen Bestätigung.',
    weekoff_swap_incoming_title: '{name} möchte den freien Tag mit Ihnen tauschen', weekoff_swap_incoming_detail: 'Sie hätten {yourNew} frei statt {yourOld}.',
    aiss_raised: 'Gemeldet', aiss_resolved_date: 'Gelöst', aiss_reply: 'Antwort', aiss_replies: 'Antworten',
    aiss_cert_submitted: 'Krankmeldung eingereicht', aiss_review_sick: 'In Krankmeldungen prüfen',
    aiss_no_cert_yet: 'Für dieses Datum wurde noch keine Krankmeldung eingereicht.',
    aiss_you_manager: 'Sie (Manager)', aiss_no_replies: 'Noch keine Antworten — bei Bedarf den Mitarbeiter um weitere Details bitten.',
    aiss_reply_placeholder: 'An Mitarbeiter antworten oder um weitere Infos bitten...', aiss_send_reply: 'Antwort senden',
    aiss_mark_resolved: 'Als gelöst markieren', aiss_issue_resolved: 'Problem gelöst', aiss_reopen: 'Wieder öffnen',
    asal_upload_slip: 'Gehaltsabrechnung hochladen', asal_employee: 'Mitarbeiter', asal_select_employee: '-- Mitarbeiter auswählen --',
    asal_month: 'Monat', asal_month_placeholder: 'z. B. Juli 2026', asal_hours_worked: 'Gearbeitete Stunden', asal_hours_placeholder: 'z. B. 86',
    asal_net_pay: 'Nettolohn', asal_net_pay_placeholder: 'z. B. 1.240 €', asal_upload_pdf: 'PDF hochladen', asal_optional: '(optional)',
    asal_choose_pdf: 'PDF-Datei auswählen', asal_slip_uploaded: 'Gehaltsabrechnung hochgeladen!', asal_upload_btn: 'Gehaltsabrechnung hochladen',
    asal_all_slips: 'Alle Gehaltsabrechnungen', asal_none_uploaded: 'Noch keine Gehaltsabrechnungen hochgeladen.', asal_no_pdf: 'Kein PDF',
    asal_bulk_upload: 'Massen-Upload', asal_bulk_hint: 'Mehrere Gehaltsabrechnungs-PDFs gleichzeitig auswählen. Wir versuchen, jede anhand des Dateinamens dem richtigen Mitarbeiter zuzuordnen — bitte prüfen und bei Bedarf korrigieren.',
    asal_choose_files: 'PDF-Dateien auswählen', asal_no_match: '-- Mitarbeiter auswählen --', asal_submit_bulk: 'Alle zugeordneten hochladen', asal_files_selected: '{count} Dateien ausgewählt',
    pe_title: 'Gehaltsexport', pe_disclaimer: 'Nur Bruttolohn — Stundenlohn × genehmigte Stunden. Dies berechnet keine Steuer, Sozialversicherung oder Nettolohn. Exportieren und an Ihren Steuerberater oder Ihr Gehaltsabrechnungssystem weitergeben.',
    pe_regular_hours: 'Reguläre Stunden', pe_sick_hours: 'Bezahlte Krankheitsstunden', pe_rate: 'Satz/Std.', pe_gross: 'Bruttolohn',
    pe_no_rate: 'Stundenlohn festlegen zur Berechnung', pe_export_csv: 'CSV exportieren', pe_export_xlsx: 'Excel exportieren', pe_no_employees: 'Keine Mitarbeiter für diesen Monat.',
    pe_send_to_hq: 'An HQ senden', pe_sent_to_hq_success: 'Erfolgreich an HQ gesendet.',
    ct_title: 'Vertragsvorlagen', ct_add: 'Vorlage hinzufügen', ct_none: 'Noch keine Vorlagen hinzugefügt.', ct_no_templates_yet: 'Noch keine Vorlagen — fügen Sie zuerst eine unter Team → Vertragsvorlagen hinzu.',
    ct_hint: 'Laden Sie Ihren eigenen Word-Vertrag (.docx) hoch, genau wie Sie ihn heute verwenden. Überall wo Sie normalerweise einen Namen oder ein Datum eintippen würden, tippen Sie stattdessen: {{name}}, {{jobTitle}}, {{joinDate}}, {{dob}}, {{contractType}}, {{minHours}}, {{maxHours}}, {{hourlyRate}}, {{grossSalary}}, {{salary}}, {{companyName}}, {{date}} — diese werden automatisch durch die echten Daten des Mitarbeiters ersetzt, Ihre ursprüngliche Formatierung bleibt erhalten.',
    ct_name: 'Vorlagenname', ct_name_placeholder: 'z. B. Minijob-Vertrag', ct_content: 'Vertragstext',
    ct_content_placeholder: 'z. B. Dieser Arbeitsvertrag besteht zwischen {{companyName}} und {{name}}, beginnend am {{joinDate}}...', ct_choose_docx: '.docx-Datei auswählen',
    ct_save: 'Vorlage speichern', ct_delete_confirm: 'Diese Vorlage löschen? Dies kann nicht rückgängig gemacht werden.',
    ct_generate: 'Vertrag generieren', ct_select_template: '-- Vorlage auswählen --', ct_generate_btn: 'Generieren (erst Vorschau)',
    ct_signed: 'Unterschrieben', ct_not_signed: 'Noch nicht unterschrieben', ct_sign_contract: 'Vertrag unterschreiben', ct_type_full_name: 'Geben Sie Ihren vollständigen Namen ein, um zu unterschreiben',
    ct_sign_confirm: 'Mit Eingabe meines Namens unten bestätige ich, dass ich diesen Vertrag gelesen habe und ihm zustimme.', ct_sign_btn: 'Bestätigen & Unterschreiben', ct_signed_on: 'Unterschrieben von {name} am {date}',
    ct_you_signed_on: 'Sie haben als {name} am {date} unterschrieben', ct_employer_signed_on: 'Arbeitgeber unterschrieben von {name} am {date}',
    ct_fully_executed: 'Vollständig unterzeichnet — beide Parteien haben unterschrieben', ct_awaiting_employer: 'Warten auf die Unterschrift des Arbeitgebers',
    ct_type_signature: 'Namen eingeben', ct_upload_signature: 'Unterschrift hochladen', ct_choose_image: 'Unterschriftsbild auswählen',
    ct_sign_as_employer: 'Als Arbeitgeber unterschreiben', ct_sign_employer_confirm: 'Mit Ihrer Unterschrift unten bestätigen Sie diesen Vertrag im Namen des Unternehmens.',
    ct_review_btn: 'Überprüfen', ct_review_hint: 'So wird Ihre Unterschrift genau erscheinen. Bestätigen zum Abschließen, oder zurückgehen, um sie zu ändern.',
    ct_confirm_sign_btn: 'Bestätigen & Unterschreiben', ct_back_btn: 'Zurück',
    asick_none_submitted: 'Noch keine Krankmeldungen eingereicht.', asick_pending: 'Ausstehend', asick_approved: 'Genehmigt', asick_rejected: 'Abgelehnt',
    asick_no_cert_attached: 'Keine Bescheinigung beigefügt — Genehmigung ohne Nachweis', asick_your_note: 'Ihre Notiz',
    asick_approve: 'Genehmigen', asick_reject: 'Ablehnen', asick_undo_rereview: 'Rückgängig — Diese Entscheidung erneut prüfen',
    asick_note_approve: 'Notiz (optional — z. B. „Gute Besserung!")', asick_reason_reject: 'Grund für die Ablehnung — z. B. „Bitte eine gültige ärztliche Bescheinigung hochladen"',
    asick_get_well: 'Gute Besserung!', asick_reject_placeholder: 'z. B. Keine Bescheinigung beigefügt — bitte Nachweis hochladen und erneut einreichen',
    asick_reject_hint: 'Der Mitarbeiter sieht diese Notiz und kann seine Einreichung bearbeiten, um sie erneut einzureichen — kein Zeitlimit für eine abgelehnte Bescheinigung.',
    asick_confirm_approval: 'Genehmigung bestätigen', asick_confirm_rejection: 'Ablehnung bestätigen',
    aes_edit_shift: 'Schicht bearbeiten', aes_date: 'Datum', aes_time_range: 'Zeitraum', aes_save_changes: 'Änderungen speichern',
    wh_alltime_total: 'Gesamtsumme',
    hn_new_shift: 'neue Schicht', hn_new_shifts: 'neue Schichten', hn_assigned_bang: 'zugewiesen!',
    hn_week_assigned_of: 'Diese Woche: {mins} zugewiesen von Ihren {cap} Std. Vertragsstunden',
    hn_shift_not_submitted: 'Schicht', hn_shifts_not_submitted: 'Schichten', hn_still_not_submitted: 'noch nicht eingereicht',
    hn_oldest: 'Älteste', hn_log_hours_prompt: 'bitte erfassen Sie Ihre Stunden (oder markieren Sie sie als verpasst), damit Ihr Manager sie prüfen kann. Tippen, um zu Schichten zu gehen',
    hn_document: 'Dokument', hn_documents: 'Dokumente', hn_reviewed: 'geprüft',
    lh_edit_hours: 'Bearbeiten Sie Ihre gearbeiteten Stunden', lh_log_hours: 'Erfassen Sie die Stunden, die Sie tatsächlich gearbeitet haben', lh_scheduled: 'geplant',
    lh_total: 'Gesamt', lh_exceeds: 'Dies geht über das geplante Ende Ihrer Schicht hinaus ({end}). Setzen Sie die Endzeit auf {end} oder früher, und erfassen Sie zusätzliche Zeit unten als Überstunden.',
    lh_ended_early_warn: 'Sie beenden diese Schicht vorzeitig (geplant bis {end}) — nur {mins} zählen. Bitte erklären Sie unten, warum, bevor Sie absenden können.',
    lh_reason_early: 'Grund für das vorzeitige Verlassen', lh_what_happened: 'Was ist passiert?',
    lh_illness_hint: 'Falls dies auf Krankheit zurückzuführen war, ziehen Sie in Betracht, stattdessen eine Krankmeldung einzureichen, damit die volle Schicht angerechnet werden kann.',
    lh_add_overtime: '+ Überstunden hinzufügen', lh_overtime_after: 'Überstunden (nach Schichtende)', lh_remove: 'Entfernen',
    lh_ot_overlaps: 'Überstunden überschneiden sich mit Ihrer regulären Schicht — sie müssen bei oder nach {end} beginnen.', lh_overtime_label2: 'Überstunden',
    lh_swipe_ot: 'Nach rechts wischen zum Absenden (+ Überstunden)', lh_swipe_complete: 'Nach rechts wischen zum Abschließen',
    lh_why_missed: 'Warum haben Sie diese Schicht verpasst?', lh_health_problem: 'Gesundheitliches Problem', lh_other: 'Sonstiges',
    lh_add_details: 'Details hinzufügen (optional)', lh_current: 'Aktuell', lh_submit_btn: 'Absenden',
  },
  fr: {
    nav_home: 'Accueil', nav_shifts: 'Horaires', nav_avail: 'Disponibilité', nav_profile: 'Profil',
    nav_overview: 'Aperçu', nav_team: 'Équipe',
    title_issues: 'Problèmes', title_salary: 'Salaire',
    login_employee: 'Employé', login_manager: 'Responsable', login_email: 'Adresse e-mail', login_password: 'Mot de passe',
    login_signin: 'Se connecter', login_forgot: 'Mot de passe oublié ?', login_language: 'Langue',
    login_reset_title: 'Réinitialisation du mot de passe', login_reset_text: 'Veuillez contacter votre responsable pour réinitialiser votre mot de passe.', login_close: 'Fermer',
    login_error: 'Veuillez saisir l\u2019e-mail et le mot de passe', login_error_invalid: 'E-mail ou mot de passe invalide',
    home_overview: 'Aperçu', home_upcoming: 'Prochains horaires', home_completed: 'Horaires terminés',
    home_pending_avail: 'Disponibilité en attente', home_open_issues: 'Problèmes ouverts',
    home_worked_hours: 'Mes heures travaillées', home_this_week: 'Cette semaine', home_this_month: 'Ce mois-ci',
    home_upcoming_shifts: 'Prochains horaires', home_no_upcoming: 'Aucun horaire à venir. Soumettez votre disponibilité !',
    profile_photo: 'Photo de profil', profile_contract: 'Mon contrat', profile_hours: 'Heures contractuelles',
    profile_upload_doc: 'Télécharger un document', profile_my_docs: 'Mes documents', profile_language: 'Langue',
    logout: 'Déconnexion',
  },
  es: {
    nav_home: 'Inicio', nav_shifts: 'Turnos', nav_avail: 'Disponibilidad', nav_profile: 'Perfil',
    nav_overview: 'Resumen', nav_team: 'Equipo',
    title_issues: 'Incidencias', title_salary: 'Salario',
    login_employee: 'Empleado', login_manager: 'Gerente', login_email: 'Correo electrónico', login_password: 'Contraseña',
    login_signin: 'Iniciar sesión', login_forgot: '¿Olvidaste tu contraseña?', login_language: 'Idioma',
    login_reset_title: 'Restablecer contraseña', login_reset_text: 'Por favor, contacta a tu gerente para restablecer tu contraseña.', login_close: 'Cerrar',
    login_error: 'Por favor, introduce el correo y la contraseña', login_error_invalid: 'Correo o contraseña incorrectos',
    home_overview: 'Resumen', home_upcoming: 'Próximos turnos', home_completed: 'Turnos completados',
    home_pending_avail: 'Disponibilidad pendiente', home_open_issues: 'Incidencias abiertas',
    home_worked_hours: 'Mis horas trabajadas', home_this_week: 'Esta semana', home_this_month: 'Este mes',
    home_upcoming_shifts: 'Próximos turnos', home_no_upcoming: '¡No hay turnos próximos. Envía tu disponibilidad!',
    profile_photo: 'Foto de perfil', profile_contract: 'Mi contrato', profile_hours: 'Horas contratadas',
    profile_upload_doc: 'Subir documento', profile_my_docs: 'Mis documentos', profile_language: 'Idioma',
    logout: 'Cerrar sesión',
  },
};

function translate(lang, key) {
  return (T[lang] && T[lang][key]) || T.en[key] || key;
}

// Translates a status badge's DISPLAY text only — the underlying stored value (e.g. "Assigned")
// never changes, since other code compares against it directly. This only affects what the
// person actually reads on screen.
const STATUS_KEY_MAP = {
  'Pending': 'status_pending', 'Assigned': 'status_assigned', 'Confirmed': 'status_confirmed',
  'Missed': 'status_missed', 'Worked': 'status_worked', 'Completed': 'status_completed',
  'Approved': 'status_approved', 'Rejected': 'status_rejected', 'Open': 'status_open', 'Resolved': 'status_resolved',
  'Upcoming': 'status_upcoming', 'Active': 'status_active', 'Expired': 'status_expired',
};
function translateStatus(lang, status) {
  const key = STATUS_KEY_MAP[status];
  return key ? translate(lang, key) : status;
}


function daysUntil(dateStr) {
  if (!dateStr) return null;
  const diffMs = new Date(dateStr) - new Date(today);
  return Math.round(diffMs / 86400000);
}

function isExpiringSoon(dateStr) {
  const d = daysUntil(dateStr);
  return d !== null && d <= 30;
}

function getBadgeStyle(status) {
  if (status === 'Confirmed' || status === 'Assigned' || status === 'Active' || status === 'Worked') return s.badge('#2e7d32', '#e8f5e9');
  if (status === 'Pending') return s.badge('#f57f17', '#fff8e1');
  if (status === 'Upcoming') return s.badge('var(--brand-dark)', 'var(--brand-light)');
  if (status === 'Completed') return s.badge('#555', '#f0f0f0');
  if (status === 'On Leave' || status === 'Missed' || status === 'Rejected') return s.badge('#b71c1c', '#ffebee');
  if (status === 'Open') return s.badge('#b71c1c', '#ffebee');
  if (status === 'Resolved') return s.badge('#2e7d32', '#e8f5e9');
  return s.badge('#555', '#f0f0f0');
}

function isUpcoming(dateStr) { return dateStr > today; }

function toMinutes(t) { const [h, m] = t.split(':').map(Number); return h * 60 + m; }
function durationMins(from, to) { return toMinutes(to) - toMinutes(from); }
function isWithinAnySlot(from, to, slots) {
  if (!from || !to || !slots) return true;
  return slots.some(sl => {
    const [sf, st] = sl.split(' – ');
    return from >= sf && to <= st;
  });
}
// Checks a proposed [from, to] range against a list of "HH:MM – HH:MM" strings
// (existing shifts) and returns the first one it overlaps with, or null.
function findOverlap(from, to, existingTimes) {
  if (!from || !to) return null;
  for (const time of existingTimes) {
    const [ef, et] = time.split(' – ');
    if (from < et && ef < to) return time;
  }
  return null;
}
// Same idea as findOverlap, but for date ranges (e.g. checking a new sick certificate
// against ones already submitted) rather than time-of-day ranges.
function findDateOverlap(fromDate, toDate, existingReports) {
  if (!fromDate || !toDate) return null;
  for (const r of existingReports) {
    if (r.status === 'Rejected') continue; // a rejected certificate doesn't block resubmitting for the same dates
    if (fromDate <= r.toDate && r.fromDate <= toDate) return r;
  }
  return null;
}
function formatDuration(mins) { if (!mins || mins < 0) return '0h 0m'; return `${Math.floor(mins / 60)}h ${mins % 60}m`; }

function getWeekRange(dateStr) {
  const d = new Date(dateStr);
  const day = d.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const monday = new Date(d); monday.setDate(d.getDate() + diffToMonday);
  const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
  return [monday.toISOString().split('T')[0], sunday.toISOString().split('T')[0]];
}
function getISOWeekNumber(dateStr) {
  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - (d.getDay() + 6) % 7);
  const week1 = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}
function addDaysToDate(dateStr, n) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

// App-level filter — narrows shared data down to one branch's employees only.
// This is what makes a branch manager's screen show just their own branch,
// not the whole company. (Security rules are the separate, deeper layer —
// this alone is display filtering, not real protection.)
function filterDataByBranch(branchId, { shifts, availList, issues, sickReports, employeeRecords, profiles, swapRequests, leaveRequests }) {
  const namesInBranch = new Set(Object.keys(employeeRecords).filter(name => employeeRecords[name].branchId === branchId));
  return {
    shifts: shifts.filter(sh => namesInBranch.has(sh.employee)),
    availList: availList.filter(a => namesInBranch.has(a.employee)),
    issues: issues.filter(i => namesInBranch.has(i.employee)),
    sickReports: sickReports.filter(r => namesInBranch.has(r.employee)),
    employeeRecords: Object.fromEntries(Object.entries(employeeRecords).filter(([name]) => namesInBranch.has(name))),
    profiles: Object.fromEntries(Object.entries(profiles).filter(([name]) => namesInBranch.has(name))),
    swapRequests: (swapRequests || []).filter(r => namesInBranch.has(r.employee)),
    leaveRequests: (leaveRequests || []).filter(r => namesInBranch.has(r.employee)),
  };
}

// Simple CSV parser for the Bulk Import template — handles quoted fields
// (so values containing commas, like "€13.50/hour, negotiable", still work).
function parseCSV(text) {
  const rows = [];
  text.split(/\r\n|\n/).forEach(line => {
    if (!line.trim()) return;
    const cells = [];
    let cur = '', inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') { inQuotes = !inQuotes; }
      else if (ch === ',' && !inQuotes) { cells.push(cur.trim()); cur = ''; }
      else { cur += ch; }
    }
    cells.push(cur.trim());
    rows.push(cells);
  });
  return rows;
}

const MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

// Builds { totalMins, months: [{key:'2026-07', label:'July 2026', mins}] } sorted newest-first
function buildWorkedHistory(shifts, employeeName) {
  const worked = shifts.filter(sh => sh.employee === employeeName && sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo);
  const byMonth = {};
  let totalMins = 0;
  worked.forEach(sh => {
    const mins = durationMins(sh.workedFrom, sh.workedTo);
    totalMins += mins;
    const key = sh.date.slice(0, 7);
    byMonth[key] = (byMonth[key] || 0) + mins;
  });
  const months = Object.keys(byMonth).sort().reverse().map(key => {
    const [y, m] = key.split('-');
    return { key, label: `${MONTH_NAMES[parseInt(m,10)-1]} ${y}`, mins: byMonth[key] };
  });
  return { totalMins, months };
}

function getAvailableYears(shifts, employeeName) {
  const worked = shifts.filter(sh => sh.employee === employeeName);
  const years = new Set(worked.map(sh => sh.date.slice(0, 4)));
  const currentYear = new Date(today).getFullYear();
  // Always offer a wide range upfront (2 years back, 10 years forward) so nothing needs updating yearly
  for (let y = currentYear - 2; y <= currentYear + 10; y++) years.add(String(y));
  return Array.from(years).sort().reverse();
}

// All 12 months for a given year, with total worked minutes (0 if none — every month always shown)
function getMonthlyForYear(shifts, employeeName, year) {
  const worked = shifts.filter(sh => sh.employee === employeeName && sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo && sh.date.startsWith(year));
  const byMonth = {};
  worked.forEach(sh => {
    const mm = sh.date.slice(5, 7);
    byMonth[mm] = (byMonth[mm] || 0) + durationMins(sh.workedFrom, sh.workedTo);
  });
  return Array.from({ length: 12 }, (_, i) => {
    const mm = String(i + 1).padStart(2, '0');
    return { key: `${year}-${mm}`, mm, label: MONTH_NAMES[i], mins: byMonth[mm] || 0 };
  });
}

// Shared Year → Month worked-hours browser, used by both employee (own hours) and admin (any employee)
// Automatically shrinks a photo before it's stored (max ~1000px wide, JPEG quality 0.7) —
// keeps casual issue/certificate photos comfortably under Firestore's 1MB document limit,
// with no extra step for the person uploading. PDFs and other non-image files pass through untouched.
function compressImage(file, maxWidth = 1000, quality = 0.7) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (ev) => resolve({ name: file.name, data: ev.target.result });
      reader.onerror = reject;
      reader.readAsDataURL(file);
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxWidth) {
          height = Math.round(height * (maxWidth / width));
          width = maxWidth;
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        resolve({ name: file.name.replace(/\.\w+$/, '.jpg'), data: canvas.toDataURL('image/jpeg', quality) });
      };
      img.onerror = reject;
      img.src = ev.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function compactDuration(mins) {
  if (!mins || mins < 0) return '0h';
  const h = Math.floor(mins / 60), m = mins % 60;
  return m ? `${h}h${m}m` : `${h}h`;
}

function buildContractPlaceholders(employeeName, rec, p, emp, companyName) {
  return {
    name: employeeName, email: emp?.email || '', jobTitle: rec.jobTitle || '', joinDate: rec.joinDate || '',
    dob: rec.dob || '', contractType: p.contractType || '', minHours: p.minHours || '', maxHours: p.maxHours || '',
    hourlyRate: p.hourlyRate || '', grossSalary: p.grossSalary || '', salary: rec.salary || '',
    companyName: companyName || 'KarmaDal', date: today,
  };
}

// A 1x1 transparent PNG — used so image placeholders never crash the render even
// when that party hasn't signed with an image (or hasn't signed at all yet).
const BLANK_SIG_IMAGE = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=';

function base64ToBytes(dataUriOrBase64) {
  const base64 = dataUriOrBase64.includes(',') ? dataUriOrBase64.split(',')[1] : dataUriOrBase64;
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
  return bytes;
}

// Renders a template's raw file data into a finished .docx, filling both the
// employee's real details AND whichever signatures (text or image) are known so far
// — called both at first generation (signatures blank) and again after either party
// signs, so the signature ends up in its actual place inside the document, not just
// tracked separately as app metadata.
function renderContractDocx(templateFileData, placeholderValues, extra) {
  const bytes = base64ToBytes(templateFileData);
  const zip = new PizZip(bytes);
  const imageOpts = {
    centered: false,
    getImage: (tagValue) => base64ToBytes(tagValue || BLANK_SIG_IMAGE),
    getSize: () => [140, 50],
  };
  const doc = new Docxtemplater(zip, {
    paragraphLoop: true, linebreaks: true, delimiters: { start: '{{', end: '}}' },
    modules: [new ImageModule(imageOpts)],
  });
  doc.render({
    ...placeholderValues,
    signature: '', sigImage: BLANK_SIG_IMAGE,
    employerSignature: '', employerSigImage: BLANK_SIG_IMAGE,
    ...extra,
  });
  const outBase64 = doc.getZip().generate({ type: 'base64', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  return `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${outBase64}`;
}

// Month calendar grid: green = worked, red = absent (Other), purple = sick (Health problem).
// Only shows shifts the manager has approved (attendanceApproved), per how KarmaDal tracks confirmed records.
function CalendarView({ shifts, employeeName, onMarkAbsent, profile, language }) {
  const years = getAvailableYears(shifts, employeeName);
  const [year, setYear] = useState(today.slice(0, 4));
  const [month, setMonth] = useState(String(new Date(today).getMonth() + 1).padStart(2, '0'));
  const [selectedDate, setSelectedDate] = useState(null);

  const daysInMonth = new Date(parseInt(year), parseInt(month), 0).getDate();
  const firstDay = new Date(parseInt(year), parseInt(month) - 1, 1).getDay(); // 0 = Sunday
  const offset = (firstDay + 6) % 7; // Monday-first offset

  // Every shift for this person that month — both completed (approved) and still-upcoming/assigned.
  const monthShifts = shifts.filter(sh => sh.employee === employeeName && sh.date.startsWith(`${year}-${month}`));
  const dayMap = {};
  monthShifts.forEach(sh => { (dayMap[sh.date] = dayMap[sh.date] || []).push(sh); });

  // Month summary — completed (logged worked hours, includes overtime, plus any approved sick
  // hours), approved (manager-accepted only), and assigned. Sick hours use the shift's own
  // scheduled duration (not workedFrom/workedTo, which don't apply to a missed shift) — matching
  // exactly how payroll calculates sick hours, so all three stay consistent with each other.
  const assignedMins = monthShifts.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const workedShiftsThisMonth = monthShifts.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo);
  const sickShiftsThisMonth = monthShifts.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem');
  const completedMins = workedShiftsThisMonth.reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo) + (sh.otFrom && sh.otTo ? durationMins(sh.otFrom, sh.otTo) : 0), 0)
    + sickShiftsThisMonth.filter(sh => sh.payApproved).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const approvedMins = workedShiftsThisMonth.filter(sh => sh.attendanceApproved).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo) + (sh.otFrom && sh.otTo ? durationMins(sh.otFrom, sh.otTo) : 0), 0)
    + sickShiftsThisMonth.filter(sh => sh.payApproved).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);

  const cells = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  function shiftKind(sh) {
    if (sh.attendanceApproved && sh.attendance === 'Worked') return 'worked';
    if (sh.attendanceApproved && sh.attendance === 'Missed') return sh.missedReason === 'Health problem' ? 'sick' : 'absent';
    return 'scheduled'; // assigned but not yet completed/approved
  }

  function cellStyle(dayShifts) {
    if (!dayShifts || dayShifts.length === 0) return { background: '#f5f6fa', color: '#aaa' };
    const kinds = dayShifts.map(shiftKind);
    if (kinds.includes('worked')) return { background: '#e8f5e9', color: '#2e7d32' };
    if (kinds.includes('sick')) return { background: '#f3e5f5', color: '#8e24aa' };
    if (kinds.includes('absent')) return { background: '#ffebee', color: '#b71c1c' };
    return { background: '#e3f2fd', color: '#1565c0' }; // scheduled only
  }

  const selectedShifts = selectedDate ? (dayMap[selectedDate] || []) : [];

  return (
    <div style={{ background: 'white', borderRadius: '8px', padding: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
        <select style={{ ...s.selectInput, marginBottom: 0, flex: 1 }} value={year} onChange={e => { setYear(e.target.value); setSelectedDate(null); }}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={{ ...s.selectInput, marginBottom: 0, flex: 1 }} value={month} onChange={e => { setMonth(e.target.value); setSelectedDate(null); }}>
          {MONTH_NAMES.map((mName, i) => <option key={mName} value={String(i + 1).padStart(2, '0')}>{mName}</option>)}
        </select>
      </div>
      <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'10px' }}>
        <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', marginBottom:'4px' }}>{MONTH_NAMES[parseInt(month)-1]} {year} {translate(language, 'cal_so_far')}</div>
        <div style={{ fontSize:'13px', color:'var(--brand-dark)', fontWeight:'600' }}>✅ {compactDuration(completedMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{translate(language, 'cal_completed')}</span></div>
        <div style={{ fontSize:'13px', color:'#2e7d32', fontWeight:'600', marginTop:'2px' }}>✔️ {compactDuration(approvedMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{translate(language, 'cal_approved')}</span></div>
        <div style={{ fontSize:'11px', color:'#888', marginTop:'4px' }}>/ {compactDuration(assignedMins)} {translate(language, 'cal_assigned')}{profile?.maxHours ? ` · ${translate(language, 'cal_cap')}: ${profile.minHours ? `${profile.minHours*4}–` : ''}${profile.maxHours*4}h` : ''}</div>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', fontSize: '11px', color: '#666', flexWrap:'wrap' }}>
        <span>🔵 {translate(language, 'cal_scheduled')}</span><span>🟢 {translate(language, 'cal_worked')}</span><span>🔴 {translate(language, 'cal_absent')}</span><span>🟣 {translate(language, 'cal_sick')}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
        {['Mo','Tu','We','Th','Fr','Sa','Su'].map(d => (
          <div key={d} style={{ textAlign: 'center', fontSize: '10px', color: '#888', fontWeight: '600', paddingBottom: '2px' }}>{d}</div>
        ))}
        {cells.map((d, i) => {
          if (d === null) return <div key={`e${i}`} />;
          const dateStr = `${year}-${month}-${String(d).padStart(2, '0')}`;
          const dayShifts = dayMap[dateStr];
          const cs = cellStyle(dayShifts);
          const isSelected = selectedDate === dateStr;
          const kinds = dayShifts ? dayShifts.map(shiftKind) : [];
          return (
            <div key={d} onClick={() => setSelectedDate(isSelected ? null : dateStr)} style={{ ...cs, borderRadius: '6px', padding: '4px 2px', textAlign: 'center', minHeight: '46px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: isSelected ? '2px solid var(--brand)' : '2px solid transparent' }}>
              <div style={{ fontSize: '11px', fontWeight: '700' }}>{d}</div>
              {kinds.includes('scheduled') && <div style={{ fontSize: '9px' }}>🔵</div>}
              {kinds.includes('worked') && <div style={{ fontSize: '9px' }}>🟢</div>}
              {kinds.includes('sick') && <div style={{ fontSize: '9px' }}>🟣</div>}
              {kinds.includes('absent') && <div style={{ fontSize: '9px' }}>🔴</div>}
            </div>
          );
        })}
      </div>
      {selectedDate && (
        <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginTop:'12px' }}>
          <div style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d', marginBottom:'6px' }}>{selectedDate}</div>
          {selectedShifts.length === 0 && <div style={{ fontSize:'12px', color:'#aaa' }}>{translate(language, 'cal_no_shift')}</div>}
          {selectedShifts.map(sh => {
            const kind = shiftKind(sh);
            return (
              <div key={sh.id} style={{ marginBottom:'8px', paddingBottom:'8px', borderBottom:'1px solid #e8e8e8' }}>
                {kind === 'scheduled' && (
                  <div>
                    <div style={{ fontSize:'13px', color:'#1565c0' }}>🔵 {translate(language, 'cal_scheduled')}: {sh.time} <span style={{ color:'#888', fontSize:'11px' }}>({translate(language, 'cal_not_completed')})</span></div>
                    {onMarkAbsent && !isUpcoming(sh.date) && (
                      <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'3px 8px', marginTop:'6px' }} onClick={() => onMarkAbsent(sh)}>❌ {translate(language, 'cal_mark_absent')}</button>
                    )}
                  </div>
                )}
                {kind === 'worked' && <div style={{ fontSize:'13px', color:'#2e7d32' }}>✅ {translate(language, 'cal_worked')} {sh.workedFrom} – {sh.workedTo} ({compactDuration(durationMins(sh.workedFrom, sh.workedTo))})</div>}
                {kind === 'sick' && <div style={{ fontSize:'13px', color:'#8e24aa' }}>🤒 {translate(language, 'cal_sick_leave')}{sh.missedDesc ? ` — ${sh.missedDesc}` : ''}</div>}
                {kind === 'absent' && <div style={{ fontSize:'13px', color:'#b71c1c' }}>❌ {translate(language, 'cal_absent')}{sh.missedDesc ? ` — ${sh.missedDesc}` : ''}</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Month calendar for Issues — orange = raised that day, green = resolved that day
// (a day can show both if an issue was opened and closed the same day).
function IssueCalendarView({ issues, language }) {
  const [year, setYear] = useState(today.slice(0, 4));
  const [month, setMonth] = useState(String(new Date(today).getMonth() + 1).padStart(2, '0'));
  const [selectedDate, setSelectedDate] = useState(null);

  const years = (() => {
    const set = new Set();
    issues.forEach(iss => { if (iss.raisedDate) set.add(iss.raisedDate.slice(0,4)); if (iss.resolvedDate) set.add(iss.resolvedDate.slice(0,4)); });
    set.add(today.slice(0, 4));
    return Array.from(set).sort().reverse();
  })();

  const daysInMonth = new Date(parseInt(year), parseInt(month), 0).getDate();
  const firstDay = new Date(parseInt(year), parseInt(month) - 1, 1).getDay();
  const offset = (firstDay + 6) % 7;

  const raisedMap = {}, resolvedMap = {};
  issues.forEach(iss => {
    if (iss.raisedDate && iss.raisedDate.startsWith(`${year}-${month}`)) raisedMap[iss.raisedDate] = (raisedMap[iss.raisedDate] || 0) + 1;
    if (iss.resolvedDate && iss.resolvedDate.startsWith(`${year}-${month}`)) resolvedMap[iss.resolvedDate] = (resolvedMap[iss.resolvedDate] || 0) + 1;
  });

  const cells = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const selectedIssues = selectedDate ? issues.filter(iss => iss.raisedDate === selectedDate || iss.resolvedDate === selectedDate) : [];

  return (
    <div style={{ background: 'white', borderRadius: '8px', padding: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
        <select style={{ ...s.selectInput, marginBottom: 0, flex: 1 }} value={year} onChange={e => { setYear(e.target.value); setSelectedDate(null); }}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={{ ...s.selectInput, marginBottom: 0, flex: 1 }} value={month} onChange={e => { setMonth(e.target.value); setSelectedDate(null); }}>
          {MONTH_NAMES.map((mName, i) => <option key={mName} value={String(i + 1).padStart(2, '0')}>{mName}</option>)}
        </select>
      </div>
      <div style={{ display: 'flex', gap: '12px', marginBottom: '10px', fontSize: '11px', color: '#666' }}>
        <span>🟠 Raised</span><span>🟢 Resolved</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
        {['Mo','Tu','We','Th','Fr','Sa','Su'].map(d => (
          <div key={d} style={{ textAlign: 'center', fontSize: '10px', color: '#888', fontWeight: '600', paddingBottom: '2px' }}>{d}</div>
        ))}
        {cells.map((d, i) => {
          if (d === null) return <div key={`e${i}`} />;
          const dateStr = `${year}-${month}-${String(d).padStart(2, '0')}`;
          const raised = raisedMap[dateStr], resolved = resolvedMap[dateStr];
          const hasAny = raised || resolved;
          const isSelected = selectedDate === dateStr;
          return (
            <div key={d} onClick={() => setSelectedDate(isSelected ? null : dateStr)} style={{ background: hasAny ? '#fff8f0' : '#f5f6fa', borderRadius: '6px', padding: '4px 2px', textAlign: 'center', minHeight: '46px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: isSelected ? '2px solid var(--brand)' : '2px solid transparent' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: hasAny ? '#2d2d2d' : '#aaa' }}>{d}</div>
              {raised && <div style={{ fontSize: '9px' }}>🟠{raised > 1 ? `×${raised}` : ''}</div>}
              {resolved && <div style={{ fontSize: '9px' }}>🟢{resolved > 1 ? `×${resolved}` : ''}</div>}
            </div>
          );
        })}
      </div>
      {selectedDate && (
        <div style={{ marginTop:'12px' }}>
          <div style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d', marginBottom:'6px' }}>{selectedDate}</div>
          {selectedIssues.length === 0 && <div style={{ fontSize:'12px', color:'#aaa' }}>No issues on this day.</div>}
          {selectedIssues.map(iss => (
            <div key={iss.id} style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                <div style={{ fontSize:'13px', fontWeight:'600', color:'#2d2d2d' }}>{iss.employee}</div>
                <span style={getBadgeStyle(iss.status)}>{translateStatus(language, iss.status)}</span>
              </div>
              <div style={{ fontSize:'12px', color:'#888', marginBottom:'4px' }}>{iss.type} · {iss.shift}</div>
              <div style={{ fontSize:'13px', color:'#555' }}>{iss.description}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function WorkedHistory({ shifts, employeeName, year: controlledYear, month: controlledMonth, onYearChange, onMonthChange, language }) {
  const years = getAvailableYears(shifts, employeeName);
  const [internalYear, setInternalYear] = useState(today.slice(0, 4));
  const [internalMonth, setInternalMonth] = useState(String(new Date(today).getMonth() + 1).padStart(2, '0'));
  const year = controlledYear !== undefined ? controlledYear : internalYear;
  const month = controlledMonth !== undefined ? controlledMonth : internalMonth;
  const setYear = onYearChange || setInternalYear;
  const setMonth = onMonthChange || setInternalMonth;
  const monthly = getMonthlyForYear(shifts, employeeName, year);
  const activeMonth = monthly.find(m => m.mm === month);
  const monthShifts = shifts.filter(sh => sh.employee === employeeName && sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo && sh.date.startsWith(`${year}-${month}`)).sort((a,b) => a.date.localeCompare(b.date));
  const allTimeTotal = buildWorkedHistory(shifts, employeeName).totalMins;

  return (
    <div style={{ background:'white', borderRadius:'8px', padding:'10px' }}>
      <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{translate(language, 'wh_alltime_total')}: <strong style={{ color:'#2d2d2d' }}>{formatDuration(allTimeTotal)}</strong></div>
      <div style={{ display:'flex', gap:'8px', marginBottom:'8px' }}>
        <select style={{ ...s.selectInput, marginBottom:0, flex:1 }} value={year} onChange={e => setYear(e.target.value)}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={{ ...s.selectInput, marginBottom:0, flex:1 }} value={month} onChange={e => setMonth(e.target.value)}>
          {monthly.map(m => <option key={m.mm} value={m.mm}>{m.label}</option>)}
        </select>
      </div>
      <div style={{ fontSize:'13px', color:'#2d2d2d', marginBottom: monthShifts.length ? '10px' : '0' }}>
        {activeMonth?.label} {year}: <strong>{formatDuration(activeMonth?.mins)}</strong>
      </div>
      {monthShifts.length === 0 ? (
        <div style={{ fontSize:'12px', color:'#aaa' }}>No worked shifts logged in this month.</div>
      ) : (
        monthShifts.map(sh => (
          <div key={sh.id} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #f0f0f0', fontSize:'12px' }}>
            <span>{sh.dateLabel}</span>
            <span style={{ color:'#2e7d32' }}>{sh.workedFrom} – {sh.workedTo} ({formatDuration(durationMins(sh.workedFrom, sh.workedTo))})</span>
          </div>
        ))
      )}
    </div>
  );
}

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = ['00', '15', '30', '45'];

// Two dropdowns (hour + minute) that always produce a clean 15-min value, e.g. "09:15"
// A small circular progress ring — fills proportionally to hours-assigned vs cap,
// color shifts green → amber → red as it fills, remaining portion stays blank.
function HourRing({ mins, maxMins, label, capLabel, size = 56 }) {
  const pct = maxMins ? Math.min(1, mins / maxMins) : 0;
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - pct);
  let color = '#888';
  if (maxMins) {
    const ratio = mins / maxMins;
    if (ratio >= 1) color = '#b71c1c';
    else if (ratio >= 0.75) color = 'var(--brand-dark)';
    else color = '#2e7d32';
  }
  return (
    <div style={{ textAlign:'center' }}>
      <div style={{ fontSize:'10px', color:'#888', marginBottom:'2px' }}>{label}</div>
      <div style={{ position:'relative', width:size, height:size, margin:'0 auto' }}>
        <svg width={size} height={size} style={{ transform:'rotate(-90deg)' }}>
          <circle cx={size/2} cy={size/2} r={radius} fill='none' stroke='#f0f0f0' strokeWidth='6' />
          <circle cx={size/2} cy={size/2} r={radius} fill='none' stroke={color} strokeWidth='6' strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap='round' style={{ transition:'stroke-dashoffset 0.4s ease' }} />
        </svg>
        <div style={{ position:'absolute', top:0, left:0, right:0, bottom:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', fontWeight:'700', color:'#2d2d2d' }}>
          {compactDuration(mins)}
        </div>
      </div>
      <div style={{ fontSize:'9px', color:'#aaa', marginTop:'2px' }}>{capLabel}</div>
    </div>
  );
}

// Drag-to-select time range — tap and drag across the day to set From/To, matching the
// visual scheduling pattern used by established shift-scheduling tools (drag directly on
// a timeline to create/adjust a block) instead of picking each time from a dropdown list.
function DragTimeRange({ from, to, onChange }) {
  const trackRef = useRef();
  const [drag, setDrag] = useState(null);
  const [live, setLive] = useState(null);
  const DAY_END = 24 * 60;
  const SNAP = 15;

  function toMins(t) { if (!t) return null; const [h, m] = t.split(':').map(Number); return h * 60 + m; }
  function fmt(mins) { const h = Math.floor(mins / 60), m = mins % 60; return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`; }
  function minsFromClientX(clientX) {
    const rect = trackRef.current.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    return Math.round((pct * DAY_END) / SNAP) * SNAP;
  }
  function getX(e) { return e.clientX ?? (e.touches && e.touches[0] && e.touches[0].clientX); }

  const savedFrom = toMins(from), savedTo = toMins(to);
  const curFrom = live ? live.from : savedFrom;
  const curTo = live ? live.to : savedTo;
  const hasRange = curFrom !== null && curTo !== null && curTo > curFrom;

  function startDrag(mode, extra) {
    return (e) => {
      e.preventDefault(); e.stopPropagation();
      const clientX = getX(e);
      if (mode === 'create') {
        const mins = minsFromClientX(clientX);
        setDrag({ mode, anchor: mins });
        setLive({ from: mins, to: mins });
      } else {
        setDrag({ mode, origFrom: curFrom, origTo: curTo, startClientX: clientX });
        setLive({ from: curFrom, to: curTo });
      }
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    };
  }

  function onMove(e) {
    const clientX = getX(e);
    if (clientX == null) return;
    if (e.preventDefault) e.preventDefault();
    const mins = minsFromClientX(clientX);
    setDrag(d => {
      if (!d) return d;
      if (d.mode === 'create') setLive({ from: Math.min(d.anchor, mins), to: Math.max(d.anchor, mins) });
      else if (d.mode === 'start') setLive(l => ({ from: Math.min(mins, l.to - SNAP), to: l.to }));
      else if (d.mode === 'end') setLive(l => ({ from: l.from, to: Math.max(mins, l.from + SNAP) }));
      else if (d.mode === 'move') {
        const rect = trackRef.current.getBoundingClientRect();
        const deltaMins = Math.round(((clientX - d.startClientX) / rect.width) * DAY_END / SNAP) * SNAP;
        const span = d.origTo - d.origFrom;
        const newFrom = Math.max(0, Math.min(DAY_END - span, d.origFrom + deltaMins));
        setLive({ from: newFrom, to: newFrom + span });
      }
      return d;
    });
  }

  function onUp() {
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    setDrag(null);
    setLive(l => { if (l && l.to > l.from) onChange(fmt(l.from), fmt(l.to)); return null; });
  }

  const leftPct = hasRange ? (curFrom / DAY_END) * 100 : 0;
  const widthPct = hasRange ? ((curTo - curFrom) / DAY_END) * 100 : 0;

  return (
    <div>
      {hasRange && (
        <div style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:'10px', marginBottom:'6px' }}>
          <div style={{ fontSize:'13px', fontWeight:'700', color:'var(--brand-dark)' }}>{fmt(curFrom)} – {fmt(curTo)}</div>
          <span style={{ fontSize:'12px', color:'#b71c1c', fontWeight:'600', cursor:'pointer' }} onClick={() => { setLive(null); onChange('', ''); }}>✕ Clear</span>
        </div>
      )}
      <div ref={trackRef} onPointerDown={startDrag('create')}
        style={{ position:'relative', height:'40px', background:'#F1EEE9', borderRadius:'8px', touchAction:'none', cursor:'pointer', userSelect:'none' }}>
        {[0,6,12,18,24].map(h => (
          <div key={h} style={{ position:'absolute', left:`${(h*60/DAY_END)*100}%`, top:0, bottom:0, width:'1px', background:'#e0dcd4' }} />
        ))}
        {hasRange && (
          <div style={{ position:'absolute', top:'4px', bottom:'4px', left:`${leftPct}%`, width:`${widthPct}%`, background:'var(--brand)', borderRadius:'6px', cursor:'grab' }}
            onPointerDown={startDrag('move')}>
            <div data-handle onPointerDown={startDrag('start')}
              style={{ position:'absolute', left:'-6px', top:'-4px', bottom:'-4px', width:'16px', cursor:'ew-resize' }} />
            <div data-handle onPointerDown={startDrag('end')}
              style={{ position:'absolute', right:'-6px', top:'-4px', bottom:'-4px', width:'16px', cursor:'ew-resize' }} />
          </div>
        )}
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', fontSize:'10px', color:'#aaa', marginTop:'4px' }}>
        <span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span><span>24:00</span>
      </div>
      {!hasRange && <div style={{ fontSize:'11px', color:'#aaa', textAlign:'center', marginTop:'4px' }}>Drag across the timeline to set your available hours</div>}
    </div>
  );
}

function TimeSelect({ value, onChange }) {
  const [h, m] = value ? value.split(':') : ['', ''];
  return (
    <div style={{ display:'flex', gap:'4px', flex:1 }}>
      <select style={{ ...s.selectInput, marginBottom:0, flex:1, padding:'11px 6px' }} value={h} onChange={e => onChange(`${e.target.value}:${m || '00'}`)}>
        <option value=''>HH</option>
        {HOURS.map(hh => <option key={hh} value={hh}>{hh}</option>)}
      </select>
      <select style={{ ...s.selectInput, marginBottom:0, flex:1, padding:'11px 6px' }} value={m} onChange={e => onChange(`${h || '00'}:${e.target.value}`)}>
        <option value=''>MM</option>
        {MINUTES.map(mm => <option key={mm} value={mm}>{mm}</option>)}
      </select>
    </div>
  );
}

// A real swipe-to-confirm control (rounded rectangle track, fills solid as it's dragged,
// snaps back if released early) — used for confirming worked hours. Accepts a color so
// the fill can look different when the submission includes overtime.
function SwipeToConfirm({ onComplete, disabled, color = 'var(--brand)', label = 'Swipe right to complete' }) {
  const [percent, setPercent] = useState(0);
  const [dragging, setDragging] = useState(false);
  const trackRef = useRef();
  const HANDLE = 32;

  function updateFromClientX(clientX) {
    const track = trackRef.current;
    if (!track) return;
    const rect = track.getBoundingClientRect();
    const usable = Math.max(1, rect.width - HANDLE);
    const x = clientX - rect.left - HANDLE / 2;
    setPercent(Math.max(0, Math.min(100, (x / usable) * 100)));
  }
  function onDown() { if (!disabled) setDragging(true); }
  function onMove(clientX) { if (dragging) updateFromClientX(clientX); }
  function finish() {
    if (!dragging) return;
    setDragging(false);
    if (percent >= 88) {
      setPercent(100);
      onComplete();
      setTimeout(() => setPercent(0), 500);
    } else {
      setPercent(0);
    }
  }
  const trackWidth = trackRef.current?.offsetWidth || 300;
  const handleLeft = 3 + (percent / 100) * Math.max(0, trackWidth - HANDLE - 6);

  return (
    <div
      ref={trackRef}
      onMouseMove={e => onMove(e.clientX)}
      onMouseUp={finish}
      onMouseLeave={finish}
      onTouchMove={e => onMove(e.touches[0].clientX)}
      onTouchEnd={finish}
      style={{ position:'relative', height:'44px', borderRadius:'14px', background:'#eef0f4', overflow:'hidden', opacity: disabled ? 0.5 : 1, touchAction:'none', userSelect:'none', marginBottom:'10px' }}
    >
      <div style={{ position:'absolute', top:0, left:0, bottom:0, width:`${percent}%`, background:color, transition: dragging ? 'none' : 'width 0.25s ease' }} />
      <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px', fontWeight:'700', color: percent > 45 ? 'white' : '#888', transition:'color 0.2s' }}>
        {percent >= 95 ? '✅ Submitted!' : `${label} →`}
      </div>
      <div
        onMouseDown={onDown}
        onTouchStart={onDown}
        style={{
          position:'absolute', top:'6px', left:`${handleLeft}px`, width:`${HANDLE}px`, height:'32px',
          borderRadius:'9px', background:color, border:'3px solid white', display:'flex', alignItems:'center', justifyContent:'center',
          fontSize:'22px', fontWeight:'900', color:'white', boxShadow:'0 2px 8px rgba(0,0,0,0.3)', cursor: disabled ? 'not-allowed' : 'grab',
          transition: dragging ? 'none' : 'left 0.25s ease',
        }}
      >→</div>
    </div>
  );
}

// Circular orange/white back & forward buttons — genuine navigation history, like a browser
function NavControls({ canBack, canForward, onBack, onForward }) {
  return (
    <div style={{ display:'flex', gap:'8px', marginBottom:'2px' }}>
      <button style={s.navControlBtn(canBack)} onClick={canBack ? onBack : undefined} disabled={!canBack}>‹</button>
      <button style={s.navControlBtn(canForward)} onClick={canForward ? onForward : undefined} disabled={!canForward}>›</button>
    </div>
  );
}

// Categorized menu row (icon + label + badge + chevron) — tap to expand/collapse or navigate
function MenuRow({ icon, label, badge, open, onClick, last }) {
  return (
    <div style={{ ...s.menuRow, borderBottom: last ? 'none' : '1px solid #f0f0f0' }} onClick={onClick}>
      <div style={s.menuRowLeft}>
        <span style={s.menuRowIcon}>{icon}</span>
        <span style={s.menuRowLabel}>{label}</span>
        {badge}
      </div>
      <span style={s.menuChevron(open)}>{open !== undefined ? '⌄' : '›'}</span>
    </div>
  );
}

// Shows a certificate/document right in the app instead of forcing a download —
// images render directly, PDFs render inline via the browser's built-in PDF viewer.
function CertificateViewer({ fileName, fileData }) {
  const [expanded, setExpanded] = useState(false);
  if (!fileData) return null;
  const isImage = fileData.startsWith('data:image');
  return (
    <div>
      <span style={{ fontSize:'12px', color:'#4A3CDB', cursor:'pointer', textDecoration:'underline' }} onClick={() => setExpanded(!expanded)}>
        {expanded ? '▾' : '▸'} 📎 {fileName || 'View certificate'}
      </span>
      {expanded && (
        <div style={{ marginTop:'8px' }}>
          <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'4px' }}>
            <span style={{ fontSize:'13px', color:'#b71c1c', fontWeight:'700', cursor:'pointer', padding:'2px 8px' }} onClick={() => setExpanded(false)}>✕ Close</span>
          </div>
          <div style={{ borderRadius:'8px', overflow:'hidden', border:'1px solid #e0e0e0' }}>
            {isImage ? (
              <img src={fileData} alt={fileName} style={{ width:'100%', display:'block' }} />
            ) : (
              <embed src={fileData} type="application/pdf" style={{ width:'100%', height:'400px' }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── EMPLOYEE APP ────────────────────────────────────────────────
function EmployeeApp({ user, shifts, availList, salarySlips, onSubmitAvail, onEditAvail, onRemoveAvail, onReportIssue, onIssueReply, onUpdateIssue, issues, onUpdateShiftAttendance, profiles, onUpdateProfile, onAddProfileDocument, sickReports, onSubmitSick, onUpdateSickReport, employeeRecords, swapRequests, onAddSwapRequest, onUpdateSwapRequest, leaveRequests, onAddLeaveRequest, onUpdateLeaveRequest, onDeleteLeaveRequest, onUpdateSalarySlip, dayOffChoices, onSetDayOffChoice, fixedScheduleConfig, language, setLanguage, onLogout }) {
  const t = (key) => translate(language, key);
  const [tab, setTab] = useState('home');
  const [tabHistory, setTabHistory] = useState(['home']);
  const [historyIndex, setHistoryIndex] = useState(0);

  function navigateTo(newTab) {
    if (newTab === tab) return;
    const trimmed = tabHistory.slice(0, historyIndex + 1);
    trimmed.push(newTab);
    setTabHistory(trimmed);
    setHistoryIndex(trimmed.length - 1);
    setTab(newTab);
  }
  function goBack() {
    if (historyIndex === 0) return;
    const newIndex = historyIndex - 1;
    setHistoryIndex(newIndex);
    setTab(tabHistory[newIndex]);
  }
  function goForward() {
    if (historyIndex >= tabHistory.length - 1) return;
    const newIndex = historyIndex + 1;
    setHistoryIndex(newIndex);
    setTab(tabHistory[newIndex]);
  }

  const myShifts = shifts.filter(sh => sh.employee === user.name);
  const myUpcoming = myShifts.filter(sh => isUpcoming(sh.date));
  const myCompleted = myShifts.filter(sh => !isUpcoming(sh.date));
  const myAvail = availList.filter(a => a.employee === user.name);
  const mySlips = salarySlips.filter(sl => sl.employee === user.name);
  const myIssues = issues.filter(iss => iss.employee === user.name);

  const [weekStart, weekEnd] = getWeekRange(today);
  const monthPrefix = today.slice(0, 7);
  const workedShifts = myShifts.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo);
  const sickShifts = myShifts.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem' && sh.payApproved);
  const weekMins = workedShifts.filter(sh => sh.date >= weekStart && sh.date <= weekEnd).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0)
    + sickShifts.filter(sh => sh.date >= weekStart && sh.date <= weekEnd).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const monthMins = workedShifts.filter(sh => sh.date.startsWith(monthPrefix)).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0)
    + sickShifts.filter(sh => sh.date.startsWith(monthPrefix)).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const weekApprovedMins = workedShifts.filter(sh => sh.date >= weekStart && sh.date <= weekEnd && sh.attendanceApproved).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0)
    + sickShifts.filter(sh => sh.date >= weekStart && sh.date <= weekEnd).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const monthApprovedMins = workedShifts.filter(sh => sh.date.startsWith(monthPrefix) && sh.attendanceApproved).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0)
    + sickShifts.filter(sh => sh.date.startsWith(monthPrefix)).reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const weekShiftsAll = myShifts.filter(sh => sh.date >= weekStart && sh.date <= weekEnd);
  const monthShiftsAll = myShifts.filter(sh => sh.date.startsWith(monthPrefix));
  const weekAssignedMins = weekShiftsAll.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const monthAssignedMins = monthShiftsAll.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
  const myCapProfile = profiles[user.name] || { minHours: '', maxHours: '' };

  const [actionShift, setActionShift] = useState(null); // { id, mode: 'missed' }
  const [missedDesc, setMissedDesc] = useState('');
  const [clockBusy, setClockBusy] = useState(false); // true while capturing location/waiting on camera
  const [clockError, setClockError] = useState('');
  const [clockPendingShiftId, setClockPendingShiftId] = useState(null); // which shift is mid clock-in/out action
  const [expandedShiftId, setExpandedShiftId] = useState(null); // which upcoming/today shift row is tapped open
  const [swapRequestFor, setSwapRequestFor] = useState(null);
  const [swapRequestNote, setSwapRequestNote] = useState('');
  const [swapTargetEmployee, setSwapTargetEmployee] = useState('');
  const [weekOffSwapOpen, setWeekOffSwapOpen] = useState(false);
  const [swapRequestType, setSwapRequestType] = useState(null);
  const [respondingToSwapId, setRespondingToSwapId] = useState(null);
  const [selectedOwnShiftForSwap, setSelectedOwnShiftForSwap] = useState('');
  const [pendingLateClockIn, setPendingLateClockIn] = useState(null); // { shiftId, timeStr, photoData, location } — held until a reason is given
  const [lateClockInNote, setLateClockInNote] = useState('');
  const [pendingClockOutReason, setPendingClockOutReason] = useState(null); // { shiftId, clockInTime, timeStr, photoData, location, kind: 'early'|'late' }
  const [clockOutReasonNote, setClockOutReasonNote] = useState('');
  const myUpcomingOrToday = myShifts.filter(sh => sh.date >= today);
  const myShiftsUpcoming = myShifts.filter(sh => getShiftPhase(sh) === 'upcoming');
  const myShiftsOngoing = myShifts.filter(sh => getShiftPhase(sh) === 'ongoing');
  const myShiftsCompletedNew = myShifts.filter(sh => getShiftPhase(sh) === 'completed');
  const myShiftsMissed = myShifts.filter(sh => getShiftPhase(sh) === 'missed');

  // Captures the device's current GPS location. Resolves with null (rather than
  // rejecting) if permission is denied or unavailable, so a missing location never
  // blocks someone from clocking in — it's a verification signal, not a hard gate.
  function captureLocation() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) { resolve(null); return; }
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => resolve(null),
        { timeout: 8000, enableHighAccuracy: true }
      );
    });
  }

  async function startClockIn(sh) {
    setClockError(''); setClockBusy(true); setClockPendingShiftId(sh.id);
    try {
      const location = await captureLocation();
      const now = new Date();
      const timeStr = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
      const [scheduledStart] = sh.time.split(' – ');
      if (timeStr > scheduledStart) {
        // Late arrival — hold the captured location until a reason is given.
        setPendingLateClockIn({ shiftId: sh.id, timeStr, location });
        setLateClockInNote('');
        setClockBusy(false); setClockPendingShiftId(null);
        return;
      }
      await onUpdateShiftAttendance(sh.id, {
        attendance: 'Clocked In',
        clockInTime: timeStr, clockInServerTS: serverTimestamp(),
        clockInLat: location ? location.lat : null, clockInLng: location ? location.lng : null,
      });
    } catch (err) {
      setClockError(`Something went wrong: ${err?.message || 'please try again.'}`);
    }
    setClockBusy(false); setClockPendingShiftId(null);
  }

  async function startClockOut(sh) {
    setClockError(''); setClockBusy(true); setClockPendingShiftId(sh.id);
    try {
      const location = await captureLocation();
      const now = new Date();
      const liveTimeStr = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
      const clockInTime = sh.clockInTime || liveTimeStr;
      const [, scheduledEnd] = sh.time.split(' – ');
      const forgotToClockOut = sh.date !== today; // the real calendar date has already moved past the shift's own day
      // If they forgot entirely, today's time-of-day is meaningless for this shift —
      // fall back to the shift's own scheduled end time as the sensible default, and
      // always require an explanation regardless of how that compares to the schedule.
      const timeStr = forgotToClockOut ? scheduledEnd : liveTimeStr;
      if (forgotToClockOut || timeStr !== scheduledEnd) {
        // Either early (missed time), late (overtime), or genuinely forgotten — either
        // way, a reason is required before the clock-out actually submits.
        setPendingClockOutReason({ shiftId: sh.id, clockInTime, timeStr, location, kind: forgotToClockOut ? 'forgot' : (timeStr < scheduledEnd ? 'early' : 'late') });
        setClockOutReasonNote('');
        setClockBusy(false); setClockPendingShiftId(null);
        return;
      }
      await onUpdateShiftAttendance(sh.id, {
        attendance: 'Worked', attendanceApproved: false,
        workedFrom: clockInTime, workedTo: timeStr,
        clockOutTime: timeStr, clockOutServerTS: serverTimestamp(),
        clockOutLat: location ? location.lat : null, clockOutLng: location ? location.lng : null,
      });
    } catch (err) {
      setClockError(`Something went wrong: ${err?.message || 'please try again.'}`);
    }
    setClockBusy(false); setClockPendingShiftId(null);
  }

  function submitLateClockIn() {
    if (!pendingLateClockIn || !lateClockInNote.trim()) return;
    const { shiftId, timeStr, location } = pendingLateClockIn;
    onUpdateShiftAttendance(shiftId, {
      attendance: 'Clocked In',
      clockInTime: timeStr, clockInServerTS: serverTimestamp(),
      clockInLat: location ? location.lat : null, clockInLng: location ? location.lng : null,
      clockInLate: true, clockInLateNote: lateClockInNote.trim(),
    });
    setPendingLateClockIn(null); setLateClockInNote('');
  }
  function cancelLateClockIn() { setPendingLateClockIn(null); setLateClockInNote(''); }

  function submitClockOutReason() {
    if (!pendingClockOutReason || !clockOutReasonNote.trim()) return;
    const { shiftId, clockInTime, timeStr, location, kind } = pendingClockOutReason;
    onUpdateShiftAttendance(shiftId, {
      attendance: 'Worked', attendanceApproved: false,
      workedFrom: clockInTime, workedTo: timeStr,
      clockOutTime: timeStr, clockOutServerTS: serverTimestamp(),
      clockOutLat: location ? location.lat : null, clockOutLng: location ? location.lng : null,
      endedEarly: kind === 'early', earlyEndNote: kind === 'early' ? clockOutReasonNote.trim() : '',
      endedLate: kind === 'late', lateEndNote: kind === 'late' ? clockOutReasonNote.trim() : '',
      forgotClockOut: kind === 'forgot', forgotClockOutNote: kind === 'forgot' ? clockOutReasonNote.trim() : '',
    });
    setPendingClockOutReason(null); setClockOutReasonNote('');
  }
  function cancelClockOutReason() { setPendingClockOutReason(null); setClockOutReasonNote(''); }

  // Shared row renderer for Home's "Upcoming Shifts" card and the Shifts tab's
  // "Upcoming" list — tap the shift itself to reveal the clock-in/out action below it,
  // rather than always-visible buttons cluttering the list.
  // Whether it's currently within 30 minutes before this shift's start (through its end) —
  // the real, actionable window for clocking in. Outside this window, the shift is still
  // tappable to view, but clocking in is blocked with a clear explanation.
  function getClockWindow(sh) {
    const [startStr] = sh.time.split(' – ');
    const [sh_, sm_] = startStr.split(':').map(Number);
    const shiftStart = new Date(`${sh.date}T00:00:00`);
    shiftStart.setHours(sh_, sm_, 0, 0);
    const windowOpen = new Date(shiftStart.getTime() - 30 * 60000);
    const now = new Date();
    return { withinWindow: now >= windowOpen && sh.date === today, windowOpen, shiftStart };
  }

  // Which of the 4 shift tabs a shift actually belongs in — based on its real attendance
  // state and the actual clock, not just its calendar date. A shift already reported
  // (Worked, or Missed-with-a-reason) is "resolved" and belongs in Completed regardless
  // of date; only a still-unreported Pending shift moves through Upcoming → Ongoing →
  // Missed as real time passes.
  function getShiftPhase(sh) {
    if (sh.attendance === 'Worked') return 'completed';
    if (sh.attendance === 'Missed' && sh.missedDesc) return 'completed'; // already explained
    if (sh.attendance === 'Clocked In') return 'ongoing';
    // Remaining case: attendance === 'Pending' (or 'Missed' with no reason yet, treated the same)
    const [, endStr] = sh.time.split(' – ');
    const [eh_, em_] = endStr.split(':').map(Number);
    const shiftEnd = new Date(`${sh.date}T00:00:00`);
    shiftEnd.setHours(eh_, em_, 0, 0);
    const { withinWindow, windowOpen } = getClockWindow(sh);
    const now = new Date();
    if (now > shiftEnd) return 'missed';
    if (withinWindow || now >= windowOpen) return 'ongoing';
    return 'upcoming';
  }

  function renderShiftRow(sh, isLast) {
    const isOpen = expandedShiftId === sh.id;
    const isPending = sh.attendance === 'Pending';
    const isClockedIn = sh.attendance === 'Clocked In';
    const tappable = isPending || isClockedIn;
    const { withinWindow, windowOpen } = tappable ? getClockWindow(sh) : {};
    return (
      <div key={sh.id}>
        <div
          role={tappable ? 'button' : undefined} tabIndex={tappable ? 0 : undefined}
          onClick={tappable ? () => setExpandedShiftId(isOpen ? null : sh.id) : undefined}
          style={{ ...(isLast && !isOpen ? s.rowLast : s.row), cursor: tappable ? 'pointer' : 'default' }}
        >
          <div>
            <div style={s.name}>{sh.dateLabel}</div>
            <div style={s.sub}>{sh.time}</div>
            {sh.attendance === 'Missed' && <div style={{ fontSize:'11px', color:'#b71c1c', marginTop:'2px' }}>🤒 {t('shifts_marked_sick')}</div>}
            {sh.attendance === 'Clocked In' && <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'2px', fontWeight:'600' }}>🕐 Clocked in at {sh.clockInTime}</div>}
          </div>
          <span style={getBadgeStyle(sh.attendance === 'Missed' ? 'Missed' : sh.attendance === 'Clocked In' ? 'Confirmed' : sh.status)}>{sh.attendance === 'Missed' ? translate(language, 'status_sick_leave') : sh.attendance === 'Clocked In' ? 'Clocked In' : translateStatus(language, sh.status)}</span>
        </div>
        {isOpen && isPending && withinWindow && !pendingLateClockIn && (
          <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            <SwipeToConfirm disabled={clockBusy && clockPendingShiftId===sh.id} color='var(--brand)' label={clockBusy && clockPendingShiftId===sh.id ? 'Working…' : 'Swipe right to Clock In'} onComplete={() => startClockIn(sh)} />
          </div>
        )}
        {isOpen && isPending && !withinWindow && (
          <div style={{ background:'#fff8e1', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            <div style={{ fontSize:'12px', color:'#8a6d00', fontWeight:'500' }}>
              {sh.date !== today
                ? `⏰ This isn't today's shift. You can clock in from ${String(windowOpen.getHours()).padStart(2,'0')}:${String(windowOpen.getMinutes()).padStart(2,'0')} on ${sh.dateLabel}.`
                : `⏰ You can clock in starting at ${String(windowOpen.getHours()).padStart(2,'0')}:${String(windowOpen.getMinutes()).padStart(2,'0')} (30 minutes before your shift).`}
            </div>
            {(() => {
              const req = swapRequests.find(r => r.shiftId === sh.id && r.employee === user.name);
              const isDeclined = req?.stage === 'declined_by_colleague' || req?.stage === 'declined_by_admin';
              if (sh.date !== today && (!req || isDeclined)) {
                return (
                  <div style={{ marginTop:'10px', paddingTop:'10px', borderTop:'1px solid #f0e0b0' }}>
                    {req?.stage === 'declined_by_colleague' && <div style={{ fontSize:'11px', color:'#b71c1c', marginBottom:'6px', fontWeight:'600' }}>✕ {t('swap_status_declined_colleague').replace('{name}', req.targetEmployee)}</div>}
                    {req?.stage === 'declined_by_admin' && <div style={{ fontSize:'11px', color:'#b71c1c', marginBottom:'6px', fontWeight:'600' }}>✕ {t('swap_status_declined')}</div>}
                    <span style={{ fontSize:'12px', color:'#4A3CDB', cursor:'pointer', fontWeight:'600' }} onClick={() => { setSwapRequestFor(sh); setSwapRequestNote(''); setSwapTargetEmployee(''); setSwapRequestType(null); }}>🔄 {t('swap_request_btn')}</span>
                  </div>
                );
              }
              if (req?.stage === 'awaiting_colleague') return <div style={{ fontSize:'11px', color:'var(--brand-dark)', marginTop:'8px', fontWeight:'600' }}>🔄 {t('swap_status_awaiting_colleague').replace('{name}', req.targetEmployee)}</div>;
              if (req?.stage === 'awaiting_admin') return <div style={{ fontSize:'11px', color:'var(--brand-dark)', marginTop:'8px', fontWeight:'600' }}>🔄 {t('swap_status_awaiting_admin')}</div>;
              if (req?.stage === 'resolved') return <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'8px', fontWeight:'600' }}>✅ {t('swap_status_resolved')}</div>;
              return null;
            })()}
          </div>
        )}
        {pendingLateClockIn?.shiftId === sh.id && (
          <div style={{ background:'#fff8e1', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            <div style={{ fontSize:'12px', fontWeight:'600', color:'#8a6d00', marginBottom:'8px' }}>⏰ You're clocking in later than your shift's scheduled start ({sh.time.split(' – ')[0]}) — please explain why below before you can submit.</div>
            <textarea style={{ ...s.input, minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('lh_what_happened')} value={lateClockInNote} onChange={e => setLateClockInNote(e.target.value)} />
            <div style={{ display:'flex', gap:'8px' }}>
              <button style={{ ...s.dangerBtn, flex:1, padding:'10px', opacity: lateClockInNote.trim() ? 1 : 0.5 }} disabled={!lateClockInNote.trim()} onClick={submitLateClockIn}>Submit</button>
              <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={cancelLateClockIn}>{t('avail_cancel')}</button>
            </div>
          </div>
        )}
        {isOpen && isClockedIn && pendingClockOutReason?.shiftId !== sh.id && (
          <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            <SwipeToConfirm disabled={clockBusy && clockPendingShiftId===sh.id} color='#b71c1c' label={clockBusy && clockPendingShiftId===sh.id ? 'Working…' : 'Swipe right to Clock Out'} onComplete={() => startClockOut(sh)} />
          </div>
        )}
        {pendingClockOutReason?.shiftId === sh.id && (
          <div style={{ background:'#fff8e1', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            <div style={{ fontSize:'12px', fontWeight:'600', color:'#8a6d00', marginBottom:'8px' }}>
              {pendingClockOutReason.kind === 'forgot'
                ? `⚠️ This shift was on ${sh.dateLabel} — it looks like you forgot to clock out then. Please explain what happened before you can submit.`
                : pendingClockOutReason.kind === 'early'
                ? `⏰ You're clocking out before your shift's scheduled end (${sh.time.split(' – ')[1]}) — only ${pendingClockOutReason.timeStr} will count. Please explain why below before you can submit.`
                : `⏰ You're clocking out later than your shift's scheduled end (${sh.time.split(' – ')[1]}) — please explain why below before you can submit.`}
            </div>
            {pendingClockOutReason.kind === 'early' && (
              <button style={{ ...s.outlineBtn, width:'100%', padding:'9px', marginBottom:'10px' }} onClick={() => { cancelClockOutReason(); setSickCertFrom(sh.date); setSickCertTo(sh.date); setSickFormOpen(true); navigateTo('sick'); }}>🤒 It was a health problem — submit sick certificate instead</button>
            )}
            <textarea style={{ ...s.input, minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('lh_what_happened')} value={clockOutReasonNote} onChange={e => setClockOutReasonNote(e.target.value)} />
            {pendingClockOutReason.kind === 'early' && <div style={{ fontSize:'11px', color:'#888', marginBottom:'10px' }}>{t('lh_illness_hint')}</div>}
            <div style={{ display:'flex', gap:'8px' }}>
              <button style={{ ...s.dangerBtn, flex:1, padding:'10px', opacity: clockOutReasonNote.trim() ? 1 : 0.5 }} disabled={!clockOutReasonNote.trim()} onClick={submitClockOutReason}>Submit</button>
              <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={cancelClockOutReason}>{t('avail_cancel')}</button>
            </div>
          </div>
        )}
        {isOpen && tappable && clockError && (
          <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom: isLast ? 0 : '10px', fontWeight:'500' }}>⚠️ {clockError}</div>
        )}
        {swapRequestFor?.id === sh.id && (
          <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom: isLast ? 0 : '10px' }}>
            {!swapRequestType ? (
              <>
                <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'10px' }}>{t('swap_request_title').replace('{date}', sh.dateLabel)}</div>
                <button style={{ ...s.outlineBtn, width:'100%', textAlign:'left', padding:'12px', marginBottom:'8px' }} onClick={() => setSwapRequestType('transfer')}>
                  <div style={{ fontWeight:'700' }}>↗️ {t('swap_type_transfer')}</div>
                  <div style={{ fontSize:'11px', color:'#888', fontWeight:'400', marginTop:'2px' }}>{t('swap_type_transfer_desc')}</div>
                </button>
                <button style={{ ...s.outlineBtn, width:'100%', textAlign:'left', padding:'12px', marginBottom:'8px' }} onClick={() => setSwapRequestType('swap')}>
                  <div style={{ fontWeight:'700' }}>🔁 {t('swap_type_swap')}</div>
                  <div style={{ fontSize:'11px', color:'#888', fontWeight:'400', marginTop:'2px' }}>{t('swap_type_swap_desc')}</div>
                </button>
                <button style={{ ...s.outlineBtn, width:'100%', padding:'10px' }} onClick={() => setSwapRequestFor(null)}>{t('avail_cancel')}</button>
              </>
            ) : (
              <>
                <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>
                  {swapRequestType === 'swap' ? t('swap_type_swap') : t('swap_type_transfer')} — {sh.dateLabel}
                </div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('swap_pick_colleague')}</label>
                <select style={{ ...s.selectInput, marginTop:'6px' }} value={swapTargetEmployee} onChange={e => setSwapTargetEmployee(e.target.value)}>
                  <option value=''>{t('swap_pick_colleague_placeholder')}</option>
                  {myColleagues.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
                <textarea style={{ ...s.input, minHeight:'50px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('swap_note_placeholder')} value={swapRequestNote} onChange={e => setSwapRequestNote(e.target.value)} />
                <div style={{ display:'flex', gap:'8px' }}>
                  <button style={{ ...s.assignBtn, flex:1, padding:'10px', opacity: swapTargetEmployee ? 1 : 0.5 }} disabled={!swapTargetEmployee} onClick={() => { onAddSwapRequest({ employee: user.name, targetEmployee: swapTargetEmployee, shiftId: sh.id, date: sh.date, dateLabel: sh.dateLabel, time: sh.time, note: swapRequestNote.trim(), stage: 'awaiting_colleague', requestType: swapRequestType }); setSwapRequestFor(null); setSwapRequestNote(''); setSwapTargetEmployee(''); setSwapRequestType(null); }}>{t('swap_submit_btn')}</button>
                  <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => setSwapRequestType(null)}>{t('swap_back_btn')}</button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  function openMissed(sh) {
    setActionShift({ id: sh.id, mode: 'missed' });
    setMissedDesc(sh.missedDesc || '');
  }
  function cancelAction() { setActionShift(null); }

  function submitMissed(shiftId) {
    if (!missedDesc.trim()) return;
    onUpdateShiftAttendance(shiftId, {
      attendance: 'Missed', attendanceApproved: false, missedReason: 'Other', missedDesc: missedDesc.trim(),
    });
    setActionShift(null);
  }

  // General sick certificate — not tied to one specific shift; covers upcoming and completed shifts
  // that fall inside the given date range automatically.
  const mySickReports = sickReports.filter(r => r.employee === user.name);
  const [sickFormOpen, setSickFormOpen] = useState(false);
  const [leaveFormOpen, setLeaveFormOpen] = useState(false);
  const [leaveFrom, setLeaveFrom] = useState('');
  const [leaveTo, setLeaveTo] = useState('');
  const [leaveNote, setLeaveNote] = useState('');
  const [editingLeaveId, setEditingLeaveId] = useState(null);
  const [leaveTab, setLeaveTab] = useState('Pending');
  const [editingSickId, setEditingSickId] = useState(null);
  const [sickCertFrom, setSickCertFrom] = useState('');
  const [sickCertTo, setSickCertTo] = useState('');
  const [sickCertNote, setSickCertNote] = useState('');
  const [sickCertFile, setSickCertFile] = useState(null);
  const [sickDupWarning, setSickDupWarning] = useState(null);
  const sickCertRef = useRef();

  async function handleSickCertChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setSickCertFile(await compressImage(file));
  }

  function canEditSickReport(r) {
    if (r.status === 'Rejected') return true; // always allowed to fix and resubmit a rejected certificate
    return r.status === 'Pending' && r.submittedAt && (Date.now() - r.submittedAt) < 24 * 60 * 60 * 1000;
  }

  function startEditSick(r) {
    setEditingSickId(r.id);
    setSickCertFrom(r.fromDate); setSickCertTo(r.toDate); setSickCertNote(r.note || ''); setSickCertFile(null);
    setSickFormOpen(true); setSickDupWarning(null);
  }

  function submitSickCert() {
    if (!sickCertFrom || !sickCertTo || sickCertFrom > sickCertTo) return;
    const others = mySickReports.filter(r => r.id !== editingSickId);
    const dup = findDateOverlap(sickCertFrom, sickCertTo, others);
    if (dup) { setSickDupWarning(`You already have a certificate covering ${dup.fromDate} to ${dup.toDate} (${dup.status}). Edit that one instead, or choose different dates.`); return; }
    if (editingSickId) {
      const wasRejected = mySickReports.find(r => r.id === editingSickId)?.status === 'Rejected';
      const updates = { fromDate: sickCertFrom, toDate: sickCertTo, note: sickCertNote };
      if (sickCertFile) { updates.certFileName = sickCertFile.name; updates.certFileData = sickCertFile.data; }
      if (wasRejected) { updates.status = 'Pending'; updates.submittedAt = Date.now(); updates.notifiedRead = true; }
      onUpdateSickReport(editingSickId, updates);
    } else {
      onSubmitSick({ employee: user.name, fromDate: sickCertFrom, toDate: sickCertTo, note: sickCertNote, certFileName: sickCertFile ? sickCertFile.name : null, certFileData: sickCertFile ? sickCertFile.data : null, submittedAt: Date.now() });
    }
    setSickCertFrom(''); setSickCertTo(''); setSickCertNote(''); setSickCertFile(null); setSickFormOpen(false); setEditingSickId(null); setSickDupWarning(null);
  }

  function dismissSickNotification(id) {
    onUpdateSickReport(id, { notifiedRead: true });
  }

  const [weekOffset, setWeekOffset] = useState(0);
  const [dayOff, setDayOff] = useState({});
  const [dayFrom, setDayFrom] = useState({});
  const [dayTo, setDayTo] = useState({});
  const [quickFrom, setQuickFrom] = useState('');
  const [quickTo, setQuickTo] = useState('');
  const [weekNote, setWeekNote] = useState('');
  const [copyToNextWeek, setCopyToNextWeek] = useState(false);
  const [weekSubmitted, setWeekSubmitted] = useState(false);
  const [editingAvailDate, setEditingAvailDate] = useState(null);
  const [shiftsTab, setShiftsTab] = useState('upcoming');
  const [myShiftsWeekOffset, setMyShiftsWeekOffset] = useState(0);
  const [completedSubTab, setCompletedSubTab] = useState('all');
  const [issueShift, setIssueShift] = useState('');
  const [issueType, setIssueType] = useState('');
  const [issueDesc, setIssueDesc] = useState('');
  const [issueSubmitted, setIssueSubmitted] = useState(false);
  const [issueFile, setIssueFile] = useState(null);
  const issueFileRef = useRef();
  const [openIssueId, setOpenIssueId] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [replyFile, setReplyFile] = useState(null);
  const replyFileRef = useRef();

  const myProfile = profiles[user.name] || { photo: null, photoChangeRequested: false, contractFile: null, contractName: null, contractShared: false, minHours: '', maxHours: '', documents: [] };
  const myColleagues = Object.keys(employeeRecords).filter(name => name !== user.name && employeeRecords[name].branchId === user.branchId && employeeRecords[name].status !== 'deactivated');
  const [docName, setDocName] = useState('');
  const [docExpiry, setDocExpiry] = useState('');
  const [docFile, setDocFile] = useState(null);
  const photoRef = useRef();
  const [openPanel, setOpenPanel] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [featureSearchOpen, setFeatureSearchOpen] = useState(false);
  const [featureSearchQuery, setFeatureSearchQuery] = useState('');
  const [signingContract, setSigningContract] = useState(false);
  const [signatureName, setSignatureName] = useState('');
  const [signatureMode, setSignatureMode] = useState('type');
  const [signatureImage, setSignatureImage] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(false);
  const signatureFileRef = useRef();
  function handleSignatureFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setSignatureImage(ev.target.result);
    reader.readAsDataURL(file);
  }
  function confirmEmployeeSignature() {
    const signerName = signatureMode === 'upload' ? user.name : signatureName.trim();
    const signatureImg = signatureMode === 'upload' ? signatureImage : null;
    try {
      if (myProfile.contractTemplateFileData) {
        const rec = employeeRecords[user.name] || { jobTitle: '', joinDate: '', dob: '', salary: '' };
        const placeholders = buildContractPlaceholders(user.name, rec, myProfile, { email: user.email }, user.companyName);
        const extra = {
          signature: signatureImg ? '' : signerName,
          sigImage: signatureImg || BLANK_SIG_IMAGE,
          employerSignature: myProfile.employerSigned ? (myProfile.employerSignedImage ? '' : myProfile.employerSignedName) : '',
          employerSigImage: myProfile.employerSigned ? (myProfile.employerSignedImage || BLANK_SIG_IMAGE) : BLANK_SIG_IMAGE,
        };
        const docxDataUri = renderContractDocx(myProfile.contractTemplateFileData, placeholders, extra);
        onUpdateProfile(user.name, {
          contractFile: docxDataUri,
          contractSigned: true, contractSignedName: signerName, contractSignedImage: signatureImg, contractSignedAt: today,
        });
      } else {
        // Not a generated contract (e.g. admin uploaded a plain PDF) — no template to
        // re-render into, so just record the signature as app-tracked metadata.
        onUpdateProfile(user.name, { contractSigned: true, contractSignedName: signerName, contractSignedImage: signatureImg, contractSignedAt: today });
      }
    } catch (err) {
      alert(t('err_signature_generic').replace('{err}', err?.message || err));
    }
    setSigningContract(false); setSignaturePreview(false); setSignatureImage(null);
  }
  function togglePanel(name) { setOpenPanel(openPanel === name ? null : name); }

  // Pulls together everything across the app that needs this employee's attention,
  // into one unified feed — reuses existing read/unread tracking where it exists,
  // and treats still-pending items (like an incoming swap request) as live reminders
  // that naturally clear once the underlying action is taken.
  function getEmployeeNotifications() {
    const items = [];
    myShifts.filter(sh => sh.notifiedRead === false).forEach(sh => {
      items.push({ id: `shift-${sh.id}`, icon: '📅', text: `${t('notif_new_shift')}: ${sh.dateLabel} · ${sh.time}`, tab: 'shifts', onOpen: () => onUpdateShiftAttendance(sh.id, { notifiedRead: true }) });
    });
    mySickReports.filter(r => r.status !== 'Pending' && !r.notifiedRead).forEach(r => {
      items.push({ id: `sick-${r.id}`, icon: '🤒', text: `${t('notif_sick_reviewed')}: ${translateStatus(language, r.status)}`, tab: 'sick', onOpen: () => onUpdateSickReport(r.id, { notifiedRead: true }) });
    });
    (myProfile.documents || []).filter(d => d.status !== 'Pending' && d.notifiedRead === false).forEach(d => {
      items.push({ id: `doc-${d.id}`, icon: '📄', text: `${t('notif_doc_reviewed')}: ${d.name}`, tab: 'profile', onOpen: () => onUpdateProfile(user.name, { documents: myProfile.documents.map(x => x.id === d.id ? { ...x, notifiedRead: true } : x) }) });
    });
    swapRequests.filter(r => r.targetEmployee === user.name && r.stage === 'awaiting_colleague').forEach(r => {
      items.push({ id: `swapin-${r.id}`, icon: '🔄', text: `${r.employee} ${t('notif_swap_incoming')}`, tab: 'home', onOpen: () => {} });
    });
    swapRequests.filter(r => r.employee === user.name && ['resolved','declined_by_colleague','declined_by_admin'].includes(r.stage)).forEach(r => {
      items.push({ id: `swapout-${r.id}`, icon: '🔄', text: `${t('notif_swap_result')}: ${r.stage === 'resolved' ? t('swap_status_resolved') : t('swap_status_declined')}`, tab: 'shifts', onOpen: () => {} });
    });
    leaveRequests.filter(r => r.employee === user.name && r.status !== 'Pending').forEach(r => {
      items.push({ id: `leave-${r.id}`, icon: '🏖️', text: `${t('notif_leave_result')}: ${translateStatus(language, r.status)}`, tab: 'leave', onOpen: () => {} });
    });
    issues.filter(iss => iss.employee === user.name && iss.replies && iss.replies.length > 0).forEach(iss => {
      const last = iss.replies[iss.replies.length - 1];
      if (last.from === 'admin' && iss.replies.length > (iss.employeeSeenReplyCount || 0)) {
        items.push({ id: `issuereply-${iss.id}`, icon: '💬', text: `${t('notif_issue_reply')}: ${iss.type}`, tab: 'issues', onOpen: () => onUpdateIssue(iss.id, { employeeSeenReplyCount: iss.replies.length }) });
      }
    });
    if (myProfile.employerSigned && !myProfile.employerSignedSeenByEmployee) {
      items.push({ id: 'contract-employer-signed', icon: '✍️', text: t('notif_contract_signed'), tab: 'profile', onOpen: () => onUpdateProfile(user.name, { employerSignedSeenByEmployee: true }) });
    }
    mySlips.filter(sl => sl.notifiedRead === false).forEach(sl => {
      items.push({ id: `slip-${sl.id}`, icon: '💶', text: `${t('notif_new_slip')}: ${sl.month}`, tab: 'salary', onOpen: () => onUpdateSalarySlip(sl.id, { notifiedRead: true }) });
    });
    return items;
  }
  const [histYear, setHistYear] = useState(today.slice(0, 4));
  const [histMonth, setHistMonth] = useState(String(new Date(today).getMonth() + 1).padStart(2, '0'));
  const docFileRef = useRef();

  async function handlePhotoUpload(e) {
    const file = e.target.files[0];
    if (!file) return;
    const compressed = await compressImage(file);
    onUpdateProfile(user.name, { photo: compressed.data });
  }

  async function handleDocFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setDocFile(await compressImage(file));
  }

  function submitDocument() {
    if (!docName || !docExpiry) return;
    const newDoc = { id: Date.now(), name: docName, expiryDate: docExpiry, fileName: docFile ? docFile.name : null, fileData: docFile ? docFile.data : null, status: 'Pending' };
    onAddProfileDocument(user.name, newDoc);
    setDocName(''); setDocExpiry(''); setDocFile(null);
  }

  function downloadContract() {
    if (!myProfile.contractFile) return;
    const a = document.createElement('a');
    a.href = myProfile.contractFile;
    a.download = myProfile.contractName || 'contract.pdf';
    a.click();
  }

  // Weekly availability grid — computed dates for whichever week is selected via weekOffset
  const [baseMonday] = getWeekRange(today);

  // A week is "resolved" once every submission in it has actually become a shift (Assigned) —
  // at that point it should stop being the active submission view and move to history instead.
  function isWeekResolved(wkStart, wkEnd) {
    const entries = myAvail.filter(a => a.date >= wkStart && a.date <= wkEnd);
    return entries.length > 0 && entries.every(a => a.status === 'Assigned' || a.status === 'Expired');
  }
  function findNextActionableOffset() {
    for (let o = 0; o <= 12; o++) {
      const s = addDaysToDate(baseMonday, o * 7);
      const e = addDaysToDate(s, 6);
      if (!isWeekResolved(s, e)) return o;
    }
    return 0;
  }
  const minActionableOffset = findNextActionableOffset();
  useEffect(() => {
    const s = addDaysToDate(baseMonday, weekOffset * 7);
    const e = addDaysToDate(s, 6);
    if (isWeekResolved(s, e)) setWeekOffset(findNextActionableOffset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myAvail]);

  const selectedMonday = addDaysToDate(baseMonday, weekOffset * 7);
  const weekDates = Array.from({ length: 7 }, (_, i) => addDaysToDate(selectedMonday, i));
  const weekEndDate = weekDates[6];
  const weekNum = getISOWeekNumber(selectedMonday);
  const weekYear = selectedMonday.slice(0, 4);
  const DAY_NAMES = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

  function toggleDayOff(date) {
    setDayOff(prev => ({ ...prev, [date]: !prev[date] }));
  }

  function applyQuickFill() {
    if (!quickFrom || !quickTo || quickFrom >= quickTo) return;
    const newFrom = { ...dayFrom }, newTo = { ...dayTo };
    weekDates.forEach(d => {
      if (!dayOff[d] && !myAvail.find(a => a.date === d)) { newFrom[d] = quickFrom; newTo[d] = quickTo; }
    });
    setDayFrom(newFrom); setDayTo(newTo);
  }

  function submitWeek() {
    const editableDates = weekDates.filter(d => !myAvail.find(a => a.date === d));
    const toSubmit = editableDates.filter(d => !dayOff[d] && dayFrom[d] && dayTo[d] && dayFrom[d] < dayTo[d]);
    if (toSubmit.length === 0) return;
    toSubmit.forEach(d => {
      onSubmitAvail({ employee: user.name, initials: user.initials, color: user.color, textColor: user.textColor, date: d, slots: [`${dayFrom[d]} – ${dayTo[d]}`], note: weekNote, status: 'Pending' });
    });
    if (copyToNextWeek) {
      toSubmit.forEach(d => {
        const nextDate = addDaysToDate(d, 7);
        if (!myAvail.find(a => a.date === nextDate)) {
          onSubmitAvail({ employee: user.name, initials: user.initials, color: user.color, textColor: user.textColor, date: nextDate, slots: [`${dayFrom[d]} – ${dayTo[d]}`], note: weekNote, status: 'Pending' });
        }
      });
    }
    setDayOff({}); setDayFrom({}); setDayTo({}); setWeekNote(''); setCopyToNextWeek(false);
    setWeekSubmitted(true);
    setTimeout(() => setWeekSubmitted(false), 3000);
  }

  function submitIssue() {
    if (!issueShift || !issueType || !issueDesc) return;
    onReportIssue({ employee: user.name, shift: issueShift, type: issueType, description: issueDesc, status: 'Open', certFileName: issueFile ? issueFile.name : null, certFileData: issueFile ? issueFile.data : null, replies: [], raisedDate: today });
    setIssueShift(''); setIssueType(''); setIssueDesc(''); setIssueFile(null); setIssueSubmitted(true);
    setTimeout(() => setIssueSubmitted(false), 3000);
  }

  async function handleIssueFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setIssueFile(await compressImage(file));
  }

  async function handleReplyFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setReplyFile(await compressImage(file));
  }

  function sendReply(issueId) {
    if (!replyText && !replyFile) return;
    onIssueReply(issueId, { from: 'employee', fromName: user.name, text: replyText, fileName: replyFile ? replyFile.name : null, fileData: replyFile ? replyFile.data : null });
    setReplyText(''); setReplyFile(null);
  }

  function downloadSlip(slip) {
    if (slip.fileData) {
      const a = document.createElement('a');
      a.href = slip.fileData;
      a.download = slip.fileName;
      a.click();
    } else {
      alert(t('err_contract_not_uploaded'));
    }
  }

  const myScheduleMode = (employeeRecords[user.name] || {}).schedulingMode || 'availability';
  const isFixedMode = myScheduleMode === 'fixed-standard' || myScheduleMode === 'fixed-choose-dayoff';
  const tabs = [['home','🏠',t('nav_home')],['shifts','📅',t('nav_shifts')], ...(isFixedMode ? [] : [['avail','🕐',t('nav_avail')]]),['profile','👤',t('nav_profile')]];
  const ALL_TAB_LABELS = { home:t('nav_home'), shifts:t('nav_shifts'), avail:t('nav_avail'), issues:t('title_issues'), salary:t('title_salary'), sick:t('nav_sick'), leave:t('nav_leave'), profile:t('nav_profile') };
  const mySearchableFeatures = isFixedMode ? EMPLOYEE_SEARCHABLE_FEATURES.filter(f => f.tab !== 'avail') : EMPLOYEE_SEARCHABLE_FEATURES;

  return (
    <div style={s.app}>
      <div style={s.topbar}>
        <div>
          <div style={s.topbarTitle}>{ALL_TAB_LABELS[tab]}</div>
          <div style={s.topbarSub}>{user.companyName || 'KarmaDal'}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', position:'relative' }}>
          <button style={{ ...s.logoutBtn, fontSize:'11px', padding:'5px 10px' }} onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>🌐 {language.toUpperCase()}</button>
          <div style={{ position:'relative', cursor:'pointer' }} onClick={() => { setFeatureSearchOpen(!featureSearchOpen); setFeatureSearchQuery(''); }}>
            <span style={{ fontSize:'19px' }}>🔍</span>
          </div>
          {featureSearchOpen && (
            <div style={{ position:'absolute', top:'34px', right:'0', width:'260px', background:'white', border:'1px solid #eee', borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:20 }}>
              <input autoFocus style={{ ...s.input, margin:'10px', width:'calc(100% - 20px)' }} placeholder={t('feature_search_placeholder')} value={featureSearchQuery} onChange={e => setFeatureSearchQuery(e.target.value)} />
              <div style={{ maxHeight:'260px', overflowY:'auto' }}>
                {mySearchableFeatures.filter(f => t(f.labelKey).toLowerCase().includes(featureSearchQuery.toLowerCase())).map(f => (
                  <div key={f.labelKey} onClick={() => { navigateTo(f.tab); setFeatureSearchOpen(false); }}
                    style={{ padding:'10px 14px', borderBottom:'1px solid #f5f5f5', cursor:'pointer', fontSize:'13px', color:'#2d2d2d' }}>
                    {f.icon} {t(f.labelKey)}
                  </div>
                ))}
                {mySearchableFeatures.filter(f => t(f.labelKey).toLowerCase().includes(featureSearchQuery.toLowerCase())).length === 0 && (
                  <div style={{ padding:'16px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>{t('tm_no_matches')}</div>
                )}
              </div>
            </div>
          )}
          <div style={{ position:'relative', cursor:'pointer' }} onClick={() => setNotifOpen(!notifOpen)}>
            <span style={{ fontSize:'19px' }}>🔔</span>
            {getEmployeeNotifications().length > 0 && (
              <span style={{ position:'absolute', top:'-4px', right:'-4px', background:'#b71c1c', color:'white', fontSize:'10px', fontWeight:'700', borderRadius:'50%', width:'16px', height:'16px', display:'flex', alignItems:'center', justifyContent:'center' }}>{getEmployeeNotifications().length}</span>
            )}
          </div>
          {notifOpen && (
            <div style={{ position:'absolute', top:'34px', right:'0', width:'280px', background:'white', border:'1px solid #eee', borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:20, maxHeight:'320px', overflowY:'auto' }}>
              <div style={{ padding:'12px 14px', fontSize:'12px', fontWeight:'700', color:'#888', borderBottom:'1px solid #f0f0f0' }}>{t('notif_title')}</div>
              {getEmployeeNotifications().length === 0 ? (
                <div style={{ padding:'20px 14px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>{t('notif_none')}</div>
              ) : getEmployeeNotifications().map(n => (
                <div key={n.id} onClick={() => { n.onOpen(); navigateTo(n.tab); setNotifOpen(false); }} style={{ padding:'10px 14px', borderBottom:'1px solid #f5f5f5', cursor:'pointer', display:'flex', gap:'8px', alignItems:'flex-start' }}>
                  <span style={{ fontSize:'15px' }}>{n.icon}</span>
                  <span style={{ fontSize:'12px', color:'#2d2d2d', lineHeight:'1.4' }}>{n.text}</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ ...s.avatar, cursor:'pointer' }} onClick={() => navigateTo('profile')}>{user.initials}</div>
          <button style={s.logoutBtn} onClick={onLogout}>{t('logout')}</button>
        </div>
      </div>

      <div style={s.content}>
        {tab === 'home' && <>
          {(() => {
            const myMode = (employeeRecords[user.name] || {}).schedulingMode;
            if (myMode !== 'fixed-choose-dayoff') return null;
            const now = new Date();
            const dayNum = now.getDay(); // 0=Sun
            const daysUntilNextMonday = ((8 - dayNum) % 7) || 7;
            const nextMonday = new Date(now); nextMonday.setDate(now.getDate() + daysUntilNextMonday);
            const nextMondayStr = nextMonday.toISOString().split('T')[0];
            const existingChoice = dayOffChoices.find(c => c.employee === user.name && c.weekStart === nextMondayStr);
            const maxCap = fixedScheduleConfig?.maxDayOffPerDay || 0;
            const countForDay = (day) => dayOffChoices.filter(c => c.weekStart === nextMondayStr && c.dayOff === day && c.employee !== user.name).length;
            return (
              <div style={{ background:'white', borderRadius:'12px', padding:'14px', marginBottom:'12px', boxShadow:'0 2px 10px rgba(0,0,0,0.06)' }}>
                <div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>🕘 {t('dayoff_picker_title')}</div>
                <div style={{ fontSize:'11px', color:'#888', marginTop:'4px', marginBottom:'10px' }}>{t('dayoff_picker_hint')}</div>
                <select style={s.selectInput} value={existingChoice?.dayOff || ''} onChange={e => onSetDayOffChoice(user.name, nextMondayStr, e.target.value)}>
                  <option value=''>{t('dayoff_picker_placeholder')}</option>
                  {['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].map(day => {
                    const isFull = maxCap > 0 && countForDay(day) >= maxCap;
                    return <option key={day} value={day} disabled={isFull}>{t(`day_${day.toLowerCase()}`)}{isFull ? ` (${t('dayoff_picker_full')})` : ''}</option>;
                  })}
                </select>
                {existingChoice && <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'8px', fontWeight:'600' }}>✅ {t('dayoff_picker_saved')}</div>}
                {existingChoice && (() => {
                  const myPendingSwap = swapRequests.find(r => r.requestType === 'weekoff-swap' && r.employee === user.name && r.weekStart === nextMondayStr && ['awaiting_colleague','awaiting_admin'].includes(r.stage));
                  if (myPendingSwap) {
                    return <div style={{ fontSize:'11px', color:'var(--brand-dark)', marginTop:'10px', paddingTop:'10px', borderTop:'1px solid #f0f0f0', fontWeight:'600' }}>🔄 {myPendingSwap.stage === 'awaiting_colleague' ? t('weekoff_swap_status_awaiting_colleague').replace('{name}', myPendingSwap.targetEmployee) : t('weekoff_swap_status_awaiting_admin')}</div>;
                  }
                  if (!weekOffSwapOpen) {
                    return <span style={{ fontSize:'12px', color:'var(--brand)', cursor:'pointer', marginTop:'10px', display:'inline-block', fontWeight:'600' }} onClick={() => setWeekOffSwapOpen(true)}>🔄 {t('weekoff_swap_open_btn')}</span>;
                  }
                  const colleagues = myColleagues.filter(name => (employeeRecords[name] || {}).schedulingMode === 'fixed-choose-dayoff');
                  const colleagueChoices = colleagues.map(name => ({ name, choice: dayOffChoices.find(c => c.employee === name && c.weekStart === nextMondayStr) })).filter(c => c.choice && c.choice.dayOff !== existingChoice.dayOff);
                  return (
                    <div style={{ marginTop:'10px', paddingTop:'10px', borderTop:'1px solid #f0f0f0' }}>
                      <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>{t('weekoff_swap_pick_hint')}</div>
                      {colleagueChoices.length === 0 ? (
                        <div style={{ fontSize:'11px', color:'#aaa' }}>{t('weekoff_swap_none_available')}</div>
                      ) : colleagueChoices.map(c => (
                        <div key={c.name} onClick={() => { onAddSwapRequest({ employee: user.name, targetEmployee: c.name, requestType: 'weekoff-swap', weekStart: nextMondayStr, employeeCurrentDayOff: existingChoice.dayOff, targetCurrentDayOff: c.choice.dayOff, stage: 'awaiting_colleague' }); setWeekOffSwapOpen(false); }}
                          style={{ padding:'8px 0', borderBottom:'1px solid #f5f5f5', cursor:'pointer', fontSize:'12px' }}>
                          {c.name} — {t('weekoff_swap_has_off').replace('{day}', t(`day_${c.choice.dayOff.toLowerCase()}`))}
                        </div>
                      ))}
                      <span style={{ fontSize:'11px', color:'#888', cursor:'pointer', marginTop:'6px', display:'inline-block' }} onClick={() => setWeekOffSwapOpen(false)}>{t('avail_cancel')}</span>
                    </div>
                  );
                })()}
              </div>
            );
          })()}
          {swapRequests.filter(r => r.targetEmployee === user.name && r.stage === 'awaiting_colleague' && r.requestType === 'weekoff-swap').map(r => (
            <div key={r.id} style={{ background:'var(--brand-light)', borderRadius:'12px', padding:'14px', marginBottom:'12px', border:'1px solid #FFD4B0' }}>
              <div style={{ fontSize:'13px', fontWeight:'700', color:'var(--brand-dark)' }}>🔄 {t('weekoff_swap_incoming_title').replace('{name}', r.employee)}</div>
              <div style={{ fontSize:'12px', color:'var(--brand-dark)', marginTop:'4px' }}>{t('weekoff_swap_incoming_detail').replace('{yourOld}', t(`day_${r.targetCurrentDayOff.toLowerCase()}`)).replace('{yourNew}', t(`day_${r.employeeCurrentDayOff.toLowerCase()}`))}</div>
              <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => onUpdateSwapRequest(r.id, { stage: 'awaiting_admin', colleagueRespondedAt: today })}>{t('swap_accept_btn')}</button>
                <button style={{ ...s.outlineBtn, flex:1, padding:'9px' }} onClick={() => onUpdateSwapRequest(r.id, { stage: 'declined_by_colleague', colleagueRespondedAt: today })}>{t('swap_reject_btn')}</button>
              </div>
            </div>
          ))}
          {swapRequests.filter(r => r.targetEmployee === user.name && r.stage === 'awaiting_colleague' && r.requestType !== 'weekoff-swap').map(r => {
            const isSwapType = r.requestType === 'swap';
            const isResponding = respondingToSwapId === r.id;
            const myOwnUpcoming = myShiftsUpcoming.filter(s2 => s2.id !== r.shiftId);
            return (
              <div key={r.id} style={{ background:'var(--brand-light)', borderRadius:'12px', padding:'14px', marginBottom:'12px', border:'1px solid #FFD4B0' }}>
                <div style={{ fontSize:'13px', fontWeight:'700', color:'var(--brand-dark)' }}>
                  🔄 {isSwapType ? t('swap_incoming_swap_title').replace('{name}', r.employee) : t('swap_incoming_title').replace('{name}', r.employee)}
                </div>
                <div style={{ fontSize:'12px', color:'var(--brand-dark)', marginTop:'4px' }}>{r.dateLabel} · {r.time}</div>
                {r.note && <div style={{ fontSize:'12px', color:'#8a6d00', marginTop:'4px', fontStyle:'italic' }}>"{r.note}"</div>}
                {!isSwapType || !isResponding ? (
                  <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                    <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => {
                      if (isSwapType) { setRespondingToSwapId(r.id); setSelectedOwnShiftForSwap(''); }
                      else { onUpdateSwapRequest(r.id, { stage: 'awaiting_admin', colleagueRespondedAt: today }); }
                    }}>{t('swap_accept_btn')}</button>
                    <button style={{ ...s.outlineBtn, flex:1, padding:'9px' }} onClick={() => onUpdateSwapRequest(r.id, { stage: 'declined_by_colleague', colleagueRespondedAt: today })}>{t('swap_reject_btn')}</button>
                  </div>
                ) : (
                  <div style={{ background:'white', borderRadius:'8px', padding:'10px', marginTop:'10px' }}>
                    <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>{t('swap_pick_own_shift')}</div>
                    {myOwnUpcoming.length === 0 ? (
                      <div style={{ fontSize:'11px', color:'#b71c1c' }}>{t('swap_no_own_shifts')}</div>
                    ) : (
                      <>
                        <select style={{ ...s.selectInput, marginBottom:'8px' }} value={selectedOwnShiftForSwap} onChange={e => setSelectedOwnShiftForSwap(e.target.value)}>
                          <option value=''>{t('swap_pick_own_shift_placeholder')}</option>
                          {myOwnUpcoming.map(s2 => <option key={s2.id} value={s2.id}>{s2.dateLabel} · {s2.time}</option>)}
                        </select>
                        <div style={{ display:'flex', gap:'8px' }}>
                          <button style={{ ...s.assignBtn, flex:1, padding:'9px', opacity: selectedOwnShiftForSwap ? 1 : 0.5 }} disabled={!selectedOwnShiftForSwap} onClick={() => {
                            const myShift = myOwnUpcoming.find(s2 => s2.id === selectedOwnShiftForSwap);
                            onUpdateSwapRequest(r.id, { stage: 'awaiting_admin', colleagueRespondedAt: today, targetShiftId: myShift.id, targetShiftDateLabel: myShift.dateLabel, targetShiftTime: myShift.time });
                            setRespondingToSwapId(null); setSelectedOwnShiftForSwap('');
                          }}>{t('swap_confirm_btn')}</button>
                          <button style={{ ...s.outlineBtn, padding:'9px 14px' }} onClick={() => setRespondingToSwapId(null)}>{t('swap_back_btn')}</button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            );
          })}
          {(() => {
            const featured = myShiftsOngoing[0] || [...myShiftsUpcoming].sort((a,b) => a.date.localeCompare(b.date) || a.time.localeCompare(b.time))[0];
            if (!featured) return null;
            return (
              <div style={{ marginBottom:'12px' }}>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'8px', paddingLeft:'2px' }}>
                  {myShiftsOngoing[0] ? t('home_current_shift') : t('home_next_shift')}
                </div>
                <div style={{ background:'white', borderRadius:'14px', padding:'4px', boxShadow:'0 2px 10px rgba(0,0,0,0.08)' }}>
                  {renderShiftRow(featured, true)}
                </div>
              </div>
            );
          })()}
          {(() => {
            const newShifts = myShifts.filter(sh => sh.notifiedRead === false);
            if (newShifts.length === 0) return null;
            return (
              <div style={{ background:'#e8f5e9', borderRadius:'10px', padding:'14px', marginBottom:'12px' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={{ fontSize:'13px', fontWeight:'600', color:'#2e7d32' }}>🔔 {newShifts.length} {newShifts.length !== 1 ? t('hn_new_shifts') : t('hn_new_shift')} {t('hn_assigned_bang')}</div>
                    <div style={{ fontSize:'12px', color:'#388e3c', marginTop:'4px' }}>
                      {myCapProfile.maxHours
                        ? t('hn_week_assigned_of').replace('{mins}', compactDuration(weekAssignedMins)).replace('{cap}', `${myCapProfile.minHours ? `${myCapProfile.minHours}–` : ''}${myCapProfile.maxHours}`)
                        : `${t('home_this_week')}: ${compactDuration(weekAssignedMins)} ${t('cal_assigned')}`}
                    </div>
                  </div>
                  <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => newShifts.forEach(sh => onUpdateShiftAttendance(sh.id, { notifiedRead: true }))}>✕</span>
                </div>
              </div>
            );
          })()}
          {(() => {
            const unswipedShifts = myShifts.filter(sh => sh.attendance === 'Pending' && -daysUntil(sh.date) >= 3);
            if (unswipedShifts.length === 0) return null;
            const oldest = [...unswipedShifts].sort((a, b) => a.date.localeCompare(b.date))[0];
            return (
              <div onClick={() => navigateTo('shifts')} style={{ background:'#ffebee', borderRadius:'10px', padding:'14px', marginBottom:'12px', cursor:'pointer' }}>
                <div style={{ fontSize:'13px', fontWeight:'600', color:'#b71c1c' }}>⚠️ {unswipedShifts.length} {unswipedShifts.length !== 1 ? t('hn_shifts_not_submitted') : t('hn_shift_not_submitted')} {t('hn_still_not_submitted')}</div>
                <div style={{ fontSize:'12px', color:'#c62828', marginTop:'4px' }}>
                  {t('hn_oldest')}: {oldest.dateLabel}, {oldest.time} — {t('hn_log_hours_prompt')} →
                </div>
              </div>
            );
          })()}
          {(() => {
            const reviewedDocs = myProfile.documents.filter(d => d.status !== 'Pending' && d.notifiedRead === false);
            if (reviewedDocs.length === 0) return null;
            return (
              <div style={{ background: reviewedDocs.some(d => d.status === 'Rejected') ? '#ffebee' : '#e8f5e9', borderRadius:'10px', padding:'14px', marginBottom:'12px' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={{ fontSize:'13px', fontWeight:'600', color: reviewedDocs.some(d => d.status === 'Rejected') ? '#b71c1c' : '#2e7d32' }}>
                      🔔 {reviewedDocs.length} {reviewedDocs.length !== 1 ? t('hn_documents') : t('hn_document')} {t('hn_reviewed')}
                    </div>
                    {reviewedDocs.map(d => (
                      <div key={d.id} style={{ fontSize:'12px', color: d.status === 'Rejected' ? '#c62828' : '#388e3c', marginTop:'4px' }}>
                        {d.status === 'Rejected' ? '❌' : '✅'} {d.name} — {translateStatus(language, d.status)}{d.reviewNote ? `: ${d.reviewNote}` : ''}
                      </div>
                    ))}
                  </div>
                  <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => onUpdateProfile(user.name, { documents: myProfile.documents.map(d => reviewedDocs.find(rd => rd.id === d.id) ? { ...d, notifiedRead: true } : d) })}>✕</span>
                </div>
              </div>
            );
          })()}
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={s.cardLabel}>{t('home_overview')}</div>
              <span style={{ fontSize:'12px', color:'#4A3CDB', cursor:'pointer', fontWeight:'600' }} onClick={() => { navigateTo('shifts'); setShiftsTab('calendar'); }}>📅 {t('shifts_calendar')}</span>
            </div>
            <div style={s.statRow}>
              <div style={s.stat}><div style={s.statNum}>{myUpcoming.length}</div><div style={s.statLbl}>{t('home_upcoming')}</div></div>
              <div style={s.stat}><div style={s.statNum}>{myCompleted.length}</div><div style={s.statLbl}>{t('home_completed')}</div></div>
              <div style={s.stat}><div style={s.statNum}>{myAvail.filter(a=>a.status==='Pending').length}</div><div style={s.statLbl}>{t('home_pending_avail')}</div></div>
              <div style={s.stat}><div style={s.statNum}>{myIssues.filter(i=>i.status==='Open').length}</div><div style={s.statLbl}>{t('home_open_issues')}</div></div>
            </div>
          </div>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('home_worked_hours')}</div>
            <div style={{ display:'flex', gap:'10px' }}>
              <div style={{ flex:1, background:'#f5f6fa', borderRadius:'8px', padding:'10px' }}>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', marginBottom:'6px' }}>{t('home_this_week')}</div>
                <div style={{ fontSize:'13px', color:'var(--brand-dark)', fontWeight:'600' }}>✅ {compactDuration(weekMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{t('cal_completed')}</span></div>
                <div style={{ fontSize:'13px', color:'#2e7d32', fontWeight:'600', marginTop:'2px' }}>✔️ {compactDuration(weekApprovedMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{t('cal_approved')}</span></div>
                <div style={{ fontSize:'11px', color:'#888', marginTop:'4px' }}>/ {compactDuration(weekAssignedMins)} {t('cal_assigned')}{myCapProfile.maxHours ? ` · ${t('cal_cap')}: ${myCapProfile.minHours ? `${myCapProfile.minHours}–` : ''}${myCapProfile.maxHours}h` : ''}</div>
              </div>
              <div style={{ flex:1, background:'#f5f6fa', borderRadius:'8px', padding:'10px' }}>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', marginBottom:'6px' }}>{t('home_this_month')}</div>
                <div style={{ fontSize:'13px', color:'var(--brand-dark)', fontWeight:'600' }}>✅ {compactDuration(monthMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{t('cal_completed')}</span></div>
                <div style={{ fontSize:'13px', color:'#2e7d32', fontWeight:'600', marginTop:'2px' }}>✔️ {compactDuration(monthApprovedMins)} <span style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>{t('cal_approved')}</span></div>
                <div style={{ fontSize:'11px', color:'#888', marginTop:'4px' }}>/ {compactDuration(monthAssignedMins)} {t('cal_assigned')}{myCapProfile.maxHours ? ` · ${t('cal_cap')}: ${myCapProfile.minHours ? `${myCapProfile.minHours*4}–` : ''}${myCapProfile.maxHours*4}h` : ''}</div>
              </div>
            </div>
          </div>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('home_upcoming_shifts')}</div>
            {myUpcomingOrToday.length === 0 && <div style={s.emptyBox}>{t('home_no_upcoming')}</div>}
            {myUpcomingOrToday.map((sh,i) => renderShiftRow(sh, i === myUpcomingOrToday.length - 1))}
          </div>
        </>}

        {tab === 'shifts' && <>
          <div style={s.tabRow}>
            <button style={s.tabBtn(shiftsTab==='upcoming')} onClick={()=>setShiftsTab('upcoming')}>{t('shifts_upcoming')} ({myShiftsUpcoming.length})</button>
            <button style={s.tabBtn(shiftsTab==='ongoing')} onClick={()=>setShiftsTab('ongoing')}>🕐 {t('shifts_ongoing')} ({myShiftsOngoing.length})</button>
            <button style={s.tabBtn(shiftsTab==='completed')} onClick={()=>setShiftsTab('completed')}>{t('shifts_completed')} ({myShiftsCompletedNew.length})</button>
            <button style={s.tabBtn(shiftsTab==='missed')} onClick={()=>setShiftsTab('missed')}>⚠️ {t('shifts_missed')} ({myShiftsMissed.length})</button>
          </div>
          {shiftsTab === 'calendar' && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('shifts_calendar_view')}</div>
              <CalendarView shifts={shifts} employeeName={user.name} profile={myProfile} language={language} />
            </div>
          )}
          {shiftsTab === 'ongoing' && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('shifts_ongoing_title')}</div>
              {myShiftsOngoing.length === 0 && <div style={s.emptyBox}>{t('shifts_none_ongoing')}</div>}
              {myShiftsOngoing.map((sh,i) => renderShiftRow(sh, i === myShiftsOngoing.length - 1))}
              </div>
          )}
          {shiftsTab === 'missed' && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('shifts_missed_title')}</div>
              {myShiftsMissed.length === 0 && <div style={s.emptyBox}>{t('shifts_none_missed')}</div>}
              {myShiftsMissed.map((sh,i) => (
                <div key={sh.id}>
                  <div role='button' tabIndex={0} onClick={() => setExpandedShiftId(expandedShiftId === sh.id ? null : sh.id)}
                    style={{ ...(i===myShiftsMissed.length-1 && expandedShiftId!==sh.id ? s.rowLast : s.row), cursor:'pointer' }}>
                    <div><div style={s.name}>{sh.dateLabel}</div><div style={s.sub}>{sh.time}</div></div>
                    <span style={getBadgeStyle('Open')}>⚠️ {t('shifts_missed')}</span>
                  </div>
                  {expandedShiftId === sh.id && actionShift?.id !== sh.id && (
                    <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom: i===myShiftsMissed.length-1 ? 0 : '10px' }}>
                      <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'10px' }}>{t('missed_why')}</div>
                      <div style={{ display:'flex', gap:'8px' }}>
                        <button style={{ ...s.outlineBtn, flex:1, padding:'10px' }} onClick={() => { setExpandedShiftId(null); setSickCertFrom(sh.date); setSickCertTo(sh.date); setSickFormOpen(true); navigateTo('sick'); }}>🤒 {t('missed_health_btn')}</button>
                        <button style={{ ...s.outlineBtn, flex:1, padding:'10px' }} onClick={() => { setExpandedShiftId(null); openMissed(sh); }}>📝 {t('missed_other_btn')}</button>
                      </div>
                    </div>
                  )}
                  {actionShift?.id === sh.id && actionShift.mode === 'missed' && (
                    <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom: i===myShiftsMissed.length-1 ? 0 : '10px' }}>
                      <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('lh_why_missed')}</div>
                      <textarea style={{ ...s.input, minHeight:'70px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('lh_add_details')} value={missedDesc} onChange={e => setMissedDesc(e.target.value)} />
                      <div style={{ display:'flex', gap:'8px' }}>
                        <button style={{ ...s.dangerBtn, flex:1, padding:'10px', opacity: missedDesc.trim() ? 1 : 0.5 }} disabled={!missedDesc.trim()} onClick={() => submitMissed(sh.id)}>{t('lh_submit_btn')}</button>
                        <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={cancelAction}>{t('avail_cancel')}</button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {(shiftsTab === 'upcoming' || shiftsTab === 'completed') && (
          <div style={s.card}>
            <div style={s.cardLabel}>{shiftsTab === 'upcoming' ? t('shifts_upcoming_title') : t('shifts_completed_title')}</div>
            {shiftsTab === 'upcoming' && <>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'14px' }}>
                <button style={s.navControlBtn(true)} onClick={() => setMyShiftsWeekOffset(w => w - 1)}>‹</button>
                <div style={{ textAlign:'center' }}>
                  {(() => {
                    const [wStart] = getWeekRange(addDaysToDate(today, myShiftsWeekOffset * 7));
                    const wEnd = addDaysToDate(wStart, 6);
                    const wNum = getISOWeekNumber(wStart);
                    return <><div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>Week {wNum}{myShiftsWeekOffset === 0 ? ' (current)' : ''}</div><div style={{ fontSize:'11px', color:'#888' }}>{wStart} – {wEnd}</div></>;
                  })()}
                </div>
                <button style={s.navControlBtn(true)} onClick={() => setMyShiftsWeekOffset(w => w + 1)}>›</button>
              </div>
              {(() => {
                const [wStart] = getWeekRange(addDaysToDate(today, myShiftsWeekOffset * 7));
                const wEnd = addDaysToDate(wStart, 6);
                const weekUpcoming = myShiftsUpcoming.filter(sh => sh.date >= wStart && sh.date <= wEnd);
                if (weekUpcoming.length === 0) return <div style={s.emptyBox}>{t('shifts_none_this_week')}</div>;
                return weekUpcoming.map((sh,i) => renderShiftRow(sh, i === weekUpcoming.length - 1));
              })()}
              </>}
            {shiftsTab === 'completed' && <>
              <div style={{ marginBottom:'14px' }}>
                <div style={{ fontSize:'11px', color:'#888', textTransform:'uppercase', fontWeight:'600', marginBottom:'8px' }}>{t('shifts_worked_history')}</div>
                <WorkedHistory shifts={shifts} employeeName={user.name} year={histYear} month={histMonth} onYearChange={setHistYear} onMonthChange={setHistMonth} language={language} />
              </div>

              {(() => {
                const monthCompleted = myShiftsCompletedNew.filter(sh => sh.date.startsWith(`${histYear}-${histMonth}`));
                const needsApprovalCount = monthCompleted.filter(sh => sh.attendance !== 'Pending' && !sh.attendanceApproved).length;
                const approvedCount = monthCompleted.filter(sh => sh.attendanceApproved).length;
                return (
                  <div style={{ display:'flex', gap:'8px', marginBottom:'14px' }}>
                    <button style={s.tabBtn(completedSubTab==='all')} onClick={()=>setCompletedSubTab('all')}>{t('shifts_all')} ({monthCompleted.length})</button>
                    <button style={s.tabBtn(completedSubTab==='approved')} onClick={()=>setCompletedSubTab('approved')}>✅ {t('shifts_approved')} ({approvedCount})</button>
                    <button style={s.tabBtn(completedSubTab==='pending')} onClick={()=>setCompletedSubTab('pending')}>⏳ {t('shifts_needs_approval')} ({needsApprovalCount})</button>
                  </div>
                );
              })()}
              {(() => {
                let filteredCompleted = myShiftsCompletedNew.filter(sh => sh.date.startsWith(`${histYear}-${histMonth}`));
                if (completedSubTab === 'approved') filteredCompleted = filteredCompleted.filter(sh => sh.attendanceApproved);
                if (completedSubTab === 'pending') filteredCompleted = filteredCompleted.filter(sh => sh.attendance !== 'Pending' && !sh.attendanceApproved);
                if (filteredCompleted.length === 0) return <div style={s.emptyBox}>{t('shifts_nothing_this_month')}</div>;
                return filteredCompleted.map((sh,i) => (
                <div key={sh.id} style={{ marginBottom: i===filteredCompleted.length-1 ? 0 : '4px' }}>
                  <div style={i===filteredCompleted.length-1 && actionShift?.id!==sh.id ? s.rowLast : s.row}>
                    <div>
                      <div style={s.name}>{sh.dateLabel}</div>
                      <div style={s.sub}>{sh.time}</div>
                      {sh.attendance === 'Worked' && !sh.endedEarly && <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'2px' }}>✅ {t('shifts_logged')}: {sh.workedFrom} – {sh.workedTo}</div>}
                      {sh.attendance === 'Worked' && sh.endedEarly && <div style={{ fontSize:'11px', color:'#8a6d00', marginTop:'2px' }}>⏰ {t('shifts_ended_early')}: {sh.workedFrom} – {sh.workedTo} — {sh.earlyEndNote}</div>}
                      {sh.attendance === 'Worked' && sh.otFrom && sh.otTo && <div style={{ fontSize:'11px', color:'#4527a0', marginTop:'2px' }}>➕ {t('shifts_overtime')}: {sh.otFrom} – {sh.otTo} ({formatDuration(durationMins(sh.otFrom, sh.otTo))})</div>}
                      {sh.attendance === 'Missed' && (
                        <div style={{ fontSize:'11px', color:'#b71c1c', marginTop:'2px' }}>
                          ❌ {sh.missedReason}{sh.missedDesc ? ` — ${sh.missedDesc}` : ''}
                          {sh.missedReason === 'Health problem' && sh.sickFrom && <div>🤒 {t('shifts_sick_range').replace('{from}', sh.sickFrom).replace('{to}', sh.sickTo)}</div>}
                        </div>
                      )}
                      {sh.attendance !== 'Pending' && (
                        <div style={{ fontSize:'11px', color: sh.attendanceApproved ? '#2e7d32' : '#f57f17', marginTop:'2px' }}>
                          {sh.attendanceApproved ? `✅ ${t('shifts_approved_by_manager')}` : `⏳ ${t('shifts_awaiting_review')}`}
                        </div>
                      )}
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'6px' }}>
                      <span style={getBadgeStyle(sh.attendance === 'Pending' ? 'Completed' : sh.attendance)}>{sh.attendance === 'Pending' ? translate(language, 'status_not_reported') : translateStatus(language, sh.attendance)}</span>
                      {actionShift?.id !== sh.id && (
                        <div style={{ display:'flex', gap:'4px' }}>
                          {sh.attendance === 'Pending' && <>
                            <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => openMissed(sh)}>❌ {t('shifts_not_attended')}</button>
                          </>}
                          {sh.attendance === 'Missed' && <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => openMissed(sh)}>✏️ {t('shifts_edit')}</button>}
                        </div>
                      )}
                    </div>
                  </div>

                  {actionShift?.id === sh.id && actionShift.mode === 'missed' && (
                    <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                      <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('lh_why_missed')}</div>
                      <textarea style={{ ...s.input, minHeight:'70px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('lh_add_details')} value={missedDesc} onChange={e => setMissedDesc(e.target.value)} />
                      <div style={{ fontSize:'11px', color:'#888', marginBottom:'10px' }}>{t('lh_illness_hint')}</div>
                      <div style={{ display:'flex', gap:'8px' }}>
                        <button style={{ ...s.dangerBtn, flex:1, padding:'10px', opacity: missedDesc.trim() ? 1 : 0.5 }} disabled={!missedDesc.trim()} onClick={() => submitMissed(sh.id)}>{t('lh_submit_btn')}</button>
                        <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={cancelAction}>{t('avail_cancel')}</button>
                      </div>
                    </div>
                  )}
                </div>
                ));
              })()}
              </>}
          </div>
          )}
        </>}

        {tab === 'avail' && <>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <button style={s.navControlBtn(weekOffset > minActionableOffset)} disabled={weekOffset <= minActionableOffset} onClick={() => setWeekOffset(w => w - 1)}>‹</button>
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:'14px', fontWeight:'700', color:'#2d2d2d' }}>{t('avail_week')} {weekNum}, {weekYear}</div>
                <div style={{ fontSize:'11px', color:'#888' }}>{selectedMonday} – {weekEndDate}</div>
              </div>
              <button style={s.navControlBtn(true)} onClick={() => setWeekOffset(w => w + 1)}>›</button>
            </div>
          </div>

          {!weekDates.every(d => myAvail.find(a => a.date === d)) && (
            <div style={s.card}>
              <div style={s.cardLabel}>⚡ {t('avail_quick_fill')}</div>
              <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('avail_quick_fill_desc')}</div>
              <DragTimeRange from={quickFrom} to={quickTo} onChange={(f, t) => { setQuickFrom(f); setQuickTo(t); }} />
              <button style={{ ...s.outlineBtn, width:'100%', marginTop:'12px' }} onClick={applyQuickFill}>{t('avail_apply_week')}</button>
            </div>
          )}

          <div style={s.card}>
            <div style={s.cardLabel}>{t('avail_week')} {weekNum}, {weekYear}{weekOffset === 0 ? ` (${t('avail_current')})` : ''}</div>
            {weekDates.map((d, idx) => {
              const existing = myAvail.find(a => a.date === d);
              const dateObj = new Date(d);
              const dateLabel = dateObj.toLocaleDateString('en-GB', { day:'numeric', month:'short' });
              if (existing) {
                const isEditing = editingAvailDate === d;
                const canEdit = existing.status === 'Pending';
                if (isEditing) {
                  const [origFrom, origTo] = existing.slots[0].split(' – ');
                  return (
                    <div key={d} style={{ padding:'12px 0', borderBottom: idx===6 ? 'none' : '1px solid #f0f0f0' }}>
                      <div style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d', marginBottom:'8px' }}>{DAY_NAMES[idx]}, {dateLabel} — {t('avail_editing')}</div>
                      <DragTimeRange from={dayFrom[d] ?? origFrom} to={dayTo[d] ?? origTo}
                        onChange={(f, t) => { setDayFrom(prev => ({ ...prev, [d]: f })); setDayTo(prev => ({ ...prev, [d]: t })); }} />
                      <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                        <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => {
                          const f = dayFrom[d] ?? origFrom, t = dayTo[d] ?? origTo;
                          onEditAvail(existing.id, { slots: [`${f} – ${t}`] });
                          setEditingAvailDate(null);
                        }}>💾 {t('avail_save')}</button>
                        <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setEditingAvailDate(null)}>{t('avail_cancel')}</button>
                      </div>
                      <div style={{ textAlign:'center', marginTop:'10px' }}>
                        <span style={{ fontSize:'12px', color:'#b71c1c', cursor:'pointer', textDecoration:'underline' }} onClick={() => { if (window.confirm(t('avail_remove_confirm'))) { onRemoveAvail(existing.id); setEditingAvailDate(null); } }}>{t('avail_mark_day_off')}</span>
                      </div>
                    </div>
                  );
                }
                return (
                  <div key={d} style={idx===6 ? s.rowLast : s.row}>
                    <div>
                      <div style={s.name}>{DAY_NAMES[idx]}, {dateLabel}</div>
                      <div style={s.sub}>🕐 {existing.slots.join(', ')}{existing.note ? ` · 📝 ${existing.note}` : ''}</div>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                      <span style={getBadgeStyle(existing.status)}>{translateStatus(language, existing.status)}</span>
                      {canEdit && <span style={{ fontSize:'16px', cursor:'pointer' }} onClick={() => setEditingAvailDate(d)}>✏️</span>}
                    </div>
                  </div>
                );
              }
              const isOff = dayOff[d];
              return (
                <div key={d} style={{ padding:'12px 0', borderBottom: idx===6 ? 'none' : '1px solid #f0f0f0' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: isOff ? 0 : '10px' }}>
                    <div style={s.name}>{DAY_NAMES[idx]}, {dateLabel}</div>
                    <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'12px', color:'#888', cursor:'pointer' }}>
                      <input type='checkbox' checked={!!isOff} onChange={() => toggleDayOff(d)} /> {t('avail_day_off')}
                    </label>
                  </div>
                  {!isOff && (
                    <DragTimeRange from={dayFrom[d] || ''} to={dayTo[d] || ''}
                      onChange={(f, t) => { setDayFrom(prev => ({ ...prev, [d]: f })); setDayTo(prev => ({ ...prev, [d]: t })); }} />
                  )}
                </div>
              );
            })}
          </div>

          {weekDates.every(d => myAvail.find(a => a.date === d)) ? (
            <div style={{ ...s.card, background:'#e8f5e9' }}>
              <div style={{ fontSize:'13px', fontWeight:'600', color:'#2e7d32' }}>✅ {t('avail_already_submitted')}</div>
              <div style={{ fontSize:'12px', color:'#388e3c', marginTop:'4px' }}>{t('avail_edit_hint')}</div>
            </div>
          ) : (
            <div style={s.card}>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('avail_note')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('avail_note_hint')}</span></label>
              <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('avail_note_placeholder')} value={weekNote} onChange={e => setWeekNote(e.target.value)} />
              <label style={{ display:'flex', alignItems:'center', gap:'8px', fontSize:'13px', color:'#555', marginBottom:'14px', cursor:'pointer' }}>
                <input type='checkbox' checked={copyToNextWeek} onChange={e => setCopyToNextWeek(e.target.checked)} /> {t('avail_copy_next')}
              </label>
              {weekSubmitted && <div style={{ ...s.successBox, marginBottom:'10px' }}>✅ {t('avail_submitted_msg')}</div>}
              <button style={{ ...s.primaryBtn, marginTop:0 }} onClick={submitWeek}>{t('avail_submit_btn')} →</button>
            </div>
          )}
        </>}

        {tab === 'issues' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          <div style={s.card}>
            <div style={s.cardLabel}>{t('iss_report_title')}</div>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('iss_select_shift')}</label>
            <select style={{ ...s.selectInput, marginTop:'6px' }} value={issueShift} onChange={e => setIssueShift(e.target.value)}>
              <option value=''>{t('iss_choose_shift')}</option>
              {myShifts.map(sh => <option key={sh.id} value={sh.dateLabel}>{sh.dateLabel} · {sh.time}</option>)}
              <option value='General'>{t('iss_general')}</option>
            </select>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600', display:'block', marginBottom:'8px' }}>{t('iss_type')}</label>
            <div style={{ display:'flex', gap:'8px', marginBottom:'14px' }}>
              {[['Before shift', t('iss_before')], ['During shift', t('iss_during')], ['After shift', t('iss_after')]].map(([val, label]) => (
                <button key={val} style={s.issueTypeBtn(issueType===val)} onClick={() => setIssueType(val)}>{label}</button>
              ))}
            </div>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('iss_description')}</label>
            <textarea style={{ ...s.input, marginTop:'6px', minHeight:'80px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('iss_desc_placeholder')} value={issueDesc} onChange={e => setIssueDesc(e.target.value)} />
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('iss_attach_doc')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('iss_attach_doc_hint')}</span></label>
            <div style={{ marginTop:'6px', marginBottom:'14px' }}>
              <input ref={issueFileRef} type='file' accept='.pdf,image/*' style={{ display:'none' }} onChange={handleIssueFileChange} />
              <button style={s.outlineBtn} onClick={() => issueFileRef.current.click()}>📎 {t('iss_choose_file')}</button>
              {issueFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {issueFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setIssueFile(null)}>✕</span></span>}
            </div>
            {issueSubmitted && <div style={{ ...s.successBox, marginBottom:'10px' }}>✅ {t('iss_reported_msg')}</div>}
            <button style={{ ...s.primaryBtn, opacity:(!issueShift||!issueType||!issueDesc)?0.5:1 }} onClick={submitIssue}>{t('iss_report_btn')} →</button>
          </div>
          {myIssues.length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('iss_my_issues')}</div>
              {myIssues.map((iss,i) => (
                <div key={iss.id} style={{ marginBottom: i===myIssues.length-1 ? 0 : '4px' }}>
                  <div onClick={() => setOpenIssueId(openIssueId===iss.id ? null : iss.id)} style={{ ...(i===myIssues.length-1 && openIssueId!==iss.id ? s.rowLast : s.row), cursor:'pointer' }}>
                    <div>
                      <div style={s.name}>{iss.shift}</div>
                      <div style={s.sub}>{iss.type} · {iss.description.substring(0,40)}{iss.description.length>40?'...':''}</div>
                      {iss.replies?.length > 0 && <div style={{ fontSize:'11px', color:'var(--brand)', marginTop:'2px' }}>💬 {iss.replies.length} repl{iss.replies.length===1?'y':'ies'}</div>}
                    </div>
                    <span style={getBadgeStyle(iss.status)}>{translateStatus(language, iss.status)}</span>
                  </div>
                  {openIssueId === iss.id && (
                    <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                      <div style={{ fontSize:'13px', color:'#555', marginBottom:'10px' }}>{iss.description}</div>
                      {iss.type === 'Attendance' && iss.shiftDate && (
                        <button style={{ ...s.assignBtn, width:'100%', padding:'10px', marginBottom:'10px' }} onClick={() => { setSickCertFrom(iss.shiftDate); setSickCertTo(iss.shiftDate); setSickFormOpen(true); navigateTo('sick'); }}>🤒 {t('iss_submit_sick_for_date')}</button>
                      )}
                      {iss.certFileData && (
                        <div style={{ fontSize:'12px', color:'#4A3CDB', marginBottom:'10px', cursor:'pointer' }} onClick={() => { const a=document.createElement('a'); a.href=iss.certFileData; a.download=iss.certFileName; a.click(); }}>📎 {iss.certFileName}</div>
                      )}
                      {iss.replies?.map((r,ri) => (
                        <div key={ri} style={{ background: r.from==='admin' ? 'var(--brand-light)' : 'white', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                          <div style={{ fontSize:'11px', fontWeight:'600', color: r.from==='admin' ? 'var(--brand-dark)' : '#2d2d2d', marginBottom:'2px' }}>{r.from==='admin' ? `⚙️ ${t('iss_manager')}` : r.fromName}</div>
                          {r.text && <div style={{ fontSize:'13px', color:'#555' }}>{r.text}</div>}
                          {r.fileData && <div style={{ fontSize:'12px', color:'#4A3CDB', marginTop:'4px', cursor:'pointer' }} onClick={() => { const a=document.createElement('a'); a.href=r.fileData; a.download=r.fileName; a.click(); }}>📎 {r.fileName}</div>}
                        </div>
                      ))}
                      {iss.replies?.some(r => r.from === 'admin') && !iss.escalatedToHR && (
                        <div style={{ marginBottom:'10px' }}>
                          <span style={{ fontSize:'12px', color:'#b71c1c', cursor:'pointer', fontWeight:'600' }} onClick={() => { if (window.confirm(t('iss_escalate_confirm'))) onUpdateIssue(iss.id, { escalatedToHR: true, escalatedAt: today }); }}>⚠️ {t('iss_escalate_btn')}</span>
                        </div>
                      )}
                      {iss.escalatedToHR && (
                        <div style={{ fontSize:'12px', color:'#e65100', marginBottom:'10px', fontWeight:'600' }}>⚠️ {t('iss_escalated_label')}</div>
                      )}
                      <textarea style={{ ...s.input, marginTop:'8px', minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('iss_reply_placeholder')} value={replyText} onChange={e => setReplyText(e.target.value)} />
                      <div style={{ marginBottom:'10px' }}>
                        <input ref={replyFileRef} type='file' accept='.pdf,image/*' style={{ display:'none' }} onChange={handleReplyFileChange} />
                        <button style={s.outlineBtn} onClick={() => replyFileRef.current.click()}>📎 {t('btn_attach')}</button>
                        {replyFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {replyFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setReplyFile(null)}>✕</span></span>}
                      </div>
                      <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!replyText && !replyFile)?0.5:1 }} onClick={() => sendReply(iss.id)}>{t('iss_send_reply')} →</button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>}

        {tab === 'salary' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          <div style={{ ...s.card, background:'#e8f5e9', border:'1px solid #c8e6c9' }}>
            <div style={{ fontSize:'13px', color:'#2e7d32', fontWeight:'500' }}>
              💡 {t('salary_info')}
            </div>
          </div>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('salary_slips_title')}</div>
            {mySlips.length === 0 && <div style={s.emptyBox}>{t('salary_none')}</div>}
            {mySlips.map((sl,i) => (
              <div key={sl.id} style={i===mySlips.length-1?s.rowLast:s.row}>
                <div>
                  <div style={s.name}>{sl.month}</div>
                  <div style={s.sub}>{sl.hours} hrs · {sl.netPay}</div>
                </div>
                <button style={sl.fileData ? s.dlBtn : { ...s.dlBtn, opacity:0.5 }} onClick={() => downloadSlip(sl)}>
                  {sl.fileData ? '⬇ PDF' : '⏳ Pending'}
                </button>
              </div>
            ))}
          </div>
        </>}

        {tab === 'sick' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          {mySickReports.filter(r => r.status !== 'Pending' && !r.notifiedRead).map(r => (
            <div key={r.id} style={{ background: r.status==='Approved' ? '#e8f5e9' : '#ffebee', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div>
                  <div style={{ fontSize:'13px', fontWeight:'600', color: r.status==='Approved' ? '#2e7d32' : '#b71c1c' }}>
                    🔔 {t('sick_notif').replace('{from}', r.fromDate).replace('{to}', r.toDate)} {translateStatus(language, r.status)}
                  </div>
                  {r.adminNote && <div style={{ fontSize:'12px', color:'#555', marginTop:'4px' }}>"{r.adminNote}"</div>}
                </div>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => dismissSickNotification(r.id)}>✕</span>
              </div>
            </div>
          ))}
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: sickFormOpen ? '14px' : 0 }}>
              <div style={s.cardLabel}>{editingSickId ? `✏️ ${t('sick_edit_title')}` : t('sick_submit_title')}</div>
              <button style={s.outlineBtn} onClick={() => { if (sickFormOpen) { setEditingSickId(null); setSickCertFrom(''); setSickCertTo(''); setSickCertNote(''); setSickCertFile(null); setSickDupWarning(null); } setSickFormOpen(!sickFormOpen); }}>{sickFormOpen ? t('avail_cancel') : `+ ${t('sick_submit_short')}`}</button>
            </div>
            {sickFormOpen && (
              <>
                <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('sick_covers_desc')}</div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_from')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={sickCertFrom} onChange={e => { setSickCertFrom(e.target.value); setSickDupWarning(null); }} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_to')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={sickCertTo} onChange={e => { setSickCertTo(e.target.value); setSickDupWarning(null); }} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_note_optional')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('sick_note_optional_hint')}</span></label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('sick_note_placeholder')} value={sickCertNote} onChange={e => setSickCertNote(e.target.value)} />
                <div style={{ marginBottom:'14px' }}>
                  <input ref={sickCertRef} type='file' accept='.pdf,image/*' style={{ display:'none' }} onChange={handleSickCertChange} />
                  <button style={s.outlineBtn} onClick={() => sickCertRef.current.click()}>📎 {editingSickId ? t('sick_replace_cert') : t('sick_upload_cert')}</button>
                  {sickCertFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {sickCertFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setSickCertFile(null)}>✕</span></span>}
                </div>
                {sickDupWarning && (
                  <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {sickDupWarning}</div>
                )}
                <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!sickCertFrom||!sickCertTo||sickCertFrom>sickCertTo)?0.5:1 }} onClick={submitSickCert}>{editingSickId ? `${t('sick_save_changes')} →` : `${t('sick_submit_cert')} →`}</button>
              </>
            )}
          </div>
          {mySickReports.length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('sick_my_certs')}</div>
              {mySickReports.map((r,i) => (
                <div key={r.id} style={i===mySickReports.length-1?s.rowLast:s.row}>
                  <div>
                    <div style={s.name}>🤒 {r.fromDate} to {r.toDate}</div>
                    {r.note && <div style={s.sub}>{r.note}</div>}
                    <CertificateViewer fileName={r.certFileName} fileData={r.certFileData} />
                    {r.adminNote && <div style={{ fontSize:'12px', color:'#888', marginTop:'4px' }}>{t('sick_manager_note')}: "{r.adminNote}"</div>}
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'6px' }}>
                    <span style={getBadgeStyle(r.status === 'Approved' ? 'Confirmed' : r.status === 'Rejected' ? 'Open' : 'Pending')}>{translateStatus(language, r.status)}</span>
                    {canEditSickReport(r) && <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 10px' }} onClick={() => startEditSick(r)}>✏️ {t('shifts_edit')}</button>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>}

        {tab === 'leave' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: leaveFormOpen ? '14px' : 0 }}>
              <div style={s.cardLabel}>{editingLeaveId ? `✏️ ${t('leave_edit_title')}` : t('leave_apply_title')}</div>
              <button style={s.outlineBtn} onClick={() => { if (leaveFormOpen) { setEditingLeaveId(null); setLeaveFrom(''); setLeaveTo(''); setLeaveNote(''); } setLeaveFormOpen(!leaveFormOpen); }}>{leaveFormOpen ? t('avail_cancel') : `+ ${t('leave_apply_short')}`}</button>
            </div>
            {leaveFormOpen && (
              <>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_from')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={leaveFrom} onChange={e => setLeaveFrom(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_to')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={leaveTo} onChange={e => setLeaveTo(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('sick_note_optional')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('leave_note_placeholder')} value={leaveNote} onChange={e => setLeaveNote(e.target.value)} />
                <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!leaveFrom||!leaveTo||leaveFrom>leaveTo)?0.5:1 }} disabled={!leaveFrom||!leaveTo||leaveFrom>leaveTo} onClick={() => {
                  if (editingLeaveId) { onUpdateLeaveRequest(editingLeaveId, { dateFrom: leaveFrom, dateTo: leaveTo, note: leaveNote.trim() }); }
                  else { onAddLeaveRequest({ employee: user.name, dateFrom: leaveFrom, dateTo: leaveTo, note: leaveNote.trim() }); }
                  setEditingLeaveId(null); setLeaveFrom(''); setLeaveTo(''); setLeaveNote(''); setLeaveFormOpen(false);
                }}>{editingLeaveId ? `${t('sick_save_changes')} →` : `${t('leave_submit_btn')} →`}</button>
              </>
            )}
          </div>
          <div style={s.card}>
            <div style={s.tabRow}>
              <button style={s.tabBtn(leaveTab==='Pending')} onClick={() => setLeaveTab('Pending')}>{t('leave_tab_pending')}</button>
              <button style={s.tabBtn(leaveTab==='Approved')} onClick={() => setLeaveTab('Approved')}>{t('leave_tab_approved')}</button>
              <button style={s.tabBtn(leaveTab==='Rejected')} onClick={() => setLeaveTab('Rejected')}>{t('leave_tab_rejected')}</button>
            </div>
            {(() => {
              const list = leaveRequests.filter(r => r.employee === user.name && r.status === leaveTab).sort((a,b) => b.dateFrom.localeCompare(a.dateFrom));
              if (list.length === 0) return <div style={s.emptyBox}>{t('leave_none_in_tab')}</div>;
              return list.map((r,i) => (
                <div key={r.id} style={i===list.length-1?s.rowLast:s.row}>
                  <div>
                    <div style={s.name}>{r.dateFrom} → {r.dateTo}</div>
                    {r.note && <div style={s.sub}>{r.note}</div>}
                    {r.adminNote && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t('sick_manager_note')}: "{r.adminNote}"</div>}
                  </div>
                  {r.status === 'Pending' && (
                    <div style={{ display:'flex', gap:'6px' }}>
                      <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 10px' }} onClick={() => { setEditingLeaveId(r.id); setLeaveFrom(r.dateFrom); setLeaveTo(r.dateTo); setLeaveNote(r.note || ''); setLeaveFormOpen(true); }}>✏️</button>
                      <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'3px 10px' }} onClick={() => { if (window.confirm(t('leave_cancel_confirm'))) onDeleteLeaveRequest(r.id); }}>✕</button>
                    </div>
                  )}
                </div>
              ));
            })()}
          </div>
          {leaveRequests.filter(r => r.employee === user.name && r.status === 'Approved').length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('leave_used_title')} ({leaveRequests.filter(r => r.employee === user.name && r.status === 'Approved').reduce((sum,r) => sum + (Math.round((new Date(r.dateTo) - new Date(r.dateFrom)) / 86400000) + 1), 0)} {t('leave_days_unit')})</div>
              {leaveRequests.filter(r => r.employee === user.name && r.status === 'Approved').sort((a,b) => b.dateFrom.localeCompare(a.dateFrom)).map((r,i,arr) => (
                <div key={r.id} style={i===arr.length-1?s.rowLast:s.row}>
                  <div style={s.name}>{r.dateFrom} → {r.dateTo}</div>
                  <div style={s.sub}>{Math.round((new Date(r.dateTo) - new Date(r.dateFrom)) / 86400000) + 1} {t('leave_days_unit')}</div>
                </div>
              ))}
            </div>
          )}
        </>}

        {tab === 'profile' && <>
          {/* Profile header card */}
          <div style={{ ...s.card, display:'flex', alignItems:'center', gap:'14px' }}>
            {myProfile.photo ? (
              <img src={myProfile.photo} alt='Profile' style={{ width:'56px', height:'56px', borderRadius:'50%', objectFit:'cover' }} />
            ) : (
              <div style={{ width:'56px', height:'56px', borderRadius:'50%', background:'var(--brand-light)', color:'var(--brand-dark)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px', fontWeight:'600' }}>{user.initials}</div>
            )}
            <div><div style={{ fontSize:'16px', fontWeight:'700', color:'#2d2d2d' }}>{user.name}</div><div style={s.sub}>{t('prof_employee_label')}</div></div>
          </div>

          {/* ── Account & Profile ── */}
          <div style={s.sectionHeader}>{t('prof_account_section')}</div>
          <div style={s.card}>
            <MenuRow icon='📷' label={t('profile_photo')} open={openPanel==='photo'} onClick={() => togglePanel('photo')} />
            {openPanel==='photo' && (
              <div style={{ padding:'0 16px 16px' }}>
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'12px' }}>
                  {myProfile.photo ? (
                    <img src={myProfile.photo} alt='Profile' style={{ width:'96px', height:'96px', borderRadius:'50%', objectFit:'cover', border:'2px solid var(--brand-light)' }} />
                  ) : (
                    <div style={{ width:'96px', height:'96px', borderRadius:'50%', background:'var(--brand-light)', color:'var(--brand-dark)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'28px', fontWeight:'600' }}>{user.initials}</div>
                  )}
                  {!myProfile.photo ? (
                    <>
                      <input ref={photoRef} type='file' accept='image/*' style={{ display:'none' }} onChange={handlePhotoUpload} />
                      <button style={s.outlineBtn} onClick={() => photoRef.current.click()}>📷 {t('prof_upload_photo')}</button>
                      <div style={{ fontSize:'11px', color:'#aaa', textAlign:'center' }}>{t('prof_photo_once_hint')}</div>
                    </>
                  ) : myProfile.photoChangeRequested ? (
                    <div style={{ fontSize:'12px', color:'#f57f17', textAlign:'center', fontWeight:'500' }}>⏳ {t('prof_photo_change_sent')}</div>
                  ) : (
                    <button style={s.outlineBtn} onClick={() => onUpdateProfile(user.name, { photoChangeRequested: true })}>🔄 {t('prof_request_photo_change')}</button>
                  )}
                </div>
              </div>
            )}

            <MenuRow icon='📄' label={t('profile_contract')} open={openPanel==='contract'} onClick={() => togglePanel('contract')} />
            {openPanel==='contract' && (
              <div style={{ padding:'0 16px 16px' }}>
                {myProfile.contractShared && myProfile.contractFile ? (
                  <>
                    <div style={s.row}>
                      <div><div style={s.name}>📄 {myProfile.contractName || 'Contract.pdf'}</div><div style={s.sub}>{t('prof_shared_by_manager')}</div></div>
                      <button style={s.dlBtn} onClick={downloadContract}>⬇ PDF</button>
                    </div>
                    {myProfile.contractSigned && (
                      <div style={{ fontSize:'12px', color:'#2e7d32', fontWeight:'600', marginTop:'10px' }}>
                        ✅ {t('ct_you_signed_on').replace('{name}', myProfile.contractSignedName).replace('{date}', myProfile.contractSignedAt)}
                        {myProfile.contractSignedImage && <img src={myProfile.contractSignedImage} alt='signature' style={{ display:'block', maxHeight:'40px', marginTop:'6px' }} />}
                      </div>
                    )}
                    {myProfile.contractSigned && (
                      myProfile.employerSigned ? (
                        <div style={{ fontSize:'12px', color:'#2e7d32', fontWeight:'600', marginTop:'6px' }}>
                          ✅ {t('ct_employer_signed_on').replace('{name}', myProfile.employerSignedName).replace('{date}', myProfile.employerSignedAt)}
                          <div style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'700', marginTop:'4px' }}>🎉 {t('ct_fully_executed')}</div>
                        </div>
                      ) : (
                        <div style={{ fontSize:'12px', color:'#f57f17', marginTop:'6px' }}>⏳ {t('ct_awaiting_employer')}</div>
                      )
                    )}
                    {!myProfile.contractSigned && signingContract ? (
                      <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginTop:'10px' }}>
                        {!signaturePreview ? (
                          <>
                            <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('ct_sign_confirm')}</div>
                            <div style={{ display:'flex', gap:'8px', marginBottom:'10px' }}>
                              <button style={s.tabBtn(signatureMode!=='upload')} onClick={() => setSignatureMode('type')}>{t('ct_type_signature')}</button>
                              <button style={s.tabBtn(signatureMode==='upload')} onClick={() => setSignatureMode('upload')}>{t('ct_upload_signature')}</button>
                            </div>
                            {signatureMode === 'upload' ? (
                              <div style={{ marginBottom:'10px' }}>
                                <input ref={signatureFileRef} type='file' accept='image/*' style={{ display:'none' }} onChange={handleSignatureFileChange} />
                                <button style={s.outlineBtn} onClick={() => signatureFileRef.current.click()}>📎 {t('ct_choose_image')}</button>
                                {signatureImage && <img src={signatureImage} alt='signature preview' style={{ display:'block', maxHeight:'50px', marginTop:'8px' }} />}
                              </div>
                            ) : (
                              <>
                                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('ct_type_full_name')}</label>
                                <input style={{ ...s.input, marginTop:'6px' }} placeholder={user.name} value={signatureName} onChange={e => setSignatureName(e.target.value)} />
                              </>
                            )}
                            <div style={{ display:'flex', gap:'8px' }}>
                              <button style={{ ...s.assignBtn, flex:1, padding:'10px', opacity: (signatureMode==='upload' ? signatureImage : signatureName.trim()) ? 1 : 0.5 }} disabled={signatureMode==='upload' ? !signatureImage : !signatureName.trim()} onClick={() => setSignaturePreview(true)}>{t('ct_review_btn')} →</button>
                              <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => { setSigningContract(false); setSignatureImage(null); }}>{t('avail_cancel')}</button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('ct_review_hint')}</div>
                            <div style={{ background:'white', borderRadius:'8px', padding:'12px', marginBottom:'10px', textAlign:'center' }}>
                              {signatureMode === 'upload'
                                ? <img src={signatureImage} alt='your signature' style={{ maxHeight:'60px' }} />
                                : <div style={{ fontFamily:'cursive', fontSize:'22px', color:'#2d2d2d' }}>{signatureName.trim()}</div>}
                              <div style={{ fontSize:'11px', color:'#888', marginTop:'6px' }}>{today}</div>
                            </div>
                            <div style={{ display:'flex', gap:'8px' }}>
                              <button style={{ ...s.assignBtn, flex:1, padding:'10px' }} onClick={confirmEmployeeSignature}>✅ {t('ct_confirm_sign_btn')}</button>
                              <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => setSignaturePreview(false)}>{t('ct_back_btn')}</button>
                            </div>
                          </>
                        )}
                      </div>
                    ) : !myProfile.contractSigned && (
                      <button style={{ ...s.assignBtn, width:'100%', marginTop:'10px' }} onClick={() => { setSigningContract(true); setSignatureName(''); setSignatureMode('type'); setSignaturePreview(false); }}>✍️ {t('ct_sign_contract')}</button>
                    )}
                  </>
                ) : (
                  <div style={s.emptyBox}>{t('prof_no_contract')}</div>
                )}
              </div>
            )}

            <MenuRow icon='⏱️' label={t('profile_hours')} open={openPanel==='hours'} onClick={() => togglePanel('hours')} />
            {openPanel==='hours' && (
              <div style={{ padding:'0 16px 16px' }}>
                {(myProfile.minHours || myProfile.maxHours) ? (
                  <div style={s.statRow}>
                    <div style={s.stat}><div style={s.statNum}>{myProfile.minHours || '–'}</div><div style={s.statLbl}>{t('prof_min_hrs_week')}</div></div>
                    <div style={s.stat}><div style={s.statNum}>{myProfile.maxHours || '–'}</div><div style={s.statLbl}>{t('prof_max_hrs_week')}</div></div>
                  </div>
                ) : (
                  <div style={s.emptyBox}>{t('prof_hours_not_set')}</div>
                )}
              </div>
            )}

            <MenuRow icon='📁' label={t('profile_my_docs')} badge={myProfile.documents.some(d=>isExpiringSoon(d.expiryDate)&&d.status!=='Approved') ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>●</span> : null} open={openPanel==='docs'} onClick={() => togglePanel('docs')} last />
            {openPanel==='docs' && (
              <div style={{ padding:'0 16px 16px' }}>
                <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('prof_docs_examples')}</div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('prof_doc_name')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('prof_doc_name_placeholder')} value={docName} onChange={e => setDocName(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('prof_expiry_date')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={docExpiry} onChange={e => setDocExpiry(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('prof_file_optional')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('prof_file_optional_hint')}</span></label>
                <div style={{ marginTop:'6px', marginBottom:'14px' }}>
                  <input ref={docFileRef} type='file' accept='.pdf,image/*' style={{ display:'none' }} onChange={handleDocFileChange} />
                  <button style={s.outlineBtn} onClick={() => docFileRef.current.click()}>📎 {t('iss_choose_file')}</button>
                  {docFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {docFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setDocFile(null)}>✕</span></span>}
                </div>
                <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!docName||!docExpiry)?0.5:1 }} onClick={submitDocument}>{t('prof_submit_doc')} →</button>
                {myProfile.documents.length > 0 && (
                  <div style={{ marginTop:'14px' }}>
                    {myProfile.documents.map((d,i) => (
                      <div key={d.id} style={i===myProfile.documents.length-1?s.rowLast:s.row}>
                        <div>
                          <div style={s.name}>{d.name}</div>
                          <div style={{ fontSize:'12px', marginTop:'2px', color: isExpiringSoon(d.expiryDate) ? '#b71c1c' : '#888', fontWeight: isExpiringSoon(d.expiryDate) ? '600' : '400' }}>
                            {isExpiringSoon(d.expiryDate) ? `⚠️ ${t('prof_expires')}` : t('prof_expires')} {d.expiryDate}
                          </div>
                          {d.status === 'Rejected' && d.reviewNote && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'4px' }}>📝 {d.reviewNote} {t('prof_resubmit_hint')}</div>}
                        </div>
                        <span style={getBadgeStyle(d.status === 'Approved' ? 'Confirmed' : d.status)}>{translateStatus(language, d.status)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ── App ── */}
          <div style={s.sectionHeader}>{t('prof_app_section')}</div>
          <div style={s.card}>
            <MenuRow icon='🌐' label={t('profile_language')} open={openPanel==='lang'} onClick={() => togglePanel('lang')} />
            {openPanel==='lang' && (
              <div style={{ padding:'0 16px 16px' }}>
                <select style={{ ...s.selectInput, marginBottom:0 }} value={language} onChange={e => setLanguage(e.target.value)}>
                  {LANGUAGES.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
                </select>
              </div>
            )}
            <MenuRow icon='🚨' label={t('title_issues')} badge={myIssues.filter(i=>i.status==='Open').length>0 ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>{myIssues.filter(i=>i.status==='Open').length} {t('prof_open_count')}</span> : null} onClick={() => navigateTo('issues')} />
            <MenuRow icon='🤒' label={t('nav_sick')} badge={mySickReports.some(r=>r.status!=='Pending' && !r.notifiedRead) ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>●</span> : null} onClick={() => navigateTo('sick')} />
            <MenuRow icon='🏖️' label={t('nav_leave')} onClick={() => navigateTo('leave')} />
            <MenuRow icon='💶' label={t('title_salary')} onClick={() => navigateTo('salary')} last />
          </div>

          <button style={{ ...s.outlineBtn, width:'100%', padding:'12px', color:'#b71c1c', borderColor:'#b71c1c' }} onClick={onLogout}>{t('logout')}</button>
        </>}
      </div>

      <div style={s.nav}>
        {tabs.map(([id,icon,label]) => (
          <button key={id} style={s.navBtn(tab===id)} onClick={() => navigateTo(id)}>
            <span style={{ fontSize:'18px' }}>{icon}</span>
            <span style={s.navLbl(tab===id)}>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── ADMIN APP ───────────────────────────────────────────────────
function AdminApp({ user, shifts, onAddShift, onUpdateShift, onRemoveShift, availList, onUpdateAvail, salarySlips, onAddSalarySlip, issues, onUpdateIssue, onIssueReply, onCreateIssue, profiles, onUpdateProfile, sickReports, onUpdateSickReport, employeeRecords, onUpdateEmployeeRecord, onAddEmployee, contractTemplates, onAddContractTemplate, onUpdateContractTemplate, onDeleteContractTemplate, swapRequests, onUpdateSwapRequest, leaveRequests, onUpdateLeaveRequest, companyThemeColor, onUpdateCompanyThemeColor, fixedScheduleConfig, onUpdateFixedScheduleConfig, onGenerateFixedShifts, dayOffChoices, onExecuteWeekOffSwap, shiftTemplates, onAddShiftTemplate, onUpdateShiftTemplate, onDeleteShiftTemplate, jobPostings, applicants, onAddJobPosting, onUpdateJobPosting, onUpdateApplicant, onHireApplicant, onAddHRAccount, onSubmitPayrollToHQ, rotationConfig, onUpdateRotationConfig, onGenerateRotationShifts, onCheckRotationRest, language, setLanguage, onLogout }) {
  const t = (key) => translate(language, key);
  const [tab, setTab] = useState('overview');
  const [tabHistory, setTabHistory] = useState(['overview']);
  const [historyIndex, setHistoryIndex] = useState(0);

  function navigateTo(newTab) {
    if (newTab === tab) return;
    const trimmed = tabHistory.slice(0, historyIndex + 1);
    trimmed.push(newTab);
    setTabHistory(trimmed);
    setHistoryIndex(trimmed.length - 1);
    setTab(newTab);
  }
  function goBack() {
    if (historyIndex === 0) return;
    const newIndex = historyIndex - 1;
    setHistoryIndex(newIndex);
    setTab(tabHistory[newIndex]);
  }
  function goForward() {
    if (historyIndex >= tabHistory.length - 1) return;
    const newIndex = historyIndex + 1;
    setHistoryIndex(newIndex);
    setTab(tabHistory[newIndex]);
  }

  const [assignTarget, setAssignTarget] = useState(null);
  const [assignFrom, setAssignFrom] = useState('');
  const [assignTo, setAssignTo] = useState('');
  const [autoProposals, setAutoProposals] = useState(null); // null = not run yet; [] or [...] once run
  const [shiftCategoryFilter, setShiftCategoryFilter] = useState('all');
  const [viewingWeeklyShifts, setViewingWeeklyShifts] = useState(null); // employee name, or null
  const [weeklyShiftsSearch, setWeeklyShiftsSearch] = useState('');
  const [weeklyShiftsDropdownOpen, setWeeklyShiftsDropdownOpen] = useState(false);
  const [editingShift, setEditingShift] = useState(null);
  const [editDate, setEditDate] = useState('');
  const [editFrom, setEditFrom] = useState('');
  const [editTo, setEditTo] = useState('');
  const [uploadMonth, setUploadMonth] = useState('');
  const [uploadHours, setUploadHours] = useState('');
  const [uploadPay, setUploadPay] = useState('');
  const [uploadEmployee, setUploadEmployee] = useState('');
  const fileRef = useRef();
  const bulkSalaryFileRef = useRef();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [bulkSalaryOpen, setBulkSalaryOpen] = useState(false);
  const [bulkSalaryMonth, setBulkSalaryMonth] = useState('');
  const [bulkSalaryFiles, setBulkSalaryFiles] = useState([]);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [viewEmployee, setViewEmployee] = useState(null);
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [employeeStatusTab, setEmployeeStatusTab] = useState('active');
  const [shiftsViewTab, setShiftsViewTab] = useState('all');
  const [dayViewOffset, setDayViewOffset] = useState(0);
  const [dayViewMode, setDayViewMode] = useState('day'); // 'day' | 'week'
  const [expandedDayViewShiftId, setExpandedDayViewShiftId] = useState(null);

  // Live "now" position for the Day View timeline — updates every minute so the
  // marker line and shift colors genuinely move as real time passes, not just on reload.
  const [nowMinutes, setNowMinutes] = useState(() => { const d = new Date(); return d.getHours() * 60 + d.getMinutes(); });
  useEffect(() => {
    const timer = setInterval(() => { const d = new Date(); setNowMinutes(d.getHours() * 60 + d.getMinutes()); }, 60000);
    return () => clearInterval(timer);
  }, []);

  const DAYVIEW_COLORS = { upcoming: '#90A4C4', ongoing: 'var(--brand)', worked: '#2e7d32', missed: '#b71c1c', unreported: '#b71c1c' };
  // Classifies a shift for Day View coloring — real attendance status wins when it
  // exists; a still-Pending shift falls back to purely time-based classification
  // against the live "now" line, so the line and the colors move together.
  // Importantly: once the scheduled start time arrives, a Pending (not-yet-clocked-in)
  // shift turns red immediately — not orange — so admin can see right away who hasn't
  // started, rather than that only showing up once the whole shift has passed.
  function classifyDayViewShift(sh, viewingToday) {
    if (sh.attendance === 'Worked') return 'worked';
    if (sh.attendance === 'Missed') return 'missed';
    if (sh.attendance === 'Clocked In') return 'ongoing';
    // Pending:
    const [startStr] = sh.time.split(' – ');
    const [sh_, sm_] = startStr.split(':').map(Number);
    const startMins = sh_ * 60 + sm_;
    if (!viewingToday) return 'upcoming';
    if (nowMinutes < startMins) return 'upcoming';
    return 'unreported';
  }

  const [calendarEmployee, setCalendarEmployee] = useState('');
  const [pendingBrandColor, setPendingBrandColor] = useState(companyThemeColor || '#FF6B1A');
  const [showBrandColorPanel, setShowBrandColorPanel] = useState(false);
  const [showFixedSchedulePanel, setShowFixedSchedulePanel] = useState(false);
  const [showRotationPanel, setShowRotationPanel] = useState(false);
  const [rotationFormShifts, setRotationFormShifts] = useState(rotationConfig?.shiftTypes || [{ name:'Frühschicht', start:'06:00', end:'14:00', premiumPercent:'0' }, { name:'Spätschicht', start:'14:00', end:'22:00', premiumPercent:'10' }, { name:'Nachtschicht', start:'22:00', end:'06:00', premiumPercent:'20' }]);
  const [rotationFormDays, setRotationFormDays] = useState(rotationConfig?.daysPerShift || 2);
  const [showShiftTemplatesPanel, setShowShiftTemplatesPanel] = useState(false);
  const [newPostingOpen, setNewPostingOpen] = useState(false);
  const [newPosting, setNewPosting] = useState({ title:'', role:'', location:'', description:'', interviewRounds:'1' });
  const [newHROpen, setNewHROpen] = useState(false);
  const [newHRName, setNewHRName] = useState('');
  const [newHREmail, setNewHREmail] = useState('');
  const [newHRError, setNewHRError] = useState('');
  const [hqSubmitStatus, setHqSubmitStatus] = useState(null);
  const [newTemplateOpen, setNewTemplateOpen] = useState(false);
  const [newTpl, setNewTpl] = useState({ templateName:'', startTime:'09:00', endTime:'17:00', breakMinutes:'60', maxEmployees:'2', role:'', branch:'', weeklyOff:[] });
  const [fixedFormStart, setFixedFormStart] = useState(fixedScheduleConfig?.start || '09:00');
  const [fixedFormEnd, setFixedFormEnd] = useState(fixedScheduleConfig?.end || '18:00');
  const [fixedFormBreakStart, setFixedFormBreakStart] = useState(fixedScheduleConfig?.breakStart || '13:00');
  const [fixedFormBreakEnd, setFixedFormBreakEnd] = useState(fixedScheduleConfig?.breakEnd || '14:00');
  const [fixedFormWorkDays, setFixedFormWorkDays] = useState(fixedScheduleConfig?.workDays || ['Monday','Tuesday','Wednesday','Thursday','Friday']);
  const [fixedFormMaxDayOff, setFixedFormMaxDayOff] = useState(fixedScheduleConfig?.maxDayOffPerDay || 0);
  const [fixedSaveStatus, setFixedSaveStatus] = useState(null);
  useEffect(() => {
    if (fixedScheduleConfig) {
      setFixedFormStart(fixedScheduleConfig.start || '09:00');
      setFixedFormEnd(fixedScheduleConfig.end || '18:00');
      setFixedFormBreakStart(fixedScheduleConfig.breakStart || '13:00');
      setFixedFormBreakEnd(fixedScheduleConfig.breakEnd || '14:00');
      setFixedFormWorkDays(fixedScheduleConfig.workDays || ['Monday','Tuesday','Wednesday','Thursday','Friday']);
      setFixedFormMaxDayOff(fixedScheduleConfig.maxDayOffPerDay || 0);
    }
  }, [fixedScheduleConfig]);
  useEffect(() => { setPendingBrandColor(companyThemeColor || '#FF6B1A'); }, [companyThemeColor]);
  const [employeeDetailOpen, setEmployeeDetailOpen] = useState(true);
  const [showEmpDropdown, setShowEmpDropdown] = useState(false);

  const [editingEmployment, setEditingEmployment] = useState(null); // { name, joinDate, salary, jobTitle }
  const [addEmpFormOpen, setAddEmpFormOpen] = useState(false);
  const [newEmpName, setNewEmpName] = useState('');
  const [newEmpEmail, setNewEmpEmail] = useState('');
  const [newEmpJoinDate, setNewEmpJoinDate] = useState(today);
  const [newEmpSalary, setNewEmpSalary] = useState('');
  const [newEmpJobTitle, setNewEmpJobTitle] = useState('');
  const [addEmpLoading, setAddEmpLoading] = useState(false);
  const [addEmpError, setAddEmpError] = useState('');
  const [addEmpSuccess, setAddEmpSuccess] = useState('');

  async function submitAddEmployee() {
    if (!newEmpName || !newEmpEmail) return;
    setAddEmpLoading(true); setAddEmpError(''); setAddEmpSuccess('');
    try {
      // Branch Manager can only create Employees (never other managers), and new hires
      // automatically inherit their own branch — no manual picker, no risk of a wrong branch.
      await onAddEmployee({ name: newEmpName, email: newEmpEmail, role: 'employee', joinDate: newEmpJoinDate, salary: newEmpSalary, jobTitle: newEmpJobTitle, branchId: user.branchId || null });
      setAddEmpSuccess(`${newEmpName} added — they'll receive an email to set their password.`);
      setNewEmpName(''); setNewEmpEmail(''); setNewEmpJoinDate(today); setNewEmpSalary(''); setNewEmpJobTitle('');
      setTimeout(() => { setAddEmpFormOpen(false); setAddEmpSuccess(''); }, 3000);
    } catch (err) {
      setAddEmpError(err.code === 'auth/email-already-in-use' ? 'This email already has an account.' : 'Something went wrong — please try again.');
    }
    setAddEmpLoading(false);
  }

  // Bulk Import — parse a CSV, validate every row before touching anything, let the
  // manager review the preview, then create accounts one at a time using the exact
  // same trusted mechanism as Add Employee. Every row becomes a regular Employee,
  // automatically tied to this branch manager's own branch — same rule as single Add.
  const [bulkFormOpen, setBulkFormOpen] = useState(false);
  const [templateFormOpen, setTemplateFormOpen] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState('');
  const [newTemplateType, setNewTemplateType] = useState('Part-time');
  const [newTemplateFile, setNewTemplateFile] = useState(null);
  const templateFileRef = useRef();
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [employerSigningFor, setEmployerSigningFor] = useState(null);
  const [employerSigName, setEmployerSigName] = useState('');
  const [employerSigMode, setEmployerSigMode] = useState('type');
  const [employerSigImage, setEmployerSigImage] = useState(null);
  const [employerSigPreview, setEmployerSigPreview] = useState(false);
  const employerSigFileRef = useRef();
  function handleEmployerSigFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setEmployerSigImage(ev.target.result);
    reader.readAsDataURL(file);
  }
  const [bulkRows, setBulkRows] = useState(null);
  const [bulkRunning, setBulkRunning] = useState(false);
  const [bulkProgress, setBulkProgress] = useState(0);
  const [bulkResults, setBulkResults] = useState(null);
  const bulkFileRef = useRef();

  function downloadBulkTemplate() {
    const csv = 'Name,Email,Job Title,Join Date,Salary\nMaria Schmidt,maria@example.com,Sales Executive,2026-08-01,€13.50/hour\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'karmadal_employee_template.csv'; a.click();
    URL.revokeObjectURL(url);
  }

  // Gross-pay-only payroll data for a given month, per employee — regular hours,
  // paid sick hours, and gross pay if their hourly rate is set. Never touches tax,
  // social security, or net pay — that stays with a real payroll system or accountant.
  function computePayrollRows(year, month) {
    return allEmployeesList.map(emp => {
      const p = getProfile(emp.name);
      const rec = getEmployeeRecord(emp.name);
      const monthShifts = shifts.filter(sh => sh.employee === emp.name && sh.date.startsWith(`${year}-${month}`));
      const workedShifts = monthShifts.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo && sh.attendanceApproved);
      const regularMins = workedShifts.reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo) + (sh.otFrom && sh.otTo ? durationMins(sh.otFrom, sh.otTo) : 0), 0);
      const sickMins = monthShifts.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem' && sh.payApproved)
        .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
      const totalMins = regularMins + sickMins;
      const payType = p.payType === 'gross' ? 'gross' : 'hourly';
      const hourlyRate = parseFloat(p.hourlyRate) || null;
      const grossSalary = parseFloat(p.grossSalary) || null;
      const maxHours = parseFloat(p.maxHours) || null;
      let gross = null;
      let premiumPay = 0;
      if (payType === 'hourly' && hourlyRate) {
        gross = (totalMins / 60) * hourlyRate;
        // Shift premiums (Zuschläge) — extra pay for shifts like Spätschicht or
        // Nachtschicht from the Multi-Shift Rotation model, matching real German
        // shift-work practice where late/night shifts carry a pay percentage on top.
        workedShifts.filter(sh => sh.shiftPremiumPercent).forEach(sh => {
          const mins = durationMins(sh.workedFrom, sh.workedTo);
          premiumPay += (mins / 60) * hourlyRate * (sh.shiftPremiumPercent / 100);
        });
        gross += premiumPay;
      } else if (payType === 'gross' && grossSalary && maxHours) {
        const monthlyRefHours = maxHours * 4;
        const effectiveRate = grossSalary / monthlyRefHours;
        gross = effectiveRate * (totalMins / 60);
      }
      return {
        name: emp.name, email: emp.email || '', dob: rec.dob || '', contractType: p.contractType || '',
        payType, hourlyRate, grossSalary, maxHours, regularMins, sickMins, totalMins, premiumPay, gross,
      };
    });
  }

  function exportPayrollCSV(year, month) {
    const rows = computePayrollRows(year, month);
    const header = 'Name;Email;Date of Birth;Pay Type;Rate or Gross Salary;Max Capped Hours;Regular Hours;Paid Sick Hours;Gross Payable\n';
    const lines = rows.map(r => {
      const payTypeLabel = r.payType === 'gross' ? 'Gross Salary' : 'Hourly';
      const rateOrGross = r.payType === 'gross' ? (r.grossSalary ?? '') : (r.hourlyRate ?? '');
      return `${r.name};${r.email};${r.dob};${payTypeLabel};${rateOrGross};${r.maxHours ?? ''};${(r.regularMins/60).toFixed(2)};${(r.sickMins/60).toFixed(2)};${r.gross !== null ? r.gross.toFixed(2) : ''}`;
    }).join('\n');
    const csv = 'sep=;\n' + header + lines + '\n';
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `karmadal_payroll_${year}-${month}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  function exportPayrollXLSX(year, month) {
    const rows = computePayrollRows(year, month);
    const data = rows.map(r => ({
      'Name': r.name,
      'Email': r.email,
      'Date of Birth': r.dob,
      'Pay Type': r.payType === 'gross' ? 'Gross Salary' : 'Hourly',
      'Rate or Gross Salary': r.payType === 'gross' ? (r.grossSalary ?? '') : (r.hourlyRate ?? ''),
      'Max Capped Hours': r.maxHours ?? '',
      'Regular Hours': Number((r.regularMins / 60).toFixed(2)),
      'Paid Sick Hours': Number((r.sickMins / 60).toFixed(2)),
      'Gross Payable': r.gross !== null ? Number(r.gross.toFixed(2)) : '',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [{ wch: 20 }, { wch: 26 }, { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 14 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payroll');
    XLSX.writeFile(wb, `karmadal_payroll_${year}-${month}.xlsx`);
  }


  function handleBulkFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const rows = parseCSV(ev.target.result);
      if (rows.length === 0) return;
      const [header, ...dataRows] = rows;
      const idx = { name: header.findIndex(h => h.toLowerCase().includes('name')), email: header.findIndex(h => h.toLowerCase().includes('email')), jobTitle: header.findIndex(h => h.toLowerCase().includes('job') || h.toLowerCase().includes('title')), joinDate: header.findIndex(h => h.toLowerCase().includes('join')), salary: header.findIndex(h => h.toLowerCase().includes('salary')) };
      const existingEmails = allEmployeesList.map(emp => emp.email.toLowerCase());
      const seenInFile = new Set();
      const preview = dataRows.map((row, i) => {
        const name = idx.name >= 0 ? row[idx.name] : '';
        const email = idx.email >= 0 ? row[idx.email] : '';
        const jobTitle = idx.jobTitle >= 0 ? row[idx.jobTitle] : '';
        const joinDate = (idx.joinDate >= 0 && row[idx.joinDate]) ? row[idx.joinDate] : today;
        const salary = idx.salary >= 0 ? row[idx.salary] : '';
        let issue = null;
        if (!name) issue = 'Missing name';
        else if (!email) issue = 'Missing email';
        else if (!/^\S+@\S+\.\S+$/.test(email)) issue = 'Invalid email format';
        else if (existingEmails.includes(email.toLowerCase())) issue = 'Email already exists';
        else if (seenInFile.has(email.toLowerCase())) issue = 'Duplicate email within this file';
        if (!issue) seenInFile.add(email.toLowerCase());
        return { rowNum: i + 2, name, email, jobTitle, joinDate, salary, issue };
      });
      setBulkRows(preview);
      setBulkResults(null);
    };
    reader.readAsText(file);
  }

  async function runBulkImport() {
    const validRows = bulkRows.filter(r => !r.issue);
    if (validRows.length === 0) return;
    setBulkRunning(true); setBulkProgress(0);
    const skipped = bulkRows.filter(r => r.issue).map(r => ({ row: r.rowNum, reason: r.issue }));
    let created = 0;
    for (const r of validRows) {
      try {
        await onAddEmployee({ name: r.name, email: r.email, role: 'employee', joinDate: r.joinDate, salary: r.salary, jobTitle: r.jobTitle, branchId: user.branchId || null });
        created++;
      } catch (err) {
        skipped.push({ row: r.rowNum, reason: err.code === 'auth/email-already-in-use' ? 'Email already has an account' : 'Failed to create — please add manually' });
      }
      setBulkProgress(p => p + 1);
    }
    setBulkResults({ created, skipped });
    setBulkRows(null);
    setBulkRunning(false);
  }


  // Combines the original 5 demo employees with any real employees added since —
  // but only when there's no branch filtering active. A branch manager should only
  // ever see real, branch-tagged employees — the old hardcoded fallback list would
  // otherwise bypass the filter entirely and show everyone regardless of branch.
  const allEmployeesList = (() => {
    const map = {};
    Object.keys(employeeRecords).forEach(name => {
      if (!map[name]) {
        const rec = employeeRecords[name];
        map[name] = { id: name, name: rec.name, email: rec.email, initials: rec.initials, color: rec.color, textColor: rec.textColor };
      }
    });
    return Object.values(map);
  })();

  const [editingHours, setEditingHours] = useState(null); // { name, min, max }
  const [adminEditAttendance, setAdminEditAttendance] = useState(null); // { id, from, to }
  const [openIssueId, setOpenIssueId] = useState(null);
  const [issuesSubTab, setIssuesSubTab] = useState('open');
  const [issueSearchQuery, setIssueSearchQuery] = useState('');
  const [replyText, setReplyText] = useState('');
  const [replyFile, setReplyFile] = useState(null);
  const replyFileRef = useRef();
  const [sickSubTab, setSickSubTab] = useState('pending');
  const [payrollYear, setPayrollYear] = useState(today.slice(0, 4));
  const [payrollMonth, setPayrollMonth] = useState(String(new Date(today).getMonth() + 1).padStart(2, '0'));
  const [reviewingSickId, setReviewingSickId] = useState(null); // { id, action: 'approve'|'reject' }
  const [reviewingDoc, setReviewingDoc] = useState(null); // { name, docId, action: 'approve'|'reject' }
  const [docReviewNote, setDocReviewNote] = useState('');

  function submitDocReview(name, docId, status) {
    const p = getProfile(name);
    updateProfile(name, { documents: p.documents.map(d => d.id === docId ? { ...d, status, reviewNote: docReviewNote, notifiedRead: false } : d) });
    setReviewingDoc(null); setDocReviewNote('');
  }

  const [sickReviewNote, setSickReviewNote] = useState('');

  function submitSickReview(report, status) {
    onUpdateSickReport(report.id, { status, adminNote: sickReviewNote, notifiedRead: false });
    if (status === 'Approved') {
      const inRange = shifts.filter(sh => sh.employee === report.employee && sh.date >= report.fromDate && sh.date <= report.toDate);
      inRange.forEach(sh => {
        if (sh.attendance === 'Missed' && sh.missedReason === 'Health problem') {
          // Already self-reported as sick for this date — just approve it.
          onUpdateShift(sh.id, { attendanceApproved: true, payApproved: true });
        } else if (sh.attendance === 'Pending') {
          // Never reported at all — the approved certificate itself is now the record.
          onUpdateShift(sh.id, {
            attendance: 'Missed', missedReason: 'Health problem',
            missedDesc: report.note || '', sickFrom: report.fromDate, sickTo: report.toDate,
            certFileName: report.certFileName, certFileData: report.certFileData,
            attendanceApproved: true, payApproved: true,
          });
        }
        // Worked, or Missed for a different reason, is left untouched — that's the
        // employee's own separate account of that specific day and shouldn't be
        // silently overwritten by an unrelated certificate.
      });
    }
    setReviewingSickId(null); setSickReviewNote('');
  }

  // Marking an unreported shift as absent both records it AND opens a conversation with
  // the employee (via Issues) so they can explain what happened — if it turns out to be
  // illness, admin can update this to sick leave afterward via the Sick Certificate flow.
  const [markingAbsent, setMarkingAbsent] = useState(null); // shift being marked
  const [discussingShiftId, setDiscussingShiftId] = useState(null);
  const [discussText, setDiscussText] = useState('');

  // Turns a self-reported Missed shift into a real, two-way conversation — reuses the
  // same Issues system Mark Absent already relies on, so replies, history, and the
  // employee's own view all work exactly the same way, rather than a second system.
  function sendDiscussReply(sh) {
    if (!discussText.trim()) return;
    const existing = issues.find(iss => iss.type === 'Attendance' && iss.employee === sh.employee && iss.shiftDate === sh.date);
    if (existing) {
      onIssueReply(existing.id, { from: 'admin', fromName: 'Admin', text: discussText.trim() });
    } else {
      const employeeNote = sh.missedDesc || sh.clockInLateNote || sh.lateEndNote || sh.earlyEndNote || sh.missedReason || '(no note provided)';
      onCreateIssue({
        employee: sh.employee, shift: sh.dateLabel, shiftDate: sh.date, type: 'Attendance',
        description: `Regarding the ${sh.dateLabel} shift (${sh.time}) — ${sh.employee} reported: "${employeeNote}"`,
        status: 'Open', replies: [{ from: 'admin', fromName: 'Admin', text: discussText.trim(), at: Date.now() }], raisedDate: today,
      });
    }
    setDiscussingShiftId(null); setDiscussText('');
  }

  const [absentNote, setAbsentNote] = useState('');

  function confirmMarkAbsent() {
    if (!markingAbsent) return;
    onUpdateShift(markingAbsent.id, { attendance: 'Missed', attendanceApproved: true, missedReason: 'No show', missedDesc: absentNote || 'Marked absent by manager — no attendance was logged.' });
    // Avoid creating a duplicate conversation if one's already open for this exact shift
    // (e.g. if it was previously reset to Pending and marked absent again).
    const existing = issues.find(iss => iss.type === 'Attendance' && iss.employee === markingAbsent.employee && iss.shiftDate === markingAbsent.date && iss.status === 'Open');
    if (existing) {
      onIssueReply(existing.id, { from: 'admin', fromName: 'Admin', text: `Marked absent again — no attendance was logged.${absentNote ? ` Note: ${absentNote}` : ''}` });
    } else {
      onCreateIssue({
        employee: markingAbsent.employee, shift: markingAbsent.dateLabel, shiftDate: markingAbsent.date, type: 'Attendance',
        description: `You were scheduled ${markingAbsent.dateLabel}, ${markingAbsent.time}, but no attendance was logged, so this was marked as absent.${absentNote ? ` Note: ${absentNote}` : ''} If this was due to illness, please submit a sick certificate for this date under Profile → Sick Certificates — it will automatically update this record once approved. Otherwise, reply here to explain.`,
        status: 'Open', replies: [], raisedDate: today,
      });
    }
    setMarkingAbsent(null); setAbsentNote('');
  }

  // Wipes a completed shift record back to "not yet reported" — used to undo an
  // accidental approval, a wrong worked-hours entry, or a Mark Absent decision.
  function resetShiftToPending(sh) {
    if (!window.confirm(t('confirm_reset_shift').replace('{employee}', sh.employee).replace('{date}', sh.dateLabel))) return;
    onUpdateShift(sh.id, {
      attendance: 'Pending', attendanceApproved: false, workedFrom: '', workedTo: '',
      missedReason: '', missedDesc: '', sickFrom: '', sickTo: '', certFileName: null, certFileData: null,
    });
  }

  // Being informed is not the same as being paid — Acknowledge just confirms the employee's
  // explanation was seen (a fair, non-punitive record), Approve Pay is the separate, deliberate
  // decision that this counts as paid time. Neither of these touches or clears their note.
  function acknowledgeMissedShift(sh) {
    onUpdateShift(sh.id, { attendanceApproved: true });
  }
  function approvePayForShift(sh) {
    onUpdateShift(sh.id, { attendanceApproved: true, payApproved: true });
  }
  function reopenMissedShift(sh) {
    onUpdateShift(sh.id, { attendanceApproved: false, payApproved: false });
  }

  async function handleReplyFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setReplyFile(await compressImage(file));
  }

  function sendReply(issueId) {
    if (!replyText && !replyFile) return;
    onIssueReply(issueId, { from: 'admin', fromName: 'Admin', text: replyText, fileName: replyFile ? replyFile.name : null, fileData: replyFile ? replyFile.data : null });
    setReplyText(''); setReplyFile(null);
  }
  const adminPhotoRef = useRef();
  const [openPanel, setOpenPanel] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [featureSearchOpen, setFeatureSearchOpen] = useState(false);
  const [featureSearchQuery, setFeatureSearchQuery] = useState('');
  function togglePanel(name) { setOpenPanel(openPanel === name ? null : name); }

  // Pulls together everything across the app that needs admin's attention into one
  // unified feed — the same pending items already shown in Overview, just reachable
  // from any tab via the bell, not only when already on Overview.
  function getAdminNotifications() {
    const items = [];
    openIssues.forEach(iss => {
      items.push({ id: `issue-${iss.id}`, icon: '🚨', text: `${iss.employee}: ${iss.type}`, tab: 'issues', onOpen: () => {} });
    });
    pending.forEach(a => {
      items.push({ id: `avail-${a.id}`, icon: '⚠️', text: `${a.employee}: ${t('notif_pending_avail')}`, tab: 'avail', onOpen: () => {} });
    });
    sickReports.filter(r => r.status === 'Pending').forEach(r => {
      items.push({ id: `sickreq-${r.id}`, icon: '🤒', text: `${r.employee}: ${t('notif_pending_sick')}`, tab: 'sick', onOpen: () => {} });
    });
    swapRequests.filter(r => r.stage === 'awaiting_admin').forEach(r => {
      items.push({ id: `swapreq-${r.id}`, icon: '🔄', text: `${r.employee} ↔ ${r.targetEmployee}: ${t('notif_pending_swap')}`, tab: 'overview', onOpen: () => {} });
    });
    leaveRequests.filter(r => r.status === 'Pending').forEach(r => {
      items.push({ id: `leavereq-${r.id}`, icon: '🏖️', text: `${r.employee}: ${t('notif_pending_leave')}`, tab: 'overview', onOpen: () => {} });
    });
    issues.filter(iss => iss.replies && iss.replies.length > 0).forEach(iss => {
      const last = iss.replies[iss.replies.length - 1];
      if (last.from === 'employee' && iss.replies.length > (iss.adminSeenReplyCount || 0)) {
        items.push({ id: `issuereply-${iss.id}`, icon: '💬', text: `${iss.employee}: ${t('notif_issue_reply')}`, tab: 'issues', onOpen: () => onUpdateIssue(iss.id, { adminSeenReplyCount: iss.replies.length }) });
      }
    });
    Object.keys(profiles).forEach(name => {
      const p = profiles[name];
      if (p.contractSigned && !p.contractSignedSeenByAdmin) {
        items.push({ id: `contract-emp-signed-${name}`, icon: '✍️', text: `${name}: ${t('notif_contract_signed')}`, tab: 'employees', onOpen: () => onUpdateProfile(name, { contractSignedSeenByAdmin: true }) });
      }
    });
    return items;
  }
  const contractRef = useRef();

  const pending = availList.filter(a => a.status === 'Pending');
  const openIssues = issues.filter(i => i.status === 'Open');

  // Which week Auto-Assign and the Weekly Shifts search are currently looking at —
  // defaults to the current week, navigable forward/back like the availability grid.
  const [assignWeekOffset, setAssignWeekOffset] = useState(0);
  const [overviewWeekOffset, setOverviewWeekOffset] = useState(0);
  const [overviewMonthOffset, setOverviewMonthOffset] = useState(0);
  const [assignWeekStart] = getWeekRange(addDaysToDate(today, assignWeekOffset * 7));
  const assignWeekEnd = addDaysToDate(assignWeekStart, 6);
  const assignWeekNum = getISOWeekNumber(assignWeekStart);
  const assignWeekYear = assignWeekStart.slice(0, 4);
  const pendingForWeek = pending.filter(a => a.date >= assignWeekStart && a.date <= assignWeekEnd)
    .filter(a => !leaveRequests.some(lv => lv.employee === a.employee && lv.status === 'Approved' && a.date >= lv.dateFrom && a.date <= lv.dateTo));

  // Once a week has passed, any availability that was submitted but never assigned a shift
  // is no longer actionable — mark it Expired (not deleted) so the list stays uncluttered
  // while the record is still there if ever needed for reference.
  useEffect(() => {
    availList.filter(a => a.status === 'Pending' && a.date < today).forEach(a => {
      onUpdateAvail(a.id, { status: 'Expired' });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availList]);

  function getProfile(name) {
    return profiles[name] || { photo: null, photoChangeRequested: false, contractFile: null, contractName: null, contractShared: false, minHours: '', maxHours: '', contractType: '', hourlyRate: '', documents: [] };
  }

  function updateProfile(name, updates) {
    onUpdateProfile(name, updates);
  }

  function getEmployeeRecord(name) {
    const seedEmp = EMPLOYEES.find(e => e.name === name);
    return employeeRecords[name] || {
      name, email: seedEmp?.email || '', initials: seedEmp?.initials || name.slice(0,2).toUpperCase(),
      color: seedEmp?.color || '#f5f6fa', textColor: seedEmp?.textColor || '#555',
      joinDate: '', salary: '', status: 'active',
    };
  }

  function updateEmployeeRecord(name, updates) {
    onUpdateEmployeeRecord(name, updates);
  }

  async function handleAdminPhotoUpload(e, name) {
    const file = e.target.files[0];
    if (!file) return;
    const compressed = await compressImage(file);
    updateProfile(name, { photo: compressed.data, photoChangeRequested: false });
  }

  async function handleContractUpload(e, name) {
    const file = e.target.files[0];
    if (!file) return;
    const compressed = await compressImage(file);
    updateProfile(name, { contractFile: compressed.data, contractName: file.name, contractShared: false });
  }

  function downloadContractFor(name) {
    const p = getProfile(name);
    if (!p.contractFile) return;
    const a = document.createElement('a');
    a.href = p.contractFile;
    a.download = p.contractName || 'contract.pdf';
    a.click();
  }

  function unapproveDocument(name, docId) {
    const p = getProfile(name);
    updateProfile(name, { documents: p.documents.map(d => d.id === docId ? { ...d, status: 'Pending' } : d) });
  }

  function handleTemplateFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setNewTemplateFile({ name: file.name, data: ev.target.result });
    reader.readAsDataURL(file);
  }

  // Fills an employer-authored template's {{placeholders}} with the employee's real
  // data already stored in the app — never generates or alters any legal wording itself.
  function getContractPlaceholderValues(employeeName) {
    const rec = getEmployeeRecord(employeeName);
    const p = getProfile(employeeName);
    const emp = allEmployeesList.find(e => e.name === employeeName);
    return buildContractPlaceholders(employeeName, rec, p, emp, user.companyName);
  }

  function approveSwapRequest(r) {
    if (r.requestType === 'weekoff-swap') {
      onExecuteWeekOffSwap(r);
    } else if (r.requestType === 'swap' && r.targetShiftId) {
      // True swap — both shifts change hands between the two employees.
      onUpdateShift(r.shiftId, { employee: r.targetEmployee });
      onUpdateShift(r.targetShiftId, { employee: r.employee });
    } else {
      // One-way transfer — only the requester's shift moves.
      onUpdateShift(r.shiftId, { employee: r.targetEmployee });
    }
    onUpdateSwapRequest(r.id, { stage: 'resolved', resolvedAt: today });
  }

  function confirmEmployerSignature(employeeName) {
    const p = getProfile(employeeName);
    const signerName = employerSigMode === 'upload' ? user.name : employerSigName.trim();
    const signatureImg = employerSigMode === 'upload' ? employerSigImage : null;
    try {
      if (p.contractTemplateFileData) {
        const extra = {
          signature: p.contractSignedImage ? '' : (p.contractSignedName || ''),
          sigImage: p.contractSignedImage || BLANK_SIG_IMAGE,
          employerSignature: signatureImg ? '' : signerName,
          employerSigImage: signatureImg || BLANK_SIG_IMAGE,
        };
        const docxDataUri = renderContractDocx(p.contractTemplateFileData, getContractPlaceholderValues(employeeName), extra);
        updateProfile(employeeName, {
          contractFile: docxDataUri,
          employerSigned: true, employerSignedName: signerName, employerSignedImage: signatureImg, employerSignedAt: today,
        });
      } else {
        // Not a generated contract (e.g. a manually uploaded PDF) — no template to
        // re-render into, so just record the signature as app-tracked metadata.
        updateProfile(employeeName, { employerSigned: true, employerSignedName: signerName, employerSignedImage: signatureImg, employerSignedAt: today });
      }
    } catch (err) {
      alert(t('err_signature_employer').replace('{err}', err?.message || err));
    }
    setEmployerSigningFor(null); setEmployerSigPreview(false); setEmployerSigImage(null);
  }

  function generateAndShareContract(template, employeeName) {
    if (!template.fileData) {
      alert(t('err_old_template'));
      return;
    }
    try {
      const docxDataUri = renderContractDocx(template.fileData, getContractPlaceholderValues(employeeName), {});
      const fileName = `${template.name.replace(/\s+/g, '_')}_${employeeName.replace(/\s+/g, '_')}.docx`;
      // Not shared yet — admin can download and review first (via the existing Download
      // button), then explicitly tap "Share with Employee" when ready, same as an uploaded contract.
      updateProfile(employeeName, {
        contractFile: docxDataUri, contractName: fileName, contractShared: false,
        contractSigned: false, contractSignedName: '', contractSignedAt: '',
        employerSigned: false, employerSignedName: '', employerSignedAt: '',
        contractTemplateId: template.id, contractTemplateFileData: template.fileData,
      });
    } catch (err) {
      alert(t('err_contract_generate').replace('{err}', err?.message || err));
    }
  }

  function prefillFromSlot(slot) {
    const [f, t] = slot.split(' – ');
    setAssignFrom(f); setAssignTo(t);
  }

  function assignShift(avail) {
    if (!assignFrom || !assignTo || assignFrom >= assignTo) return;
    const dateObj = new Date(avail.date);
    const dateLabel = dateObj.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });
    const time = `${assignFrom} – ${assignTo}`;
    const newShift = { employee: avail.employee, date: avail.date, dateLabel, time, status: 'Confirmed', attendance: 'Pending', attendanceApproved: false, workedFrom: '', workedTo: '', missedReason: '', missedDesc: '', sickFrom: '', sickTo: '', certFileName: null, certFileData: null, notifiedRead: false };
    onAddShift(newShift);
    onUpdateAvail(avail.id, { status: 'Assigned' });
    setAssignTarget(null); setAssignFrom(''); setAssignTo('');
  }

  // Auto-Assign: builds a draft from every pending availability submission — respects each
  // person's weekly hour cap (trimming rather than skipping where there's partial room left),
  // and never double-books a day. Nothing is saved until the admin explicitly confirms it.
  function minsToTime(mins) {
    return `${String(Math.floor(mins / 60)).padStart(2, '0')}:${String(mins % 60).padStart(2, '0')}`;
  }

  // Shift start-time templates, weighted toward daytime/evening (typical delivery-demand
  // shape: light mornings, steady midday/evening, tapering off late at night). Late-night
  // templates end at 23:59 same day — shifts can't cross midnight in this data model
  // (each shift belongs to a single date), so "8–1am" / "9–2am" are shortened accordingly.
  const SHIFT_TEMPLATES = [
    { start: 360, end: 660, weight: 15 },   // 06:00–11:00
    { start: 600, end: 900, weight: 15 },   // 10:00–15:00
    { start: 780, end: 1080, weight: 15 },  // 13:00–18:00
    { start: 960, end: 1260, weight: 15 },  // 16:00–21:00
    { start: 1020, end: 1320, weight: 13 }, // 17:00–22:00
    { start: 1140, end: 1439, weight: 12 }, // 19:00–23:59 ("7–12", shortened)
    { start: 1200, end: 1439, weight: 8 },  // 20:00–23:59 ("8–1am", shortened)
    { start: 1260, end: 1439, weight: 5 },  // 21:00–23:59 ("9–2am", shortened)
  ];
  const DAY_START_FLOOR = 360; // 6am — no shift starts earlier than this, regardless of availability
  const REST_GAP_MINS = 600;   // 10 hours minimum between end of one day's shift and start of the next

  // Stable pseudo-random index (not true random — same inputs always give the same result,
  // so re-opening the draft doesn't reshuffle it) used to vary template choice per person/day.
  function stableSeed(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) >>> 0; }
    return h;
  }

  // Picks a template start time for a block of `lengthMins`, biased by the weighted list,
  // but constrained to fit inside [floorMins, availToMins] — falls back to the person's own
  // availability start if none of the weighted templates fit.
  function pickTemplateStart(lengthMins, floorMins, availToMins, seed) {
    const expanded = [];
    SHIFT_TEMPLATES.forEach(t => { for (let i = 0; i < t.weight; i++) expanded.push(t); });
    const order = expanded.slice(seed % expanded.length).concat(expanded.slice(0, seed % expanded.length));
    const fittingSet = new Set();
    for (const t of order) {
      const start = Math.max(t.start, floorMins);
      if (start + lengthMins <= availToMins) fittingSet.add(start);
    }
    const fitting = [...fittingSet];
    if (fitting.length === 0) return floorMins; // nothing fit — safe fallback, caller will clamp/trim further
    // Sort distinct options by how little of the person's stated availability they'd
    // waste, then pick among the top few using the seed — keeps variety across people/
    // days, but reliably surfaces a genuinely better late-fitting option (e.g. reaching
    // their full 11pm) instead of collapsing to whichever clamped value most templates
    // happened to share.
    fitting.sort((a, b) => (availToMins - (a + lengthMins)) - (availToMins - (b + lengthMins)));
    const topCandidates = fitting.slice(0, Math.min(3, fitting.length));
    return topCandidates[seed % topCandidates.length];
  }

  // How many hours to schedule per working day, given someone's weekly cap and how many
  // days they actually submitted availability for. Returns an array of hour-lengths.
  function planDailyHours(weeklyCapHours, numDays) {
    if (!weeklyCapHours || numDays === 0) return Array(numDays).fill(4);
    if (weeklyCapHours <= 11) {
      const days = Math.min(numDays, 2);
      return Array(days).fill(weeklyCapHours / days);
    }
    if (weeklyCapHours <= 20) {
      const days = Math.min(numDays, Math.max(1, Math.ceil(weeklyCapHours / 4)));
      return Array(days).fill(Math.min(4, weeklyCapHours / days));
    }
    if (weeklyCapHours <= 24) {
      const days = Math.min(numDays, 5);
      const plan = Array(days).fill(4);
      let total = days * 4, i = 0;
      while (total < weeklyCapHours && i < days) { plan[i] += 1; total += 1; i++; }
      return plan;
    }
    if (weeklyCapHours < 40) {
      const days = Math.min(numDays, 6);
      const eightCount = Math.max(1, Math.round(days * 0.25));
      const fiveCount = Math.max(1, Math.round(days * 0.25));
      const fourCount = Math.max(0, days - eightCount - fiveCount);
      const plan = [...Array(eightCount).fill(8), ...Array(fiveCount).fill(5), ...Array(fourCount).fill(4)];
      let total = plan.reduce((a, b) => a + b, 0);
      while (total > weeklyCapHours && plan.length) {
        const idx = plan.length - 1;
        const cut = Math.min(plan[idx], total - weeklyCapHours);
        plan[idx] -= cut; total -= cut;
        if (plan[idx] <= 0) plan.pop();
      }
      return plan;
    }
    return Array(Math.min(numDays, Math.ceil(weeklyCapHours / 8))).fill(8); // 40h/48h — 8h every day
  }

  function runAutoAssign() {
    const proposals = [];
    const runningWeekMins = {};
    const lastShiftEndByEmployee = {}; // employee -> { date, endMins } — for the cross-day rest check

    // Seed the rest-check with any already-real shifts, so the cap doesn't only apply
    // within this draft — a shift from yesterday still counts.
    shifts.forEach(sh => {
      const [, endT] = sh.time.split(' – ');
      const [eh, em] = endT.split(':').map(Number);
      const prev = lastShiftEndByEmployee[sh.employee];
      if (!prev || sh.date > prev.date) lastShiftEndByEmployee[sh.employee] = { date: sh.date, endMins: eh * 60 + em };
    });

    // Step 1 — for each employee, spread their weekly hour plan across the days they
    // actually submitted availability for (varying which day gets the longer shift,
    // rather than always front-loading the earliest days).
    const byEmployee = {};
    pendingForWeek.forEach(a => { (byEmployee[a.employee] = byEmployee[a.employee] || []).push(a); });

    const targets = []; // { availEntry, targetHours }
    Object.entries(byEmployee).forEach(([employee, entries]) => {
      const byWeek = {};
      entries.forEach(a => { const [wkStart] = getWeekRange(a.date); (byWeek[wkStart] = byWeek[wkStart] || []).push(a); });
      Object.values(byWeek).forEach(weekEntries => {
        weekEntries.sort((a, b) => a.date.localeCompare(b.date));
        const profile = getProfile(employee);
        const weeklyCapHours = profile.maxHours ? parseFloat(profile.maxHours) : null;
        const plan = planDailyHours(weeklyCapHours, weekEntries.length);
        // Interleave long/short days across the week instead of clustering big days together.
        const order = [];
        let lo = 0, hi = plan.length - 1, takeHigh = true;
        const sorted = [...plan].sort((a, b) => a - b);
        while (lo <= hi) { order.push(takeHigh ? sorted[hi--] : sorted[lo++]); takeHigh = !takeHigh; }
        weekEntries.forEach((a, i) => { targets.push({ a, targetHours: order[i] ?? 4 }); });
      });
    });

    // Step 2 — group by DATE, so template/time-of-day selection can stagger everyone
    // working that day across the day, weighted toward typical demand shape.
    const byDate = {};
    targets.forEach(tg => { (byDate[tg.a.date] = byDate[tg.a.date] || []).push(tg); });
    const sortedDates = Object.keys(byDate).sort();

    sortedDates.forEach(date => {
      const dayTargets = byDate[date];
      dayTargets.sort((x, y) => x.a.employee.localeCompare(y.a.employee));

      dayTargets.forEach(({ a, targetHours }, idx) => {
        const profile = getProfile(a.employee);
        const maxWeeklyMins = profile.maxHours ? parseFloat(profile.maxHours) * 60 : null;
        const [wkStart, wkEnd] = getWeekRange(a.date);
        const key = `${a.employee}_${wkStart}`;
        if (!(key in runningWeekMins)) {
          const existingMins = shifts.filter(sh => sh.employee === a.employee && sh.date >= wkStart && sh.date <= wkEnd)
            .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
          runningWeekMins[key] = existingMins;
        }

        const [availFrom, availTo] = a.slots[0].split(' – ');
        const [afh, afm] = availFrom.split(':').map(Number);
        const [ath, atm] = availTo.split(':').map(Number);
        const availFromMins = afh * 60 + afm;
        const availToMins = ath * 60 + atm;
        const dateObj = new Date(a.date);
        const dateLabel = dateObj.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });

        // Earliest this person can start today: the 6am floor, their own availability,
        // AND at least 10h after their last shift ended (yesterday or earlier).
        let floorMins = Math.max(DAY_START_FLOOR, availFromMins);
        const prevShift = lastShiftEndByEmployee[a.employee];
        if (prevShift && prevShift.date < a.date) {
          const daysBetween = (new Date(a.date) - new Date(prevShift.date)) / 86400000;
          if (daysBetween === 1) floorMins = Math.max(floorMins, prevShift.endMins + REST_GAP_MINS - 24 * 60);
        }
        // (Same-day chaining — if this employee already has an earlier block today from a
        // split shift — is handled implicitly below via sameDayTimes/findOverlap.)

        const weeklyRoom = maxWeeklyMins === null ? Infinity : maxWeeklyMins - runningWeekMins[key];
        if (weeklyRoom <= 0) {
          proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, skippedReason: `Already at weekly cap (${profile.maxHours}h)` });
          return;
        }

        const targetMins = Math.min(Math.round(targetHours * 60), weeklyRoom, Math.max(0, availToMins - floorMins));
        if (targetMins <= 0) {
          proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, skippedReason: 'No room left in their availability window that day' });
          return;
        }

        const sameDayTimes = () => [
          ...shifts.filter(sh => sh.employee === a.employee && sh.date === a.date).map(sh => sh.time),
          ...proposals.filter(p => p.employee === a.employee && p.date === a.date && !p.skippedReason).map(p => p.time),
        ];

        const seed = stableSeed(a.employee + a.date);
        const isSplitDay = targetMins >= 7 * 60; // ~8h days get split into two blocks with a break

        if (!isSplitDay) {
          const start = pickTemplateStart(targetMins, floorMins, availToMins, seed);
          const end = Math.min(start + targetMins, availToMins);
          const startTime = minsToTime(start), endTime = minsToTime(end);
          if (findOverlap(startTime, endTime, sameDayTimes())) {
            proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, skippedReason: 'Overlaps another shift that day' });
            return;
          }
          const trimmed = start > availFromMins || (end - start) < targetMins;
          proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, time: `${startTime} – ${endTime}`, originalTime: a.slots[0], trimmed, trimReason: trimmed ? 'placed to help cover the day\'s demand pattern alongside others working that date' : null });
          runningWeekMins[key] = (runningWeekMins[key] || 0) + (end - start);
          lastShiftEndByEmployee[a.employee] = { date: a.date, endMins: end };
        } else {
          // Split into two ~half blocks with a break in between, drawn from different
          // parts of the day so it also helps cover a wider spread of the day overall.
          const half = Math.round(targetMins / 2);
          const breakMins = 60;
          const blockAStart = pickTemplateStart(half, floorMins, availToMins - half - breakMins, seed);
          const blockAEnd = Math.min(blockAStart + half, availToMins);
          const blockBFloor = Math.max(blockAEnd + breakMins, floorMins);
          let blockBStart = pickTemplateStart(half, blockBFloor, availToMins, seed + 7);
          let blockBEnd = Math.min(blockBStart + half, availToMins);

          if (blockBStart < blockAEnd + breakMins || blockBEnd - blockBStart < 60) {
            // not enough room for two proper blocks — fall back to one continuous shift
            const start = Math.max(availFromMins, floorMins);
            const end = Math.min(start + targetMins, availToMins);
            const startTime = minsToTime(start), endTime = minsToTime(end);
            if (findOverlap(startTime, endTime, sameDayTimes())) {
              proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, skippedReason: 'Overlaps another shift that day' });
              return;
            }
            proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, time: `${startTime} – ${endTime}`, originalTime: a.slots[0], trimmed: true, trimReason: 'their availability window was too narrow to fit a split shift with a break, so this is one continuous block instead' });
            runningWeekMins[key] = (runningWeekMins[key] || 0) + (end - start);
            lastShiftEndByEmployee[a.employee] = { date: a.date, endMins: end };
            return;
          }

          const aStartTime = minsToTime(blockAStart), aEndTime = minsToTime(blockAEnd);
          const bStartTime = minsToTime(blockBStart), bEndTime = minsToTime(blockBEnd);
          if (findOverlap(aStartTime, aEndTime, sameDayTimes()) || findOverlap(bStartTime, bEndTime, [...sameDayTimes(), `${aStartTime} – ${aEndTime}`])) {
            proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, skippedReason: 'Overlaps another shift that day' });
            return;
          }
          proposals.push({ availId: a.id, employee: a.employee, date: a.date, dateLabel, time: `${aStartTime} – ${aEndTime}`, originalTime: a.slots[0], trimmed: true, trimReason: `split shift, block 1 of 2 — ${bStartTime}–${bEndTime} is block 2, with a break between` });
          proposals.push({ availId: `${a.id}-b`, employee: a.employee, date: a.date, dateLabel, time: `${bStartTime} – ${bEndTime}`, originalTime: a.slots[0], trimmed: true, trimReason: `split shift, block 2 of 2 — follows a break after ${aStartTime}–${aEndTime}`, isSecondBlock: true, linkedAvailId: a.id });
          runningWeekMins[key] = (runningWeekMins[key] || 0) + (blockAEnd - blockAStart) + (blockBEnd - blockBStart);
          lastShiftEndByEmployee[a.employee] = { date: a.date, endMins: blockBEnd };
        }
      });
    });

    setAutoProposals(proposals);
  }

  function removeProposal(availId) {
    setAutoProposals(prev => {
      const target = prev.find(p => p.availId === availId);
      if (!target) return prev;
      const groupKey = target.linkedAvailId || target.availId;
      return prev.filter(p => p.availId !== groupKey && p.linkedAvailId !== groupKey);
    });
  }



  function confirmAutoAssign() {
    const updatedAvailIds = new Set();
    autoProposals.filter(p => !p.skippedReason).forEach(p => {
      onAddShift({ employee: p.employee, date: p.date, dateLabel: p.dateLabel, time: p.time, status: 'Confirmed', attendance: 'Pending', attendanceApproved: false, workedFrom: '', workedTo: '', missedReason: '', missedDesc: '', sickFrom: '', sickTo: '', certFileName: null, certFileData: null, notifiedRead: false });
      const realAvailId = p.linkedAvailId || p.availId;
      if (!updatedAvailIds.has(realAvailId)) {
        onUpdateAvail(realAvailId, { status: 'Assigned' });
        updatedAvailIds.add(realAvailId);
      }
    });
    setAutoProposals(null);
  }

  function removeShift(id) {
    if (window.confirm(t('confirm_remove_shift'))) onRemoveShift(id);
  }

  function startEditShift(sh) {
    setEditingShift(sh);
    setEditDate(sh.date);
    const [f, t] = sh.time.split(' – ');
    setEditFrom(f || ''); setEditTo(t || '');
  }

  function saveEditShift() {
    if (!editFrom || !editTo || editFrom >= editTo) return;
    const dateObj = new Date(editDate);
    const dateLabel = dateObj.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });
    const time = `${editFrom} – ${editTo}`;
    onUpdateShift(editingShift.id, { date: editDate, dateLabel, time });
    setEditingShift(null);
  }

  function resolveIssue(id) {
    onUpdateIssue(id, { status: 'Resolved', resolvedDate: today });
  }

  async function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploadedFile(await compressImage(file));
  }

  function uploadSlip() {
    if (!uploadEmployee || !uploadMonth || !uploadHours || !uploadPay) return;
    const newSlip = { employee: uploadEmployee, month: uploadMonth, hours: parseInt(uploadHours), netPay: uploadPay, fileName: uploadedFile ? uploadedFile.name : `${uploadMonth.replace(' ','_')}_slip.pdf`, fileData: uploadedFile ? uploadedFile.data : null, notifiedRead: false };
    onAddSalarySlip(newSlip);
    setUploadEmployee(''); setUploadMonth(''); setUploadHours(''); setUploadPay(''); setUploadedFile(null);
    setUploadSuccess(true);
    setTimeout(() => setUploadSuccess(false), 3000);
  }

  // Best-effort filename match — if an employee's name (or a close variant of it)
  // appears in the file's name, pre-select them; otherwise leave blank for admin
  // to pick manually. Never auto-submits a guess without admin seeing it first.
  function guessEmployeeFromFilename(fileName) {
    const cleaned = fileName.toLowerCase().replace(/[_\-.]/g, ' ');
    const match = allEmployeesList.find(e => {
      const parts = e.name.toLowerCase().split(' ').filter(p => p.length > 2);
      return parts.every(p => cleaned.includes(p));
    });
    return match ? match.name : '';
  }

  function handleBulkSalaryFiles(e) {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    Promise.all(files.map(file => new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (ev) => resolve({ fileName: file.name, fileData: ev.target.result, employee: guessEmployeeFromFilename(file.name) });
      reader.readAsDataURL(file);
    }))).then(results => setBulkSalaryFiles(results));
  }

  function submitBulkSalarySlips() {
    const ready = bulkSalaryFiles.filter(f => f.employee);
    ready.forEach(f => {
      onAddSalarySlip({ employee: f.employee, month: bulkSalaryMonth, hours: 0, netPay: '', fileName: f.fileName, fileData: f.fileData, notifiedRead: false });
    });
    setBulkSalaryFiles([]); setBulkSalaryMonth(''); setBulkSalaryOpen(false);
    setUploadSuccess(true);
    setTimeout(() => setUploadSuccess(false), 3000);
  }

  const tabs = [['overview','📊',t('nav_overview')],['avail','📋',t('nav_avail')],['shifts','📅',t('nav_shifts')],['employees','👥',t('nav_team')]];
  const ALL_TAB_LABELS = { overview:t('nav_overview'), avail:t('nav_avail'), shifts:t('nav_shifts'), issues:t('title_issues'), salary:t('title_salary'), sick:t('nav_sick'), employees:t('nav_team'), hiring:t('nav_hiring') };

  return (
    <div style={s.app}>
      <div style={s.topbarAdmin}>
        <div>
          <div style={s.topbarTitle}>{ALL_TAB_LABELS[tab]}</div>
          <div style={s.topbarSub}>{user.companyName || 'KarmaDal'}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', position:'relative' }}>
          <button style={{ ...s.logoutBtn, fontSize:'11px', padding:'5px 10px' }} onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>🌐 {language.toUpperCase()}</button>
          <div style={{ position:'relative', cursor:'pointer' }} onClick={() => { setFeatureSearchOpen(!featureSearchOpen); setFeatureSearchQuery(''); }}>
            <span style={{ fontSize:'19px' }}>🔍</span>
          </div>
          {featureSearchOpen && (
            <div style={{ position:'absolute', top:'34px', right:'0', width:'260px', background:'white', border:'1px solid #eee', borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:20 }}>
              <input autoFocus style={{ ...s.input, margin:'10px', width:'calc(100% - 20px)' }} placeholder={t('feature_search_placeholder')} value={featureSearchQuery} onChange={e => setFeatureSearchQuery(e.target.value)} />
              <div style={{ maxHeight:'260px', overflowY:'auto' }}>
                {ADMIN_SEARCHABLE_FEATURES.filter(f => t(f.labelKey).toLowerCase().includes(featureSearchQuery.toLowerCase())).map(f => (
                  <div key={f.labelKey} onClick={() => { if (f.special === 'brandColor') { navigateTo('overview'); setShowBrandColorPanel(true); } else if (f.special === 'fixedSchedule') { navigateTo('overview'); setShowFixedSchedulePanel(true); } else if (f.special === 'rotationSchedule') { navigateTo('overview'); setShowRotationPanel(true); } else if (f.special === 'shiftTemplates') { navigateTo('overview'); setShowShiftTemplatesPanel(true); } else { navigateTo(f.tab); } setFeatureSearchOpen(false); }}
                    style={{ padding:'10px 14px', borderBottom:'1px solid #f5f5f5', cursor:'pointer', fontSize:'13px', color:'#2d2d2d' }}>
                    {f.icon} {t(f.labelKey)}
                  </div>
                ))}
                {ADMIN_SEARCHABLE_FEATURES.filter(f => t(f.labelKey).toLowerCase().includes(featureSearchQuery.toLowerCase())).length === 0 && (
                  <div style={{ padding:'16px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>{t('tm_no_matches')}</div>
                )}
              </div>
            </div>
          )}
          <div style={{ position:'relative', cursor:'pointer' }} onClick={() => setNotifOpen(!notifOpen)}>
            <span style={{ fontSize:'19px' }}>🔔</span>
            {getAdminNotifications().length > 0 && (
              <span style={{ position:'absolute', top:'-4px', right:'-4px', background:'#b71c1c', color:'white', fontSize:'10px', fontWeight:'700', borderRadius:'50%', width:'16px', height:'16px', display:'flex', alignItems:'center', justifyContent:'center' }}>{getAdminNotifications().length}</span>
            )}
          </div>
          {notifOpen && (
            <div style={{ position:'absolute', top:'34px', right:'0', width:'280px', background:'white', border:'1px solid #eee', borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:20, maxHeight:'320px', overflowY:'auto' }}>
              <div style={{ padding:'12px 14px', fontSize:'12px', fontWeight:'700', color:'#888', borderBottom:'1px solid #f0f0f0' }}>{t('notif_title')}</div>
              {getAdminNotifications().length === 0 ? (
                <div style={{ padding:'20px 14px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>{t('notif_none')}</div>
              ) : getAdminNotifications().map(n => (
                <div key={n.id} onClick={() => { n.onOpen(); navigateTo(n.tab); setNotifOpen(false); }} style={{ padding:'10px 14px', borderBottom:'1px solid #f5f5f5', cursor:'pointer', display:'flex', gap:'8px', alignItems:'flex-start' }}>
                  <span style={{ fontSize:'15px' }}>{n.icon}</span>
                  <span style={{ fontSize:'12px', color:'#2d2d2d', lineHeight:'1.4' }}>{n.text}</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ ...s.avatar, cursor:'pointer' }} onClick={() => navigateTo('employees')}>AD</div>
          <button style={s.logoutBtn} onClick={onLogout}>{t('logout')}</button>
        </div>
      </div>

      <div style={s.content}>
        {tab === 'overview' && <>
          {showBrandColorPanel && (
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div style={s.cardLabel}>{t('brand_color_title')}</div>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setShowBrandColorPanel(false)}>✕</span>
              </div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('brand_color_hint')}</div>
              <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                <input type='color' value={pendingBrandColor} onChange={e => setPendingBrandColor(e.target.value)} style={{ width:'44px', height:'44px', border:'none', borderRadius:'10px', cursor:'pointer', padding:0 }} />
                <div style={{ fontSize:'12px', color:'#888' }}>{t('brand_color_tap_hint')}</div>
              </div>
              <button style={{ ...s.assignBtn, width:'100%', marginTop:'12px', opacity: pendingBrandColor === (companyThemeColor || '#FF6B1A') ? 0.5 : 1 }} disabled={pendingBrandColor === (companyThemeColor || '#FF6B1A')} onClick={() => onUpdateCompanyThemeColor(pendingBrandColor)}>{t('brand_color_apply')}</button>
            </div>
          )}
          {showFixedSchedulePanel && (
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div style={s.cardLabel}>{t('fixed_schedule_title')}</div>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setShowFixedSchedulePanel(false)}>✕</span>
              </div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('fixed_schedule_hint')}</div>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_start_time')}</label>
              <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={fixedFormStart} onChange={e => setFixedFormStart(e.target.value)}>
                {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
              </select>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_end_time')}</label>
              <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={fixedFormEnd} onChange={e => setFixedFormEnd(e.target.value)}>
                {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
              </select>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_break_start')}</label>
              <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={fixedFormBreakStart} onChange={e => setFixedFormBreakStart(e.target.value)}>
                {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
              </select>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_break_end')}</label>
              <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={fixedFormBreakEnd} onChange={e => setFixedFormBreakEnd(e.target.value)}>
                {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
              </select>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_work_days')}</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'8px', marginBottom:'12px' }}>
                {['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'].map(day => (
                  <button key={day} type='button' style={s.tabBtn(fixedFormWorkDays.includes(day))} onClick={() => setFixedFormWorkDays(fixedFormWorkDays.includes(day) ? fixedFormWorkDays.filter(d => d !== day) : [...fixedFormWorkDays, day])}>{t(`day_${day.toLowerCase()}`)}</button>
                ))}
              </div>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_max_dayoff')}</label>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', marginBottom:'6px' }}>{t('fixed_max_dayoff_hint')}</div>
              <input type='number' min='0' style={{ ...s.input, marginBottom:'12px' }} value={fixedFormMaxDayOff} onChange={e => setFixedFormMaxDayOff(e.target.value)} placeholder='0' />
              <button style={{ ...s.assignBtn, width:'100%' }} disabled={fixedSaveStatus === 'saving'} onClick={async () => {
                setFixedSaveStatus('saving');
                try {
                  await onUpdateFixedScheduleConfig({ start: fixedFormStart, end: fixedFormEnd, breakStart: fixedFormBreakStart, breakEnd: fixedFormBreakEnd, workDays: fixedFormWorkDays, maxDayOffPerDay: parseInt(fixedFormMaxDayOff) || 0 });
                  setFixedSaveStatus('success');
                  setTimeout(() => setFixedSaveStatus(null), 2500);
                } catch (err) {
                  setFixedSaveStatus('error: ' + (err?.message || err));
                }
              }}>{fixedSaveStatus === 'saving' ? '…' : t('fixed_save_btn')}</button>
              {fixedSaveStatus === 'success' && <div style={{ fontSize:'12px', color:'#2e7d32', marginTop:'8px', fontWeight:'600' }}>✅ {t('fixed_save_success')}</div>}
              {fixedSaveStatus && fixedSaveStatus.startsWith('error') && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'8px', fontWeight:'600' }}>⚠️ {fixedSaveStatus}</div>}
            </div>
          )}
          {showRotationPanel && (
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div style={s.cardLabel}>{t('rotation_title')}</div>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setShowRotationPanel(false)}>✕</span>
              </div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'14px' }}>{t('rotation_hint')}</div>
              {rotationFormShifts.map((sh, idx) => (
                <div key={idx} style={{ background:'#f9f9fb', borderRadius:'10px', padding:'12px', marginBottom:'10px' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'8px' }}>
                    <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('rotation_shift_label')} {idx + 1}</label>
                    {rotationFormShifts.length > 1 && (
                      <span style={{ fontSize:'12px', color:'#b71c1c', cursor:'pointer' }} onClick={() => setRotationFormShifts(rotationFormShifts.filter((_, i) => i !== idx))}>✕</span>
                    )}
                  </div>
                  <input style={{ ...s.input, marginBottom:'8px' }} placeholder={t('rotation_shift_name_placeholder')} value={sh.name} onChange={e => {
                    const updated = [...rotationFormShifts]; updated[idx] = { ...sh, name: e.target.value }; setRotationFormShifts(updated);
                  }} />
                  <div style={{ display:'flex', gap:'8px', marginBottom:'8px' }}>
                    <select style={{ ...s.selectInput, flex:1 }} value={sh.start} onChange={e => {
                      const updated = [...rotationFormShifts]; updated[idx] = { ...sh, start: e.target.value }; setRotationFormShifts(updated);
                    }}>{TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}</select>
                    <select style={{ ...s.selectInput, flex:1 }} value={sh.end} onChange={e => {
                      const updated = [...rotationFormShifts]; updated[idx] = { ...sh, end: e.target.value }; setRotationFormShifts(updated);
                    }}>{TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}</select>
                  </div>
                  <label style={{ fontSize:'11px', color:'#888' }}>{t('rotation_premium_label')}</label>
                  <input type='number' min='0' max='100' style={{ ...s.input, marginTop:'4px' }} placeholder='0' value={sh.premiumPercent} onChange={e => {
                    const updated = [...rotationFormShifts]; updated[idx] = { ...sh, premiumPercent: e.target.value }; setRotationFormShifts(updated);
                  }} />
                </div>
              ))}
              <button style={{ ...s.outlineBtn, width:'100%', marginBottom:'14px' }} onClick={() => setRotationFormShifts([...rotationFormShifts, { name:'', start:'06:00', end:'14:00', premiumPercent:'0' }])}>+ {t('rotation_add_shift_btn')}</button>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('rotation_days_label')}</label>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', marginBottom:'6px' }}>{t('rotation_days_hint')}</div>
              <input type='number' min='1' max='14' style={{ ...s.input, marginBottom:'12px' }} value={rotationFormDays} onChange={e => setRotationFormDays(e.target.value)} />
              {(() => {
                const previewConfig = { shiftTypes: rotationFormShifts.map(sh => ({ ...sh, premiumPercent: parseInt(sh.premiumPercent) || 0 })), daysPerShift: parseInt(rotationFormDays) || 2 };
                const violation = onCheckRotationRest(previewConfig);
                return violation ? (
                  <div style={{ background:'#fff3e0', borderRadius:'8px', padding:'10px 12px', marginBottom:'12px', fontSize:'12px', color:'#e65100' }}>
                    ⚠️ {t('rotation_rest_warning').replace('{last}', violation.lastShift).replace('{first}', violation.firstShift).replace('{hours}', violation.restHours)}
                  </div>
                ) : null;
              })()}
              <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={rotationFormShifts.some(sh => !sh.name.trim())} onClick={async () => {
                await onUpdateRotationConfig({ shiftTypes: rotationFormShifts.map(sh => ({ ...sh, premiumPercent: parseInt(sh.premiumPercent) || 0 })), daysPerShift: parseInt(rotationFormDays) || 2 });
                setShowRotationPanel(false);
              }}>{t('rotation_save_btn')}</button>
            </div>
          )}
          {showShiftTemplatesPanel && (
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div style={s.cardLabel}>{t('shift_templates_title')}</div>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setShowShiftTemplatesPanel(false)}>✕</span>
              </div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'14px' }}>{t('shift_templates_hint')}</div>
              {shiftTemplates.map((tpl, i, arr) => (
                <div key={tpl.id} style={i===arr.length-1 && !newTemplateOpen ?s.rowLast:s.row}>
                  <div>
                    <div style={s.name}>{tpl.templateName}</div>
                    <div style={s.sub}>{tpl.startTime} – {tpl.endTime} · {tpl.breakMinutes||0}min break · max {tpl.maxEmployees}</div>
                    <div style={s.sub}>{tpl.role}{tpl.branch ? ` · ${tpl.branch}` : ''}{tpl.weeklyOff && tpl.weeklyOff.length ? ` · ${t('shift_tpl_off')}: ${tpl.weeklyOff.map(d=>t(`day_${d.toLowerCase()}`)).join(', ')}` : ''}</div>
                  </div>
                  <span style={{ fontSize:'12px', color:'#b71c1c', cursor:'pointer' }} onClick={() => onDeleteShiftTemplate(tpl.id)}>✕</span>
                </div>
              ))}
              {!newTemplateOpen ? (
                <button style={{ ...s.outlineBtn, width:'100%', marginTop: shiftTemplates.length ? '12px' : 0 }} onClick={() => setNewTemplateOpen(true)}>+ {t('shift_tpl_add_btn')}</button>
              ) : (
                <div style={{ marginTop:'12px', paddingTop:'12px', borderTop: shiftTemplates.length ? '1px solid #f0f0f0' : 'none' }}>
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_name')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('shift_tpl_name_placeholder')} value={newTpl.templateName} onChange={e => setNewTpl({ ...newTpl, templateName: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_start_time')}</label>
                  <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={newTpl.startTime} onChange={e => setNewTpl({ ...newTpl, startTime: e.target.value })}>
                    {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
                  </select>
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('fixed_end_time')}</label>
                  <select style={{ ...s.selectInput, marginTop:'6px', marginBottom:'12px' }} value={newTpl.endTime} onChange={e => setNewTpl({ ...newTpl, endTime: e.target.value })}>
                    {TIME_OPTIONS.map(tm => <option key={tm} value={tm}>{tm}</option>)}
                  </select>
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_break_minutes')}</label>
                  <input type='number' min='0' style={{ ...s.input, marginTop:'6px' }} placeholder='60' value={newTpl.breakMinutes} onChange={e => setNewTpl({ ...newTpl, breakMinutes: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_max_employees')}</label>
                  <input type='number' min='1' style={{ ...s.input, marginTop:'6px' }} placeholder='2' value={newTpl.maxEmployees} onChange={e => setNewTpl({ ...newTpl, maxEmployees: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_role')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('shift_tpl_role_placeholder')} value={newTpl.role} onChange={e => setNewTpl({ ...newTpl, role: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_branch')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('shift_tpl_branch_placeholder')} value={newTpl.branch} onChange={e => setNewTpl({ ...newTpl, branch: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_weekly_off')}</label>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'8px', marginBottom:'14px' }}>
                    {['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'].map(day => (
                      <button key={day} type='button' style={s.tabBtn(newTpl.weeklyOff.includes(day))} onClick={() => setNewTpl({ ...newTpl, weeklyOff: newTpl.weeklyOff.includes(day) ? newTpl.weeklyOff.filter(d => d !== day) : [...newTpl.weeklyOff, day] })}>{t(`day_${day.toLowerCase()}`)}</button>
                    ))}
                  </div>
                  <div style={{ display:'flex', gap:'8px' }}>
                    <button style={{ ...s.assignBtn, flex:1 }} disabled={!newTpl.templateName.trim()} onClick={() => {
                      onAddShiftTemplate({ templateName: newTpl.templateName.trim(), startTime: newTpl.startTime, endTime: newTpl.endTime, breakMinutes: parseInt(newTpl.breakMinutes)||0, maxEmployees: parseInt(newTpl.maxEmployees)||1, role: newTpl.role.trim(), branch: newTpl.branch.trim(), weeklyOff: newTpl.weeklyOff });
                      setNewTpl({ templateName:'', startTime:'09:00', endTime:'17:00', breakMinutes:'60', maxEmployees:'2', role:'', branch:'', weeklyOff:[] });
                      setNewTemplateOpen(false);
                    }}>{t('shift_tpl_save_btn')}</button>
                    <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => setNewTemplateOpen(false)}>{t('avail_cancel')}</button>
                  </div>
                </div>
              )}
            </div>
          )}
          <div style={s.card}>
            <div style={s.cardLabel}>{t('adm_company_overview')}</div>
            <div style={s.statRow}>
              <div style={{ ...s.stat, cursor:'pointer' }} onClick={() => navigateTo('employees')}><div style={s.statNum}>{allEmployeesList.length}</div><div style={s.statLbl}>{t('adm_employees')}</div></div>
              <div style={{ ...s.stat, cursor:'pointer' }} onClick={() => navigateTo('shifts')}><div style={s.statNum}>{shifts.filter(sh=>isUpcoming(sh.date)).length}</div><div style={s.statLbl}>{t('adm_upcoming_shifts')}</div></div>
              <div style={{ ...s.stat, cursor:'pointer' }} onClick={() => navigateTo('avail')}><div style={{ ...s.statNum, color: pending.length > 0 ? '#f57f17' : '#2d2d2d' }}>{pending.length}</div><div style={s.statLbl}>{t('adm_pending_avail')}</div></div>
              <div style={{ ...s.stat, cursor:'pointer' }} onClick={() => navigateTo('issues')}><div style={{ ...s.statNum, color: openIssues.length > 0 ? '#b71c1c' : '#2d2d2d' }}>{openIssues.length}</div><div style={s.statLbl}>{t('adm_open_issues_stat')}</div></div>
              <div style={{ ...s.stat, cursor:'pointer' }} onClick={() => navigateTo('shifts')}><div style={{ ...s.statNum, color: '#2e7d32' }}>{shifts.filter(sh => sh.date === today && sh.attendance === 'Clocked In').length}</div><div style={s.statLbl}>{t('adm_working_now')}</div></div>
              <div style={s.stat}><div style={{ ...s.statNum, color: swapRequests.filter(r => r.stage === 'awaiting_admin').length > 0 ? 'var(--brand-dark)' : '#2d2d2d' }}>{swapRequests.filter(r => r.stage === 'awaiting_admin').length}</div><div style={s.statLbl}>{t('adm_swap_stat')}</div></div>
              <div style={s.stat}><div style={{ ...s.statNum, color: leaveRequests.filter(r => r.status === 'Pending').length > 0 ? 'var(--brand-dark)' : '#2d2d2d' }}>{leaveRequests.filter(r => r.status === 'Pending').length}</div><div style={s.statLbl}>{t('adm_leave_stat')}</div></div>
            </div>
          </div>
          {swapRequests.filter(r => r.stage === 'awaiting_admin').length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('swap_requests_title')} ({swapRequests.filter(r => r.stage === 'awaiting_admin').length})</div>
              {swapRequests.filter(r => r.stage === 'awaiting_admin').map((r, i, arr) => (
                <div key={r.id} style={i===arr.length-1?s.rowLast:s.row}>
                  <div>
                    <div style={s.name}>{r.ticketNumber ? `#${r.ticketNumber} · ` : ''}{r.employee} ↔ {r.targetEmployee}</div>
                    {r.requestType === 'weekoff-swap' ? (
                      <div style={s.sub}>{r.employee}: {t(`day_${r.targetCurrentDayOff.toLowerCase()}`)} · {r.targetEmployee}: {t(`day_${r.employeeCurrentDayOff.toLowerCase()}`)}</div>
                    ) : (
                      <>
                        <div style={s.sub}>{r.employee}: {r.dateLabel} · {r.time}</div>
                        {r.requestType === 'swap' && r.targetShiftDateLabel && (
                          <div style={s.sub}>{r.targetEmployee}: {r.targetShiftDateLabel} · {r.targetShiftTime}</div>
                        )}
                      </>
                    )}
                    <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'2px', fontWeight:'600' }}>✅ {t('swap_both_agreed')}</div>
                    {r.note && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontStyle:'italic' }}>"{r.note}"</div>}
                  </div>
                  <div style={{ display:'flex', gap:'6px' }}>
                    <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => approveSwapRequest(r)}>✅ {t('swap_approve_btn')}</button>
                    <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateSwapRequest(r.id, { stage: 'declined_by_admin', resolvedAt: today })}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          )}
          {leaveRequests.filter(r => r.status === 'Pending').length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('leave_requests_title')} ({leaveRequests.filter(r => r.status === 'Pending').length})</div>
              {leaveRequests.filter(r => r.status === 'Pending').map((r, i, arr) => {
                const daysUsed = leaveRequests.filter(x => x.employee === r.employee && x.status === 'Approved').reduce((sum,x) => sum + (Math.round((new Date(x.dateTo) - new Date(x.dateFrom)) / 86400000) + 1), 0);
                return (
                  <div key={r.id} style={i===arr.length-1?s.rowLast:s.row}>
                    <div>
                      <div style={s.name}>{r.ticketNumber ? `#${r.ticketNumber} · ` : ''}{r.employee}</div>
                      <div style={s.sub}>{r.dateFrom} → {r.dateTo}</div>
                      {r.note && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontStyle:'italic' }}>"{r.note}"</div>}
                      <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t('leave_used_so_far').replace('{count}', daysUsed)}</div>
                    </div>
                    <div style={{ display:'flex', gap:'6px' }}>
                      <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateLeaveRequest(r.id, { status: 'Approved', resolvedAt: today })}>✅ {t('asick_approve')}</button>
                      <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateLeaveRequest(r.id, { status: 'Rejected', resolvedAt: today })}>✕</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>}

        {tab === 'avail' && <>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <button style={s.navControlBtn(true)} onClick={() => setAssignWeekOffset(w => w - 1)}>‹</button>
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:'14px', fontWeight:'700', color:'#2d2d2d' }}>{t('avail_week')} {assignWeekNum}, {assignWeekYear}{assignWeekOffset === 0 ? ` (${t('avail_current')})` : ''}</div>
                <div style={{ fontSize:'11px', color:'#888' }}>{assignWeekStart} – {assignWeekEnd}</div>
              </div>
              <button style={s.navControlBtn(true)} onClick={() => setAssignWeekOffset(w => w + 1)}>›</button>
            </div>
          </div>
          <div style={{ ...s.card, background: 'var(--brand-light)' }}>
            {(() => {
              const uniqueEmployees = new Set(pendingForWeek.map(a => a.employee)).size;
              return (
                <div style={{ fontSize:'13px', color:'var(--brand-dark)', fontWeight:'500' }}>
                  📋 {uniqueEmployees === 0 ? t('aa_no_employees') : `${uniqueEmployees} ${uniqueEmployees !== 1 ? t('aa_employee_plural') : t('aa_employee_singular')}`} {t('aa_submitted_for_week')} {pendingForWeek.length} {pendingForWeek.length !== 1 ? t('aa_day_plural') : t('aa_day_singular')} {t('aa_waiting')}
                </div>
              );
            })()}
          </div>
          {pendingForWeek.length > 0 && !autoProposals && (
            <div style={s.card}>
              <button style={{ ...s.assignBtn, width:'100%', padding:'12px' }} onClick={runAutoAssign}>🤖 {t('aa_build_draft')}</button>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'8px' }}>{t('aa_only_builds').replace('{n}', assignWeekNum).replace('{start}', assignWeekStart).replace('{end}', assignWeekEnd)}</div>
            </div>
          )}
          {fixedScheduleConfig && (
            <div style={s.card}>
              <div style={s.cardLabel}>🕘 {t('fixed_generate_title')}</div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'10px' }}>{t('fixed_generate_hint')}</div>
              <button style={{ ...s.assignBtn, width:'100%', padding:'12px' }} onClick={async () => {
                const fixedEmployees = allEmployeesList.filter(e => ['fixed-standard','fixed-choose-dayoff'].includes(getEmployeeRecord(e.name).schedulingMode));
                const count = await onGenerateFixedShifts(assignWeekStart, fixedScheduleConfig, fixedEmployees);
                alert(t('fixed_generate_result').replace('{n}', count));
              }}>🕘 {t('fixed_generate_btn')}</button>
            </div>
          )}
          {rotationConfig && (
            <div style={s.card}>
              <div style={s.cardLabel}>🔄 {t('rotation_generate_title')}</div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'10px' }}>{t('rotation_generate_hint')}</div>
              <button style={{ ...s.assignBtn, width:'100%', padding:'12px' }} onClick={async () => {
                const rotationEmployees = allEmployeesList.filter(e => getEmployeeRecord(e.name).schedulingMode === 'rotation');
                const count = await onGenerateRotationShifts(assignWeekStart, rotationConfig, rotationEmployees);
                alert(t('fixed_generate_result').replace('{n}', count));
              }}>🔄 {t('rotation_generate_btn')}</button>
            </div>
          )}
          {autoProposals && (
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
                <div style={s.cardLabel}>🤖 {t('aa_draft_title')}</div>
                <span style={{ fontSize:'11px', color:'#888', cursor:'pointer' }} onClick={() => setAutoProposals(null)}>✕ {t('aa_discard')}</span>
              </div>
              {autoProposals.length > 0 && (() => {
                const summary = {};
                autoProposals.forEach(p => {
                  const [wkStart, wkEnd] = getWeekRange(p.date);
                  const key = `${p.employee}_${wkStart}`;
                  if (!summary[key]) {
                    const profile = getProfile(p.employee);
                    const existingMins = shifts.filter(sh => sh.employee === p.employee && sh.date >= wkStart && sh.date <= wkEnd)
                      .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
                    summary[key] = { employee: p.employee, min: profile.minHours, max: profile.maxHours, mins: existingMins };
                  }
                  if (!p.skippedReason) {
                    const [f, t] = p.time.split(' – ');
                    summary[key].mins += durationMins(f, t);
                  }
                });
                const rows = Object.values(summary);
                return (
                  <div style={{ marginBottom:'16px' }}>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('aa_weekly_totals')}</div>
                    {rows.map(r => {
                      const maxMins = r.max ? parseFloat(r.max) * 60 : null;
                      const overCap = maxMins && r.mins > maxMins;
                      return (
                        <div key={r.employee} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 10px', background: overCap ? '#ffebee' : '#f5f6fa', borderRadius:'8px', marginBottom:'6px' }}>
                          <span style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d' }}>{r.employee}</span>
                          <span style={{ fontSize:'12px', color: overCap ? '#b71c1c' : '#555' }}>
                            {compactDuration(r.mins)}{(r.min || r.max) ? ` (${t('aa_cap')}: ${r.min || '–'}–${r.max || '–'}h)` : ''}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
              {autoProposals.filter(p => !p.skippedReason).length === 0 && autoProposals.filter(p => p.skippedReason).length === 0 && (
                <div style={s.emptyBox}>{t('aa_nothing_to_assign')}</div>
              )}
              {autoProposals.map(p => (
                <div key={p.availId} style={{ ...s.row, alignItems:'flex-start' }}>
                  <div>
                    <div style={s.name}>{p.employee}</div>
                    <div style={s.sub}>{p.dateLabel}</div>
                    {p.skippedReason ? (
                      <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'2px' }}>⛔ {t('aa_skipped')} — {p.skippedReason}</div>
                    ) : (
                      <div style={{ fontSize:'12px', color:'#2e7d32', marginTop:'2px' }}>
                        ✅ {p.time}
                        {p.trimmed && <span style={{ color:'#f57f17' }}> · ⚠️ {t('aa_trimmed_from')} {p.originalTime} — {p.trimReason}</span>}
                      </div>
                    )}
                  </div>
                  {!p.skippedReason && <span style={{ fontSize:'11px', color:'#b71c1c', cursor:'pointer' }} onClick={() => removeProposal(p.availId)}>{t('aa_remove')}</span>}
                </div>
              ))}
              {autoProposals.filter(p => !p.skippedReason).length > 0 && (
                <button style={{ ...s.assignBtn, width:'100%', padding:'12px', marginTop:'12px' }} onClick={confirmAutoAssign}>✅ {t('aa_confirm_assign')} {autoProposals.filter(p => !p.skippedReason).length} {autoProposals.filter(p => !p.skippedReason).length !== 1 ? t('aa_shift_plural') : t('aa_shift_singular')}</button>
              )}
            </div>
          )}
          <div style={s.card}>
            <div style={s.cardLabel}>{t('aa_shifts_by_employee')} — {t('avail_week')} {assignWeekNum}, {assignWeekYear}</div>
            {(() => {
              const weekShifts = shifts.filter(sh => sh.date >= assignWeekStart && sh.date <= assignWeekEnd);
              const namesThisWeek = [...new Set(weekShifts.map(sh => sh.employee))].sort();
              if (namesThisWeek.length === 0) return <div style={s.emptyBox}>{t('aa_no_shifts_week')}</div>;
              const filteredNames = namesThisWeek.filter(name => name.toLowerCase().includes(weeklyShiftsSearch.toLowerCase()));
              return (
                <>
                  <div style={{ position:'relative' }}>
                    <input
                      style={{ ...s.input, marginBottom:'0' }} placeholder={t('aa_search_placeholder')}
                      value={viewingWeeklyShifts || weeklyShiftsSearch}
                      onChange={ev => { setWeeklyShiftsSearch(ev.target.value); setViewingWeeklyShifts(null); setWeeklyShiftsDropdownOpen(true); }}
                      onFocus={() => { setWeeklyShiftsDropdownOpen(true); if (viewingWeeklyShifts) { setWeeklyShiftsSearch(''); setViewingWeeklyShifts(null); } }}
                      onBlur={() => setTimeout(() => setWeeklyShiftsDropdownOpen(false), 150)}
                    />
                    {weeklyShiftsDropdownOpen && (
                      filteredNames.length === 0 ? (
                        <div style={{ position:'absolute', top:'46px', left:0, right:0, background:'white', border:'1px solid #eee', borderRadius:'8px', padding:'10px 14px', fontSize:'12px', color:'#aaa', zIndex:10 }}>{t('aa_no_matches')}</div>
                      ) : (
                        <div style={{ position:'absolute', top:'46px', left:0, right:0, background:'white', border:'1px solid #eee', borderRadius:'8px', boxShadow:'0 4px 16px rgba(0,0,0,0.12)', zIndex:10, maxHeight:'220px', overflowY:'auto' }}>
                          {filteredNames.map(name => (
                            <div key={name} onMouseDown={() => { setViewingWeeklyShifts(name); setWeeklyShiftsSearch(''); setWeeklyShiftsDropdownOpen(false); }}
                              style={{ padding:'10px 14px', cursor:'pointer', borderBottom:'1px solid #f5f5f5', fontSize:'13px', color:'#2d2d2d' }}>
                              {name}
                            </div>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                  {viewingWeeklyShifts ? (() => {
                    const theirShifts = weekShifts.filter(sh => sh.employee === viewingWeeklyShifts).sort((a, b) => a.date.localeCompare(b.date));
                    return (
                      <div style={{ marginTop:'14px' }}>
                        {theirShifts.map((sh, i) => (
                          <div key={sh.id} style={i === theirShifts.length - 1 ? s.rowLast : s.row}>
                            <div><div style={s.name}>{sh.dateLabel}</div><div style={s.sub}>{sh.date}</div></div>
                            <div style={{ fontSize:'13px', color:'#2d2d2d', fontWeight:'600' }}>{sh.time}</div>
                          </div>
                        ))}
                      </div>
                    );
                  })() : (
                    <div style={{ fontSize:'12px', color:'#aaa', marginTop:'10px' }}>{t('aa_search_hint')}</div>
                  )}
                </>
              );
            })()}
          </div>
          {availList.filter(a => a.status !== 'Expired' && a.date >= assignWeekStart && a.date <= assignWeekEnd).length === 0 && <div style={s.card}><div style={s.emptyBox}>{t('aa_no_avail_week')}</div></div>}
          {availList.filter(a => a.status !== 'Expired' && a.date >= assignWeekStart && a.date <= assignWeekEnd).map(a => {
            const alreadyAssigned = shifts.filter(sh => sh.employee === a.employee && sh.date === a.date);
            return (
            <div key={a.id} style={s.card}>
              <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'12px' }}>
                <div style={{ width:'36px', height:'36px', borderRadius:'50%', background:a.color, color:a.textColor, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'13px', fontWeight:'600' }}>{a.initials}</div>
                <div style={{ flex:1 }}><div style={s.name}>{a.employee}</div><div style={s.sub}>{t('aa_submitted_avail')}</div></div>
                <span style={getBadgeStyle(a.status)}>{translateStatus(language, a.status)}</span>
              </div>
              <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'12px' }}>
                <div style={{ fontSize:'13px', marginBottom:'4px' }}>📅 <strong>{t('aa_date_label')}:</strong> {a.date}</div>
                <div style={{ fontSize:'13px' }}>🕐 <strong>{t('aa_available_slots')}:</strong></div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'6px' }}>
                  {a.slots.map(sl => <span key={sl} style={{ background:'var(--brand-light)', color:'var(--brand-dark)', fontSize:'11px', padding:'3px 10px', borderRadius:'20px', fontWeight:'500' }}>{sl}</span>)}
                </div>
                {a.note && <div style={{ fontSize:'12px', color:'#888', marginTop:'6px' }}>📝 {a.note}</div>}
              </div>
              {alreadyAssigned.length > 0 && (
                  <div style={{ background:'#e8f5e9', borderRadius:'8px', padding:'10px', marginBottom:'12px' }}>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#2e7d32', marginBottom:'4px' }}>✅ {t('aa_already_assigned_date')}</div>
                    {alreadyAssigned.map(sh => <div key={sh.id} style={{ fontSize:'12px', color:'#2e7d32' }}>{sh.time}</div>)}
                  </div>
              )}
              {(() => {
                const overlap = findOverlap(assignFrom, assignTo, alreadyAssigned.map(sh => sh.time));
                const newMins = (assignFrom && assignTo && assignFrom < assignTo) ? durationMins(assignFrom, assignTo) : 0;

                // Daily — includes any other split shifts already assigned this same day (e.g. 10-2 + 4:30-10)
                const dailyMinsSoFar = alreadyAssigned.reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
                const dailyProjected = dailyMinsSoFar + newMins;
                const DAILY_REFERENCE_MINS = 8 * 60; // Germany's standard legal workday (Arbeitszeitgesetz)
                const overDailyRef = newMins > 0 && dailyProjected > DAILY_REFERENCE_MINS;

                // Weekly — against this employee's own Max Hours cap
                const [weekStart, weekEnd] = getWeekRange(a.date);
                const weeklyMinsSoFar = shifts.filter(sh => sh.employee === a.employee && sh.date >= weekStart && sh.date <= weekEnd)
                  .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
                const weeklyProjected = weeklyMinsSoFar + newMins;
                const profile = getProfile(a.employee);
                const maxWeeklyMins = profile.maxHours ? parseFloat(profile.maxHours) * 60 : null;
                const overWeeklyCap = maxWeeklyMins && newMins > 0 && weeklyProjected > maxWeeklyMins;

                // Monthly — informational total for the calendar month (no cap field exists yet for this)
                const monthKey = a.date.slice(0, 7);
                const monthlyMinsSoFar = shifts.filter(sh => sh.employee === a.employee && sh.date.startsWith(monthKey))
                  .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
                const monthlyProjected = monthlyMinsSoFar + newMins;

                const overLongShift = newMins > 10 * 60; // single shift over 10 hours — worth a sanity check regardless of caps
                return (
                assignTarget === a.id ? (
                  <div>
                    <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('aa_tap_slot')}</label>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'6px', marginBottom:'12px' }}>
                      {a.slots.map(sl => (
                        <span key={sl} onClick={() => prefillFromSlot(sl)} style={{ background:'var(--brand-light)', color:'var(--brand-dark)', fontSize:'11px', padding:'5px 12px', borderRadius:'20px', fontWeight:'500', cursor:'pointer', border: (`${assignFrom} – ${assignTo}` === sl) ? '2px solid #4527a0' : '2px solid transparent' }}>{sl}</span>
                      ))}
                    </div>
                    <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('aa_assign_time')}</label>
                    <div style={{ display:'flex', gap:'8px', alignItems:'center', marginTop:'6px', marginBottom:'12px' }}>
                      <TimeSelect value={assignFrom} onChange={setAssignFrom} />
                      <span style={{ color:'#888', fontSize:'13px' }}>to</span>
                      <TimeSelect value={assignTo} onChange={setAssignTo} />
                    </div>
                    {assignFrom && assignTo && assignFrom < assignTo && (
                      <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'10px' }}>
                        <div style={{ fontSize:'12px', color:'var(--brand-dark)', fontWeight:'600', marginBottom:'6px' }}>⏱ {t('aa_this_shift')}: {compactDuration(newMins)}</div>
                        <div style={{ fontSize:'12px', color: overDailyRef ? '#b71c1c' : '#555' }}>{t('aa_today')}: {compactDuration(dailyProjected)} {t('aa_of_ref')}{overDailyRef ? ` — ${compactDuration(dailyProjected - DAILY_REFERENCE_MINS)} ${t('aa_over')}` : ` (${compactDuration(Math.max(0, DAILY_REFERENCE_MINS - dailyProjected))} ${t('aa_left')})`}</div>
                        <div style={{ fontSize:'12px', color: overWeeklyCap ? '#b71c1c' : '#555' }}>{t('aa_this_week')}: {compactDuration(weeklyProjected)}{maxWeeklyMins ? ` ${t('aa_of_cap')} ${profile.maxHours}h ${t('aa_cap')}${overWeeklyCap ? ` — ${compactDuration(weeklyProjected - maxWeeklyMins)} ${t('aa_over')}` : ` (${compactDuration(Math.max(0, maxWeeklyMins - weeklyProjected))} ${t('aa_left')})`}` : ` (${t('aa_no_weekly_cap')})`}</div>
                        <div style={{ fontSize:'12px', color:'#555' }}>{t('aa_this_month_far')}: {compactDuration(monthlyProjected)}{maxWeeklyMins ? ` ${t('aa_of_cap')} ${profile.minHours ? `${profile.minHours*4}–` : ''}${profile.maxHours*4}h ${t('aa_cap')} (${t('aa_weeks4')})` : ''}</div>
                      </div>
                    )}
                    {assignFrom && assignTo && assignFrom < assignTo && !isWithinAnySlot(assignFrom, assignTo, a.slots) && (
                      <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('aa_outside_avail').replace('{name}', a.employee)} ({a.slots.join(', ')})</div>
                    )}
                    {overlap && (
                      <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⛔ {t('aa_overlaps')} ({overlap}) {t('aa_overlaps_adjust')}</div>
                    )}
                    {overDailyRef && (
                      <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('aa_over_daily').replace('{name}', a.employee).replace('{mins}', compactDuration(dailyProjected))}</div>
                    )}
                    {overWeeklyCap && (
                      <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('aa_over_weekly').replace('{name}', a.employee).replace('{mins}', formatDuration(weeklyProjected)).replace('{cap}', profile.maxHours)}</div>
                    )}
                    {overLongShift && (
                      <div style={{ fontSize:'12px', color:'#f57f17', background:'#fff8e1', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('aa_over_long')}</div>
                    )}
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button style={{ ...s.assignBtn, flex:1, padding:'10px', opacity:(!assignFrom||!assignTo||assignFrom>=assignTo||overlap)?0.5:1 }} disabled={!!overlap} onClick={() => assignShift(a)}>✅ {t('aa_confirm_assignment')}</button>
                      <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => { setAssignTarget(null); setAssignFrom(''); setAssignTo(''); }}>{t('avail_cancel')}</button>
                    </div>
                  </div>
                ) : (
                  <button style={{ ...s.assignBtn, width:'100%', padding:'10px' }} onClick={() => { setAssignTarget(a.id); setAssignFrom(''); setAssignTo(''); }}>+ {a.status === 'Assigned' ? t('aa_assign_another') : t('aa_assign_shift_to')} {a.employee}</button>
                )
                );
              })()}
              {a.status === 'Assigned' && <div style={s.successBox}>✅ Shift assigned successfully</div>}
            </div>
          );})}
        </>}

        {tab === 'shifts' && <>
          <div style={s.tabRow}>
            <button style={s.tabBtn(shiftsViewTab==='all')} onClick={()=>setShiftsViewTab('all')}>{t('sh_all_shifts')}</button>
            <button style={s.tabBtn(shiftsViewTab==='dayview')} onClick={()=>setShiftsViewTab('dayview')}>🕐 {t('sh_dayview')}</button>
            <button style={s.tabBtn(shiftsViewTab==='overview')} onClick={()=>setShiftsViewTab('overview')}>📊 {t('sh_overview')}</button>
            <button style={s.tabBtn(shiftsViewTab==='calendar')} onClick={()=>setShiftsViewTab('calendar')}>📅 {t('sh_calendar')}</button>
          </div>

          {shiftsViewTab === 'dayview' && (() => {
            const HOUR_MARKS = [0,3,6,9,12,15,18,21,24];
            const pctFor = (mins) => (mins / (24*60)) * 100;
            const renderDayTimeline = (dateStr, dateLabel, compact) => {
              const dayShifts = shifts.filter(sh => sh.date === dateStr);
              const viewingToday = dateStr === today;
              return (
                <div key={dateStr} style={{ marginBottom: compact ? '18px' : 0 }}>
                  <div style={{ fontSize: compact ? '12px' : '14px', fontWeight:'700', color:'#2d2d2d', marginBottom:'8px' }}>{dateLabel}{viewingToday ? ` (${t('avail_current')})` : ''}</div>
                  {dayShifts.length === 0 ? (
                    <div style={{ ...s.emptyBox, padding: compact ? '10px' : undefined, fontSize: compact ? '12px' : undefined }}>{t('sh_no_shifts_day')}</div>
                  ) : (
                    <div style={{ position:'relative', background:'#F1EEE9', borderRadius:'8px', padding: compact ? '8px 10px 24px' : '14px 16px 30px' }}>
                      {viewingToday && (
                        <div style={{ position:'absolute', left:`${pctFor(nowMinutes)}%`, top:0, bottom: compact ? '18px' : '24px', width:'2px', background:'#4527a0', zIndex:5 }} />
                      )}
                      <div style={{ position:'relative', height: compact ? `${dayShifts.length * 22 + 4}px` : `${dayShifts.length * 34 + 6}px` }}>
                        {dayShifts.map((sh, i) => {
                          const [startStr, endStr] = sh.time.split(' – ');
                          const [sh_, sm_] = startStr.split(':').map(Number);
                          const [eh_, em_] = endStr.split(':').map(Number);
                          const startMins = sh_ * 60 + sm_, endMins = eh_ * 60 + em_;
                          const kind = classifyDayViewShift(sh, viewingToday);
                          const rowH = compact ? 20 : 30;
                          const toMins = (hhmm) => { if (!hhmm) return null; const [h,m] = hhmm.split(':').map(Number); return h*60+m; };
                          const clockInMins = toMins(sh.clockInTime), clockOutMins = toMins(sh.clockOutTime);
                          const isExpanded = expandedDayViewShiftId === sh.id;
                          return (
                            <Fragment key={sh.id}>
                              <div
                                onClick={() => setExpandedDayViewShiftId(isExpanded ? null : sh.id)}
                                style={{
                                  position:'absolute', top:`${i * (rowH + 2)}px`, left:`${pctFor(startMins)}%`, width:`${pctFor(endMins - startMins)}%`,
                                  height:`${rowH}px`, background: DAYVIEW_COLORS[kind], borderRadius:'6px', cursor:'pointer',
                                  display:'flex', alignItems:'center', padding:'0 6px', overflow:'hidden', whiteSpace:'nowrap',
                                  fontSize: compact ? '10px' : '11px', color:'white', fontWeight:'600',
                                  outline: isExpanded ? '2px solid #2d2d2d' : 'none',
                                }}>
                                {compact ? sh.employee.split(' ')[0] : `${sh.employee} · ${formatDuration(endMins - startMins)}`}
                              </div>
                              {clockInMins !== null && (
                                <div title={`Clock in: ${sh.clockInTime}`} style={{ position:'absolute', top:`${i * (rowH + 2) - 3}px`, left:`${pctFor(clockInMins)}%`, width:'8px', height:'8px', borderRadius:'50%', background:'white', border:'2px solid #2d2d2d', transform:'translateX(-50%)', zIndex:4 }} />
                              )}
                              {clockOutMins !== null && (
                                <div title={`Clock out: ${sh.clockOutTime}`} style={{ position:'absolute', top:`${i * (rowH + 2) + rowH - 5}px`, left:`${pctFor(clockOutMins)}%`, width:'8px', height:'8px', borderRadius:'50%', background:'var(--brand)', border:'2px solid white', transform:'translateX(-50%)', zIndex:4 }} />
                              )}
                            </Fragment>
                          );
                        })}
                        {(() => {
                          const expandedShift = dayShifts.find(sh => sh.id === expandedDayViewShiftId);
                          if (!expandedShift) return null;
                          const idx = dayShifts.indexOf(expandedShift);
                          const rowH = compact ? 20 : 30;
                          return (
                            <div style={{ position:'absolute', top:`${idx * (rowH + 2) + rowH + 4}px`, left:'0', background:'white', borderRadius:'6px', padding:'6px 10px', fontSize:'11px', color:'#2d2d2d', boxShadow:'0 2px 8px rgba(0,0,0,0.15)', zIndex:6, whiteSpace:'nowrap' }}>
                              {expandedShift.clockInTime ? `Clock in: ${expandedShift.clockInTime}` : 'Not clocked in yet'}
                              {expandedShift.clockOutTime ? ` · Clock out: ${expandedShift.clockOutTime}` : ''}
                            </div>
                          );
                        })()}
                      </div>
                      <div style={{ position:'absolute', bottom:'6px', left:'10px', right:'10px', display:'flex', justifyContent:'space-between', fontSize: compact ? '9px' : '10px', color:'#999' }}>
                        {HOUR_MARKS.map(h => <span key={h}>{String(h).padStart(2,'0')}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              );
            };
            return (
              <>
                <div style={s.card}>
                  <div style={{ display:'flex', gap:'8px', marginBottom:'14px' }}>
                    <button style={s.tabBtn(dayViewMode==='day')} onClick={()=>setDayViewMode('day')}>{t('sh_day_mode')}</button>
                    <button style={s.tabBtn(dayViewMode==='week')} onClick={()=>setDayViewMode('week')}>{t('sh_week_mode')}</button>
                  </div>
                  {dayViewMode === 'day' && (
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
                      <button style={s.navControlBtn(true)} onClick={() => setDayViewOffset(o => o - 1)}>‹</button>
                      <div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>{addDaysToDate(today, dayViewOffset)}</div>
                      <button style={s.navControlBtn(true)} onClick={() => setDayViewOffset(o => o + 1)}>›</button>
                    </div>
                  )}
                  {dayViewMode === 'week' && (
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
                      <button style={s.navControlBtn(true)} onClick={() => setDayViewOffset(o => o - 7)}>‹</button>
                      <div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>{t('sh_week_mode')} {getISOWeekNumber(getWeekRange(addDaysToDate(today, dayViewOffset))[0])}</div>
                      <button style={s.navControlBtn(true)} onClick={() => setDayViewOffset(o => o + 7)}>›</button>
                    </div>
                  )}
                  <div style={{ display:'flex', gap:'14px', flexWrap:'wrap', marginBottom:'16px', fontSize:'11px', color:'#666' }}>
                    {Object.entries(DAYVIEW_COLORS).map(([k, c]) => (
                      <span key={k} style={{ display:'flex', alignItems:'center', gap:'4px' }}><span style={{ width:'10px', height:'10px', borderRadius:'3px', background:c, display:'inline-block' }} />{t(`sh_${k}_color`)}</span>
                    ))}
                  </div>
                  {dayViewMode === 'day'
                    ? renderDayTimeline(addDaysToDate(today, dayViewOffset), addDaysToDate(today, dayViewOffset), false)
                    : (() => {
                        const [wStart] = getWeekRange(addDaysToDate(today, dayViewOffset));
                        return Array.from({ length: 7 }, (_, i) => addDaysToDate(wStart, i)).map(d => renderDayTimeline(d, d, true));
                      })()}
                </div>
              </>
            );
          })()}

          {shiftsViewTab === 'overview' && (
            <>
              <div style={s.card}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px' }}>
                  <button style={s.navControlBtn(true)} onClick={() => setOverviewWeekOffset(w => w - 1)}>‹</button>
                  <div style={{ textAlign:'center' }}>
                    {(() => {
                      const [wStart] = getWeekRange(addDaysToDate(today, overviewWeekOffset * 7));
                      const wEnd = addDaysToDate(wStart, 6);
                      const wNum = getISOWeekNumber(wStart);
                      return <><div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>{t('sh_week')} {wNum}{overviewWeekOffset === 0 ? ` (${t('avail_current')})` : ''}</div><div style={{ fontSize:'11px', color:'#888' }}>{wStart} – {wEnd}</div></>;
                    })()}
                  </div>
                  <button style={s.navControlBtn(true)} onClick={() => setOverviewWeekOffset(w => w + 1)}>›</button>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'1px solid #f0f0f0', paddingTop:'10px' }}>
                  <button style={s.navControlBtn(true)} onClick={() => setOverviewMonthOffset(m => m - 1)}>‹</button>
                  <div style={{ textAlign:'center' }}>
                    {(() => {
                      const d = new Date(today); d.setMonth(d.getMonth() + overviewMonthOffset);
                      const monthLabel = d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
                      return <div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d' }}>{monthLabel}{overviewMonthOffset === 0 ? ` (${t('avail_current')})` : ''}</div>;
                    })()}
                  </div>
                  <button style={s.navControlBtn(true)} onClick={() => setOverviewMonthOffset(m => m + 1)}>›</button>
                </div>
              </div>
              <div style={s.card}>
              <div style={s.cardLabel}>{t('sh_hours_overview')}</div>
              {allEmployeesList.map(e => {
                const rec = getEmployeeRecord(e.name);
                if (rec.status === 'deactivated') return null;
                const p = getProfile(e.name);
                const [wkStart] = getWeekRange(addDaysToDate(today, overviewWeekOffset * 7));
                const wkEnd = addDaysToDate(wkStart, 6);
                const monthDate = new Date(today); monthDate.setMonth(monthDate.getMonth() + overviewMonthOffset);
                const monthKey = `${monthDate.getFullYear()}-${String(monthDate.getMonth() + 1).padStart(2, '0')}`;
                const weekShiftsAll = shifts.filter(sh => sh.employee === e.name && sh.date >= wkStart && sh.date <= wkEnd);
                const monthShiftsAll = shifts.filter(sh => sh.employee === e.name && sh.date.startsWith(monthKey));
                const weekMins = weekShiftsAll.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const monthMins = monthShiftsAll.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const maxWeekMins = p.maxHours ? parseFloat(p.maxHours) * 60 : null;
                const maxMonthMins = p.maxHours ? parseFloat(p.maxHours) * 4 * 60 : null;
                const weekWorked = weekShiftsAll.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo);
                const weekSick = weekShiftsAll.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem' && sh.payApproved);
                const weekCompletedMins = weekWorked.reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0) + weekSick.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const weekApprovedMins = weekWorked.filter(sh => sh.attendanceApproved).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0) + weekSick.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const monthWorked = monthShiftsAll.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo);
                const monthSick = monthShiftsAll.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem' && sh.payApproved);
                const monthCompletedMins = monthWorked.reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0) + monthSick.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const monthApprovedMinsRow = monthWorked.filter(sh => sh.attendanceApproved).reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo), 0) + monthSick.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
                const needsReview = weekWorked.some(sh => !sh.attendanceApproved) || monthWorked.some(sh => !sh.attendanceApproved);
                return (
                  <div key={e.id} style={{ padding:'10px 0', borderBottom:'1px solid #f0f0f0' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
                    <div style={{ width:'36px', height:'36px', borderRadius:'50%', background:e.color, color:e.textColor, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:'600', flexShrink:0 }}>{e.initials}</div>
                    <div style={{ flex:1, fontSize:'13px', fontWeight:'600', color:'#2d2d2d' }}>{e.name}{needsReview && <span style={{ marginLeft:'6px', fontSize:'10px', color:'#f57f17', fontWeight:'700' }}>⏳ {t('sh_needs_review')}</span>}</div>
                    <div style={{ display:'flex', gap:'14px' }}>
                      <HourRing mins={weekMins} maxMins={maxWeekMins} label={t('sh_week')} capLabel={`/${p.minHours ? `${p.minHours}–` : ''}${p.maxHours || '–'}h`} />
                      <HourRing mins={monthMins} maxMins={maxMonthMins} label={t('sh_month')} capLabel={`/${p.minHours ? `${p.minHours*4}–` : ''}${p.maxHours ? p.maxHours*4 : '–'}h`} />
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'10px', marginTop:'8px', paddingLeft:'50px' }}>
                    <div style={{ fontSize:'11px', color:'#888' }}>{t('sh_week')}: <span style={{ color:'var(--brand-dark)', fontWeight:'600' }}>✅ {compactDuration(weekCompletedMins)}</span> · <span style={{ color:'#2e7d32', fontWeight:'600' }}>✔️ {compactDuration(weekApprovedMins)}</span></div>
                    <div style={{ fontSize:'11px', color:'#888' }}>{t('sh_month')}: <span style={{ color:'var(--brand-dark)', fontWeight:'600' }}>✅ {compactDuration(monthCompletedMins)}</span> · <span style={{ color:'#2e7d32', fontWeight:'600' }}>✔️ {compactDuration(monthApprovedMinsRow)}</span></div>
                  </div>
                  </div>
                );
              })}
            </div>
            </>
          )}

          {shiftsViewTab === 'calendar' && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('sh_employee_calendar')}</div>
              <select style={{ ...s.selectInput, marginBottom: calendarEmployee ? '14px' : 0 }} value={calendarEmployee} onChange={e => setCalendarEmployee(e.target.value)}>
                <option value=''>{t('sh_select_employee')}</option>
                {allEmployeesList.map(e => <option key={e.id} value={e.name}>{e.name}</option>)}
              </select>
              {calendarEmployee && (
                <CalendarView shifts={shifts} employeeName={calendarEmployee} onMarkAbsent={(sh) => { setMarkingAbsent(sh); setAbsentNote(''); }} profile={getProfile(calendarEmployee)} language={language} />
              )}
              {markingAbsent && markingAbsent.employee === calendarEmployee && (
                <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginTop:'10px' }}>
                  <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('sh_mark_absent_title').replace('{name}', markingAbsent.employee).replace('{date}', markingAbsent.dateLabel)}</div>
                  <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('sh_mark_absent_desc').replace('{name}', markingAbsent.employee)}</div>
                  <textarea style={{ ...s.input, minHeight:'50px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('sh_optional_note')} value={absentNote} onChange={e2 => setAbsentNote(e2.target.value)} />
                  <div style={{ display:'flex', gap:'8px' }}>
                    <button style={{ ...s.dangerBtn, flex:1, padding:'9px' }} onClick={confirmMarkAbsent}>{t('sh_confirm_mark_absent')}</button>
                    <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setMarkingAbsent(null)}>{t('avail_cancel')}</button>
                  </div>
                </div>
              )}
            </div>
          )}

          {shiftsViewTab === 'all' && <>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('sh_shifts_label')}</div>
            {(() => {
              // Single source of truth: whether a shift is "awaiting" depends only on its own
              // approval status, not a separate cross-check against the sickReports collection.
              // Approving a certificate already updates this same flag (see submitSickReview),
              // so checking it here directly avoids the two signals ever getting out of sync.
              const isAwaitingCert = (sh) => sh.missedReason === 'Health problem' && !sh.attendanceApproved;
              const isUnexplained = (sh) => sh.attendance === 'Missed' && sh.missedReason !== 'Health problem' && !sh.attendanceApproved;
              const categories = [
                { id: 'all', label: t('sh_cat_all'), test: () => true },
                { id: 'upcoming', label: `📅 ${t('sh_cat_upcoming')}`, test: (sh) => isUpcoming(sh.date) },
                { id: 'ongoing', label: `🕐 ${t('sh_cat_ongoing')}`, test: (sh) => sh.attendance === 'Clocked In' },
                { id: 'review', label: `⏳ ${t('sh_cat_review')}`, test: (sh) => !isUpcoming(sh.date) && ((sh.attendance === 'Worked' && !sh.attendanceApproved) || sh.attendance === 'Pending') },
                { id: 'cert', label: `🤒 ${t('sh_cat_cert')}`, test: (sh) => !isUpcoming(sh.date) && sh.attendance === 'Missed' && isAwaitingCert(sh) },
                { id: 'unexplained', label: `⚠️ ${t('sh_cat_unexplained')}`, test: (sh) => !isUpcoming(sh.date) && isUnexplained(sh) },
                { id: 'approved', label: `✅ ${t('sh_cat_approved')}`, test: (sh) => !isUpcoming(sh.date) && sh.attendanceApproved },
              ];
              const activeCategory = categories.find(c => c.id === shiftCategoryFilter) || categories[0];
              const filteredShifts = shifts.filter(activeCategory.test);
              return (
                <>
                  <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'14px' }}>
                    {categories.map(c => (
                      <button key={c.id} style={s.tabBtn(shiftCategoryFilter === c.id)} onClick={() => setShiftCategoryFilter(c.id)}>{c.label} ({shifts.filter(c.test).length})</button>
                    ))}
                  </div>
                  {filteredShifts.length === 0 && <div style={s.emptyBox}>{t('sh_nothing_category')}</div>}
                  {filteredShifts.map((sh,i) => (
              <div key={sh.id}>
                <div style={i===filteredShifts.length-1 && adminEditAttendance?.id!==sh.id ?s.rowLast:s.row}>
                  <div>
                    <div style={s.name}>{sh.employee}</div>
                    <div style={s.sub}>{sh.dateLabel} · {sh.time}</div>
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && !sh.endedEarly && (() => {
                      const [asF, asT] = sh.time.split(' – ');
                      const assignedMins = durationMins(asF, asT);
                      const workedMins = durationMins(sh.workedFrom, sh.workedTo);
                      return <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'2px' }}>✅ {t('sh_worked_label')}: {sh.workedFrom} – {sh.workedTo} ({compactDuration(workedMins)}/{compactDuration(assignedMins)}) {sh.attendanceApproved ? t('sh_approved_paren') : t('sh_pending_review_paren')}</div>;
                    })()}
                    {!isUpcoming(sh.date) && (sh.clockInLat || sh.clockOutLat) && (
                      <div style={{ display:'flex', gap:'10px', marginTop:'4px' }}>
                        {sh.clockInLat && <a href={`https://www.google.com/maps?q=${sh.clockInLat},${sh.clockInLng}`} target="_blank" rel="noopener noreferrer" style={{ fontSize:'10px', color:'#4A3CDB', textDecoration:'none' }}>📍 in @ {sh.clockInTime}</a>}
                        {sh.clockOutLat && <a href={`https://www.google.com/maps?q=${sh.clockOutLat},${sh.clockOutLng}`} target="_blank" rel="noopener noreferrer" style={{ fontSize:'10px', color:'#4A3CDB', textDecoration:'none' }}>📍 out @ {sh.clockOutTime}</a>}
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && sh.otFrom && sh.otTo && (
                      <div style={{ fontSize:'11px', color:'#4527a0', marginTop:'2px' }}>➕ {t('sh_overtime_label')}: {sh.otFrom} – {sh.otTo} ({formatDuration(durationMins(sh.otFrom, sh.otTo))})</div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && sh.forgotClockOut && (
                      <div style={{ fontSize:'11px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'6px 8px', marginTop:'4px' }}>
                        <div style={{ fontWeight:'600' }}>⚠️ Forgot to clock out — {sh.workedFrom} – {sh.workedTo} recorded, likely inaccurate. Correct with ✏️ above.</div>
                        <div style={{ marginTop:'2px' }}>{t('sh_reason')}: {sh.forgotClockOutNote || '—'}</div>
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && sh.clockInLate && (
                      <div style={{ fontSize:'11px', color:'#8a6d00', background:'#fff8e1', borderRadius:'6px', padding:'6px 8px', marginTop:'4px' }}>
                        <div style={{ fontWeight:'600' }}>⏰ Clocked in late: {sh.clockInTime} ({t('sh_scheduled_until')} {sh.time.split(' – ')[0]})</div>
                        <div style={{ marginTop:'2px' }}>{t('sh_reason')}: {sh.clockInLateNote || '—'}</div>
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && sh.endedLate && (
                      <div style={{ fontSize:'11px', color:'#4527a0', background:'#f3e5f5', borderRadius:'6px', padding:'6px 8px', marginTop:'4px' }}>
                        <div style={{ fontWeight:'600' }}>➕ Clocked out late (overtime): {sh.workedFrom} – {sh.workedTo} ({t('sh_scheduled_until')} {sh.time.split(' – ')[1]}) {sh.attendanceApproved ? t('sh_approved_dot') : t('sh_needs_review_dot')}</div>
                        <div style={{ marginTop:'2px' }}>{t('sh_reason')}: {sh.lateEndNote || '—'}</div>
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && sh.endedEarly && (
                      <div style={{ fontSize:'11px', color:'#8a6d00', background:'#fff8e1', borderRadius:'6px', padding:'6px 8px', marginTop:'4px' }}>
                        <div style={{ fontWeight:'600' }}>⏰ {t('sh_ended_early_label')}: {sh.workedFrom} – {sh.workedTo} ({t('sh_scheduled_until')} {sh.time.split(' – ')[1]}) {sh.attendanceApproved ? t('sh_approved_dot') : t('sh_needs_review_dot')}</div>
                        <div style={{ marginTop:'2px' }}>{t('sh_reason')}: {sh.earlyEndNote || '—'}</div>
                        {(() => {
                          const cert = sickReports.find(r => r.employee === sh.employee && sh.date >= r.fromDate && sh.date <= r.toDate);
                          if (!cert) return null;
                          return (
                            <div style={{ marginTop:'6px', paddingTop:'6px', borderTop:'1px solid #f0e0b0' }}>
                              🤒 A sick certificate exists for this date — <strong>{translateStatus(language, cert.status)}</strong>.{' '}
                              <span style={{ color:'#4A3CDB', cursor:'pointer', textDecoration:'underline' }} onClick={() => navigateTo('sick')}>Review it →</span>
                              <div style={{ fontSize:'10px', color:'#888', marginTop:'2px' }}>Only the {compactDuration(durationMins(sh.workedFrom, sh.workedTo))} actually worked is currently counted — the remaining scheduled time isn't automatically paid. If appropriate, adjust manually with ✏️ above.</div>
                            </div>
                          );
                        })()}
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Missed' && (
                      <div style={{ fontSize:'11px', color:'#b71c1c', marginTop:'2px' }}>
                        ❌ {t('sh_missed_dash')} — {sh.missedReason}{sh.missedDesc ? `: ${sh.missedDesc}` : ''}
                        {sh.missedReason === 'Health problem' && sh.sickFrom && <div>🤒 {t('shifts_sick_range').replace('{from}', sh.sickFrom).replace('{to}', sh.sickTo)}</div>}
                        {sh.certFileData && <CertificateViewer fileName={sh.certFileName} fileData={sh.certFileData} />}
                        <div>{sh.payApproved ? `💶 ${t('sh_acknowledged_paid')}` : sh.attendanceApproved ? `✅ ${t('sh_acknowledged_not_paid')}` : `⏳ ${t('status_pending')} ${t('adm_review').toLowerCase()}`}</div>
                      </div>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Pending' && (() => {
                      const daysOverdue = -daysUntil(sh.date);
                      const isStale = daysOverdue >= 2;
                      return (
                        <div style={{ fontSize:'11px', color: isStale ? '#b71c1c' : '#f57f17', marginTop:'2px', fontWeight: isStale ? '700' : '400' }}>
                          {isStale ? `⚠️ ${t('sh_unreported_likely')} (${daysOverdue}${t('adm_days_ago')})` : `⏳ ${t('sh_attendance_not_reported')}`}
                        </div>
                      );
                    })()}
                    {sh.attendance === 'Clocked In' && <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'2px', fontWeight:'600' }}>🕐 Clocked in at {sh.clockInTime}</div>}
                  </div>
                  <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                    <span style={getBadgeStyle(sh.attendance === 'Clocked In' ? 'Confirmed' : isUpcoming(sh.date)?sh.status:'Completed')}>{sh.attendance === 'Clocked In' ? `🕐 ${t('sh_cat_ongoing')}` : isUpcoming(sh.date)?translateStatus(language, sh.status):translateStatus(language, 'Completed')}</span>
                    {isUpcoming(sh.date) && <>
                      <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => startEditShift(sh)}>✏️</button>
                      <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => removeShift(sh.id)}>🗑️</button>
                    </>}
                    {!isUpcoming(sh.date) && sh.attendance === 'Worked' && (
                      <>
                        {!sh.attendanceApproved && <button style={{ ...s.assignBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => onUpdateShift(sh.id, { attendanceApproved: true })}>✅ {t('sh_accept')}</button>}
                        <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => setAdminEditAttendance({ id: sh.id, from: sh.workedFrom, to: sh.workedTo })}>✏️</button>
                        <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => resetShiftToPending(sh)}>↩️</button>
                        <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => { setDiscussingShiftId(discussingShiftId === sh.id ? null : sh.id); setDiscussText(''); }}>💬 {t('sh_discuss_btn')}</button>
                      </>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Missed' && (
                      <>
                        {!sh.attendanceApproved && <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => acknowledgeMissedShift(sh)}>✅ {t('sh_acknowledge_btn')}</button>}
                        {!sh.payApproved && <button style={{ ...s.assignBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => approvePayForShift(sh)}>💶 {t('sh_approve_pay_btn')}</button>}
                        {(sh.attendanceApproved || sh.payApproved) && <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => reopenMissedShift(sh)}>↩️ {t('sh_reopen_btn')}</button>}
                        <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => { setDiscussingShiftId(discussingShiftId === sh.id ? null : sh.id); setDiscussText(''); }}>💬 {t('sh_discuss_btn')}</button>
                      </>
                    )}
                    {!isUpcoming(sh.date) && sh.attendance === 'Pending' && -daysUntil(sh.date) >= 2 && (
                      <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'3px 8px' }} onClick={() => { setMarkingAbsent(sh); setAbsentNote(''); }}>❌ {t('sh_mark_absent_btn')}</button>
                    )}
                  </div>
                </div>
                {discussingShiftId === sh.id && (
                  <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('sh_reply_to').replace('{name}', sh.employee).replace('{date}', sh.dateLabel)}</div>
                    <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>
                      {sh.missedReason === 'Health problem' ? t('sh_reply_hint_health') : t('sh_reply_hint_other')}
                    </div>
                    <textarea style={{ ...s.input, minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('sh_type_reply')} value={discussText} onChange={e => setDiscussText(e.target.value)} />
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button style={{ ...s.assignBtn, flex:1, padding:'9px', opacity: discussText.trim() ? 1 : 0.5 }} disabled={!discussText.trim()} onClick={() => sendDiscussReply(sh)}>{t('sh_send_reply_btn')}</button>
                      <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setDiscussingShiftId(null)}>{t('avail_cancel')}</button>
                    </div>
                    <div style={{ fontSize:'11px', color:'#aaa', marginTop:'8px' }}>{t('sh_becomes_conversation')}</div>
                  </div>
                )}
                {markingAbsent?.id === sh.id && (
                  <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('sh_mark_absent_row_title').replace('{name}', sh.employee).replace('{date}', sh.dateLabel)}</div>
                    <div style={{ fontSize:'12px', color:'#888', marginBottom:'10px' }}>{t('sh_mark_absent_row_desc').replace('{name}', sh.employee)}</div>
                    <textarea style={{ ...s.input, minHeight:'50px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('sh_optional_note')} value={absentNote} onChange={e => setAbsentNote(e.target.value)} />
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button style={{ ...s.dangerBtn, flex:1, padding:'9px' }} onClick={confirmMarkAbsent}>{t('sh_confirm_mark_absent')}</button>
                      <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setMarkingAbsent(null)}>{t('avail_cancel')}</button>
                    </div>
                  </div>
                )}
                {adminEditAttendance?.id === sh.id && (
                  <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('sh_correct_hours').replace('{name}', sh.employee)}</div>
                    <div style={{ display:'flex', gap:'8px', alignItems:'center', marginBottom:'12px' }}>
                      <TimeSelect value={adminEditAttendance.from} onChange={v => setAdminEditAttendance({ ...adminEditAttendance, from: v })} />
                      <span style={{ color:'#888', fontSize:'13px' }}>to</span>
                      <TimeSelect value={adminEditAttendance.to} onChange={v => setAdminEditAttendance({ ...adminEditAttendance, to: v })} />
                    </div>
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button
                        style={{ ...s.assignBtn, flex:1, padding:'9px', opacity:(!adminEditAttendance.from||!adminEditAttendance.to||adminEditAttendance.from>=adminEditAttendance.to)?0.5:1 }}
                        onClick={() => { onUpdateShift(sh.id, { workedFrom: adminEditAttendance.from, workedTo: adminEditAttendance.to, attendanceApproved: true }); setAdminEditAttendance(null); }}
                      >💾 {t('sh_save_approve')}</button>
                      <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setAdminEditAttendance(null)}>{t('avail_cancel')}</button>
                    </div>
                  </div>
                )}
              </div>
            ))}
                </>
              );
            })()}
          </div>
          {editingShift && (
            <div style={{ ...s.card, border:'2px solid #4A3CDB' }}>
              <div style={s.cardLabel}>✏️ {t('aes_edit_shift')} — {editingShift.employee}</div>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('aes_date')}</label>
              <input type='date' style={{ ...s.input, marginTop:'6px' }} value={editDate} onChange={e => setEditDate(e.target.value)} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('aes_time_range')}</label>
              <div style={{ display:'flex', gap:'8px', alignItems:'center', marginTop:'6px', marginBottom:'12px' }}>
                <TimeSelect value={editFrom} onChange={setEditFrom} />
                <span style={{ color:'#888', fontSize:'13px' }}>to</span>
                <TimeSelect value={editTo} onChange={setEditTo} />
              </div>
              <div style={{ display:'flex', gap:'8px' }}>
                <button style={{ ...s.assignBtn, flex:1, padding:'10px', opacity:(!editFrom||!editTo||editFrom>=editTo)?0.5:1 }} onClick={saveEditShift}>✅ {t('aes_save_changes')}</button>
                <button style={{ ...s.outlineBtn, padding:'10px 16px' }} onClick={() => setEditingShift(null)}>{t('avail_cancel')}</button>
              </div>
            </div>
          )}
          </>}
        </>}

        {tab === 'issues' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          {issues.length === 0 && <div style={s.card}><div style={s.emptyBox}>{t('aiss_no_issues_yet')}</div></div>}
          {issues.length > 0 && (
            <div style={s.tabRow}>
              <button style={s.tabBtn(issuesSubTab==='open')} onClick={()=>setIssuesSubTab('open')}>{t('aiss_open')} ({issues.filter(i=>i.status==='Open').length})</button>
              <button style={s.tabBtn(issuesSubTab==='resolved')} onClick={()=>setIssuesSubTab('resolved')}>{t('aiss_resolved')} ({issues.filter(i=>i.status==='Resolved').length})</button>
              <button style={s.tabBtn(issuesSubTab==='calendar')} onClick={()=>setIssuesSubTab('calendar')}>📅 {t('aiss_calendar')}</button>
            </div>
          )}
          {issues.length > 0 && issuesSubTab !== 'calendar' && (
            <input style={s.input} placeholder={t('aiss_search_placeholder')} value={issueSearchQuery} onChange={e => setIssueSearchQuery(e.target.value)} />
          )}
          {issuesSubTab === 'calendar' && issues.length > 0 && (
            <div style={s.card}>
              <div style={s.cardLabel}>{t('aiss_issues_calendar')}</div>
              <IssueCalendarView issues={issues} language={language} />
            </div>
          )}
          {issuesSubTab !== 'calendar' && issues.filter(iss => issuesSubTab === 'open' ? iss.status === 'Open' : iss.status === 'Resolved')
            .filter(iss => {
              if (!issueSearchQuery.trim()) return true;
              const q = issueSearchQuery.trim().toLowerCase().replace('#', '');
              return String(iss.ticketNumber || '').includes(q) || iss.employee.toLowerCase().includes(q);
            }).map(iss => (
            <div key={iss.id} style={s.card}>
              <div onClick={() => setOpenIssueId(openIssueId===iss.id ? null : iss.id)} style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'10px', cursor:'pointer' }}>
                <div>
                  <div style={s.name}>{iss.ticketNumber ? `#${iss.ticketNumber} · ` : ''}{iss.employee}</div>
                  <div style={s.sub}>{iss.type} · {iss.shift}</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t('aiss_raised')} {iss.raisedDate}{iss.resolvedDate ? ` · ${t('aiss_resolved_date')} ${iss.resolvedDate}` : ''}</div>
                  {iss.replies?.length > 0 && <div style={{ fontSize:'11px', color:'var(--brand)', marginTop:'2px' }}>💬 {iss.replies.length} {iss.replies.length===1?t('aiss_reply'):t('aiss_replies')}</div>}
                </div>
                <span style={getBadgeStyle(iss.status)}>{translateStatus(language, iss.status)}</span>
              </div>
              <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', fontSize:'13px', color:'#555', marginBottom:'10px' }}>{iss.description}</div>
              {iss.type === 'Attendance' && iss.shiftDate && (() => {
                const linkedCert = sickReports.find(r => r.employee === iss.employee && iss.shiftDate >= r.fromDate && iss.shiftDate <= r.toDate);
                return (
                  <div style={{ background: linkedCert ? '#f3e5f5' : '#fff8e1', borderRadius:'8px', padding:'10px', marginBottom:'10px' }}>
                    {linkedCert ? (
                      <>
                        <div style={{ fontSize:'12px', fontWeight:'600', color:'#8e24aa' }}>🤒 {t('aiss_cert_submitted')} — {translateStatus(language, linkedCert.status)}</div>
                        <div style={{ fontSize:'12px', color:'#666', marginTop:'2px' }}>{linkedCert.fromDate} to {linkedCert.toDate}{linkedCert.note ? ` — ${linkedCert.note}` : ''}</div>
                        <CertificateViewer fileName={linkedCert.certFileName} fileData={linkedCert.certFileData} />
                        <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px', marginTop:'6px' }} onClick={() => navigateTo('sick')}>{t('aiss_review_sick')} →</button>
                      </>
                    ) : (
                      <div style={{ fontSize:'12px', color:'#8a6d00', fontWeight:'500' }}>⚠️ {t('aiss_no_cert_yet')}</div>
                    )}
                  </div>
                );
              })()}
              {iss.certFileData && (
                <div style={{ fontSize:'12px', color:'#4A3CDB', marginBottom:'10px', cursor:'pointer' }} onClick={() => { const a=document.createElement('a'); a.href=iss.certFileData; a.download=iss.certFileName; a.click(); }}>📎 {iss.certFileName}</div>
              )}
              {openIssueId === iss.id && (
                <div style={{ background:'#f5f6fa', borderRadius:'10px', padding:'14px', marginBottom:'10px' }}>
                  {iss.replies?.map((r,ri) => (
                    <div key={ri} style={{ background: r.from==='admin' ? 'var(--brand-light)' : 'white', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                      <div style={{ fontSize:'11px', fontWeight:'600', color: r.from==='admin' ? 'var(--brand-dark)' : '#2d2d2d', marginBottom:'2px' }}>{r.from==='admin' ? `⚙️ ${t('aiss_you_manager')}` : r.fromName}</div>
                      {r.text && <div style={{ fontSize:'13px', color:'#555' }}>{r.text}</div>}
                      {r.fileData && <div style={{ fontSize:'12px', color:'#4A3CDB', marginTop:'4px', cursor:'pointer' }} onClick={() => { const a=document.createElement('a'); a.href=r.fileData; a.download=r.fileName; a.click(); }}>📎 {r.fileName}</div>}
                    </div>
                  ))}
                  {(!iss.replies || iss.replies.length === 0) && <div style={{ fontSize:'12px', color:'#aaa', marginBottom:'8px' }}>{t('aiss_no_replies')}</div>}
                  <textarea style={{ ...s.input, marginTop:'4px', minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={t('aiss_reply_placeholder')} value={replyText} onChange={e => setReplyText(e.target.value)} />
                  <div style={{ marginBottom:'10px' }}>
                    <input ref={replyFileRef} type='file' accept='.pdf,image/*' style={{ display:'none' }} onChange={handleReplyFileChange} />
                    <button style={s.outlineBtn} onClick={() => replyFileRef.current.click()}>📎 {t('btn_attach')}</button>
                    {replyFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {replyFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setReplyFile(null)}>✕</span></span>}
                  </div>
                  <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!replyText && !replyFile)?0.5:1 }} onClick={() => sendReply(iss.id)}>{t('aiss_send_reply')} →</button>
                </div>
              )}
              {iss.status === 'Open' && (
                <button style={{ ...s.assignBtn, width:'100%', padding:'10px' }} onClick={() => resolveIssue(iss.id)}>✅ {t('aiss_mark_resolved')}</button>
              )}
              {iss.status === 'Resolved' && (
                <div>
                  <div style={s.successBox}>✅ {t('aiss_issue_resolved')}</div>
                  <button style={{ ...s.outlineBtn, width:'100%', padding:'8px', marginTop:'8px' }} onClick={() => onUpdateIssue(iss.id, { status: 'Open' })}>↩️ {t('aiss_reopen')}</button>
                </div>
              )}
            </div>
          ))}
        </>}

        {tab === 'salary' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          <div style={s.card}>
            <div style={s.cardLabel}>{t('pe_title')}</div>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('pe_disclaimer')}</div>
            <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
              <select style={{ ...s.selectInput, marginBottom:0, flex:1 }} value={payrollYear} onChange={e => setPayrollYear(e.target.value)}>
                {[today.slice(0,4), String(Number(today.slice(0,4))-1)].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
              <select style={{ ...s.selectInput, marginBottom:0, flex:1 }} value={payrollMonth} onChange={e => setPayrollMonth(e.target.value)}>
                {Array.from({length:12},(_,i)=>String(i+1).padStart(2,'0')).map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            {(() => {
              const rows = computePayrollRows(payrollYear, payrollMonth);
              if (rows.length === 0) return <div style={s.emptyBox}>{t('pe_no_employees')}</div>;
              return (
                <>
                  {rows.map((r,i) => (
                    <div key={r.name} style={i===rows.length-1?s.rowLast:s.row}>
                      <div>
                        <div style={s.name}>{r.name}</div>
                        <div style={s.sub}>{r.email}</div>
                        <div style={s.sub}>{t('pe_regular_hours')}: {formatDuration(r.regularMins)}{r.sickMins > 0 ? ` + ${t('pe_sick_hours')}: ${formatDuration(r.sickMins)}` : ''} = {formatDuration(r.totalMins)}</div>
                        <div style={{ fontSize:'10px', color:'#888' }}>{r.payType === 'gross' ? `${t('tm_pay_gross')}: €${r.grossSalary ?? '—'} / ${t('tm_max_hrs_week').toLowerCase()}: ${r.maxHours ?? '—'}` : `${t('tm_pay_hourly')}: €${r.hourlyRate ?? '—'}/hr`}</div>
                      </div>
                      <div style={{ textAlign:'right' }}>
                        {r.gross !== null ? (
                          <>
                            <div style={{ fontSize:'14px', fontWeight:'700', color:'#2e7d32' }}>€{r.gross.toFixed(2)}</div>
                            <div style={{ fontSize:'10px', color:'#888' }}>{(r.totalMins/60).toFixed(2)}h × €{r.payType === 'gross' ? (r.grossSalary / (r.maxHours * 4)).toFixed(2) : r.hourlyRate}</div>
                          </>
                        ) : (
                          <div style={{ fontSize:'11px', color:'#f57f17' }}>{t('pe_no_rate')}</div>
                        )}
                      </div>
                    </div>
                  ))}
                  <div style={{ display:'flex', gap:'8px', marginTop:'14px' }}>
                    <button style={{ ...s.assignBtn, flex:1 }} onClick={() => exportPayrollCSV(payrollYear, payrollMonth)}>⬇ {t('pe_export_csv')}</button>
                    <button style={{ ...s.assignBtn, flex:1 }} onClick={() => exportPayrollXLSX(payrollYear, payrollMonth)}>⬇ {t('pe_export_xlsx')}</button>
                  </div>
                  {user.branchId && (
                    <div style={{ marginTop:'10px' }}>
                      <button style={{ ...s.outlineBtn, width:'100%' }} onClick={async () => {
                        const rows = computePayrollRows(payrollYear, payrollMonth);
                        await onSubmitPayrollToHQ(payrollYear, payrollMonth, rows);
                        setHqSubmitStatus(`${payrollYear}-${payrollMonth}`);
                        setTimeout(() => setHqSubmitStatus(null), 3000);
                      }}>📤 {t('pe_send_to_hq')}</button>
                      {hqSubmitStatus === `${payrollYear}-${payrollMonth}` && <div style={{ fontSize:'11px', color:'#2e7d32', marginTop:'6px', fontWeight:'600', textAlign:'center' }}>✅ {t('pe_sent_to_hq_success')}</div>}
                    </div>
                  )}
                </>
              );
            })()}
          </div>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
              <div style={{ ...s.cardLabel, marginBottom:0 }}>{t('asal_upload_slip')}</div>
              <span style={{ fontSize:'12px', color:'#4A3CDB', cursor:'pointer', fontWeight:'600' }} onClick={() => setBulkSalaryOpen(!bulkSalaryOpen)}>{bulkSalaryOpen ? t('avail_cancel') : t('asal_bulk_upload')}</span>
            </div>
            {bulkSalaryOpen ? (
              <>
                <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('asal_bulk_hint')}</div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_month')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('asal_month_placeholder')} value={bulkSalaryMonth} onChange={e => setBulkSalaryMonth(e.target.value)} />
                {bulkSalaryFiles.length === 0 ? (
                  <div style={{ marginTop:'6px' }}>
                    <input ref={bulkSalaryFileRef} type='file' accept='.pdf' multiple style={{ display:'none' }} onChange={handleBulkSalaryFiles} />
                    <button style={{ ...s.outlineBtn, width:'100%' }} onClick={() => bulkSalaryFileRef.current.click()}>📎 {t('asal_choose_files')}</button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', margin:'10px 0' }}>{t('asal_files_selected').replace('{count}', bulkSalaryFiles.length)}</div>
                    {bulkSalaryFiles.map((f, i) => (
                      <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid #f0f0f0' }}>
                        <div style={{ fontSize:'12px', color:'#2d2d2d', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginRight:'8px' }}>{f.fileName}</div>
                        <select style={{ ...s.selectInput, marginBottom:0, width:'150px', fontSize:'12px', padding:'6px 8px' }} value={f.employee} onChange={e => setBulkSalaryFiles(bulkSalaryFiles.map((x,xi) => xi===i ? { ...x, employee: e.target.value } : x))}>
                          <option value=''>{t('asal_no_match')}</option>
                          {allEmployeesList.map(e => <option key={e.id} value={e.name}>{e.name}</option>)}
                        </select>
                      </div>
                    ))}
                    <button style={{ ...s.primaryBtn, marginTop:'14px', opacity:(!bulkSalaryMonth || bulkSalaryFiles.every(f=>!f.employee))?0.5:1 }} disabled={!bulkSalaryMonth || bulkSalaryFiles.every(f=>!f.employee)} onClick={submitBulkSalarySlips}>{t('asal_submit_bulk')} →</button>
                    <button style={{ ...s.outlineBtn, width:'100%', marginTop:'8px' }} onClick={() => setBulkSalaryFiles([])}>{t('avail_cancel')}</button>
                  </>
                )}
              </>
            ) : (
              <>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_employee')}</label>
            <select style={{ ...s.selectInput, marginTop:'6px' }} value={uploadEmployee} onChange={e => setUploadEmployee(e.target.value)}>
              <option value=''>{t('asal_select_employee')}</option>
              {allEmployeesList.map(e => <option key={e.id} value={e.name}>{e.name}</option>)}
            </select>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_month')}</label>
            <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('asal_month_placeholder')} value={uploadMonth} onChange={e => setUploadMonth(e.target.value)} />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
              <div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_hours_worked')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} type='number' placeholder={t('asal_hours_placeholder')} value={uploadHours} onChange={e => setUploadHours(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_net_pay')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('asal_net_pay_placeholder')} value={uploadPay} onChange={e => setUploadPay(e.target.value)} />
              </div>
            </div>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('asal_upload_pdf')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('asal_optional')}</span></label>
            <div style={{ marginTop:'6px', marginBottom:'14px' }}>
              <input ref={fileRef} type='file' accept='.pdf' style={{ display:'none' }} onChange={handleFileChange} />
              <button style={s.outlineBtn} onClick={() => fileRef.current.click()}>📎 {t('asal_choose_pdf')}</button>
              {uploadedFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {uploadedFile.name} <span style={{ color:'#b71c1c', cursor:'pointer', fontWeight:'700', marginLeft:'4px' }} onClick={() => setUploadedFile(null)}>✕</span></span>}
            </div>
            {uploadSuccess && <div style={{ ...s.successBox, marginBottom:'10px' }}>✅ {t('asal_slip_uploaded')}</div>}
            <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!uploadEmployee||!uploadMonth||!uploadHours||!uploadPay)?0.5:1 }} onClick={uploadSlip}>{t('asal_upload_btn')} →</button>
              </>
            )}
          </div>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('asal_all_slips')} ({salarySlips.length})</div>
            {salarySlips.length === 0 && <div style={s.emptyBox}>{t('asal_none_uploaded')}</div>}
            {salarySlips.map((sl,i) => (
              <div key={sl.id} style={i===salarySlips.length-1?s.rowLast:s.row}>
                <div>
                  <div style={s.name}>{sl.employee}</div>
                  <div style={s.sub}>{sl.month} · {sl.hours}h · {sl.netPay}</div>
                </div>
                <span style={sl.fileData ? s.badge('#2e7d32','#e8f5e9') : s.badge('#f57f17','#fff8e1')}>{sl.fileData ? '📄 PDF' : t('asal_no_pdf')}</span>
              </div>
            ))}
          </div>
        </>}

        {tab === 'sick' && <>
          <NavControls canBack={historyIndex > 0} canForward={historyIndex < tabHistory.length - 1} onBack={goBack} onForward={goForward} />
          {sickReports.length === 0 && <div style={s.card}><div style={s.emptyBox}>{t('asick_none_submitted')}</div></div>}
          {sickReports.length > 0 && (
            <div style={s.tabRow}>
              <button style={s.tabBtn(sickSubTab==='pending')} onClick={()=>setSickSubTab('pending')}>{t('asick_pending')} ({sickReports.filter(r=>r.status==='Pending').length})</button>
              <button style={s.tabBtn(sickSubTab==='approved')} onClick={()=>setSickSubTab('approved')}>{t('asick_approved')} ({sickReports.filter(r=>r.status==='Approved').length})</button>
              <button style={s.tabBtn(sickSubTab==='rejected')} onClick={()=>setSickSubTab('rejected')}>{t('asick_rejected')} ({sickReports.filter(r=>r.status==='Rejected').length})</button>
            </div>
          )}
          {sickReports.filter(r => r.status.toLowerCase() === sickSubTab).map(r => (
            <div key={r.id} style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'8px' }}>
                <div>
                  <div style={s.name}>{r.ticketNumber ? `#${r.ticketNumber} · ` : ''}{r.employee}</div>
                  <div style={s.sub}>{r.fromDate} to {r.toDate}{r.note ? ` — ${r.note}` : ''}</div>
                </div>
                <span style={getBadgeStyle(r.status === 'Approved' ? 'Confirmed' : r.status === 'Rejected' ? 'Open' : 'Pending')}>{translateStatus(language, r.status)}</span>
              </div>
              {r.certFileData ? (
                <CertificateViewer fileName={r.certFileName} fileData={r.certFileData} />
              ) : (
                <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'6px 10px', fontWeight:'500' }}>⚠️ {t('asick_no_cert_attached')}</div>
              )}
              {r.adminNote && <div style={{ fontSize:'12px', color:'#888', marginTop:'6px' }}>{t('asick_your_note')}: "{r.adminNote}"</div>}
              {r.status === 'Pending' && reviewingSickId?.id !== r.id && (
                <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                  <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => { setReviewingSickId({ id: r.id, action: 'approve' }); setSickReviewNote(''); }}>✅ {t('asick_approve')}</button>
                  <button style={{ ...s.dangerBtn, flex:1, padding:'9px' }} onClick={() => { setReviewingSickId({ id: r.id, action: 'reject' }); setSickReviewNote(''); }}>✕ {t('asick_reject')}</button>
                </div>
              )}
              {(r.status === 'Approved' || r.status === 'Rejected') && (
                <button style={{ ...s.outlineBtn, width:'100%', padding:'8px', marginTop:'10px' }} onClick={() => onUpdateSickReport(r.id, { status: 'Pending' })}>↩️ {t('asick_undo_rereview')}</button>
              )}
              {reviewingSickId?.id === r.id && (
                <div style={{ marginTop:'10px' }}>
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{reviewingSickId.action === 'approve' ? t('asick_note_approve') : t('asick_reason_reject')}</label>
                  <textarea style={{ ...s.input, marginTop:'6px', minHeight:'60px', resize:'vertical', fontFamily:'inherit' }} placeholder={reviewingSickId.action === 'approve' ? t('asick_get_well') : t('asick_reject_placeholder')} value={sickReviewNote} onChange={e => setSickReviewNote(e.target.value)} />
                  {reviewingSickId.action === 'reject' && <div style={{ fontSize:'11px', color:'#888', marginTop:'4px' }}>{t('asick_reject_hint')}</div>}
                  <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                    <button style={{ ...(reviewingSickId.action === 'approve' ? s.assignBtn : s.dangerBtn), flex:1, padding:'9px' }} onClick={() => submitSickReview(r, reviewingSickId.action === 'approve' ? 'Approved' : 'Rejected')}>{reviewingSickId.action === 'approve' ? t('asick_confirm_approval') : t('asick_confirm_rejection')}</button>
                    <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setReviewingSickId(null)}>{t('avail_cancel')}</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </>}

        {tab === 'employees' && <>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px' }}>
            <div style={{ ...s.card, cursor:'pointer', textAlign:'center', padding:'12px' }} onClick={() => navigateTo('issues')}>
              <div style={{ fontSize:'22px', marginBottom:'4px' }}>🚨</div>
              <div style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d' }}>{t('tm_issues')}</div>
              {issues.filter(i=>i.status==='Open').length > 0 && <div style={{ fontSize:'11px', color:'#b71c1c', marginTop:'2px' }}>{issues.filter(i=>i.status==='Open').length} {t('tm_open')}</div>}
            </div>
            <div style={{ ...s.card, cursor:'pointer', textAlign:'center', padding:'12px' }} onClick={() => navigateTo('sick')}>
              <div style={{ fontSize:'22px', marginBottom:'4px' }}>🤒</div>
              <div style={{ fontSize:'12px', fontWeight:'600', color:'#2d2d2d' }}>{t('tm_sick_certs')}</div>
              {sickReports.filter(r=>r.status==='Pending').length > 0 && <div style={{ fontSize:'11px', color:'#b71c1c', marginTop:'2px' }}>{sickReports.filter(r=>r.status==='Pending').length} {t('tm_pending')}</div>}
            </div>
            <div style={{ ...s.card, cursor:'pointer', textAlign:'center' }} onClick={() => navigateTo('salary')}>
              <div style={{ fontSize:'24px', marginBottom:'4px' }}>💶</div>
              <div style={{ fontSize:'13px', fontWeight:'600', color:'#2d2d2d' }}>{t('tm_salary')}</div>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{salarySlips.length} {salarySlips.length!==1?t('tm_slips'):t('tm_slip')}</div>
            </div>
          </div>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: addEmpFormOpen ? '14px' : 0 }}>
              <div style={s.cardLabel}>{t('tm_add_employee')}</div>
              <button style={s.outlineBtn} onClick={() => { setAddEmpFormOpen(!addEmpFormOpen); setAddEmpError(''); setAddEmpSuccess(''); }}>{addEmpFormOpen ? t('avail_cancel') : '+ ' + t('sick_submit_short')}</button>
            </div>
            {addEmpFormOpen && (
              <>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_full_name')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('tm_name_placeholder')} value={newEmpName} onChange={e => setNewEmpName(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_email')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} type='email' placeholder={t('tm_email_placeholder')} value={newEmpEmail} onChange={e => setNewEmpEmail(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_job_title')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('tm_job_title_hint')}</span></label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('tm_job_title_placeholder')} value={newEmpJobTitle} onChange={e => setNewEmpJobTitle(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_join_date')}</label>
                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={newEmpJoinDate} onChange={e => setNewEmpJoinDate(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_salary_field')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('tm_salary_hint')}</span></label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('tm_salary_placeholder')} value={newEmpSalary} onChange={e => setNewEmpSalary(e.target.value)} />
                <div style={{ fontSize:'12px', color:'#888', marginBottom:'12px' }}>{t('tm_password_note')}</div>
                {addEmpError && <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {addEmpError}</div>}
                {addEmpSuccess && <div style={{ ...s.successBox, marginBottom:'10px' }}>✅ {addEmpSuccess}</div>}
                <button style={{ ...s.primaryBtn, marginTop:0, opacity:(!newEmpName||!newEmpEmail||addEmpLoading)?0.5:1 }} onClick={submitAddEmployee}>{addEmpLoading ? t('tm_creating_account') : `${t('tm_add_employee_btn')} →`}</button>
              </>
            )}
          </div>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: bulkFormOpen ? '14px' : 0 }}>
              <div style={s.cardLabel}>{t('tm_bulk_import')}</div>
              <button style={s.outlineBtn} onClick={() => { setBulkFormOpen(!bulkFormOpen); setBulkRows(null); setBulkResults(null); }}>{bulkFormOpen ? t('avail_cancel') : t('tm_import_btn')}</button>
            </div>
            {bulkFormOpen && (
              <>
                <div style={{ fontSize:'12px', color:'#888', marginBottom:'12px' }}>{t('tm_bulk_desc')}</div>
                <button style={{ ...s.outlineBtn, marginBottom:'12px' }} onClick={downloadBulkTemplate}>⬇ {t('tm_download_template')}</button>

                {!bulkRows && !bulkResults && (
                  <div>
                    <input ref={bulkFileRef} type='file' accept='.csv' style={{ display:'none' }} onChange={handleBulkFileChange} />
                    <button style={{ ...s.outlineBtn, width:'100%' }} onClick={() => bulkFileRef.current.click()}>📎 {t('tm_choose_csv')}</button>
                  </div>
                )}

                {bulkRows && !bulkRunning && (
                  <>
                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>
                      {t('tm_preview')} — {bulkRows.filter(r => !r.issue).length} {t('tm_ready')}, {bulkRows.filter(r => r.issue).length} {t('tm_with_issues')}
                    </div>
                    {bulkRows.map(r => (
                      <div key={r.rowNum} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid #f0f0f0' }}>
                        <div>
                          <div style={{ fontSize:'13px', fontWeight:'600', color:'#2d2d2d' }}>{r.name || `${t('tm_row')} ${r.rowNum}`}</div>
                          <div style={{ fontSize:'11px', color:'#888' }}>{r.email || '—'}{r.jobTitle ? ` · ${r.jobTitle}` : ''} · {t('tm_joins')} {r.joinDate}</div>
                        </div>
                        {r.issue ? (
                          <span style={{ fontSize:'11px', color:'#b71c1c', fontWeight:'500' }}>⚠️ {r.issue}</span>
                        ) : (
                          <span style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'500' }}>✅ {t('tm_ready_badge')}</span>
                        )}
                      </div>
                    ))}
                    <div style={{ display:'flex', gap:'8px', marginTop:'14px' }}>
                      <button style={{ ...s.primaryBtn, flex:1, marginTop:0, opacity: bulkRows.filter(r=>!r.issue).length===0 ? 0.5 : 1 }} disabled={bulkRows.filter(r=>!r.issue).length===0} onClick={runBulkImport}>
                        {t('tm_create_accounts')} {bulkRows.filter(r=>!r.issue).length} {bulkRows.filter(r=>!r.issue).length!==1?t('tm_account_plural'):t('tm_account_singular')} →
                      </button>
                      <button style={{ ...s.outlineBtn, padding:'12px 16px' }} onClick={() => setBulkRows(null)}>{t('avail_cancel')}</button>
                    </div>
                  </>
                )}

                {bulkRunning && (
                  <div style={{ textAlign:'center', padding:'20px 0' }}>
                    <div style={{ fontSize:'13px', color:'#888', marginBottom:'8px' }}>{t('tm_creating_accounts')} {bulkProgress} {t('tm_of')} {bulkRows ? bulkRows.filter(r=>!r.issue).length : 0}</div>
                  </div>
                )}

                {bulkResults && (
                  <div>
                    <div style={{ ...s.successBox, marginBottom:'10px' }}>✅ {bulkResults.created} {bulkResults.created!==1?t('tm_employees_created_pl'):t('tm_employees_created')} {t('tm_created_desc')}</div>
                    {bulkResults.skipped.length > 0 && (
                      <div style={{ background:'#fff8e1', borderRadius:'8px', padding:'10px' }}>
                        <div style={{ fontSize:'12px', fontWeight:'600', color:'#8a6d00', marginBottom:'6px' }}>⚠️ {bulkResults.skipped.length} {bulkResults.skipped.length!==1?t('tm_rows_skipped_pl'):t('tm_rows_skipped')} {t('tm_skipped')}:</div>
                        {bulkResults.skipped.map((s2,i) => (
                          <div key={i} style={{ fontSize:'12px', color:'#8a6d00' }}>{t('tm_row')} {s2.row}: {s2.reason}</div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          <div style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: templateFormOpen ? '14px' : 0 }}>
              <div style={s.cardLabel}>{t('ct_title')}</div>
              <button style={s.outlineBtn} onClick={() => { setTemplateFormOpen(!templateFormOpen); setNewTemplateName(''); setNewTemplateType('Part-time'); setNewTemplateFile(null); }}>{templateFormOpen ? t('avail_cancel') : '+ ' + t('ct_add')}</button>
            </div>
            {templateFormOpen && (
              <>
                <div style={{ fontSize:'11px', color:'#888', marginBottom:'10px' }}>{t('ct_hint')}</div>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('ct_name')}</label>
                <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('ct_name_placeholder')} value={newTemplateName} onChange={e => setNewTemplateName(e.target.value)} />
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_contract_type')}</label>
                <select style={{ ...s.selectInput, marginTop:'6px' }} value={newTemplateType} onChange={e => setNewTemplateType(e.target.value)}>
                  <option value='Minijob'>{t('tm_ct_minijob')}</option>
                  <option value='Werkstudent'>{t('tm_ct_werkstudent')}</option>
                  <option value='Part-time'>{t('tm_ct_parttime')}</option>
                  <option value='Full-time'>{t('tm_ct_fulltime')}</option>
                  <option value='Full-time Extended'>{t('tm_ct_fulltime_ext')}</option>
                  <option value='Custom'>{t('tm_ct_custom')}</option>
                </select>
                <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('ct_content')}</label>
                <div style={{ marginTop:'6px', marginBottom:'10px' }}>
                  <input ref={templateFileRef} type='file' accept='.docx' style={{ display:'none' }} onChange={handleTemplateFileChange} />
                  <button style={s.outlineBtn} onClick={() => templateFileRef.current.click()}>📎 {t('ct_choose_docx')}</button>
                  {newTemplateFile && <span style={{ fontSize:'12px', color:'#2e7d32', marginLeft:'10px' }}>✅ {newTemplateFile.name}</span>}
                </div>
                <button style={{ ...s.primaryBtn, marginTop:'10px', opacity:(!newTemplateName||!newTemplateFile)?0.5:1 }} onClick={() => { onAddContractTemplate({ name: newTemplateName, contractType: newTemplateType, fileData: newTemplateFile.data, fileName: newTemplateFile.name }); setTemplateFormOpen(false); }}>{t('ct_save')} →</button>
              </>
            )}
            {!templateFormOpen && contractTemplates.length === 0 && <div style={s.emptyBox}>{t('ct_none')}</div>}
            {!templateFormOpen && contractTemplates.map((tpl,i) => (
              <div key={tpl.id} style={i===contractTemplates.length-1?s.rowLast:s.row}>
                <div><div style={s.name}>{tpl.name}</div><div style={s.sub}>{tpl.contractType}</div></div>
                <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => { if (window.confirm(t('ct_delete_confirm'))) onDeleteContractTemplate(tpl.id); }}>🗑️</button>
              </div>
            ))}
          </div>
          <div style={s.card}>
            <div style={s.cardLabel}>{t('tm_employees_title')}</div>
            <div style={{ position:'relative' }}>
              <input
                style={{ ...s.input, marginBottom:'12px' }} placeholder={t('tm_search_placeholder')}
                value={employeeSearch}
                onChange={ev => { setEmployeeSearch(ev.target.value); setShowEmpDropdown(true); }}
                onFocus={() => setShowEmpDropdown(true)}
                onBlur={() => setTimeout(() => setShowEmpDropdown(false), 150)}
              />
              {showEmpDropdown && (() => {
                const suggestions = allEmployeesList.filter(e => {
                  const rec = getEmployeeRecord(e.name);
                  const matchesStatus = employeeStatusTab === 'active' ? rec.status !== 'deactivated' : rec.status === 'deactivated';
                  const matchesSearch = e.name.toLowerCase().includes(employeeSearch.toLowerCase()) || e.email.toLowerCase().includes(employeeSearch.toLowerCase());
                  return matchesStatus && matchesSearch;
                });
                if (suggestions.length === 0) return <div style={{ position:'absolute', top:'46px', left:0, right:0, background:'white', border:'1px solid #eee', borderRadius:'8px', padding:'10px 14px', fontSize:'12px', color:'#aaa', zIndex:10 }}>{t('tm_no_matches')}</div>;
                return (
                  <div className="kd-scroll" style={{ position:'absolute', top:'46px', left:0, right:0, background:'white', border:'1px solid #eee', borderRadius:'8px', boxShadow:'0 4px 16px rgba(0,0,0,0.12)', zIndex:10, maxHeight:'220px', overflowY:'auto', paddingRight:'8px' }}>
                    <style>{`
                      .kd-scroll::-webkit-scrollbar { width: 8px; }
                      .kd-scroll::-webkit-scrollbar-track { background: transparent; }
                      .kd-scroll::-webkit-scrollbar-thumb { background: var(--brand); border-radius: 10px; }
                      .kd-scroll::-webkit-scrollbar-thumb:hover { background: #E85D0F; }
                      .kd-scroll { scrollbar-width: thin; scrollbar-color: var(--brand) transparent; }
                    `}</style>
                    {suggestions.map(e => (
                      <div key={e.id} onMouseDown={() => { setViewEmployee(e.id); setEmployeeDetailOpen(true); setEmployeeSearch(''); setShowEmpDropdown(false); }} style={{ padding:'10px 14px', cursor:'pointer', borderBottom:'1px solid #f5f5f5', fontSize:'13px', color:'#2d2d2d' }}>
                        {e.name} <span style={{ color:'#aaa', fontSize:'11px' }}>{e.email}</span>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
            <div style={{ display:'flex', gap:'8px', marginBottom:'14px' }}>
              <button style={s.tabBtn(employeeStatusTab==='active')} onClick={()=>{setEmployeeStatusTab('active'); setEmployeeSearch(''); setShowEmpDropdown(false);}}>{t('tm_active')} ({allEmployeesList.filter(e=>getEmployeeRecord(e.name).status!=='deactivated').length})</button>
              <button style={s.tabBtn(employeeStatusTab==='deactivated')} onClick={()=>{setEmployeeStatusTab('deactivated'); setEmployeeSearch(''); setShowEmpDropdown(false);}}>{t('tm_deactivated')} ({allEmployeesList.filter(e=>getEmployeeRecord(e.name).status==='deactivated').length})</button>
            </div>
            {(() => {
              const candidates = allEmployeesList.filter(e => {
                const rec = getEmployeeRecord(e.name);
                return employeeStatusTab === 'active' ? rec.status !== 'deactivated' : rec.status === 'deactivated';
              });
              if (candidates.length === 0) return <div style={s.emptyBox}>{t('tm_no_employees_status').replace('{status}', (employeeStatusTab === 'active' ? t('tm_active') : t('tm_deactivated')).toLowerCase())}</div>;
              const selected = candidates.find(e => e.id === viewEmployee);
              if (!selected) return <div style={s.emptyBox}>{t('tm_search_to_select')}</div>;
              const filtered = [selected]; // feeds the existing unchanged detail-rendering code below
              return (
                <>
                  {filtered.map((e,i) => {
              const p = getProfile(e.name);
              const rec = getEmployeeRecord(e.name);
              const hasExpiring = p.documents.some(d => isExpiringSoon(d.expiryDate) && d.status !== 'Approved');
              const isOpen = employeeDetailOpen;
              const [wkStart, wkEnd] = getWeekRange(today);
              const monthKey = today.slice(0, 7);
              const myShiftsAll = shifts.filter(sh => sh.employee === e.name);
              const sumMins = (list) => list.reduce((sum, sh) => {
                if (sh.attendance === 'Worked') { const [f,t] = sh.workedFrom && sh.workedTo ? [sh.workedFrom, sh.workedTo] : sh.time.split(' – '); return sum + durationMins(f,t); }
                return sum;
              }, 0);
              const sumApprovedMins = (list) => list.reduce((sum, sh) => {
                if (sh.attendance === 'Worked' && sh.attendanceApproved) { const [f,t] = sh.workedFrom && sh.workedTo ? [sh.workedFrom, sh.workedTo] : sh.time.split(' – '); return sum + durationMins(f,t); }
                return sum;
              }, 0);
              const sumAssignedMins = (list) => list.reduce((sum, sh) => { const [f,t] = sh.time.split(' – '); return sum + durationMins(f,t); }, 0);
              const weekShifts = myShiftsAll.filter(sh => sh.date >= wkStart && sh.date <= wkEnd);
              const monthShifts = myShiftsAll.filter(sh => sh.date.startsWith(monthKey));
              const weekWorked = sumMins(weekShifts), weekAssigned = sumAssignedMins(weekShifts);
              const monthWorked = sumMins(monthShifts), monthAssigned = sumAssignedMins(monthShifts);
              const weekApproved = sumApprovedMins(weekShifts);
              return (
                <div key={e.id}>
                  <div onClick={() => setEmployeeDetailOpen(!isOpen)} role='button' tabIndex={0} style={{ ...(i===filtered.length-1 && !isOpen ? s.rowLast : s.row), cursor:'pointer' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                      {p.photo ? (
                        <img src={p.photo} alt={e.name} style={{ width:'36px', height:'36px', borderRadius:'50%', objectFit:'cover' }} />
                      ) : (
                        <div style={{ width:'36px', height:'36px', borderRadius:'50%', background:e.color, color:e.textColor, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:'600' }}>{e.initials}</div>
                      )}
                      <div><div style={s.name}>{e.name} {hasExpiring && <span style={{ color:'#b71c1c' }}>●</span>}</div><div style={s.sub}>{e.email}</div></div>
                    </div>
                    <span style={getBadgeStyle(rec.status === 'deactivated' ? 'Open' : 'Confirmed')}>{rec.status === 'deactivated' ? t('tm_deactivated') : t('tm_active')}</span>
                  </div>
                  {(weekAssigned > 0 || monthAssigned > 0) && (
                    <div style={{ display:'flex', gap:'8px', margin: i===filtered.length-1 && !isOpen ? '0 0 14px' : '0 0 10px' }}>
                      <span style={{ fontSize:'11px', color:'#555', background:'#f5f6fa', borderRadius:'20px', padding:'3px 10px' }}>{t('tm_wk')} {compactDuration(weekWorked)}/{compactDuration(weekAssigned)}</span>
                      <span style={{ fontSize:'11px', color:'#555', background:'#f5f6fa', borderRadius:'20px', padding:'3px 10px' }}>{t('tm_mo')} {compactDuration(monthWorked)}/{compactDuration(monthAssigned)}</span>
                      {weekWorked > weekApproved && <span style={{ fontSize:'11px', color:'#f57f17', background:'#fff8e1', borderRadius:'20px', padding:'3px 10px' }}>⏳ {t('tm_needs_review_short')}</span>}
                    </div>
                  )}

                  {isOpen && (
                    <div style={{ margin:'0 0 14px' }}>
                      <div style={s.sectionHeader}>{t('tm_employment_details')}</div>
                      <div style={s.card}>
                        {editingEmployment?.name === e.name ? (
                          <>
                            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_job_title')} <span style={{ color:'#aaa', fontWeight:'400' }}>{t('tm_job_title_hint')}</span></label>
                            <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('tm_job_title_placeholder')} value={editingEmployment.jobTitle} onChange={ev => setEditingEmployment({ ...editingEmployment, jobTitle: ev.target.value })} />
                            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_join_date')}</label>
                            <input type='date' style={{ ...s.input, marginTop:'6px' }} value={editingEmployment.joinDate} onChange={ev => setEditingEmployment({ ...editingEmployment, joinDate: ev.target.value })} />
                            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_dob')}</label>
                            <input type='date' style={{ ...s.input, marginTop:'6px' }} value={editingEmployment.dob} onChange={ev => setEditingEmployment({ ...editingEmployment, dob: ev.target.value })} />
                            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_salary_field')}</label>
                            <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('tm_salary_placeholder')} value={editingEmployment.salary} onChange={ev => setEditingEmployment({ ...editingEmployment, salary: ev.target.value })} />
                            <div style={{ display:'flex', gap:'8px' }}>
                              <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => { updateEmployeeRecord(e.name, { joinDate: editingEmployment.joinDate, dob: editingEmployment.dob, salary: editingEmployment.salary, jobTitle: editingEmployment.jobTitle }); setEditingEmployment(null); }}>💾 {t('avail_save')}</button>
                              <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setEditingEmployment(null)}>{t('avail_cancel')}</button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={s.row}><div><div style={s.name}>{t('tm_job_title')}</div></div><div style={s.sub}>{rec.jobTitle || t('tm_not_set')}</div></div>
                            <div style={s.row}><div><div style={s.name}>{t('tm_join_date')}</div></div><div style={s.sub}>{rec.joinDate || t('tm_not_set')}</div></div>
                            <div style={s.row}><div><div style={s.name}>{t('tm_dob')}</div></div><div style={s.sub}>{rec.dob || t('tm_not_set')}</div></div>
                            <div style={s.rowLast}><div><div style={s.name}>{t('tm_salary_field')}</div></div><div style={s.sub}>{rec.salary || t('tm_not_set')}</div></div>
                            <button style={{ ...s.outlineBtn, width:'100%', padding:'8px', marginTop:'12px' }} onClick={() => setEditingEmployment({ name: e.name, joinDate: rec.joinDate || '', dob: rec.dob || '', salary: rec.salary || '', jobTitle: rec.jobTitle || '' })}>✏️ {t('tm_edit_employment')}</button>
                            {rec.status === 'deactivated' ? (
                              <button style={{ ...s.assignBtn, width:'100%', padding:'8px', marginTop:'8px' }} onClick={() => updateEmployeeRecord(e.name, { status: 'active' })}>✅ {t('tm_reactivate')}</button>
                            ) : (
                              <button style={{ ...s.dangerBtn, width:'100%', padding:'8px', marginTop:'8px' }} onClick={() => { if (window.confirm(t('tm_deactivate_confirm').replace('{name}', e.name))) updateEmployeeRecord(e.name, { status: 'deactivated' }); }}>🚫 {t('tm_deactivate')}</button>
                            )}
                          </>
                        )}
                      </div>

                      <div style={s.sectionHeader}>{t('tm_account_profile')}</div>
                      <div style={s.card}>
                        <MenuRow icon='📷' label={t('tm_photo')} open={openPanel==='photo'} onClick={() => togglePanel('photo')} />
                        {openPanel==='photo' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                              {p.photo ? (
                                <img src={p.photo} alt={e.name} style={{ width:'56px', height:'56px', borderRadius:'50%', objectFit:'cover' }} />
                              ) : (
                                <div style={{ width:'56px', height:'56px', borderRadius:'50%', background:e.color, color:e.textColor, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'16px', fontWeight:'600' }}>{e.initials}</div>
                              )}
                              <div>
                                <input ref={adminPhotoRef} type='file' accept='image/*' style={{ display:'none' }} onChange={ev => handleAdminPhotoUpload(ev, e.name)} />
                                {!p.photo && <button style={s.outlineBtn} onClick={() => adminPhotoRef.current.click()}>📷 {t('tm_upload_photo_btn')}</button>}
                                {p.photo && p.photoChangeRequested && (
                                  <>
                                    <div style={{ fontSize:'11px', color:'#f57f17', fontWeight:'600', marginBottom:'6px' }}>📷 {t('tm_photo_requested')}</div>
                                    <button style={s.assignBtn} onClick={() => adminPhotoRef.current.click()}>{t('tm_update_photo')}</button>
                                  </>
                                )}
                                {p.photo && !p.photoChangeRequested && (
                                  <div style={{ fontSize:'11px', color:'#aaa' }}>{t('tm_photo_set')}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        <MenuRow icon='📄' label={t('tm_contract')} badge={p.contractFile ? <span style={getBadgeStyle(p.contractShared ? 'Confirmed' : 'Pending')}>{p.contractShared ? t('tm_shared') : t('tm_not_shared')}</span> : null} open={openPanel==='contract'} onClick={() => togglePanel('contract')} />
                        {openPanel==='contract' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            {p.contractFile ? (
                              <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px' }}>
                                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'8px' }}>
                                  <div style={s.name}>📄 {p.contractName}</div>
                                </div>
                                <div style={{ fontSize:'11px', marginBottom:'8px', color: p.contractSigned ? '#2e7d32' : '#f57f17', fontWeight:'600' }}>
                                  {p.contractSigned ? `✅ ${t('ct_signed_on').replace('{name}', p.contractSignedName).replace('{date}', p.contractSignedAt)}` : `⏳ ${t('ct_not_signed')}`}
                                </div>
                                {p.contractSigned && (
                                  p.employerSigned ? (
                                    <div style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'600', marginBottom:'8px' }}>
                                      ✅ {t('ct_employer_signed_on').replace('{name}', p.employerSignedName).replace('{date}', p.employerSignedAt)}
                                      <div style={{ marginTop:'2px' }}>🎉 {t('ct_fully_executed')}</div>
                                    </div>
                                  ) : employerSigningFor === e.name ? (
                                    <div style={{ background:'white', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                                      {!employerSigPreview ? (
                                        <>
                                          <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>{t('ct_sign_employer_confirm')}</div>
                                          <div style={{ display:'flex', gap:'8px', marginBottom:'8px' }}>
                                            <button style={s.tabBtn(employerSigMode!=='upload')} onClick={() => setEmployerSigMode('type')}>{t('ct_type_signature')}</button>
                                            <button style={s.tabBtn(employerSigMode==='upload')} onClick={() => setEmployerSigMode('upload')}>{t('ct_upload_signature')}</button>
                                          </div>
                                          {employerSigMode === 'upload' ? (
                                            <div style={{ marginBottom:'8px' }}>
                                              <input ref={employerSigFileRef} type='file' accept='image/*' style={{ display:'none' }} onChange={handleEmployerSigFileChange} />
                                              <button style={s.outlineBtn} onClick={() => employerSigFileRef.current.click()}>📎 {t('ct_choose_image')}</button>
                                              {employerSigImage && <img src={employerSigImage} alt='signature preview' style={{ display:'block', maxHeight:'40px', marginTop:'6px' }} />}
                                            </div>
                                          ) : (
                                            <input style={{ ...s.input, marginBottom:'8px' }} placeholder={user.name} value={employerSigName} onChange={ev => setEmployerSigName(ev.target.value)} />
                                          )}
                                          <div style={{ display:'flex', gap:'8px' }}>
                                            <button style={{ ...s.assignBtn, flex:1, padding:'8px', opacity:(employerSigMode==='upload'?employerSigImage:employerSigName.trim())?1:0.5 }} disabled={employerSigMode==='upload'?!employerSigImage:!employerSigName.trim()} onClick={() => setEmployerSigPreview(true)}>{t('ct_review_btn')} →</button>
                                            <button style={{ ...s.outlineBtn, padding:'8px 12px' }} onClick={() => { setEmployerSigningFor(null); setEmployerSigImage(null); }}>{t('avail_cancel')}</button>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>{t('ct_review_hint')}</div>
                                          <div style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'8px', textAlign:'center' }}>
                                            {employerSigMode === 'upload'
                                              ? <img src={employerSigImage} alt='employer signature' style={{ maxHeight:'50px' }} />
                                              : <div style={{ fontFamily:'cursive', fontSize:'20px', color:'#2d2d2d' }}>{employerSigName.trim()}</div>}
                                            <div style={{ fontSize:'10px', color:'#888', marginTop:'4px' }}>{today}</div>
                                          </div>
                                          <div style={{ display:'flex', gap:'8px' }}>
                                            <button style={{ ...s.assignBtn, flex:1, padding:'8px' }} onClick={() => confirmEmployerSignature(e.name)}>✅ {t('ct_confirm_sign_btn')}</button>
                                            <button style={{ ...s.outlineBtn, padding:'8px 12px' }} onClick={() => setEmployerSigPreview(false)}>{t('ct_back_btn')}</button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <button style={{ ...s.assignBtn, width:'100%', marginBottom:'8px' }} onClick={() => { setEmployerSigningFor(e.name); setEmployerSigName(''); setEmployerSigMode('type'); setEmployerSigPreview(false); }}>✍️ {t('ct_sign_as_employer')}</button>
                                  )
                                )}
                                <div style={{ display:'flex', gap:'8px' }}>
                                  <button style={s.dlBtn} onClick={() => downloadContractFor(e.name)}>⬇ {t('tm_download')}</button>
                                  {!p.contractShared && <button style={s.assignBtn} onClick={() => updateProfile(e.name, { contractShared: true })}>📤 {t('tm_share_employee')}</button>}
                                  <button style={s.outlineBtn} onClick={() => contractRef.current.click()}>🔁 {t('tm_replace')}</button>
                                </div>
                              </div>
                            ) : (
                              <button style={s.outlineBtn} onClick={() => contractRef.current.click()}>📎 {t('tm_upload_contract')}</button>
                            )}
                            <input ref={contractRef} type='file' accept='.pdf' style={{ display:'none' }} onChange={ev => handleContractUpload(ev, e.name)} />
                            <div style={{ marginTop:'12px', paddingTop:'12px', borderTop:'1px solid #eee' }}>
                              <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>{t('ct_generate')}</div>
                              {contractTemplates.length === 0 ? (
                                <div style={{ fontSize:'12px', color:'#aaa' }}>{t('ct_no_templates_yet')}</div>
                              ) : (
                                <>
                                  <select style={{ ...s.selectInput, marginBottom:'8px' }} value={selectedTemplateId} onChange={ev => setSelectedTemplateId(ev.target.value)}>
                                    <option value=''>{t('ct_select_template')}</option>
                                    {contractTemplates.map(tpl => <option key={tpl.id} value={tpl.id}>{tpl.name}</option>)}
                                  </select>
                                  <button style={{ ...s.assignBtn, width:'100%', opacity: selectedTemplateId ? 1 : 0.5 }} disabled={!selectedTemplateId} onClick={() => { const tpl = contractTemplates.find(t2 => t2.id === selectedTemplateId); if (tpl) { generateAndShareContract(tpl, e.name); setSelectedTemplateId(''); } }}>📄 {t('ct_generate_btn')}</button>
                                </>
                              )}
                            </div>

                          </div>
                        )}

                        <MenuRow icon='⏱️' label={t('tm_contract_hour_caps')} open={openPanel==='hours'} onClick={() => togglePanel('hours')} />
                        <MenuRow icon='🕘' label={t('sched_mode_title')} open={openPanel==='schedmode'} onClick={() => togglePanel('schedmode')} />
                        {openPanel==='schedmode' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            <label style={{ fontSize:'11px', color:'#888' }}>{t('sched_mode_hint')}</label>
                            <select style={{ ...s.selectInput, marginTop:'6px' }} value={getEmployeeRecord(e.name).schedulingMode || 'availability'} onChange={ev => onUpdateEmployeeRecord(e.name, { schedulingMode: ev.target.value, rotationStartDate: ev.target.value === 'rotation' ? (getEmployeeRecord(e.name).rotationStartDate || today) : null })}>
                              <option value='availability'>{t('sched_mode_availability')}</option>
                              <option value='fixed-standard'>{t('sched_mode_fixed_standard')}</option>
                              <option value='fixed-choose-dayoff'>{t('sched_mode_fixed_dayoff')}</option>
                              <option value='rotation'>{t('sched_mode_rotation')}</option>
                            </select>
                            {getEmployeeRecord(e.name).schedulingMode === 'rotation' && (
                              <>
                                <label style={{ fontSize:'11px', color:'#888', marginTop:'10px', display:'block' }}>{t('rotation_start_date_label')}</label>
                                <input type='date' style={{ ...s.input, marginTop:'6px' }} value={getEmployeeRecord(e.name).rotationStartDate || today} onChange={ev => onUpdateEmployeeRecord(e.name, { rotationStartDate: ev.target.value })} />
                              </>
                            )}
                          </div>
                        )}
                        {openPanel==='hours' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            {editingHours?.name === e.name ? (
                              <>
                                <label style={{ fontSize:'11px', color:'#888' }}>{t('tm_contract_type')}</label>
                                <select style={{ ...s.selectInput, marginTop:'4px' }} value={editingHours.contractType} onChange={ev => {
                                  const ct = ev.target.value;
                                  const defaults = { 'Minijob': '', 'Werkstudent': '20', 'Part-time': editingHours.weeklyHours || '20', 'Full-time': '40', 'Full-time Extended': '48', 'Custom': editingHours.weeklyHours || '' };
                                  setEditingHours({ ...editingHours, contractType: ct, weeklyHours: defaults[ct] });
                                }}>
                                  <option value='Minijob'>{t('tm_ct_minijob')}</option>
                                  <option value='Werkstudent'>{t('tm_ct_werkstudent')}</option>
                                  <option value='Part-time'>{t('tm_ct_parttime')}</option>
                                  <option value='Full-time'>{t('tm_ct_fulltime')}</option>
                                  <option value='Full-time Extended'>{t('tm_ct_fulltime_ext')}</option>
                                  <option value='Custom'>{t('tm_ct_custom')}</option>
                                </select>

                                {editingHours.contractType === 'Minijob' && (
                                  <div style={{ background:'#fff8e1', borderRadius:'8px', padding:'10px', marginTop:'10px', marginBottom:'10px' }}>
                                    <div style={{ fontSize:'12px', color:'#8a6d00', fontWeight:'600' }}>{t('tm_minijob_desc')}</div>
                                    <div style={{ fontSize:'11px', color:'#8a6d00', marginTop:'2px' }}>{t('tm_minijob_hint')}</div>
                                    <label style={{ fontSize:'11px', color:'#8a6d00', display:'block', marginTop:'8px' }}>{t('tm_optional_wage')}</label>
                                    <input type='number' style={{ ...s.input, marginTop:'4px', marginBottom:0 }} value={editingHours.hourlyRate || ''} onChange={ev => setEditingHours({ ...editingHours, hourlyRate: ev.target.value })} placeholder={t('tm_wage_placeholder')} />
                                    {editingHours.hourlyRate > 0 && editingHours.hourlyRate <= 100 && (
                                      <div style={{ fontSize:'12px', color:'#8a6d00', marginTop:'6px' }}>≈ {(603 / parseFloat(editingHours.hourlyRate) / 4.33).toFixed(1)}{t('tm_keeps_under_cap')}</div>
                                    )}
                                  </div>
                                )}
                                {editingHours.contractType !== 'Minijob' && (
                                  <div style={{ marginTop:'10px', marginBottom:'10px' }}>
                                    <label style={{ fontSize:'11px', color:'#888', display:'block', marginBottom:'6px' }}>{t('tm_pay_type')}</label>
                                    <div style={{ display:'flex', gap:'8px', marginBottom:'10px' }}>
                                      <button type='button' style={s.tabBtn(editingHours.payType!=='gross')} onClick={() => setEditingHours({ ...editingHours, payType: 'hourly' })}>{t('tm_pay_hourly')}</button>
                                      <button type='button' style={s.tabBtn(editingHours.payType==='gross')} onClick={() => setEditingHours({ ...editingHours, payType: 'gross' })}>{t('tm_pay_gross')}</button>
                                    </div>
                                    {editingHours.payType === 'gross' ? (
                                      <>
                                        <label style={{ fontSize:'11px', color:'#888' }}>{t('tm_gross_salary_label')}</label>
                                        <input type='number' style={{ ...s.input, marginTop:'4px', marginBottom:0 }} value={editingHours.grossSalary || ''} onChange={ev => setEditingHours({ ...editingHours, grossSalary: ev.target.value })} placeholder={t('tm_gross_salary_placeholder')} />
                                        <div style={{ fontSize:'10px', color:'#888', marginTop:'4px' }}>{t('tm_gross_salary_hint')}</div>
                                      </>
                                    ) : (
                                      <>
                                        <label style={{ fontSize:'11px', color:'#888' }}>{t('tm_optional_wage')}</label>
                                        <input type='number' style={{ ...s.input, marginTop:'4px', marginBottom:0 }} value={editingHours.hourlyRate || ''} onChange={ev => setEditingHours({ ...editingHours, hourlyRate: ev.target.value })} placeholder={t('tm_wage_placeholder')} />
                                      </>
                                    )}
                                  </div>
                                )}
                                <>
                                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginTop:'10px', marginBottom:'6px' }}>
                                    <div>
                                      <label style={{ fontSize:'11px', color:'#888' }}>{t('tm_min_hrs_week')}</label>
                                      <input type='number' style={{ ...s.input, marginTop:'4px', marginBottom:0 }} value={editingHours.min} onChange={ev => setEditingHours({ ...editingHours, min: ev.target.value })} placeholder={t('tm_min_placeholder')} />
                                    </div>
                                    <div>
                                      <label style={{ fontSize:'11px', color:'#888' }}>{t('tm_max_hrs_week')}</label>
                                      <input type='number' style={{ ...s.input, marginTop:'4px', marginBottom:0 }} value={editingHours.weeklyHours} onChange={ev => setEditingHours({ ...editingHours, weeklyHours: ev.target.value })} placeholder={t('tm_max_placeholder')} />
                                    </div>
                                  </div>
                                  {(editingHours.min || editingHours.weeklyHours) && (
                                    <div style={{ fontSize:'12px', color:'#555', marginBottom:'6px' }}>≈ {editingHours.min ? `${editingHours.min*4}–` : ''}{editingHours.weeklyHours ? editingHours.weeklyHours*4 : '–'}{t('tm_per_month')}</div>
                                  )}
                                  {editingHours.contractType === 'Werkstudent' && parseFloat(editingHours.weeklyHours) > 20 && (
                                    <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('tm_over20_werkstudent')}</div>
                                  )}
                                  {parseFloat(editingHours.weeklyHours) > 48 && (
                                    <div style={{ fontSize:'12px', color:'#b71c1c', background:'#ffebee', borderRadius:'6px', padding:'8px 10px', marginBottom:'10px', fontWeight:'500' }}>⚠️ {t('tm_over48')}</div>
                                  )}
                                </>
                                <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                                  <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} onClick={() => {
                                    updateProfile(e.name, { contractType: editingHours.contractType, minHours: editingHours.min || '', maxHours: editingHours.weeklyHours || '', hourlyRate: editingHours.hourlyRate || '', payType: editingHours.payType || 'hourly', grossSalary: editingHours.grossSalary || '' });
                                    setEditingHours(null);
                                  }}>💾 {t('avail_save')}</button>
                                  <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setEditingHours(null)}>{t('avail_cancel')}</button>
                                </div>
                              </>
                            ) : (
                              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                <div style={{ fontSize:'13px', color:'#2d2d2d' }}>
                                  {p.contractType ? (
                                    <>{p.contractType} — {p.minHours || '–'}–{p.maxHours || '–'} {t('tm_hrs_week')}</>
                                  ) : t('tm_not_set')}
                                </div>
                                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 12px' }} onClick={() => setEditingHours({ name: e.name, contractType: p.contractType || 'Part-time', min: p.minHours || '', weeklyHours: p.maxHours || '', hourlyRate: p.hourlyRate || '', payType: p.payType || 'hourly', grossSalary: p.grossSalary || '' })}>✏️ {p.contractType ? t('tm_edit_btn') : t('tm_set_btn')}</button>
                              </div>
                            )}
                          </div>
                        )}

                        <MenuRow icon='📊' label={t('tm_payroll')} open={openPanel==='history'} onClick={() => togglePanel('history')} />
                        {openPanel==='history' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            <WorkedHistory shifts={shifts} employeeName={e.name} year={payrollYear} month={payrollMonth} onYearChange={setPayrollYear} onMonthChange={setPayrollMonth} language={language} />
                            {(() => {
                              const monthShiftsForPayroll = shifts.filter(sh => sh.employee === e.name && sh.date.startsWith(`${payrollYear}-${payrollMonth}`));
                              const approvedMinsForPayroll = monthShiftsForPayroll.filter(sh => sh.attendance === 'Worked' && sh.workedFrom && sh.workedTo && sh.attendanceApproved)
                                .reduce((sum, sh) => sum + durationMins(sh.workedFrom, sh.workedTo) + (sh.otFrom && sh.otTo ? durationMins(sh.otFrom, sh.otTo) : 0), 0);
                              const sickMins = monthShiftsForPayroll.filter(sh => sh.attendance === 'Missed' && sh.missedReason === 'Health problem' && sh.payApproved)
                                .reduce((sum, sh) => { const [f, t] = sh.time.split(' – '); return sum + durationMins(f, t); }, 0);
                              return (
                                <>
                                  <div style={{ background:'#e8f5e9', borderRadius:'8px', padding:'10px', marginTop:'10px' }}>
                                    <div style={{ fontSize:'12px', color:'#2e7d32', fontWeight:'600' }}>✔️ {t('tm_approved_hours_month')}: {formatDuration(approvedMinsForPayroll)}</div>
                                    <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t('tm_approved_hours_hint')}</div>
                                  </div>
                                  <div style={{ background:'#f3e5f5', borderRadius:'8px', padding:'10px', marginTop:'10px' }}>
                                    <div style={{ fontSize:'12px', color:'#8e24aa', fontWeight:'600' }}>🤒 {t('tm_sick_covered_month')}: {formatDuration(sickMins)}</div>
                                    <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t('tm_sick_covered_hint')}</div>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        )}

                        <MenuRow icon='📁' label={t('tm_submitted_docs')} badge={hasExpiring ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>●</span> : null} open={openPanel==='docs'} onClick={() => togglePanel('docs')} last />
                        {openPanel==='docs' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            {p.documents.length === 0 && <div style={{ fontSize:'12px', color:'#aaa' }}>{t('tm_no_docs')}</div>}
                            {p.documents.map(d => (
                              <div key={d.id} style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                  <div>
                                    <div style={s.name}>{d.name}</div>
                                    <div style={{ fontSize:'12px', marginTop:'2px', color: isExpiringSoon(d.expiryDate) ? '#b71c1c' : '#888', fontWeight: isExpiringSoon(d.expiryDate) ? '600' : '400' }}>
                                      {isExpiringSoon(d.expiryDate) ? `⚠️ ${t('prof_expires')}` : t('prof_expires')} {d.expiryDate}
                                    </div>
                                    {d.status === 'Rejected' && d.reviewNote && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'4px' }}>📝 {d.reviewNote}</div>}
                                  </div>
                                  <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                                    <span style={getBadgeStyle(d.status === 'Approved' ? 'Confirmed' : d.status)}>{translateStatus(language, d.status)}</span>
                                    {d.status !== 'Approved' && <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => { setReviewingDoc({ name: e.name, docId: d.id, action: 'approve' }); setDocReviewNote(''); }}>✅ {t('tm_approve_btn')}</button>}
                                    {d.status === 'Approved' && <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => unapproveDocument(e.name, d.id)}>↩️ {t('tm_undo_btn')}</button>}
                                    {d.status !== 'Rejected' && <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => { setReviewingDoc({ name: e.name, docId: d.id, action: 'reject' }); setDocReviewNote(''); }}>❌ {t('tm_reject_btn')}</button>}
                                  </div>
                                </div>
                                {reviewingDoc?.docId === d.id && (
                                  <div style={{ marginTop:'10px', paddingTop:'10px', borderTop:'1px solid #eee' }}>
                                    <textarea style={{ ...s.input, minHeight:'50px', resize:'vertical', fontFamily:'inherit' }} placeholder={reviewingDoc.action === 'approve' ? t('tm_note_approve_placeholder') : t('tm_note_reject_placeholder')} value={docReviewNote} onChange={ev => setDocReviewNote(ev.target.value)} />
                                    <div style={{ display:'flex', gap:'8px' }}>
                                      <button style={{ ...(reviewingDoc.action === 'approve' ? s.assignBtn : s.dangerBtn), flex:1, padding:'9px' }} onClick={() => submitDocReview(e.name, d.id, reviewingDoc.action === 'approve' ? 'Approved' : 'Rejected')}>{reviewingDoc.action === 'approve' ? t('tm_confirm_approval') : t('tm_confirm_rejection')}</button>
                                      <button style={{ ...s.outlineBtn, padding:'9px 16px' }} onClick={() => setReviewingDoc(null)}>{t('avail_cancel')}</button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div style={s.sectionHeader}>{t('tm_other')}</div>
                      <div style={s.card}>
                        <MenuRow icon='🚨' label={t('tm_issues')} badge={issues.filter(i=>i.employee===e.name && i.status==='Open').length>0 ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>{issues.filter(i=>i.employee===e.name && i.status==='Open').length} {t('tm_open')}</span> : null} open={openPanel==='empIssues'} onClick={() => togglePanel('empIssues')} />
                        {openPanel==='empIssues' && (
                          <div style={{ padding:'0 16px 16px' }}>
                            {issues.filter(i=>i.employee===e.name).length === 0 && <div style={{ fontSize:'12px', color:'#aaa' }}>{t('tm_no_issues')}</div>}
                            {issues.filter(i=>i.employee===e.name).map(iss => (
                              <div key={iss.id} style={{ background:'#f5f6fa', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                                  <div style={s.name}>{iss.type} · {iss.shift}</div>
                                  <span style={getBadgeStyle(iss.status)}>{translateStatus(language, iss.status)}</span>
                                </div>
                                <div style={{ fontSize:'12px', color:'#666' }}>{iss.description}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        <MenuRow icon='🤒' label={t('tm_sick_certificates')} badge={sickReports.filter(r=>r.employee===e.name && r.status==='Pending').length>0 ? <span style={{ color:'#b71c1c', fontSize:'11px' }}>{sickReports.filter(r=>r.employee===e.name && r.status==='Pending').length} {t('tm_pending')}</span> : null} onClick={() => navigateTo('sick')} last />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
                </>
              );
            })()}
          </div>
        </>}
      </div>

      {tab === 'hiring' && <>
        <div style={s.card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: newHROpen ? '14px' : 0 }}>
            <div>
              <div style={s.cardLabel}>{t('hiring_hr_access_title')}</div>
              <div style={{ fontSize:'11px', color:'#888' }}>{t('hiring_hr_access_hint')}</div>
            </div>
            <button style={s.outlineBtn} onClick={() => setNewHROpen(!newHROpen)}>{newHROpen ? t('avail_cancel') : `+ ${t('hiring_add_hr_btn')}`}</button>
          </div>
          {newHROpen && (
            <div style={{ marginTop:'14px' }}>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_full_name')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} value={newHRName} onChange={e => setNewHRName(e.target.value)} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_email')}</label>
              <input type='email' style={{ ...s.input, marginTop:'6px' }} value={newHREmail} onChange={e => setNewHREmail(e.target.value)} />
              <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={!newHRName.trim() || !newHREmail.trim()} onClick={async () => {
                try {
                  await onAddHRAccount({ name: newHRName.trim(), email: newHREmail.trim() });
                  setNewHRName(''); setNewHREmail(''); setNewHROpen(false); setNewHRError('');
                } catch (err) {
                  setNewHRError(friendlyAccountError(err));
                }
              }}>{t('hiring_create_hr_btn')} →</button>
              {newHRError && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'8px', fontWeight:'600' }}>⚠️ {newHRError}</div>}
            </div>
          )}
        </div>
        <div style={s.card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: newPostingOpen ? '14px' : 0 }}>
            <div style={s.cardLabel}>{t('hiring_postings_title')}</div>
            <button style={s.outlineBtn} onClick={() => setNewPostingOpen(!newPostingOpen)}>{newPostingOpen ? t('avail_cancel') : `+ ${t('hiring_new_posting_btn')}`}</button>
          </div>
          {newPostingOpen && (
            <>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_job_title')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_job_title_placeholder')} value={newPosting.title} onChange={e => setNewPosting({ ...newPosting, title: e.target.value })} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_role')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_role_placeholder')} value={newPosting.role} onChange={e => setNewPosting({ ...newPosting, role: e.target.value })} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_location')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_location_placeholder')} value={newPosting.location} onChange={e => setNewPosting({ ...newPosting, location: e.target.value })} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_description')}</label>
              <textarea style={{ ...s.input, minHeight:'80px', fontFamily:'inherit' }} value={newPosting.description} onChange={e => setNewPosting({ ...newPosting, description: e.target.value })} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_interview_rounds')}</label>
              <input type='number' min='1' max='6' style={{ ...s.input, marginTop:'6px' }} value={newPosting.interviewRounds} onChange={e => setNewPosting({ ...newPosting, interviewRounds: e.target.value })} />
              <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={!newPosting.title.trim()} onClick={() => {
                onAddJobPosting({ title: newPosting.title.trim(), role: newPosting.role.trim(), location: newPosting.location.trim(), description: newPosting.description.trim(), interviewRounds: parseInt(newPosting.interviewRounds) || 1 });
                setNewPosting({ title:'', role:'', location:'', description:'', interviewRounds:'1' });
                setNewPostingOpen(false);
              }}>{t('hiring_publish_btn')} →</button>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'8px' }}>{t('hiring_company_code_hint')}: <strong>{user.companyId}</strong></div>
            </>
          )}
        </div>
        {jobPostings.map(p => (
          <div key={p.id} style={s.card}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div>
                <div style={s.name}>{p.title}</div>
                <div style={s.sub}>{p.role}{p.location ? ` · ${p.location}` : ''} · {p.status}</div>
              </div>
              {p.status === 'Open' ? (
                <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateJobPosting(p.id, { status: 'Closed' })}>{t('hiring_close_btn')}</button>
              ) : (
                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateJobPosting(p.id, { status: 'Open' })}>{t('hiring_reopen_btn')}</button>
              )}
            </div>
            {applicants.filter(a => a.jobPostingId === p.id).length > 0 && (
              <div style={{ marginTop:'14px', paddingTop:'14px', borderTop:'1px solid #f0f0f0' }}>
                {['Applied','Interview','Hired','Rejected'].map(stage => {
                  const stageApplicants = applicants.filter(a => a.jobPostingId === p.id && a.stage === stage);
                  if (stageApplicants.length === 0) return null;
                  return (
                    <div key={stage} style={{ marginBottom:'12px' }}>
                      <div style={{ fontSize:'11px', color:'#888', fontWeight:'700', textTransform:'uppercase', marginBottom:'6px' }}>{t(`hiring_stage_${stage.toLowerCase()}`)} ({stageApplicants.length})</div>
                      {stageApplicants.map(a => (
                        <div key={a.id} style={{ ...s.row, padding:'10px 0' }}>
                          <div>
                            <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
                            <div style={{ fontSize:'11px', color:'#888' }}>{a.email}{a.phone ? ` · ${a.phone}` : ''}</div>
                            {a.note && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontStyle:'italic' }}>"{a.note}"</div>}
                          </div>
                          {stage === 'Applied' && (
                            <div style={{ display:'flex', gap:'6px' }}>
                              <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Interview' })}>{t('hiring_move_interview')}</button>
                              <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Rejected' })}>✕</button>
                            </div>
                          )}
                          {stage === 'Interview' && (
                            <div style={{ display:'flex', gap:'6px' }}>
                              <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onHireApplicant(a)}>✅ {t('hiring_hire_btn')}</button>
                              <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Rejected' })}>✕</button>
                            </div>
                          )}
                          {stage === 'Hired' && <span style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'700' }}>✅ {t('hiring_hired_label')}</span>}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </>}

      <div style={s.nav}>
        {tabs.map(([id,icon,label]) => (
          <button key={id} style={s.navBtn(tab===id)} onClick={() => navigateTo(id)}>
            <span style={{ fontSize:'16px' }}>{icon}</span>
            <span style={s.navLbl(tab===id)}>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────
// Branded splash screen shown briefly on app launch (esp. when opened from home screen as a PWA)
// ─── HIRING PORTAL ───────────────────────────────────────────────
// A genuinely separate portal, its own login (role === 'hr'), used by whoever at a
// company handles recruiting — often not the same person as the branch manager.
// Deliberately limited to just job postings and the applicant pipeline; no shift,
// payroll, or scheduling access. Hiring converts an applicant into a real employee
// using the exact same mechanism as adding one manually.
// ─── HQ PORTAL ───────────────────────────────────────────────────
// A genuine third tier, for companies with multiple branches. Sees the whole
// company at once — every branch, every employee, unfiltered — and can stand up
// new branch managers or HR accounts. Deliberately optional: small, single-branch
// companies never need this tier at all, and nothing here touches how the
// Admin/Branch Manager or Employee portals already work.
// Shared job posting card — used by both AdminApp's embedded Hiring tab and the
// standalone HiringPortal, so the tabbed interview pipeline logic exists in exactly
// one place. Each posting defines its own number of interview rounds; tabs are
// generated dynamically from that, plus Applied, Hold, Hired, and Rejected.
function JobPostingCard({ posting, applicants, onUpdatePosting, onUpdateApplicant, onHire, t }) {
  const [activeTab, setActiveTab] = useState('Applied');
  const rounds = posting.interviewRounds || 1;
  const stageList = ['Applied', ...Array.from({ length: rounds }, (_, i) => `Interview${i+1}`), 'Hold', 'Hired', 'Rejected'];
  const stageLabel = (stage) => {
    if (stage.startsWith('Interview')) return `${t('hiring_round')} ${stage.replace('Interview', '')}`;
    return t(`hiring_stage_${stage.toLowerCase()}`);
  };
  const countFor = (stage) => applicants.filter(a => a.jobPostingId === posting.id && a.stage === stage).length;
  const visible = applicants.filter(a => a.jobPostingId === posting.id && a.stage === activeTab);
  const isLastRound = (stage) => stage === `Interview${rounds}`;

  return (
    <div style={s.card}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div style={s.name}>{posting.title}</div>
          <div style={s.sub}>{posting.role}{posting.location ? ` · ${posting.location}` : ''} · {posting.status}</div>
        </div>
        {posting.status === 'Open' ? (
          <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdatePosting(posting.id, { status: 'Closed' })}>{t('hiring_close_btn')}</button>
        ) : (
          <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdatePosting(posting.id, { status: 'Open' })}>{t('hiring_reopen_btn')}</button>
        )}
      </div>
      <div style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'14px', paddingTop:'14px', borderTop:'1px solid #f0f0f0' }}>
        {stageList.map(stage => (
          <button key={stage} style={s.tabBtn(activeTab === stage)} onClick={() => setActiveTab(stage)}>{stageLabel(stage)} ({countFor(stage)})</button>
        ))}
      </div>
      <div style={{ marginTop:'12px' }}>
        {visible.length === 0 ? (
          <div style={{ fontSize:'12px', color:'#aaa', padding:'10px 0' }}>{t('hiring_none_in_stage')}</div>
        ) : visible.map(a => (
          <div key={a.id} style={{ ...s.row, padding:'10px 0' }}>
            <div>
              <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
              <div style={{ fontSize:'11px', color:'#888' }}>{a.email}{a.phone ? ` · ${a.phone}` : ''}</div>
              {a.note && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontStyle:'italic' }}>"{a.note}"</div>}
            </div>
            <div style={{ display:'flex', gap:'6px', flexWrap:'wrap', justifyContent:'flex-end' }}>
              {activeTab === 'Applied' && (
                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Interview1' })}>{t('hiring_move_interview')}</button>
              )}
              {activeTab.startsWith('Interview') && !isLastRound(activeTab) && (
                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: `Interview${parseInt(activeTab.replace('Interview',''))+1}` })}>{t('hiring_advance_round')}</button>
              )}
              {activeTab.startsWith('Interview') && isLastRound(activeTab) && (
                <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onHire(a)}>✅ {t('hiring_hire_btn')}</button>
              )}
              {activeTab === 'Hold' ? (
                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: a.previousStage || 'Applied' })}>{t('hiring_resume_btn')}</button>
              ) : activeTab !== 'Hired' && activeTab !== 'Rejected' && (
                <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Hold', previousStage: activeTab })}>⏸ {t('hiring_hold_btn')}</button>
              )}
              {activeTab !== 'Hired' && activeTab !== 'Rejected' && (
                <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Rejected' })}>✕</button>
              )}
              {activeTab === 'Hired' && <span style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'700' }}>✅ {t('hiring_hired_label')}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function HQPortal({ user, employeeRecords, shifts, onAddBranchManager, onAddHRAccount, hqPayrollSubmissions, hqTeamMembers, onToggleTeamMemberStatus, language, setLanguage, onLogout }) {
  const t = (key) => translate(language, key);
  const [newBMOpen, setNewBMOpen] = useState(false);
  const [expandedBranch, setExpandedBranch] = useState(null);
  const [branchSearch, setBranchSearch] = useState('');
  const [employeeSearchInBranch, setEmployeeSearchInBranch] = useState('');
  const [employeeDropdownBranch, setEmployeeDropdownBranch] = useState(null);
  const [newBMName, setNewBMName] = useState('');
  const [newBMEmail, setNewBMEmail] = useState('');
  const [newBMBranch, setNewBMBranch] = useState('');
  const [newBMError, setNewBMError] = useState('');
  const [newHROpen, setNewHROpen] = useState(false);
  const [newHRName, setNewHRName] = useState('');
  const [newHREmail, setNewHREmail] = useState('');
  const [newHRError, setNewHRError] = useState('');
  const [hqTeamSearch, setHqTeamSearch] = useState('');

  function exportHQSubmissionCSV(sub) {
    const header = 'Branch;Name;Email;Pay Type;Rate or Gross Salary;Regular Hours;Sick Hours;Gross Payable\n';
    const lines = sub.rows.map(r => {
      const payTypeLabel = r.payType === 'gross' ? 'Gross Salary' : 'Hourly';
      const rateOrGross = r.payType === 'gross' ? (r.grossSalary ?? '') : (r.hourlyRate ?? '');
      return `${sub.branchId};${r.name};${r.email};${payTypeLabel};${rateOrGross};${r.regularHours};${r.sickHours};${r.gross !== null ? r.gross.toFixed(2) : ''}`;
    }).join('\n');
    const csv = 'sep=;\n' + header + lines + '\n';
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `karmadal_hq_payroll_${sub.branchId}_${sub.year}-${sub.month}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  function exportHQSubmissionXLSX(sub) {
    const data = sub.rows.map(r => ({
      'Branch': sub.branchId, 'Name': r.name, 'Email': r.email,
      'Pay Type': r.payType === 'gross' ? 'Gross Salary' : 'Hourly',
      'Rate or Gross Salary': r.payType === 'gross' ? (r.grossSalary ?? '') : (r.hourlyRate ?? ''),
      'Regular Hours': r.regularHours, 'Sick Hours': r.sickHours,
      'Gross Payable': r.gross !== null ? Number(r.gross.toFixed(2)) : '',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [{ wch: 16 }, { wch: 20 }, { wch: 26 }, { wch: 14 }, { wch: 18 }, { wch: 14 }, { wch: 12 }, { wch: 14 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payroll');
    XLSX.writeFile(wb, `karmadal_hq_payroll_${sub.branchId}_${sub.year}-${sub.month}.xlsx`);
  }

  const branchIds = [...new Set(Object.values(employeeRecords).map(r => r.branchId).filter(Boolean))];
  const totalEmployees = Object.keys(employeeRecords).length;
  const totalUpcoming = shifts.filter(sh => isUpcoming(sh.date)).length;

  return (
    <div style={s.app}>
      <div style={s.topbarAdmin}>
        <div>
          <div style={s.topbarTitle}>{t('hq_title')}</div>
          <div style={s.topbarSub}>{user.companyName || 'KarmaDal'}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <button style={{ ...s.logoutBtn, fontSize:'11px', padding:'5px 10px' }} onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>🌐 {language.toUpperCase()}</button>
          <button style={s.logoutBtn} onClick={onLogout}>{t('logout')}</button>
        </div>
      </div>
      <div style={s.content}>
        <div style={s.card}>
          <div style={s.cardLabel}>{t('hq_company_overview')}</div>
          <div style={s.statRow}>
            <div style={s.stat}><div style={s.statNum}>{branchIds.length}</div><div style={s.statLbl}>{t('hq_branches')}</div></div>
            <div style={s.stat}><div style={s.statNum}>{totalEmployees}</div><div style={s.statLbl}>{t('adm_employees')}</div></div>
            <div style={s.stat}><div style={s.statNum}>{totalUpcoming}</div><div style={s.statLbl}>{t('adm_upcoming_shifts')}</div></div>
          </div>
        </div>

        <div style={s.card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: newBMOpen ? '14px' : 0 }}>
            <div style={s.cardLabel}>{t('hq_branches_title')}</div>
            <button style={s.outlineBtn} onClick={() => setNewBMOpen(!newBMOpen)}>{newBMOpen ? t('avail_cancel') : `+ ${t('hq_add_bm_btn')}`}</button>
          </div>
          {newBMOpen && (
            <>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_full_name')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} value={newBMName} onChange={e => setNewBMName(e.target.value)} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_email')}</label>
              <input type='email' style={{ ...s.input, marginTop:'6px' }} value={newBMEmail} onChange={e => setNewBMEmail(e.target.value)} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hq_branch_id')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hq_branch_id_placeholder')} value={newBMBranch} onChange={e => setNewBMBranch(e.target.value)} />
              <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={!newBMName.trim() || !newBMEmail.trim() || !newBMBranch.trim()} onClick={async () => {
                try {
                  await onAddBranchManager({ name: newBMName.trim(), email: newBMEmail.trim(), branchId: newBMBranch.trim() });
                  setNewBMName(''); setNewBMEmail(''); setNewBMBranch(''); setNewBMOpen(false); setNewBMError('');
                } catch (err) {
                  setNewBMError(friendlyAccountError(err));
                }
              }}>{t('hq_create_bm_btn')} →</button>
              {newBMError && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'8px', fontWeight:'600' }}>⚠️ {newBMError}</div>}
            </>
          )}
          {branchIds.length > 0 && (
            <div style={{ marginTop:'14px', paddingTop:'14px', borderTop:'1px solid #f0f0f0' }}>
              <input style={{ ...s.input, marginBottom:'12px' }} placeholder={t('hq_search_branches')} value={branchSearch} onChange={e => setBranchSearch(e.target.value)} />
              {branchIds.filter(bid => bid.toLowerCase().includes(branchSearch.toLowerCase())).length === 0 ? (
                <div style={{ fontSize:'12px', color:'#aaa', textAlign:'center', padding:'12px 0' }}>{t('tm_no_matches')}</div>
              ) : branchIds.filter(bid => bid.toLowerCase().includes(branchSearch.toLowerCase())).map(bid => {
                const branchEmployees = Object.keys(employeeRecords).filter(name => employeeRecords[name].branchId === bid);
                const isOpen = expandedBranch === bid;
                const visibleEmployees = branchEmployees.filter(name => name.toLowerCase().includes(employeeSearchInBranch.toLowerCase()));
                return (
                  <div key={bid}>
                    <div style={{ ...s.row, cursor:'pointer' }} onClick={() => { setExpandedBranch(isOpen ? null : bid); setEmployeeSearchInBranch(''); setEmployeeDropdownBranch(null); }}>
                      <div><div style={s.name}>{bid}</div><div style={s.sub}>{branchEmployees.length} {t('hq_employees_in_branch')}</div></div>
                      <span style={{ fontSize:'12px', color:'#888' }}>{isOpen ? '▲' : '▼'}</span>
                    </div>
                    {isOpen && (
                      <div style={{ background:'#f9f9fb', borderRadius:'8px', padding:'10px 14px', marginBottom:'8px', position:'relative' }}>
                        <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', marginBottom:'8px' }}>
                          📅 {shifts.filter(sh => branchEmployees.includes(sh.employee) && isUpcoming(sh.date)).length} {t('hq_upcoming_in_branch')}
                        </div>
                        <input style={{ ...s.input, fontSize:'12px', padding:'8px 10px' }} placeholder={`🔍 ${t('hq_search_employees')} (${branchEmployees.length})`} value={employeeSearchInBranch} onFocus={() => setEmployeeDropdownBranch(bid)} onChange={e => setEmployeeSearchInBranch(e.target.value)} />
                        {employeeDropdownBranch === bid && (
                          <div className="kd-scroll" style={{ position:'absolute', top:'62px', left:'14px', right:'14px', background:'white', border:'1px solid #eee', borderRadius:'8px', boxShadow:'0 4px 16px rgba(0,0,0,0.10)', zIndex:10, maxHeight:'220px', overflowY:'auto', paddingRight:'8px' }}>
                            <style>{`
                              .kd-scroll::-webkit-scrollbar { width: 6px; }
                              .kd-scroll::-webkit-scrollbar-track { background: transparent; }
                              .kd-scroll::-webkit-scrollbar-thumb { background: var(--brand); border-radius: 8px; }
                              .kd-scroll { scrollbar-width: thin; scrollbar-color: var(--brand) transparent; }
                            `}</style>
                            {branchEmployees.length === 0 ? (
                              <div style={{ padding:'12px 14px', fontSize:'12px', color:'#aaa' }}>{t('hq_no_employees_yet')}</div>
                            ) : visibleEmployees.length === 0 ? (
                              <div style={{ padding:'12px 14px', fontSize:'12px', color:'#aaa' }}>{t('tm_no_matches')}</div>
                            ) : visibleEmployees.map((name, i) => (
                              <div key={name} style={{ padding:'10px 14px', borderBottom: i === visibleEmployees.length - 1 ? 'none' : '1px solid #f5f5f5', fontSize:'13px', color:'#2d2d2d' }}>
                                {name} <span style={{ color:'#aaa', fontSize:'11px' }}>({employeeRecords[name].email})</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div style={s.card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: newHROpen ? '14px' : 0 }}>
            <div style={s.cardLabel}>{t('hiring_hr_access_title')}</div>
            <button style={s.outlineBtn} onClick={() => setNewHROpen(!newHROpen)}>{newHROpen ? t('avail_cancel') : `+ ${t('hiring_add_hr_btn')}`}</button>
          </div>
          {newHROpen && (
            <>
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_full_name')}</label>
              <input style={{ ...s.input, marginTop:'6px' }} value={newHRName} onChange={e => setNewHRName(e.target.value)} />
              <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('tm_email')}</label>
              <input type='email' style={{ ...s.input, marginTop:'6px' }} value={newHREmail} onChange={e => setNewHREmail(e.target.value)} />
              <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={!newHRName.trim() || !newHREmail.trim()} onClick={async () => {
                try {
                  await onAddHRAccount({ name: newHRName.trim(), email: newHREmail.trim() });
                  setNewHRName(''); setNewHREmail(''); setNewHROpen(false); setNewHRError('');
                } catch (err) {
                  setNewHRError(friendlyAccountError(err));
                }
              }}>{t('hiring_create_hr_btn')} →</button>
              {newHRError && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'8px', fontWeight:'600' }}>⚠️ {newHRError}</div>}
            </>
          )}
        </div>

        <div style={s.card}>
          <div style={s.cardLabel}>{t('hq_team_title')} ({hqTeamMembers.length})</div>
          <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('hq_team_hint')}</div>
          {hqTeamMembers.length === 0 ? (
            <div style={s.emptyBox}>{t('hq_team_none')}</div>
          ) : (
            <>
              <input style={{ ...s.input, marginBottom:'10px' }} placeholder={`🔍 ${t('hq_search_team')}`} value={hqTeamSearch} onChange={e => setHqTeamSearch(e.target.value)} />
              {hqTeamMembers.filter(m => m.name.toLowerCase().includes(hqTeamSearch.toLowerCase()) || m.email.toLowerCase().includes(hqTeamSearch.toLowerCase())).map((m, i, arr) => {
                const isDeactivated = m.status === 'deactivated';
                return (
                  <div key={m.id} style={{ ...(i === arr.length - 1 ? s.rowLast : s.row), opacity: isDeactivated ? 0.55 : 1, alignItems:'center' }}>
                    <div>
                      <div style={s.name}>{m.name}</div>
                      <div style={s.sub}>{m.email}</div>
                      <div style={{ marginTop:'4px' }}>
                        <span style={{ fontSize:'11px', padding:'4px 10px', borderRadius:'12px', background: m.role === 'hr' ? '#e3f2fd' : '#fff3e0', color: m.role === 'hr' ? '#0d47a1' : '#e65100', fontWeight:'700' }}>
                          {m.role === 'hr' ? t('hq_role_hr') : `${t('hq_role_bm')}${m.branchId ? ` · ${m.branchId}` : ''}`}
                        </span>
                      </div>
                      {isDeactivated && <div style={{ fontSize:'11px', color:'#b71c1c', fontWeight:'700', marginTop:'4px' }}>🚫 {t('hq_deactivated_label')}</div>}
                    </div>
                    <button style={isDeactivated ? { ...s.assignBtn, fontSize:'11px', padding:'6px 12px' } : { ...s.dangerBtn, fontSize:'11px', padding:'6px 12px' }}
                      onClick={() => { if (window.confirm(isDeactivated ? t('hq_reactivate_confirm').replace('{name}', m.name) : t('hq_deactivate_confirm').replace('{name}', m.name))) onToggleTeamMemberStatus(m.id, !isDeactivated); }}>
                      {isDeactivated ? `✅ ${t('hq_reactivate_btn')}` : `🚫 ${t('hq_deactivate_btn')}`}
                    </button>
                  </div>
                );
              })}
            </>
          )}
        </div>

        {hqPayrollSubmissions.length > 0 && (
          <div style={s.card}>
            <div style={s.cardLabel}>{t('hq_payroll_title')}</div>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('hq_payroll_hint')}</div>
            {[...new Set(hqPayrollSubmissions.map(sub => `${sub.year}-${sub.month}`))].sort().reverse().map(monthKey => {
              const monthSubs = hqPayrollSubmissions.filter(sub => `${sub.year}-${sub.month}` === monthKey);
              const monthTotal = monthSubs.reduce((sum, sub) => sum + sub.rows.reduce((s2, r) => s2 + (r.gross || 0), 0), 0);
              return (
                <div key={monthKey} style={{ marginBottom:'16px' }}>
                  <div style={{ fontSize:'13px', fontWeight:'700', color:'#2d2d2d', marginBottom:'8px' }}>{monthKey} — {t('hq_total_gross')}: €{monthTotal.toFixed(2)}</div>
                  {monthSubs.map(sub => (
                    <div key={sub.id} style={{ ...s.row, alignItems:'flex-start' }}>
                      <div>
                        <div style={s.name}>{sub.branchId}</div>
                        <div style={s.sub}>{sub.rows.length} {t('hq_employees_in_branch')} · {t('hq_submitted_by')} {sub.submittedBy}</div>
                        <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                          <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => exportHQSubmissionCSV(sub)}>⬇ CSV</button>
                          <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => exportHQSubmissionXLSX(sub)}>⬇ Excel</button>
                        </div>
                      </div>
                      <div style={{ fontSize:'13px', fontWeight:'700', color:'#2e7d32' }}>€{sub.rows.reduce((s2, r) => s2 + (r.gross || 0), 0).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

function HiringPortal({ user, jobPostings, applicants, onAddJobPosting, onUpdateJobPosting, onUpdateApplicant, onHireApplicant, issues, onUpdateIssue, onIssueReply, language, setLanguage, onLogout }) {
  const t = (key) => translate(language, key);
  const [hTab, setHTab] = useState('postings');
  const [postingsSubTab, setPostingsSubTab] = useState('open');
  const [interviewSubView, setInterviewSubView] = useState(null); // { jobId, roundIndex } | 'rejected' | 'hired' | null
  const [newPostingOpen, setNewPostingOpen] = useState(false);
  const [newPosting, setNewPosting] = useState({ title:'', role:'', location:'', description:'', roundNames: ['Round 1'] });
  const [selectedApplicantIds, setSelectedApplicantIds] = useState([]);
  const [complaintReplyText, setComplaintReplyText] = useState({});
  const [bulkMessage, setBulkMessage] = useState('');
  const [bulkMessageOpen, setBulkMessageOpen] = useState(false);

  const postingById = (id) => jobPostings.find(p => p.id === id) || {};
  const appliedList = applicants.filter(a => a.stage === 'Applied');
  const interviewList = applicants.filter(a => a.stage === 'Interview');
  const hiredList = applicants.filter(a => a.stage === 'Hired');
  const rejectedList = applicants.filter(a => a.stage === 'Rejected');
  const openPostings = jobPostings.filter(p => p.status === 'Open');
  const closedPostings = jobPostings.filter(p => p.status === 'Closed');

  function moveToInterview(a) {
    onUpdateApplicant(a.id, { stage: 'Interview', interviewRound: 1 });
  }
  function advanceRound(a) {
    const posting = postingById(a.jobPostingId);
    const roundNames = posting.roundNames || ['Round 1'];
    const current = a.interviewRound || 1;
    if (current >= roundNames.length) {
      onHireApplicant(a);
    } else {
      onUpdateApplicant(a.id, { interviewRound: current + 1 });
    }
  }
  function toggleSelected(id) {
    setSelectedApplicantIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }
  function sendBulkMessages() {
    selectedApplicantIds.forEach((id, i) => {
      const a = appliedList.find(x => x.id === id);
      if (!a) return;
      const personalized = `Dear ${a.name},\n\n${bulkMessage}`;
      setTimeout(() => {
        window.open(`mailto:${a.email}?subject=${encodeURIComponent(t('hiring_mail_subject').replace('{job}', postingById(a.jobPostingId).title))}&body=${encodeURIComponent(personalized)}`, '_blank');
      }, i * 400);
    });
    setBulkMessageOpen(false); setBulkMessage(''); setSelectedApplicantIds([]);
  }

  const escalatedIssues = issues.filter(iss => iss.escalatedToHR);

  const HTABS = [
    ['postings', '📋', t('hiring_tab_postings')],
    ['applied', '📥', t('hiring_tab_applied'), appliedList.length],
    ['interview', '🗣️', t('hiring_tab_interview'), interviewList.length],
    ['complaints', '⚠️', t('hiring_tab_complaints'), escalatedIssues.filter(iss => iss.status === 'Open').length],
  ];

  return (
    <div style={s.app}>
      <div style={s.topbarAdmin}>
        <div>
          <div style={s.topbarTitle}>{t('nav_hiring')}</div>
          <div style={s.topbarSub}>{user.companyName || 'KarmaDal'}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <button style={{ ...s.logoutBtn, fontSize:'11px', padding:'5px 10px' }} onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>🌐 {language.toUpperCase()}</button>
          <button style={s.logoutBtn} onClick={onLogout}>{t('logout')}</button>
        </div>
      </div>
      <div style={{ display:'flex', gap:'6px', padding:'12px 16px 0', overflowX:'auto' }}>
        {HTABS.map(([id, icon, label, count]) => (
          <button key={id} onClick={() => { setHTab(id); setInterviewSubView(null); }} style={{
            padding:'9px 14px', borderRadius:'20px', border:'none', whiteSpace:'nowrap',
            background: hTab === id ? 'var(--brand)' : '#f0f0f0', color: hTab === id ? 'white' : '#555',
            fontSize:'13px', fontWeight:'600', cursor:'pointer',
          }}>{icon} {label}{count > 0 ? ` (${count})` : ''}</button>
        ))}
      </div>
      <div style={s.content}>

        {hTab === 'postings' && (
          <>
            <div style={s.card}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: newPostingOpen ? '14px' : 0 }}>
                <div style={s.cardLabel}>{t('hiring_new_posting_btn')}</div>
                <button style={s.outlineBtn} onClick={() => setNewPostingOpen(!newPostingOpen)}>{newPostingOpen ? t('avail_cancel') : `+ ${t('hiring_new_posting_btn')}`}</button>
              </div>
              {newPostingOpen && (
                <>
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_job_title')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_job_title_placeholder')} value={newPosting.title} onChange={e => setNewPosting({ ...newPosting, title: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('shift_tpl_role')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_role_placeholder')} value={newPosting.role} onChange={e => setNewPosting({ ...newPosting, role: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_location')}</label>
                  <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('hiring_location_placeholder')} value={newPosting.location} onChange={e => setNewPosting({ ...newPosting, location: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_description')}</label>
                  <textarea style={{ ...s.input, minHeight:'80px', fontFamily:'inherit' }} value={newPosting.description} onChange={e => setNewPosting({ ...newPosting, description: e.target.value })} />
                  <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('hiring_round_names_label')}</label>
                  <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>{t('hiring_round_names_hint')}</div>
                  {newPosting.roundNames.map((rn, idx) => (
                    <div key={idx} style={{ display:'flex', gap:'6px', marginBottom:'6px' }}>
                      <input style={{ ...s.input, flex:1 }} placeholder={`${t('hiring_round_label')} ${idx + 1}`} value={rn} onChange={e => {
                        const updated = [...newPosting.roundNames]; updated[idx] = e.target.value;
                        setNewPosting({ ...newPosting, roundNames: updated });
                      }} />
                      {newPosting.roundNames.length > 1 && (
                        <button style={{ ...s.dangerBtn, padding:'0 12px' }} onClick={() => {
                          setNewPosting({ ...newPosting, roundNames: newPosting.roundNames.filter((_, i) => i !== idx) });
                        }}>✕</button>
                      )}
                    </div>
                  ))}
                  <button style={{ ...s.outlineBtn, marginBottom:'14px' }} onClick={() => setNewPosting({ ...newPosting, roundNames: [...newPosting.roundNames, `Round ${newPosting.roundNames.length + 1}`] })}>+ {t('hiring_add_round_btn')}</button>
                  <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={!newPosting.title.trim()} onClick={() => {
                    onAddJobPosting({ title: newPosting.title.trim(), role: newPosting.role.trim(), location: newPosting.location.trim(), description: newPosting.description.trim(), roundNames: newPosting.roundNames.filter(r => r.trim()) });
                    setNewPosting({ title:'', role:'', location:'', description:'', roundNames: ['Round 1'] });
                    setNewPostingOpen(false);
                  }}>{t('hiring_publish_btn')} →</button>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'8px' }}>{t('hiring_company_code_hint')}: <strong>{user.companyId}</strong></div>
                </>
              )}
            </div>
            <div style={s.tabRow}>
              <button style={s.tabBtn(postingsSubTab==='open')} onClick={()=>setPostingsSubTab('open')}>{t('hiring_open_postings')} ({openPostings.length})</button>
              <button style={s.tabBtn(postingsSubTab==='closed')} onClick={()=>setPostingsSubTab('closed')}>{t('hiring_closed_postings')} ({closedPostings.length})</button>
            </div>
            {(postingsSubTab === 'open' ? openPostings : closedPostings).map(p => (
              <div key={p.id} style={s.card}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={s.name}>{p.title}</div>
                    <div style={s.sub}>{p.role}{p.location ? ` · ${p.location}` : ''} · {(p.roundNames || ['Round 1']).length} {t('hiring_rounds_label')}: {(p.roundNames || ['Round 1']).join(', ')}</div>
                  </div>
                  {p.status === 'Open' ? (
                    <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateJobPosting(p.id, { status: 'Closed' })}>{t('hiring_close_btn')}</button>
                  ) : (
                    <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateJobPosting(p.id, { status: 'Open' })}>{t('hiring_reopen_btn')}</button>
                  )}
                </div>
              </div>
            ))}
            {(postingsSubTab === 'open' ? openPostings : closedPostings).length === 0 && <div style={s.emptyBox}>{t('hiring_no_postings')}</div>}
          </>
        )}

        {hTab === 'applied' && (
          <>
            {selectedApplicantIds.length > 0 && (
              <div style={{ ...s.card, background:'var(--brand-light)' }}>
                <div style={{ fontSize:'13px', fontWeight:'700', marginBottom:'10px' }}>{selectedApplicantIds.length} {t('hiring_selected_label')}</div>
                {!bulkMessageOpen ? (
                  <button style={{ ...s.primaryBtn, marginTop:0 }} onClick={() => setBulkMessageOpen(true)}>✉️ {t('hiring_send_message_btn')}</button>
                ) : (
                  <>
                    <textarea style={{ ...s.input, minHeight:'90px', fontFamily:'inherit' }} placeholder={t('hiring_message_placeholder')} value={bulkMessage} onChange={e => setBulkMessage(e.target.value)} />
                    <div style={{ fontSize:'11px', color:'#888', margin:'6px 0 10px' }}>{t('hiring_message_hint')}</div>
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button style={{ ...s.primaryBtn, marginTop:0, flex:1 }} disabled={!bulkMessage.trim()} onClick={sendBulkMessages}>{t('hiring_send_now_btn')}</button>
                      <button style={{ ...s.outlineBtn }} onClick={() => setBulkMessageOpen(false)}>{t('avail_cancel')}</button>
                    </div>
                  </>
                )}
              </div>
            )}
            <div style={s.card}>
              <div style={s.cardLabel}>{t('hiring_tab_applied')}</div>
              {appliedList.length === 0 ? <div style={s.emptyBox}>{t('hiring_no_applicants')}</div> : appliedList.map(a => (
                <div key={a.id} style={s.row}>
                  <div style={{ display:'flex', alignItems:'flex-start', gap:'10px' }}>
                    <input type='checkbox' checked={selectedApplicantIds.includes(a.id)} onChange={() => toggleSelected(a.id)} style={{ marginTop:'4px' }} />
                    <div>
                      <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
                      <div style={{ fontSize:'11px', color:'#888' }}>{a.email}{a.phone ? ` · ${a.phone}` : ''} · {postingById(a.jobPostingId).title}</div>
                      {a.note && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontStyle:'italic' }}>"{a.note}"</div>}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'6px' }}>
                    <button style={{ ...s.outlineBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => moveToInterview(a)}>{t('hiring_move_interview')}</button>
                    <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Rejected' })}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {hTab === 'interview' && (
          <>
            {!interviewSubView && (
              <>
                {jobPostings.filter(p => interviewList.some(a => a.jobPostingId === p.id)).map(p => {
                  const roundNames = p.roundNames || ['Round 1'];
                  return (
                    <div key={p.id} style={s.card}>
                      <div style={s.cardLabel}>{p.title}</div>
                      {roundNames.map((rn, idx) => {
                        const count = interviewList.filter(a => a.jobPostingId === p.id && (a.interviewRound || 1) === idx + 1).length;
                        if (count === 0) return null;
                        return (
                          <div key={idx} style={{ ...s.row, cursor:'pointer' }} onClick={() => setInterviewSubView({ jobId: p.id, roundIndex: idx })}>
                            <div style={{ fontSize:'13px', fontWeight:'600' }}>{rn}</div>
                            <span style={{ fontSize:'12px', color:'#888' }}>{count} →</span>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
                {interviewList.length === 0 && <div style={s.emptyBox}>{t('hiring_no_applicants')}</div>}
                <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                  <button style={{ ...s.outlineBtn, flex:1 }} onClick={() => setInterviewSubView('hired')}>✅ {t('hiring_tab_hired')} ({hiredList.length})</button>
                  <button style={{ ...s.outlineBtn, flex:1 }} onClick={() => setInterviewSubView('rejected')}>✕ {t('hiring_tab_rejected')} ({rejectedList.length})</button>
                </div>
              </>
            )}

            {interviewSubView && interviewSubView !== 'hired' && interviewSubView !== 'rejected' && (() => {
              const posting = postingById(interviewSubView.jobId);
              const roundNames = posting.roundNames || ['Round 1'];
              const roundIdx = interviewSubView.roundIndex;
              const roundApplicants = interviewList.filter(a => a.jobPostingId === posting.id && (a.interviewRound || 1) === roundIdx + 1);
              const isFinal = roundIdx >= roundNames.length - 1;
              return (
                <div style={s.card}>
                  <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setInterviewSubView(null)}>← {t('avail_cancel')}</span>
                  <div style={{ ...s.cardLabel, marginTop:'10px' }}>{posting.title} — {roundNames[roundIdx]}</div>
                  {roundApplicants.map(a => (
                    <div key={a.id} style={s.row}>
                      <div>
                        <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
                        <div style={{ fontSize:'11px', color:'#888' }}>{a.email}</div>
                      </div>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <button style={{ ...s.assignBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => advanceRound(a)}>
                          {isFinal ? `✅ ${t('hiring_hire_btn')}` : `→ ${t('hiring_next_round_btn')}`}
                        </button>
                        <button style={{ ...s.dangerBtn, fontSize:'11px', padding:'4px 10px' }} onClick={() => onUpdateApplicant(a.id, { stage: 'Rejected' })}>✕</button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {interviewSubView === 'hired' && (
              <div style={s.card}>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setInterviewSubView(null)}>← {t('avail_cancel')}</span>
                <div style={{ ...s.cardLabel, marginTop:'10px' }}>{t('hiring_tab_hired')}</div>
                {hiredList.length === 0 ? <div style={s.emptyBox}>{t('hiring_no_applicants')}</div> : hiredList.map(a => (
                  <div key={a.id} style={s.row}>
                    <div>
                      <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
                      <div style={{ fontSize:'11px', color:'#888' }}>{a.email} · {postingById(a.jobPostingId).title}</div>
                    </div>
                    <span style={{ fontSize:'11px', color:'#2e7d32', fontWeight:'700' }}>✅</span>
                  </div>
                ))}
              </div>
            )}

            {interviewSubView === 'rejected' && (
              <div style={s.card}>
                <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setInterviewSubView(null)}>← {t('avail_cancel')}</span>
                <div style={{ ...s.cardLabel, marginTop:'10px' }}>{t('hiring_tab_rejected')}</div>
                {rejectedList.length === 0 ? <div style={s.emptyBox}>{t('hiring_no_applicants')}</div> : rejectedList.map(a => (
                  <div key={a.id} style={s.row}>
                    <div>
                      <div style={{ fontSize:'13px', fontWeight:'600' }}>{a.name}</div>
                      <div style={{ fontSize:'11px', color:'#888' }}>{a.email} · {postingById(a.jobPostingId).title}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {hTab === 'complaints' && (
          <div style={s.card}>
            <div style={s.cardLabel}>{t('hiring_tab_complaints')}</div>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('hiring_complaints_hint')}</div>
            {escalatedIssues.length === 0 ? <div style={s.emptyBox}>{t('hiring_no_complaints')}</div> : escalatedIssues.map(iss => (
              <div key={iss.id} style={{ background:'#fff3e0', borderRadius:'10px', padding:'14px', marginBottom:'12px' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'8px' }}>
                  <div>
                    <div style={{ fontSize:'13px', fontWeight:'700' }}>{iss.employee} · {iss.shift}</div>
                    <div style={{ fontSize:'11px', color:'#888' }}>{iss.type}</div>
                  </div>
                  <span style={getBadgeStyle(iss.status)}>{translateStatus(language, iss.status)}</span>
                </div>
                <div style={{ fontSize:'13px', color:'#555', marginBottom:'10px' }}>{iss.description}</div>
                {iss.replies?.map((r, ri) => (
                  <div key={ri} style={{ background:'white', borderRadius:'8px', padding:'10px', marginBottom:'8px' }}>
                    <div style={{ fontSize:'11px', fontWeight:'600', color:'#2d2d2d', marginBottom:'2px' }}>{r.from === 'admin' ? `⚙️ ${t('iss_manager')}` : r.fromName}</div>
                    {r.text && <div style={{ fontSize:'13px', color:'#555' }}>{r.text}</div>}
                  </div>
                ))}
                <textarea style={{ ...s.input, minHeight:'60px', fontFamily:'inherit' }} placeholder={t('iss_reply_placeholder')} value={complaintReplyText[iss.id] || ''} onChange={e => setComplaintReplyText({ ...complaintReplyText, [iss.id]: e.target.value })} />
                <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                  <button style={{ ...s.assignBtn, flex:1, padding:'9px' }} disabled={!complaintReplyText[iss.id]} onClick={() => {
                    onIssueReply(iss.id, { from:'admin', text: complaintReplyText[iss.id], fromName: t('nav_hiring') });
                    setComplaintReplyText({ ...complaintReplyText, [iss.id]: '' });
                  }}>{t('iss_send_reply')}</button>
                  {iss.status !== 'Resolved' && (
                    <button style={{ ...s.outlineBtn, flex:1 }} onClick={() => onUpdateIssue(iss.id, { status: 'Resolved' })}>{t('hiring_mark_resolved')}</button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

function PublicJobsPortal({ language, setLanguage, onBack, onSignUp }) {
  const t = (key) => translate(language, key);
  const [allOpenPostings, setAllOpenPostings] = useState([]);
  const [postingsLoaded, setPostingsLoaded] = useState(false);
  const [jobSearch, setJobSearch] = useState('');
  const [applyingTo, setApplyingTo] = useState(null);

  // Same aggregated, no-code feed as the logged-in Job Seeker Portal — genuinely
  // public, browsable by anyone, since browsing shouldn't require an account.
  // Only applying requires signing up, since that needs a real, accountable identity.
  useEffect(() => {
    const q = query(collection(db, 'jobPostings'), where('status', '==', 'Open'));
    const unsub = onSnapshot(q, (snap) => {
      setAllOpenPostings(snap.docs.map(d => ({ ...d.data(), id: d.id })));
      setPostingsLoaded(true);
    }, (err) => { console.error('Job postings feed error:', err); setPostingsLoaded(true); });
    return () => unsub();
  }, []);

  const visiblePostings = allOpenPostings.filter(p => {
    const q = jobSearch.trim().toLowerCase();
    if (!q) return true;
    return (p.title || '').toLowerCase().includes(q) || (p.role || '').toLowerCase().includes(q) ||
      (p.location || '').toLowerCase().includes(q) || (p.companyId || '').toLowerCase().includes(q);
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f5f6fa', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 16px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <span style={{ fontSize: '13px', color: '#888', cursor: 'pointer' }} onClick={onBack}>← {t('jobs_back_to_login')}</span>
        <h2 style={{ fontSize: '20px', fontWeight: 700, marginTop: '12px', marginBottom: '4px' }}>{t('jobs_portal_title')} ({visiblePostings.length})</h2>
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '16px' }}>{t('jobseeker_browse_hint')}</p>

        {!applyingTo && (
          <input style={{ width: '100%', border: '1px solid #eee', borderRadius: '8px', padding: '11px', fontSize: '14px', marginBottom: '16px', boxSizing: 'border-box' }} placeholder={`🔍 ${t('jobseeker_search_placeholder')}`} value={jobSearch} onChange={e => setJobSearch(e.target.value)} />
        )}

        {!applyingTo && postingsLoaded && visiblePostings.length === 0 && (
          <div style={{ fontSize: '13px', color: '#888', textAlign: 'center', marginTop: '20px' }}>{jobSearch ? t('tm_no_matches') : t('jobseeker_none_open_anywhere')}</div>
        )}

        {!applyingTo && visiblePostings.map(p => (
          <div key={p.id} style={{ background: 'white', borderRadius: '14px', padding: '18px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: '12px' }}>
            <div style={{ fontSize: '16px', fontWeight: 700 }}>{p.title}</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>{p.role}{p.location ? ` · ${p.location}` : ''} · {p.companyId}</div>
            <div style={{ fontSize: '13px', color: '#444', marginTop: '10px', lineHeight: 1.5 }}>{p.description}</div>
            <button style={{ background: 'var(--brand)', color: 'white', border: 'none', padding: '10px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, width: '100%', marginTop: '14px' }} onClick={() => setApplyingTo(p)}>{t('jobs_apply_btn')}</button>
          </div>
        ))}

        {applyingTo && (
          <div style={{ background: 'white', borderRadius: '14px', padding: '24px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <span style={{ fontSize: '12px', color: '#888', cursor: 'pointer', display:'block', textAlign:'left', marginBottom:'14px' }} onClick={() => setApplyingTo(null)}>← {t('avail_cancel')}</span>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>🔐</div>
            <div style={{ fontSize: '15px', fontWeight: 700, marginBottom: '8px' }}>{t('jobseeker_signup_prompt_title')}</div>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '18px' }}>{t('jobseeker_signup_prompt_hint').replace('{job}', applyingTo.title)}</div>
            <button style={{ background: 'var(--brand)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, width: '100%' }} onClick={onSignUp}>{t('login_signup_link')} →</button>
          </div>
        )}
      </div>
    </div>
  );
}

// Branded splash screen shown briefly on app launch (esp. when opened from home
// screen as a PWA) — animated icon pop-in, then brand name and tagline fade up.
function SplashScreen({ language }) {
  const t = (key) => translate(language || 'en', key);
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: '#FAFAFA',
    }}>
      <style>{`
        @keyframes splashIconPop {
          0% { opacity: 0; transform: scale(0.7); }
          100% { opacity: 1; transform: scale(1); }
        }
        @keyframes splashFadeUp {
          0% { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div style={{
        width: '88px', height: '88px', borderRadius: '22px', background: 'var(--brand)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'splashIconPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
        boxShadow: '0 8px 24px rgba(255,107,26,0.35)',
      }}>
        <span style={{ color: 'white', fontWeight: '800', fontSize: '32px', letterSpacing: '-1px' }}>KD</span>
      </div>
      <div style={{
        fontSize: '28px', fontWeight: '800', color: 'var(--brand)', marginTop: '18px',
        opacity: 0, animation: 'splashFadeUp 0.5s ease-out 0.35s forwards',
      }}>KarmaDal</div>
      <div style={{
        fontSize: '13px', color: '#888', marginTop: '4px',
        opacity: 0, animation: 'splashFadeUp 0.5s ease-out 0.55s forwards',
      }}>{t('app_tagline')}</div>
    </div>
  );
}

// Job-seeker sign-up — creates a real, independent account with no companyId,
// existing on its own until the person is eventually hired somewhere. Uses the
// primary auth instance directly (unlike admin-created accounts) since nobody is
// logged in yet — Firebase signs the new user in automatically once created.
// Job Seeker Portal — the real, logged-in experience for someone with an
// independent account (no companyId). Genuinely different from the earlier
// anonymous PublicJobsPortal: applications are tied to a real, persistent
// account, and applying requires a complete profile (phone + resume) first —
// phone numbers are checked for uniqueness across all job seekers, a real
// anti-fraud measure against one person running multiple fake profiles.
// Phase 4 — Dual-Access Login Routing. Shown when someone's account has both a
// real employee/admin/HR/HQ profile AND a job-seeker record — genuinely two
// different reasons to be here (their day job, and still browsing/applying to
// other opportunities). They choose which one to enter each time they log in.
function PortalChoiceScreen({ options, language, setLanguage, onChoose, onLogout }) {
  const t = (key) => translate(language, key);
  const roleLabel = {
    employee: t('nav_home'), branch_manager: t('nav_overview'), admin: t('hq_title'), hr: t('nav_hiring'),
  }[options.profileChoice.role] || t('nav_home');

  return (
    <div style={{ minHeight:'100vh', background:'#FAFAFA', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'24px 16px' }}>
      <div style={{ width:'100%', maxWidth:'360px', textAlign:'center' }}>
        <div style={{ fontSize:'36px', marginBottom:'10px' }}>👋</div>
        <h2 style={{ fontSize:'20px', fontWeight:700, marginBottom:'6px' }}>{t('choice_title')}</h2>
        <p style={{ fontSize:'13px', color:'#888', marginBottom:'26px' }}>{t('choice_hint')}</p>

        <div onClick={() => onChoose(options.profileChoice)}
          style={{ background:'white', borderRadius:'14px', padding:'20px', boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:'12px', cursor:'pointer', textAlign:'left', border:'1px solid #eee' }}>
          <div style={{ fontSize:'26px', marginBottom:'8px' }}>💼</div>
          <div style={{ fontSize:'15px', fontWeight:700, color:'#2d2d2d' }}>{roleLabel}</div>
          <div style={{ fontSize:'12px', color:'#888', marginTop:'2px' }}>{t('choice_employee_hint')}</div>
        </div>

        <div onClick={() => onChoose(options.jobSeekerChoice)}
          style={{ background:'white', borderRadius:'14px', padding:'20px', boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:'20px', cursor:'pointer', textAlign:'left', border:'1px solid #eee' }}>
          <div style={{ fontSize:'26px', marginBottom:'8px' }}>🔍</div>
          <div style={{ fontSize:'15px', fontWeight:700, color:'#2d2d2d' }}>{t('jobseeker_title')}</div>
          <div style={{ fontSize:'12px', color:'#888', marginTop:'2px' }}>{t('choice_jobs_hint')}</div>
        </div>

        <span style={{ fontSize:'13px', color:'#888', cursor:'pointer' }} onClick={onLogout}>{t('logout')}</span>
      </div>
    </div>
  );
}

function JobSeekerPortal({ user, language, setLanguage, onLogout }) {
  const t = (key) => translate(language, key);
  const [allOpenPostings, setAllOpenPostings] = useState([]);
  const [postingsLoaded, setPostingsLoaded] = useState(false);
  const [jobSearch, setJobSearch] = useState('');
  const [applyingTo, setApplyingTo] = useState(null);
  const [phone, setPhone] = useState(user.phone || '');
  const [resumeFileName, setResumeFileName] = useState(user.resumeFileName || null);
  const [resumeFileData, setResumeFileData] = useState(user.resumeFileData || null);
  const [profileError, setProfileError] = useState('');
  const [profileSaving, setProfileSaving] = useState(false);
  const [applyStatus, setApplyStatus] = useState(null);
  const profileComplete = !!(user.phone && user.resumeFileName);

  // Real-time feed of every open posting from every company using KarmaDal —
  // this is the core of Phase 2: no company code needed, genuinely aggregated.
  useEffect(() => {
    const q = query(collection(db, 'jobPostings'), where('status', '==', 'Open'));
    const unsub = onSnapshot(q, (snap) => {
      setAllOpenPostings(snap.docs.map(d => ({ ...d.data(), id: d.id })));
      setPostingsLoaded(true);
    }, (err) => { console.error('Job postings feed error:', err); setPostingsLoaded(true); });
    return () => unsub();
  }, []);

  const visiblePostings = allOpenPostings.filter(p => {
    const q = jobSearch.trim().toLowerCase();
    if (!q) return true;
    return (p.title || '').toLowerCase().includes(q) || (p.role || '').toLowerCase().includes(q) ||
      (p.location || '').toLowerCase().includes(q) || (p.companyId || '').toLowerCase().includes(q);
  });

  async function saveProfileAndApply() {
    if (!phone.trim() || !resumeFileData) { setProfileError(t('jobseeker_profile_incomplete')); return; }
    setProfileSaving(true); setProfileError('');
    try {
      const phoneQ = query(collection(db, 'jobSeekers'), where('phone', '==', phone.trim()));
      const existing = await getDocs(phoneQ);
      const usedByOther = existing.docs.some(d => d.id !== user.uid);
      if (usedByOther) { setProfileError(t('jobseeker_phone_taken')); setProfileSaving(false); return; }
      await updateDoc(doc(db, 'jobSeekers', user.uid), { phone: phone.trim(), resumeFileName, resumeFileData, profileComplete: true });
      user.phone = phone.trim(); user.resumeFileName = resumeFileName; user.resumeFileData = resumeFileData;
      setProfileSaving(false);
    } catch (err) {
      setProfileError(friendlyAccountError(err));
      setProfileSaving(false);
    }
  }

  function handleResumeUpload(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => { setResumeFileName(file.name); setResumeFileData(reader.result); };
    reader.readAsDataURL(file);
  }

  async function submitApplication() {
    setApplyStatus('submitting');
    try {
      await addDoc(collection(db, 'applicants'), {
        name: user.name, email: user.email, phone: user.phone, resumeFileName: user.resumeFileName, resumeFileData: user.resumeFileData,
        jobSeekerId: user.uid, jobPostingId: applyingTo.id, jobTitle: applyingTo.title, role: applyingTo.role || '',
        companyId: applyingTo.companyId, stage: 'Applied', appliedAt: today,
      });
      setApplyStatus('success');
    } catch (err) {
      setApplyStatus('error');
    }
  }

  return (
    <div style={s.app}>
      <div style={s.topbarAdmin}>
        <div>
          <div style={s.topbarTitle}>{t('jobseeker_title')}</div>
          <div style={s.topbarSub}>{user.name}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <button style={{ ...s.logoutBtn, fontSize:'11px', padding:'5px 10px' }} onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>🌐 {language.toUpperCase()}</button>
          <button style={s.logoutBtn} onClick={onLogout}>{t('logout')}</button>
        </div>
      </div>
      <div style={s.content}>

        {!profileComplete && (
          <div style={{ ...s.card, border:'1px solid #FFD4B0', background:'var(--brand-light)' }}>
            <div style={s.cardLabel}>{t('jobseeker_complete_profile')}</div>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('jobseeker_profile_hint')}</div>
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('jobseeker_phone')}</label>
            <input style={{ ...s.input, marginTop:'6px' }} placeholder={t('jobseeker_phone_placeholder')} value={phone} onChange={e => setPhone(e.target.value)} />
            <label style={{ fontSize:'12px', color:'#888', fontWeight:'600' }}>{t('jobseeker_resume')}</label>
            <input type='file' accept='.pdf,.doc,.docx' style={{ marginTop:'6px', marginBottom:'12px', fontSize:'13px' }} onChange={handleResumeUpload} />
            {resumeFileName && <div style={{ fontSize:'12px', color:'#2e7d32', marginBottom:'12px' }}>✅ {resumeFileName}</div>}
            {profileError && <div style={{ fontSize:'12px', color:'#b71c1c', marginBottom:'10px' }}>{profileError}</div>}
            <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={profileSaving} onClick={saveProfileAndApply}>{profileSaving ? '…' : t('jobseeker_save_profile_btn')}</button>
          </div>
        )}

        {!applyingTo && (
          <div style={s.card}>
            <div style={s.cardLabel}>{t('jobs_portal_title')} ({visiblePostings.length})</div>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'12px' }}>{t('jobseeker_browse_hint')}</div>
            <input style={{ ...s.input }} placeholder={`🔍 ${t('jobseeker_search_placeholder')}`} value={jobSearch} onChange={e => setJobSearch(e.target.value)} />
          </div>
        )}

        {!applyingTo && postingsLoaded && visiblePostings.length === 0 && (
          <div style={s.emptyBox}>{jobSearch ? t('tm_no_matches') : t('jobseeker_none_open_anywhere')}</div>
        )}

        {!applyingTo && visiblePostings.map(p => (
          <div key={p.id} style={s.card}>
            <div style={s.name}>{p.title}</div>
            <div style={s.sub}>{p.role}{p.location ? ` · ${p.location}` : ''} · {p.companyId}</div>
            <div style={{ fontSize:'13px', color:'#444', marginTop:'10px', lineHeight:1.5 }}>{p.description}</div>
            <button style={{ ...s.primaryBtn, marginTop:'14px' }} disabled={!profileComplete} onClick={() => setApplyingTo(p)}>
              {profileComplete ? t('jobs_apply_btn') : t('jobseeker_complete_first')}
            </button>
          </div>
        ))}

        {applyingTo && applyStatus !== 'success' && (
          <div style={s.card}>
            <span style={{ fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setApplyingTo(null)}>← {t('avail_cancel')}</span>
            <div style={{ ...s.cardLabel, marginTop:'10px' }}>{t('jobs_applying_for')}: {applyingTo.title}</div>
            <div style={{ fontSize:'13px', color:'#444', marginBottom:'14px' }}>{user.name} · {user.email} · {user.phone}</div>
            <button style={{ ...s.primaryBtn, marginTop:0 }} disabled={applyStatus === 'submitting'} onClick={submitApplication}>{applyStatus === 'submitting' ? '…' : t('jobs_submit_btn')}</button>
            {applyStatus === 'error' && <div style={{ fontSize:'12px', color:'#b71c1c', marginTop:'10px' }}>{t('jobs_submit_error')}</div>}
          </div>
        )}

        {applyStatus === 'success' && (
          <div style={{ ...s.card, textAlign:'center', padding:'30px 20px' }}>
            <div style={{ fontSize:'32px', marginBottom:'10px' }}>✅</div>
            <div style={{ fontSize:'15px', fontWeight:'700', marginBottom:'6px' }}>{t('jobs_success_title')}</div>
            <div style={{ fontSize:'13px', color:'#888' }}>{t('jobs_success_hint')}</div>
          </div>
        )}

      </div>
    </div>
  );
}

function SignUpPage({ language, setLanguage, onBack, onSignUpSuccess }) {
  const t = (key) => translate(language, key);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSignUp() {
    if (!name.trim() || !email.trim() || !password) { setError(t('signup_error_missing')); return; }
    if (password.length < 6) { setError(t('signup_error_password')); return; }
    setLoading(true); setError('');
    try {
      const cred = await createUserWithEmailAndPassword(auth, email.trim(), password);
      const initials = name.trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
      await setDoc(doc(db, 'jobSeekers', cred.user.uid), {
        name: name.trim(), initials, email: email.trim(), phone: '', resumeFileName: null, resumeFileData: null, profileComplete: false,
      });
      onSignUpSuccess();
    } catch (err) {
      setError(friendlyAccountError(err));
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight:'100vh', background:'#FAFAFA', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'24px 16px' }}>
      <div style={{ width:'100%', maxWidth:'380px' }}>
        <span style={{ fontSize:'13px', color:'#888', cursor:'pointer' }} onClick={onBack}>← {t('signup_back_to_login')}</span>
        <div style={{ fontSize:'36px', textAlign:'center', margin:'16px 0 6px' }}>⚡</div>
        <h2 style={{ fontSize:'22px', fontWeight:700, textAlign:'center', marginBottom:'4px' }}>{t('signup_title')}</h2>
        <p style={{ fontSize:'13px', color:'#888', textAlign:'center', marginBottom:'24px' }}>{t('signup_hint')}</p>
        <div style={{ background:'white', borderRadius:'14px', padding:'20px', boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
          <label style={{ fontSize:'12px', color:'#888', fontWeight:600 }}>{t('tm_full_name')}</label>
          <input style={{ width:'100%', border:'1px solid #eee', borderRadius:'8px', padding:'11px', fontSize:'14px', marginTop:'6px', marginBottom:'12px', boxSizing:'border-box' }} value={name} onChange={e => setName(e.target.value)} />
          <label style={{ fontSize:'12px', color:'#888', fontWeight:600 }}>{t('tm_email')}</label>
          <input type='email' style={{ width:'100%', border:'1px solid #eee', borderRadius:'8px', padding:'11px', fontSize:'14px', marginTop:'6px', marginBottom:'12px', boxSizing:'border-box' }} value={email} onChange={e => setEmail(e.target.value)} />
          <label style={{ fontSize:'12px', color:'#888', fontWeight:600 }}>{t('login_password')}</label>
          <input type='password' style={{ width:'100%', border:'1px solid #eee', borderRadius:'8px', padding:'11px', fontSize:'14px', marginTop:'6px', marginBottom:'6px', boxSizing:'border-box' }} value={password} onChange={e => setPassword(e.target.value)} />
          <div style={{ fontSize:'11px', color:'#aaa', marginBottom:'14px' }}>{t('signup_password_hint')}</div>
          {error && <div style={{ color:'#b71c1c', fontSize:'13px', marginBottom:'12px' }}>{error}</div>}
          <button style={{ background:'var(--brand)', color:'white', border:'none', padding:'12px', borderRadius:'8px', fontSize:'14px', fontWeight:600, width:'100%', opacity: loading ? 0.6 : 1 }} disabled={loading} onClick={handleSignUp}>{loading ? '…' : `${t('signup_create_btn')} →`}</button>
        </div>
      </div>
    </div>
  );
}

function LoginPage({ language, setLanguage, kickedOut, onDismissKickedOut, onBrowseJobs, onSignUp, deactivatedMessage, onDismissDeactivated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const t = (key) => translate(language, key);

  async function handleLogin() {
    if (!email || !password) { setError(t('login_error')); return; }
    setError(''); setLoading(true);
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      // Claim this device as the one active session for this account —
      // any other device currently logged in as this user gets signed out.
      const sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(`karmadal_session_${cred.user.uid}`, sessionId);
      await setDoc(doc(db, 'sessions', cred.user.uid), { sessionId, loginAt: Date.now() });
    } catch (err) {
      setError(t('login_error_invalid'));
    }
    setLoading(false);
  }

  async function handleForgotSubmit() {
    if (!forgotEmail) return;
    try {
      await sendPasswordResetEmail(auth, forgotEmail);
    } catch (err) {
      // Intentionally show the same success message either way — this avoids
      // revealing whether an email address has an account (standard security practice).
    }
    setForgotSent(true);
  }

  return (
    <div style={s.loginBox}>
      <div style={s.loginCard}>
        <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'4px' }}>
          <select style={{ ...s.selectInput, marginBottom:0, width:'auto', padding:'6px 10px', fontSize:'12px' }} value={language} onChange={e => setLanguage(e.target.value)}>
            {LANGUAGES.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
          </select>
        </div>
        <div style={{ fontSize:'36px', marginBottom:'8px' }}>⚡</div>
        <div style={{ fontSize:'26px', fontWeight:'700', color:'var(--brand)', marginBottom:'4px' }}>KarmaDal</div>
        <div style={{ fontSize:'13px', color:'#888', marginBottom:'10px' }}>{t('app_tagline')}</div>
        <a href="https://karmadal.de" target="_blank" rel="noopener noreferrer" style={{ fontSize:'13px', fontWeight:'700', color:'var(--brand)', textDecoration:'none', display:'inline-block', marginBottom:'22px' }}>What KarmaDal offers →</a>
        {kickedOut && (
          <div style={{ background:'#fff8e1', borderRadius:'10px', padding:'12px', marginBottom:'16px', textAlign:'left' }}>
            <div style={{ fontSize:'13px', fontWeight:'600', color:'#f57f17', marginBottom:'4px' }}>⚠️ You were signed out</div>
            <div style={{ fontSize:'12px', color:'#8a6d00' }}>This account was just signed in somewhere else (another tab, device, or link like karmadal.de vs the .web.app address). Only one place can be signed in at a time.</div>
            <div style={{ marginTop:'8px', fontSize:'11px', color:'#8a6d00', cursor:'pointer', textDecoration:'underline' }} onClick={onDismissKickedOut}>Dismiss</div>
          </div>
        )}
        {deactivatedMessage && (
          <div style={{ background:'#ffebee', borderRadius:'10px', padding:'12px', marginBottom:'16px', textAlign:'left' }}>
            <div style={{ fontSize:'13px', fontWeight:'600', color:'#b71c1c', marginBottom:'4px' }}>🚫 {t('login_deactivated_title')}</div>
            <div style={{ fontSize:'12px', color:'#8a6d00' }}>{t('login_deactivated_hint')}</div>
            <div style={{ marginTop:'8px', fontSize:'11px', color:'#8a6d00', cursor:'pointer', textDecoration:'underline' }} onClick={onDismissDeactivated}>{t('login_dismiss')}</div>
          </div>
        )}
        <input style={s.input} type='email' placeholder={t('login_email')} value={email} onChange={e => setEmail(e.target.value)} />
        <div style={{ position:'relative' }}>
          <input style={{ ...s.input, paddingRight:'42px' }} type={showPassword ? 'text' : 'password'} placeholder={t('login_password')} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key==='Enter' && handleLogin()} />
          <span onClick={() => setShowPassword(!showPassword)} style={{ position:'absolute', right:'12px', top:'12px', cursor:'pointer', fontSize:'16px', userSelect:'none' }} title={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? '🙈' : '👁️'}</span>
        </div>
        {error && <div style={{ color:'#b71c1c', fontSize:'13px', marginBottom:'10px' }}>{error}</div>}
        <button style={{ ...s.loginBtn, opacity: loading ? 0.6 : 1 }} onClick={handleLogin} disabled={loading}>{loading ? '...' : `${t('login_signin')} →`}</button>
        <div style={{ textAlign:'center', marginTop:'16px' }}>
          <span style={{ fontSize:'13px', color:'var(--brand)', cursor:'pointer', fontWeight:'500' }} onClick={() => { setForgot(true); setForgotSent(false); setForgotEmail(email); }}>{t('login_forgot')}</span>
        </div>
        <div style={{ textAlign:'center', marginTop:'12px' }}>
          <span style={{ fontSize:'13px', color:'#888', cursor:'pointer' }} onClick={onBrowseJobs}>💼 {t('login_browse_jobs')}</span>
        </div>
        <div style={{ textAlign:'center', marginTop:'10px' }}>
          <span style={{ fontSize:'13px', color:'var(--brand)', cursor:'pointer', fontWeight:'500' }} onClick={onSignUp}>✨ {t('login_signup_link')}</span>
        </div>
        {forgot && (
          <div style={{ marginTop:'16px', padding:'14px', background:'#e8f5e9', borderRadius:'10px', textAlign:'center' }}>
            {!forgotSent ? (
              <>
                <div style={{ fontSize:'20px', marginBottom:'6px' }}>🔒</div>
                <div style={{ fontSize:'13px', fontWeight:'600', color:'#2e7d32', marginBottom:'8px' }}>{t('login_reset_title')}</div>
                <input style={{ ...s.input, marginBottom:'10px' }} type='email' placeholder={t('login_email')} value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} />
                <button style={{ ...s.primaryBtn, marginTop:0 }} onClick={handleForgotSubmit}>Send reset link →</button>
                <div style={{ marginTop:'10px', fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setForgot(false)}>✕ {t('login_close')}</div>
              </>
            ) : (
              <>
                <div style={{ fontSize:'20px', marginBottom:'6px' }}>✅</div>
                <div style={{ fontSize:'13px', fontWeight:'600', color:'#2e7d32', marginBottom:'4px' }}>Check your email</div>
                <div style={{ fontSize:'12px', color:'#388e3c' }}>If an account exists for that address, a password reset link has been sent.</div>
                <div style={{ marginTop:'10px', fontSize:'12px', color:'#888', cursor:'pointer' }} onClick={() => setForgot(false)}>✕ {t('login_close')}</div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── MAIN ────────────────────────────────────────────────────────
function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [publicJobsMode, setPublicJobsMode] = useState(false);
  const [signUpMode, setSignUpMode] = useState(false);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [kickedOut, setKickedOut] = useState(false);
  const [deactivatedMessage, setDeactivatedMessage] = useState(false);
  const [dualAccessOptions, setDualAccessOptions] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [availList, setAvailList] = useState([]);
  const [salarySlips, setSalarySlips] = useState([]);
  const [issues, setIssues] = useState([]);
  const [profiles, setProfiles] = useState({});
  const [sickReports, setSickReports] = useState([]);
  const [contractTemplates, setContractTemplates] = useState([]);
  const [swapRequests, setSwapRequests] = useState([]);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [companyThemeColor, setCompanyThemeColor] = useState(null);
  const [language, setLanguage] = useState('en');

  // Real-time company theme sync — every logged-in user of this company (admin or
  // employee) reads from the same shared document, so the color reaches everyone,
  // not just the account that set it.
  const [fixedScheduleConfig, setFixedScheduleConfig] = useState(null);
  const [rotationConfig, setRotationConfig] = useState(null);
  useEffect(() => {
    if (!user?.companyId) { setCompanyThemeColor(null); setFixedScheduleConfig(null); setRotationConfig(null); return; }
    const unsub = onSnapshot(doc(db, 'companies', user.companyId), (snap) => {
      setCompanyThemeColor(snap.exists() ? (snap.data().themeColor || null) : null);
      setFixedScheduleConfig(snap.exists() ? (snap.data().fixedSchedule || null) : null);
      setRotationConfig(snap.exists() ? (snap.data().rotationSchedule || null) : null);
    }, (err) => console.error('Company theme sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  // Injects the company's brand color as CSS variables — every place that used to
  // reference the hardcoded orange now reads from these instead, so setting one
  // color per company re-themes the whole app without touching individual screens.
  useEffect(() => {
    const base = companyThemeColor || '#FF6B1A';
    const styleTag = document.getElementById('kd-brand-vars') || document.createElement('style');
    styleTag.id = 'kd-brand-vars';
    styleTag.innerHTML = `:root { --brand: ${base}; --brand-light: ${lightenColor(base, 0.88)}; --brand-dark: ${darkenColor(base, 0.28)}; --brand-darker: ${darkenColor(base, 0.52)}; }`;
    if (!styleTag.parentNode) document.head.appendChild(styleTag);
  }, [companyThemeColor]);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  // Real-time shift sync — shifts now live permanently in Firestore, scoped to this
  // person's company. Any change (by anyone, any device) reflects here automatically.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'shifts'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setShifts(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Shifts sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addShift(shiftData) {
    await addDoc(collection(db, 'shifts'), { ...shiftData, companyId: user.companyId });
  }
  async function updateShiftDoc(id, updates) {
    await updateDoc(doc(db, 'shifts', id), updates);
  }
  async function removeShiftDoc(id) {
    await deleteDoc(doc(db, 'shifts', id));
  }

  // Real-time availability sync — same pattern as shifts above.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'availability'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setAvailList(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Availability sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addAvailDoc(availData) {
    await addDoc(collection(db, 'availability'), { ...availData, companyId: user.companyId });
  }
  async function updateAvailDoc(id, updates) {
    await updateDoc(doc(db, 'availability', id), updates);
  }
  async function removeAvailDoc(id) {
    await deleteDoc(doc(db, 'availability', id));
  }

  // Real-time issues sync — same pattern as shifts/availability above.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'issues'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setIssues(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Issues sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addIssueDoc(issueData) {
    const ticketNumber = await getNextTicketNumber();
    await addDoc(collection(db, 'issues'), { ...issueData, companyId: user.companyId, ticketNumber });
  }
  async function updateIssueDoc(id, updates) {
    await updateDoc(doc(db, 'issues', id), updates);
  }
  async function addIssueReply(id, reply) {
    await updateDoc(doc(db, 'issues', id), { replies: arrayUnion({ ...reply, at: Date.now() }) });
  }

  // Real-time sick reports sync — same pattern as shifts/availability/issues above.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'sickReports'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setSickReports(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Sick reports sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addSickReportDoc(reportData) {
    const ticketNumber = await getNextTicketNumber();
    await addDoc(collection(db, 'sickReports'), { ...reportData, companyId: user.companyId, ticketNumber });
  }
  async function updateSickReportDoc(id, updates) {
    await updateDoc(doc(db, 'sickReports', id), updates);
  }

  // Real-time contract templates sync — same pattern as sick reports above. Templates are
  // plain text with {{placeholder}} tokens the employer wrote themselves; the app only ever
  // substitutes real data into placeholders they defined — never generates legal wording.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'contractTemplates'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setContractTemplates(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Contract templates sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addContractTemplateDoc(templateData) {
    await addDoc(collection(db, 'contractTemplates'), { ...templateData, companyId: user.companyId });
  }
  async function updateContractTemplateDoc(id, updates) {
    await updateDoc(doc(db, 'contractTemplates', id), updates);
  }
  async function deleteContractTemplateDoc(id) {
    await deleteDoc(doc(db, 'contractTemplates', id));
  }

  // Real-time shift swap requests sync — same pattern as contract templates above.
  // Admin handles actual coordination between employees outside the app; this just
  // tracks the request and its status, and reuses the existing shift-reassignment
  // tool once both people are confirmed.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'swapRequests'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setSwapRequests(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Swap requests sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addSwapRequestDoc(requestData) {
    const ticketNumber = await getNextTicketNumber();
    await addDoc(collection(db, 'swapRequests'), { ...requestData, companyId: user.companyId, requestedAt: today, ticketNumber });
  }
  async function updateSwapRequestDoc(id, updates) {
    await updateDoc(doc(db, 'swapRequests', id), updates);
  }

  // Real-time leave requests sync — same pattern as above. The app tracks the
  // request and a plain day count only; whether it's paid, and how many days
  // someone is entitled to, is entirely the employer's own policy to apply.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'leaveRequests'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setLeaveRequests(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Leave requests sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addLeaveRequestDoc(requestData) {
    const ticketNumber = await getNextTicketNumber();
    await addDoc(collection(db, 'leaveRequests'), { ...requestData, companyId: user.companyId, status: 'Pending', requestedAt: today, ticketNumber });
  }
  async function updateLeaveRequestDoc(id, updates) {
    await updateDoc(doc(db, 'leaveRequests', id), updates);
  }
  async function deleteLeaveRequestDoc(id) {
    await deleteDoc(doc(db, 'leaveRequests', id));
  }

  // Real-time employee profile sync (photos, contracts, hour caps, uploaded documents) —
  // NOT the same as the login "profiles/{uid}" collection above; this one is keyed by
  // employee name, matching how the rest of the app already identifies people.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'employeeProfiles'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      const obj = {};
      snap.docs.forEach(d => { obj[d.id] = d.data(); });
      setProfiles(obj);
    }, (err) => console.error('Employee profiles sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  const BLANK_EMPLOYEE_PROFILE = { photo: null, photoChangeRequested: false, contractFile: null, contractName: null, contractShared: false, minHours: '', maxHours: '', documents: [] };

  async function updateEmployeeProfileDoc(name, updates) {
    const ref = doc(db, 'employeeProfiles', name);
    const snap = await getDoc(ref);
    const current = snap.exists() ? snap.data() : BLANK_EMPLOYEE_PROFILE;
    await setDoc(ref, { ...current, ...updates, companyId: user.companyId });
  }
  async function addEmployeeDocumentDoc(name, newDoc) {
    const ref = doc(db, 'employeeProfiles', name);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      await setDoc(ref, { ...BLANK_EMPLOYEE_PROFILE, documents: [newDoc], companyId: user.companyId });
    } else {
      await updateDoc(ref, { documents: arrayUnion(newDoc) });
    }
  }

  // Real-time salary slips sync — same pattern as everything else above.
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'salarySlips'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setSalarySlips(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Salary slips sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addSalarySlipDoc(slipData) {
    await addDoc(collection(db, 'salarySlips'), { ...slipData, companyId: user.companyId });
  }
  async function updateSalarySlipDoc(id, updates) {
    await updateDoc(doc(db, 'salarySlips', id), updates);
  }

  // Updates the currently logged-in admin's own profile document (keyed by their
  // Firebase UID) — used for account-level settings like their company's brand color.
  async function updateCompanyThemeColor(color) {
    await setDoc(doc(db, 'companies', user.companyId), { themeColor: color }, { merge: true });
  }

  // Company-wide fixed-shift settings — one shared start/end/break time and set of
  // working days, used by employees on Fixed scheduling (Model A) instead of the
  // availability-based Auto-Assign system.
  async function updateFixedScheduleConfig(config) {
    await setDoc(doc(db, 'companies', user.companyId), { fixedSchedule: config }, { merge: true });
  }

  // Multi-Shift Rotation — a company defines named shift types (e.g. Frühschicht,
  // Spätschicht, Nachtschicht), each with its own hours and pay premium, plus how
  // many days an employee stays on each before rotating forward to the next. This
  // matches real German shift-work practice: forward-only rotation, and shift
  // premiums that need to actually reach payroll, not just scheduling.
  async function updateRotationConfig(config) {
    await setDoc(doc(db, 'companies', user.companyId), { rotationSchedule: config }, { merge: true });
  }

  // Given a rotation config and how many days have elapsed since an employee's
  // rotation start date, returns which shift type they're currently on. Genuinely
  // simple modular arithmetic — cycles forward through the shift types, looping
  // back to the first once the last is finished, matching real forward-rotation
  // practice (Früh → Spät → Nacht → Früh...).
  function getCurrentRotationShift(rotationConfig, rotationStartDate, forDate) {
    const shiftTypes = rotationConfig.shiftTypes || [];
    if (shiftTypes.length === 0) return null;
    const daysPerShift = rotationConfig.daysPerShift || 2;
    const cycleLength = shiftTypes.length * daysPerShift;
    const start = new Date(rotationStartDate);
    const target = new Date(forDate);
    const daysElapsed = Math.floor((target - start) / (1000 * 60 * 60 * 24));
    if (daysElapsed < 0) return null;
    const positionInCycle = daysElapsed % cycleLength;
    const shiftIndex = Math.floor(positionInCycle / daysPerShift);
    return shiftTypes[shiftIndex];
  }

  // Checks the one genuinely risky rotation transition — cycling from the last
  // shift type (often Nachtschicht) back to the first (often Frühschicht) — for
  // whether it leaves the legally required 11 hours of rest between shifts.
  function checkRotationRestViolation(rotationConfig) {
    const shiftTypes = rotationConfig.shiftTypes || [];
    if (shiftTypes.length < 2) return null;
    const lastShift = shiftTypes[shiftTypes.length - 1];
    const firstShift = shiftTypes[0];
    const [lastEndH, lastEndM] = (lastShift.end || '00:00').split(':').map(Number);
    const [firstStartH, firstStartM] = (firstShift.start || '00:00').split(':').map(Number);
    let lastEndMinutes = lastEndH * 60 + lastEndM;
    let firstStartMinutes = firstStartH * 60 + firstStartM;
    // If the last shift ends "after midnight" relative to the first shift's next-day start, adjust
    if (firstStartMinutes < lastEndMinutes) firstStartMinutes += 24 * 60;
    const restMinutes = firstStartMinutes - lastEndMinutes;
    return restMinutes < 11 * 60 ? { lastShift: lastShift.name, firstShift: firstShift.name, restHours: (restMinutes / 60).toFixed(1) } : null;
  }

  // Generates real shift records for rotation employees for the given week,
  // storing each shift's premium percentage so payroll can apply it automatically.
  async function generateRotationShiftsForWeek(weekStartDate, rotationConfig, rotationEmployees) {
    const weekDates = Array.from({ length: 7 }, (_, i) => {
      const d = new Date(weekStartDate); d.setDate(d.getDate() + i);
      return d.toISOString().split('T')[0];
    });
    let created = 0;
    for (const emp of rotationEmployees) {
      const rec = employeeRecords[emp.name] || {};
      if (rec.schedulingMode !== 'rotation' || !rec.rotationStartDate) continue;
      for (const dateStr of weekDates) {
        const shift = getCurrentRotationShift(rotationConfig, rec.rotationStartDate, dateStr);
        if (!shift) continue;
        const alreadyExists = shifts.some(sh => sh.employee === emp.name && sh.date === dateStr);
        if (alreadyExists) continue;
        const dateObj = new Date(dateStr);
        const dateLabel = dateObj.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });
        await addShift({
          employee: emp.name, date: dateStr, dateLabel,
          time: `${shift.start} – ${shift.end}`, shiftTypeName: shift.name, shiftPremiumPercent: shift.premiumPercent || 0,
          status: 'Confirmed', attendance: 'Pending', attendanceApproved: false,
          workedFrom: '', workedTo: '', missedReason: '', missedDesc: '',
          sickFrom: '', sickTo: '', certFileName: null, certFileData: null, notifiedRead: false,
        });
        created++;
      }
    }
    return created;
  }

  // Real-time HQ team sync — every HR and Branch Manager account within this
  // company, so HQ can actually see who's been given access, not just create
  // accounts blindly with no way to review them afterward.
  const [hqTeamMembers, setHqTeamMembers] = useState([]);
  useEffect(() => {
    if (!user?.companyId || user.role !== 'admin') return;
    const q = query(collection(db, 'profiles'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setHqTeamMembers(snap.docs.map(d => ({ ...d.data(), id: d.id })).filter(p => p.role === 'hr' || p.role === 'branch_manager'));
    }, (err) => console.error('HQ team sync error:', err));
    return () => unsub();
  }, [user?.companyId, user?.role]);

  // Real-time weekly day-off choices sync — used by Model B (fixed hours, Sunday
  // always off, employee picks one more day off each week, changeable week to week).
  const [dayOffChoices, setDayOffChoices] = useState([]);
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'dayOffChoices'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setDayOffChoices(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Day off choices sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function setDayOffChoice(employeeName, weekStart, dayOff) {
    const existingId = `${employeeName}_${weekStart}`.replace(/\s+/g, '_');
    await setDoc(doc(db, 'dayOffChoices', existingId), { employee: employeeName, weekStart, dayOff, companyId: user.companyId });
  }

  // Hiring Portal — a genuinely separate pipeline from the Admin/Employee portals,
  // connecting to them only at the moment of hire. Job postings are public (no
  // login needed to view/apply); applicants only become real employees once admin
  // explicitly hires them, which reuses the exact same addEmployee mechanism used
  // for manually adding staff today — so hired candidates get a real account,
  // profile, and login exactly like any other employee.
  const [jobPostings, setJobPostings] = useState([]);
  const [applicants, setApplicants] = useState([]);
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'jobPostings'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setJobPostings(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Job postings sync error:', err));
    return () => unsub();
  }, [user?.companyId]);
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'applicants'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setApplicants(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Applicants sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addJobPostingDoc(postingData) {
    await addDoc(collection(db, 'jobPostings'), { ...postingData, companyId: user.companyId, status: 'Open', postedAt: today });
  }
  async function updateJobPostingDoc(id, updates) {
    await updateDoc(doc(db, 'jobPostings', id), updates);
  }
  async function updateApplicantDoc(id, updates) {
    await updateDoc(doc(db, 'applicants', id), updates);
  }
  // Phase 3 — Hire Converts, Doesn't Duplicate. If this applicant signed up
  // through the real Job Seeker Portal (has a jobSeekerId), their existing
  // account gets upgraded with real employee access directly — no new Auth
  // account, no duplicate, no password reset email, since they already know
  // their own password. Their jobSeekers record stays intact too, so they keep
  // both kinds of access going forward (Phase 4 builds the login choice for this).
  // Only falls back to creating a brand-new account for applicants who applied
  // anonymously through the older, no-login public jobs page.
  async function hireApplicant(applicant) {
    if (applicant.jobSeekerId) {
      const initials = applicant.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
      const palette = NEW_EMPLOYEE_COLORS[Math.floor(Math.random() * NEW_EMPLOYEE_COLORS.length)];
      await setDoc(doc(db, 'profiles', applicant.jobSeekerId), {
        name: applicant.name, initials, color: palette.color, textColor: palette.textColor,
        role: 'employee', email: applicant.email, companyId: user.companyId, branchId: null,
      });
      await setDoc(doc(db, 'employees', applicant.name), {
        name: applicant.name, email: applicant.email, initials, color: palette.color, textColor: palette.textColor,
        joinDate: today, salary: '', jobTitle: applicant.role || '', status: 'active', companyId: user.companyId, branchId: null,
      });
    } else {
      await addEmployee({ name: applicant.name, email: applicant.email, role: 'employee', joinDate: today, salary: '', jobTitle: applicant.role || '', branchId: null });
    }
    await updateApplicantDoc(applicant.id, { stage: 'Hired', hiredAt: today });
  }

  // Shift Templates — pure static data, generated per company based on their own
  // working hours, roles, branches, and weekly-off rules. Deliberately holds no
  // scheduling logic itself; the existing Fixed Schedule generation and Auto-Assign
  // systems are untouched — this is just structured data for them (or a future
  // system) to read.
  const [shiftTemplates, setShiftTemplates] = useState([]);
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'shiftTemplates'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setShiftTemplates(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('Shift templates sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function addShiftTemplateDoc(templateData) {
    await addDoc(collection(db, 'shiftTemplates'), { ...templateData, companyId: user.companyId });
  }
  async function updateShiftTemplateDoc(id, updates) {
    await updateDoc(doc(db, 'shiftTemplates', id), updates);
  }
  async function deleteShiftTemplateDoc(id) {
    await deleteDoc(doc(db, 'shiftTemplates', id));
  }

  // Executes an approved week-off swap between two employees — updates both of their
  // day-off choices for that week, and if shifts were already generated for that
  // week, corrects them too: removes the shift on each person's new day off, and
  // creates one on what's now their work day, so the schedule stays accurate
  // regardless of whether this runs before or after generation.
  async function executeWeekOffSwap(req) {
    const { employee, targetEmployee, weekStart, employeeCurrentDayOff, targetCurrentDayOff } = req;
    await setDayOffChoice(employee, weekStart, targetCurrentDayOff);
    await setDayOffChoice(targetEmployee, weekStart, employeeCurrentDayOff);
    const config = fixedScheduleConfig;
    if (!config) return;
    const WEEKDAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    async function fixEmployeeWeek(empName, newDayOff, oldDayOff) {
      for (let i = 0; i < 7; i++) {
        const d = new Date(weekStart); d.setDate(d.getDate() + i);
        const dateStr = d.toISOString().split('T')[0];
        const weekdayName = WEEKDAY_NAMES[d.getDay()];
        const existingShift = shifts.find(sh => sh.employee === empName && sh.date === dateStr);
        if (weekdayName === newDayOff && existingShift) {
          await removeShiftDoc(existingShift.id);
        } else if (weekdayName === oldDayOff && !existingShift && weekdayName !== 'Sunday') {
          const dateLabel = d.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });
          await addShift({
            employee: empName, date: dateStr, dateLabel,
            time: `${config.start} – ${config.end}`, breakStart: config.breakStart || '', breakEnd: config.breakEnd || '',
            status: 'Confirmed', attendance: 'Pending', attendanceApproved: false,
            workedFrom: '', workedTo: '', missedReason: '', missedDesc: '',
            sickFrom: '', sickTo: '', certFileName: null, certFileData: null, notifiedRead: false,
          });
        }
      }
    }
    await fixEmployeeWeek(employee, targetCurrentDayOff, employeeCurrentDayOff);
    await fixEmployeeWeek(targetEmployee, employeeCurrentDayOff, targetCurrentDayOff);
  }

  // Generates real shift records for the week starting on weekStartDate (a Monday,
  // 'YYYY-MM-DD') for every employee on Fixed scheduling — Model A (same days every
  // week, set once) or Model B (Sunday always off, employee picks one more day off,
  // changeable week to week). Skips any date that already has a shift for that
  // employee, so running this again for the same week never creates duplicates.
  async function generateFixedShiftsForWeek(weekStartDate, fixedConfig, fixedEmployees) {
    const WEEKDAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const weekDates = Array.from({ length: 7 }, (_, i) => {
      const d = new Date(weekStartDate); d.setDate(d.getDate() + i);
      return d.toISOString().split('T')[0];
    });
    let created = 0;
    for (const emp of fixedEmployees) {
      const rec = employeeRecords[emp.name] || {};
      const mode = rec.schedulingMode;
      if (mode !== 'fixed-standard' && mode !== 'fixed-choose-dayoff') continue;
      let dayOff = null;
      if (mode === 'fixed-choose-dayoff') {
        const choice = dayOffChoices.find(c => c.employee === emp.name && c.weekStart === weekStartDate);
        dayOff = choice ? choice.dayOff : null;
      }
      for (const dateStr of weekDates) {
        const dateObj = new Date(dateStr);
        const weekdayName = WEEKDAY_NAMES[dateObj.getDay()];
        const worksThisDay = mode === 'fixed-standard'
          ? (fixedConfig.workDays || []).includes(weekdayName)
          : weekdayName !== 'Sunday' && weekdayName !== dayOff;
        if (!worksThisDay) continue;
        const alreadyExists = shifts.some(sh => sh.employee === emp.name && sh.date === dateStr);
        if (alreadyExists) continue;
        const dateLabel = dateObj.toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' });
        await addShift({
          employee: emp.name, date: dateStr, dateLabel,
          time: `${fixedConfig.start} – ${fixedConfig.end}`,
          breakStart: fixedConfig.breakStart || '', breakEnd: fixedConfig.breakEnd || '',
          status: 'Confirmed', attendance: 'Pending', attendanceApproved: false,
          workedFrom: '', workedTo: '', missedReason: '', missedDesc: '',
          sickFrom: '', sickTo: '', certFileName: null, certFileData: null, notifiedRead: false,
        });
        created++;
      }
    }
    return created;
  }

  // Every request type (Issues, Sick Certificates, Swap Requests, Leave Requests)
  // pulls from this same shared, ever-increasing counter — so "ticket #24" always
  // means one specific thing, regardless of which kind of request it was. A Firestore
  // transaction guarantees two requests submitted at the same instant never get the
  // same number.
  async function getNextTicketNumber() {
    const companyRef = doc(db, 'companies', user.companyId);
    const next = await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(companyRef);
      const current = snap.exists() ? (snap.data().nextTicketNumber || 1) : 1;
      transaction.set(companyRef, { nextTicketNumber: current + 1 }, { merge: true });
      return current;
    });
    return next;
  }

  // Real employee records (join date, salary, active/deactivated status) — keyed by name,
  // same as employeeProfiles above. Kept separate from that collection since this one holds
  // sensitive HR/payroll data, distinct from the photo/contract/documents data.
  const [employeeRecords, setEmployeeRecords] = useState({});
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'employees'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      const obj = {};
      snap.docs.forEach(d => { obj[d.id] = d.data(); });
      setEmployeeRecords(obj);
    }, (err) => console.error('Employee records sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function updateEmployeeRecordDoc(name, updates) {
    const ref = doc(db, 'employees', name);
    const snap = await getDoc(ref);
    const seedEmp = EMPLOYEES.find(e => e.name === name);
    const current = snap.exists() ? snap.data() : {
      name, email: seedEmp?.email || '', initials: seedEmp?.initials || name.slice(0,2).toUpperCase(),
      color: seedEmp?.color || '#f5f6fa', textColor: seedEmp?.textColor || '#555',
      joinDate: today, salary: '', status: 'active',
    };
    await setDoc(ref, { ...current, ...updates, companyId: user.companyId });
  }

  const NEW_EMPLOYEE_COLORS = [
    { color: 'var(--brand-light)', textColor: 'var(--brand-dark)' }, { color: '#e8f5e9', textColor: '#2e7d32' },
    { color: '#fff8e1', textColor: '#f57f17' }, { color: '#fce4ec', textColor: '#880e4f' },
    { color: '#e3f2fd', textColor: '#0d47a1' }, { color: '#f3e5f5', textColor: '#8e24aa' },
  ];

  // Creates a real login for a new employee — using a temporary, separate Firebase
  // connection so this never disturbs the admin's own signed-in session. The new
  // employee gets an email to set their own password (same system as Forgot Password).
  async function addEmployee({ name, email, role, joinDate, salary, jobTitle, branchId }) {
    const tempPassword = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'A1!';
    const secondaryApp = initializeApp(firebaseConfig, `secondary-${Date.now()}`);
    const secondaryAuth = getAuth(secondaryApp);
    try {
      const cred = await createUserWithEmailAndPassword(secondaryAuth, email, tempPassword);
      const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
      const palette = NEW_EMPLOYEE_COLORS[Math.floor(Math.random() * NEW_EMPLOYEE_COLORS.length)];
      await setDoc(doc(db, 'profiles', cred.user.uid), { name, initials, color: palette.color, textColor: palette.textColor, role, email, companyId: user.companyId, branchId: branchId || null });
      await setDoc(doc(db, 'employees', name), { name, email, initials, color: palette.color, textColor: palette.textColor, joinDate, salary: salary || '', jobTitle: jobTitle || '', status: 'active', companyId: user.companyId, branchId: branchId || null });
      await sendPasswordResetEmail(auth, email);
      await signOut(secondaryAuth);
    } finally {
      await deleteApp(secondaryApp);
    }
  }

  // Creates login access for a dedicated Hiring Portal (HR) account — deliberately
  // simpler than addEmployee, since an HR person isn't scheduled staff and shouldn't
  // show up in the Team list or be assignable to shifts. Just a real login, scoped
  // to this company, routed to the Hiring Portal by role alone.
  async function addHRAccount({ name, email }) {
    const tempPassword = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'A1!';
    const secondaryApp = initializeApp(firebaseConfig, `secondary-${Date.now()}`);
    const secondaryAuth = getAuth(secondaryApp);
    try {
      const cred = await createUserWithEmailAndPassword(secondaryAuth, email, tempPassword);
      const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
      await setDoc(doc(db, 'profiles', cred.user.uid), { name, initials, role: 'hr', email, companyId: user.companyId });
      await sendPasswordResetEmail(auth, email);
      await signOut(secondaryAuth);
    } finally {
      await deleteApp(secondaryApp);
    }
  }

  // Creates a real Branch Manager login, assigned to a specific branch — used by
  // the HQ Portal to stand up a new location, or assign a manager to an existing
  // one. Genuinely a peer to how HR accounts get created — same mechanism, just a
  // different role and a required branchId.
  async function addBranchManagerAccount({ name, email, branchId }) {
    const tempPassword = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'A1!';
    const secondaryApp = initializeApp(firebaseConfig, `secondary-${Date.now()}`);
    const secondaryAuth = getAuth(secondaryApp);
    try {
      const cred = await createUserWithEmailAndPassword(secondaryAuth, email, tempPassword);
      const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
      await setDoc(doc(db, 'profiles', cred.user.uid), { name, initials, role: 'branch_manager', email, companyId: user.companyId, branchId: branchId.trim() });
      await sendPasswordResetEmail(auth, email);
      await signOut(secondaryAuth);
    } finally {
      await deleteApp(secondaryApp);
    }
  }

  // Deactivates (or reactivates) an HR or Branch Manager account — for when
  // someone leaves the job. Doesn't delete anything; just flags their profile so
  // the login check blocks them immediately, while a new person can be given
  // access to the same branch or HR role right away.
  async function toggleHqTeamMemberStatus(uid, deactivate) {
    await updateDoc(doc(db, 'profiles', uid), { status: deactivate ? 'deactivated' : 'active' });
  }

  // Monthly payroll submissions to HQ — a branch manager sends a snapshot of their
  // already-computed payroll data (same numbers the CSV/XLSX export already uses)
  // up to HQ, who sees every branch's submission together for that month. For
  // single-branch companies with no HQ tier, the existing export already covers
  // everything they need — this is purely additive for multi-branch setups.
  const [hqPayrollSubmissions, setHqPayrollSubmissions] = useState([]);
  useEffect(() => {
    if (!user?.companyId) return;
    const q = query(collection(db, 'hqPayrollSubmissions'), where('companyId', '==', user.companyId));
    const unsub = onSnapshot(q, (snap) => {
      setHqPayrollSubmissions(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    }, (err) => console.error('HQ payroll submissions sync error:', err));
    return () => unsub();
  }, [user?.companyId]);

  async function submitPayrollToHQ(year, month, rows) {
    const submissionId = `${user.branchId}_${year}-${month}`.replace(/\s+/g, '_');
    await setDoc(doc(db, 'hqPayrollSubmissions', submissionId), {
      companyId: user.companyId, branchId: user.branchId || 'default', year, month,
      submittedBy: user.name, submittedAt: today,
      rows: rows.map(r => ({ name: r.name, email: r.email, payType: r.payType, hourlyRate: r.hourlyRate ?? null, grossSalary: r.grossSalary ?? null, regularHours: +(r.regularMins/60).toFixed(2), sickHours: +(r.sickMins/60).toFixed(2), gross: r.gross })),
    });
  }

  // Restores the logged-in user automatically on page load/refresh (real session,
  // not temporary memory), and creates a profile document the first time someone
  // with a known demo email signs in for the first time via real Firebase Auth.
  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, async (authUser) => {
      if (!authUser) { setUser(null); setDualAccessOptions(null); setAuthLoading(false); return; }
      try {
        const profileRef = doc(db, 'profiles', authUser.uid);
        const jobSeekerRef = doc(db, 'jobSeekers', authUser.uid);
        const [profileSnap, jobSeekerSnapInitial] = await Promise.all([getDoc(profileRef), getDoc(jobSeekerRef)]);
        let jobSeekerSnap = jobSeekerSnapInitial;
        let profileData;
        if (profileSnap.exists()) {
          profileData = profileSnap.data();
          if (profileData.status === 'deactivated') {
            await signOut(auth);
            setDeactivatedMessage(true);
            setAuthLoading(false);
            return;
          }
          // Phase 4 — this account has both real employee/admin/hr access AND a
          // job-seeker record (they were hired through the pipeline, or signed up
          // separately). Present the choice instead of picking one automatically.
          if (jobSeekerSnap.exists()) {
            setDualAccessOptions({
              profileChoice: { ...profileData, uid: authUser.uid },
              jobSeekerChoice: { ...jobSeekerSnap.data(), uid: authUser.uid, isJobSeeker: true },
            });
            setAuthLoading(false);
            return;
          }
        } else {
          if (!jobSeekerSnap.exists()) {
            // Guards against a rare timing case: sign-up just created this auth
            // account, and the jobSeekers document write may still be in flight.
            await new Promise(resolve => setTimeout(resolve, 700));
            jobSeekerSnap = await getDoc(jobSeekerRef);
          }
          if (jobSeekerSnap.exists()) {
            const jsData = jobSeekerSnap.data();
            setUser({ ...jsData, uid: authUser.uid, isJobSeeker: true });
            setAuthLoading(false);
            return;
          }
          const seedEmp = EMPLOYEES.find(e => e.email === authUser.email);
          if (seedEmp) {
            profileData = { name: seedEmp.name, initials: seedEmp.initials, color: seedEmp.color, textColor: seedEmp.textColor, role: 'employee', email: authUser.email, companyId: 'demo-company' };
          } else if (authUser.email === 'manager@demo.com') {
            profileData = { name: 'Admin', initials: 'AD', role: 'admin', email: authUser.email, companyId: 'demo-company' };
          } else {
            profileData = { name: authUser.email, initials: authUser.email.slice(0, 2).toUpperCase(), color: 'var(--brand-light)', textColor: 'var(--brand-dark)', role: 'employee', email: authUser.email, companyId: 'demo-company' };
          }
          await setDoc(profileRef, profileData);
        }
        setUser({ ...profileData, uid: authUser.uid });
      } catch (err) {
        console.error('Error loading profile:', err);
        setUser(null);
      }
      setAuthLoading(false);
    });
    return () => unsubAuth();
  }, []);

  // Single active session: if this account logs in on another device, that login
  // overwrites the shared "sessions" record, and this device gets signed out
  // automatically the moment it notices the mismatch.
  useEffect(() => {
    if (!user?.uid) return;
    const localKey = `karmadal_session_${user.uid}`;
    const unsubSession = onSnapshot(doc(db, 'sessions', user.uid), (snap) => {
      const remoteSessionId = snap.data()?.sessionId;
      const localSessionId = localStorage.getItem(localKey);
      if (remoteSessionId && localSessionId && remoteSessionId !== localSessionId) {
        setKickedOut(true);
        signOut(auth);
      }
    });
    return () => unsubSession();
  }, [user?.uid]);

  function handleLogout() {
    signOut(auth);
  }

  function handleSubmitAvail(avail) {
    addAvailDoc(avail);
  }

  function handleEditAvail(id, updates) {
    updateAvailDoc(id, updates);
  }

  function handleReportIssue(issue) {
    addIssueDoc(issue);
  }

  function handleUpdateShiftAttendance(shiftId, updates) {
    return updateShiftDoc(shiftId, updates);
  }

  // Submitting a sick certificate: log the report, AND auto-mark any of that
  // employee's shifts (upcoming or already completed) that fall in the date range.
  function handleSubmitSick(report) {
    addSickReportDoc({ ...report, status: 'Pending' });
    const matching = shifts.filter(sh => sh.employee === report.employee && sh.date >= report.fromDate && sh.date <= report.toDate);
    matching.forEach(sh => updateShiftDoc(sh.id, {
      attendance: 'Missed', attendanceApproved: false, missedReason: 'Health problem',
      missedDesc: report.note, sickFrom: report.fromDate, sickTo: report.toDate,
      certFileName: report.certFileName, certFileData: report.certFileData,
    }));
  }

  if (showSplash || authLoading) return <SplashScreen language={language} />;
  if (dualAccessOptions) return (
    <PortalChoiceScreen options={dualAccessOptions} language={language} setLanguage={setLanguage}
      onChoose={(choice) => { setUser(choice); setDualAccessOptions(null); }}
      onLogout={handleLogout} />
  );
  if (publicJobsMode) return <PublicJobsPortal language={language} setLanguage={setLanguage} onBack={() => setPublicJobsMode(false)} onSignUp={() => { setPublicJobsMode(false); setSignUpMode(true); }} />;
  if (signUpMode) return <SignUpPage language={language} setLanguage={setLanguage} onBack={() => setSignUpMode(false)} onSignUpSuccess={() => setSignUpMode(false)} />;
  if (!user) return <LoginPage language={language} setLanguage={setLanguage} kickedOut={kickedOut} onDismissKickedOut={() => setKickedOut(false)} onBrowseJobs={() => setPublicJobsMode(true)} onSignUp={() => setSignUpMode(true)} deactivatedMessage={deactivatedMessage} onDismissDeactivated={() => setDeactivatedMessage(false)} />;
  if (user.isJobSeeker) return <JobSeekerPortal user={user} language={language} setLanguage={setLanguage} onLogout={handleLogout} />;
  if (user.role === 'branch_manager') {
    const filtered = user.branchId
      ? filterDataByBranch(user.branchId, { shifts, availList, issues, sickReports, employeeRecords, profiles, swapRequests, leaveRequests })
      : { shifts: [], availList: [], issues: [], sickReports: [], employeeRecords: {}, profiles: {}, swapRequests: [], leaveRequests: [] };
    return (
      <AdminApp user={user} shifts={filtered.shifts} onAddShift={addShift} onUpdateShift={updateShiftDoc} onRemoveShift={removeShiftDoc} availList={filtered.availList} onUpdateAvail={updateAvailDoc}
        salarySlips={salarySlips} onAddSalarySlip={addSalarySlipDoc} issues={filtered.issues} onUpdateIssue={updateIssueDoc} onIssueReply={addIssueReply} onCreateIssue={addIssueDoc}
        profiles={filtered.profiles} onUpdateProfile={updateEmployeeProfileDoc} sickReports={filtered.sickReports} onUpdateSickReport={updateSickReportDoc}
        employeeRecords={filtered.employeeRecords} onUpdateEmployeeRecord={updateEmployeeRecordDoc} onAddEmployee={addEmployee}
        contractTemplates={contractTemplates} onAddContractTemplate={addContractTemplateDoc} onUpdateContractTemplate={updateContractTemplateDoc} onDeleteContractTemplate={deleteContractTemplateDoc}
        swapRequests={filtered.swapRequests} onUpdateSwapRequest={updateSwapRequestDoc}
        leaveRequests={filtered.leaveRequests} onUpdateLeaveRequest={updateLeaveRequestDoc}
        companyThemeColor={companyThemeColor} onUpdateCompanyThemeColor={updateCompanyThemeColor}
        fixedScheduleConfig={fixedScheduleConfig} onUpdateFixedScheduleConfig={updateFixedScheduleConfig} onGenerateFixedShifts={generateFixedShiftsForWeek}
        dayOffChoices={dayOffChoices}
        onExecuteWeekOffSwap={executeWeekOffSwap}
        shiftTemplates={shiftTemplates} onAddShiftTemplate={addShiftTemplateDoc} onUpdateShiftTemplate={updateShiftTemplateDoc} onDeleteShiftTemplate={deleteShiftTemplateDoc}
        jobPostings={jobPostings} applicants={applicants} onAddJobPosting={addJobPostingDoc} onUpdateJobPosting={updateJobPostingDoc} onUpdateApplicant={updateApplicantDoc} onHireApplicant={hireApplicant} onAddHRAccount={addHRAccount}
        onSubmitPayrollToHQ={submitPayrollToHQ}
        rotationConfig={rotationConfig} onUpdateRotationConfig={updateRotationConfig} onGenerateRotationShifts={generateRotationShiftsForWeek} onCheckRotationRest={checkRotationRestViolation}
        language={language} setLanguage={setLanguage} onLogout={handleLogout} />
    );
  }
  if (user.role === 'hr') return (
    <HiringPortal user={user} jobPostings={jobPostings.filter(p => p.companyId === user.companyId)} applicants={applicants.filter(a => a.companyId === user.companyId)}
      onAddJobPosting={addJobPostingDoc} onUpdateJobPosting={updateJobPostingDoc} onUpdateApplicant={updateApplicantDoc} onHireApplicant={hireApplicant}
      issues={issues} onUpdateIssue={updateIssueDoc} onIssueReply={addIssueReply}
      language={language} setLanguage={setLanguage} onLogout={handleLogout} />
  );
  if (user.role === 'admin') return (
    <HQPortal user={user} employeeRecords={employeeRecords} shifts={shifts}
      onAddBranchManager={addBranchManagerAccount} onAddHRAccount={addHRAccount} hqPayrollSubmissions={hqPayrollSubmissions} hqTeamMembers={hqTeamMembers} onToggleTeamMemberStatus={toggleHqTeamMemberStatus}
      language={language} setLanguage={setLanguage} onLogout={handleLogout} />
  );
  return (
    <EmployeeApp user={user} shifts={shifts} availList={availList} salarySlips={salarySlips}
      onSubmitAvail={handleSubmitAvail} onEditAvail={handleEditAvail} onRemoveAvail={removeAvailDoc} onReportIssue={handleReportIssue} onIssueReply={addIssueReply} onUpdateIssue={updateIssueDoc}
      onUpdateShiftAttendance={handleUpdateShiftAttendance}
      profiles={profiles} onUpdateProfile={updateEmployeeProfileDoc} onAddProfileDocument={addEmployeeDocumentDoc}
      sickReports={sickReports} onSubmitSick={handleSubmitSick} onUpdateSickReport={updateSickReportDoc}
      employeeRecords={employeeRecords}
      swapRequests={swapRequests} onAddSwapRequest={addSwapRequestDoc} onUpdateSwapRequest={updateSwapRequestDoc}
      onUpdateSalarySlip={updateSalarySlipDoc}
      dayOffChoices={dayOffChoices} onSetDayOffChoice={setDayOffChoice}
      fixedScheduleConfig={fixedScheduleConfig}
      leaveRequests={leaveRequests} onAddLeaveRequest={addLeaveRequestDoc} onUpdateLeaveRequest={updateLeaveRequestDoc} onDeleteLeaveRequest={deleteLeaveRequestDoc}
      language={language} setLanguage={setLanguage}
      issues={issues} onLogout={handleLogout} />
  );
}

export default App;